(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionAlertShare = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ActionAlertShare = /*#__PURE__*/function () {
  function ActionAlertShare($el) {
    _classCallCheck(this, ActionAlertShare);

    this.$el = $el;
    this.bindEvents();
  }

  _createClass(ActionAlertShare, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$el.on('click', function (event) {
        return _this.toggleShareMenu(event);
      });
      this.$el.parent().find('.action-alert-share__menu-item').on('click', function (event) {
        return _this.close(event);
      });
    }
  }, {
    key: "toggleShareMenu",
    value: function toggleShareMenu(event) {
      var toggle = (0, _jquery.default)(event.currentTarget);
      var menu = toggle.parent().find('.js-action-alert-share-menu');

      if (menu.hasClass('action-alert-share--active')) {
        toggle.show();
        menu.removeClass('action-alert-share--active');
      } else {
        menu.addClass('action-alert-share--active');
        toggle.hide();
      }
    }
  }, {
    key: "close",
    value: function close(event) {
      var toggle = (0, _jquery.default)(event.currentTarget);
      var menu = toggle.parents('.action-alert-share').find('.js-action-alert-share-menu');
      menu.removeClass('action-alert-share--active');
      toggle.parents('.action-alert-share').find('.js-action-alert-share').show();
    }
  }]);

  return ActionAlertShare;
}();

exports.ActionAlertShare = ActionAlertShare;

},{"jquery":"jquery"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicBanner = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _objectFit = require("../polyfill/object-fit");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DynamicBanner = /*#__PURE__*/function () {
  function DynamicBanner($el) {
    _classCallCheck(this, DynamicBanner);

    this.$el = $el;
    this.$container = $el.parent();
    this.$media = $el.find(".js-banner-media");
    this.bindEvents();
  }

  _createClass(DynamicBanner, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      // only apply this if media is video or object-fit is not natively supported
      if (!(0, _objectFit.objectFitSupport)() || this.$media[0] != null && this.$media[0].nodeName === "VIDEO") {
        this.adjustMedia();
        (0, _jquery.default)(window).on("resize", function () {
          return _this.adjustMedia();
        });
      }
    }
  }, {
    key: "adjustMedia",
    value: function adjustMedia() {
      //console.log("run adjust media");
      var maxHeight = parseInt(this.$el.css("max-height").replace("px", ""), 10); // The object-fit polyfill will apply absolute positioning to the media element.
      // This will remove the media from flow making it's effective height zero.
      // In the case that we have a max-height applied, we still to provide an appropriate
      // height value for both the media and it's container.

      if (maxHeight) {
        var mediaWidth = this.$media.width();
        var mediaHeight = this.$media.height();
        var containerWidth = this.$container.width(); // get the aspect ration of the original media

        var ratio = mediaHeight / mediaWidth; // calculate proportional height based on container size

        var newHeight = containerWidth * ratio;

        if (newHeight > maxHeight) {
          newHeight = maxHeight;
        } //this.$media.height(newHeight);


        this.$media.parent().height(newHeight);
        this.$media.height(newHeight);
      }

      (0, _objectFit.objectFit)(this.$media[0]);
    }
  }]);

  return DynamicBanner;
}();

exports.DynamicBanner = DynamicBanner;

},{"../polyfill/object-fit":121,"jquery":"jquery"}],3:[function(require,module,exports){
"use strict";

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery.default)(document).ready(function () {
  var truncateDynamicContent = function truncateDynamicContent(content) {
    if (content && content.length >= 250) {
      return content.substr(0, 250) + "\u2026";
    } else {
      return content;
    }
  };

  (0, _jquery.default)('.dynamic-content-listing__loading-spinner').hide();
  var dynamicContentPage = 0;

  var dynamicContentBlueprint = function dynamicContentBlueprint(data) {
    data.featureItemSummary = truncateDynamicContent(data.featureItemSummary);
    return "\n      <div class=\"dynamic-content-listing__content\">\n        ".concat(data.featureItemImage1x1 && data.featureItemImage1x1.src ? "\n          <a class=\"dynamic-content-listing__image\" href=\"".concat(data.featureItemUrl, "\">\n            <img src=\"").concat(data.featureItemImage1x1.src, "\">\n          </a>\n        ") : "", "\n        <div class=\"dynamic-content-listing__details\">\n          ").concat(data.featureItemContentType ? "\n            <h4 class=\"dynamic-content-listing__content-type\">".concat(data.featureItemContentType, "</h4>\n          ") : "", "\n          ").concat(data.featureItemDisplayDate ? "\n            <span class=\"dynamic-content-listing__date\">".concat(data.featureItemDisplayDate, "</span>\n          ") : "", "\n          <a class=\"dynamic-content-listing__listing-title\" href=\"").concat(data.featureItemUrl, "\">").concat(data.featureItemTitle, "</a>\n          ").concat(data.featureItemSummary ? "\n            <span class=\"dynamic-content-listing__listing-summary\">".concat(data.featureItemSummary, "</span>\n          ") : "", "\n        </div>\n      </div>\n    ");
  };

  (0, _jquery.default)('.js-load-more-dynamic-content').on('click', function () {
    (0, _jquery.default)('.dynamic-content-listing__loading-spinner').show();
    dynamicContentPage += 1;
    var $loadMore = (0, _jquery.default)(this);
    var $loadMoreWrapper = $loadMore.closest((0, _jquery.default)('.dynamic-content-listing__load-more-wrapper'));

    _jquery.default.get($loadMore.attr('data-api') + dynamicContentPage).done(function (data) {
      if (!data.items.length) {
        $loadMoreWrapper.hide();
      } else {
        (0, _jquery.default)(data.items).each(function (ind, elm) {
          $loadMoreWrapper.before(dynamicContentBlueprint(elm));
        });
      }

      if (data.isEndOfList) {
        $loadMoreWrapper.hide();
      }

      (0, _jquery.default)('.dynamic-content-listing__loading-spinner').hide();
    });
  }); // Truncate any existing content

  (0, _jquery.default)('.dynamic-content-listing__listing-summary').each(function (ind, elm) {
    (0, _jquery.default)(elm).text(truncateDynamicContent((0, _jquery.default)(elm).text()));
  });
});

},{"jquery":"jquery"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmbedToggle = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var EmbedToggle = /*#__PURE__*/function () {
  function EmbedToggle($el) {
    _classCallCheck(this, EmbedToggle);

    this.$button = $el;
    this.$embedCode = $el.siblings(".js-embed-code");
    this.bindEvents();
  }

  _createClass(EmbedToggle, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$button.on("click", function (event) {
        event.preventDefault();

        _this.toggleEmbedCode();
      });
    }
  }, {
    key: "toggleEmbedCode",
    value: function toggleEmbedCode() {
      this.$embedCode.toggleClass("is-visible");
    }
  }]);

  return EmbedToggle;
}();

exports.EmbedToggle = EmbedToggle;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(str) {
  if (typeof jQuery !== "undefined") {
    // Create an empty div to use as a container,
    // then put the raw text in and get the HTML
    // equivalent out.
    return jQuery("<div/>").text(str).html();
  } // No jQuery, so use string replace.


  return str.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
};

exports.default = _default;

},{}],6:[function(require,module,exports){
"use strict";

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery.default)(document).ready(function () {
  var exploreIndex = 0;
  var exploreItems;
  var iframeCache = [];
  var $iframeBlueprint = (0, _jquery.default)('<iframe>', {
    'class': 'explore-module__modal-iframe js-explore-modal-iframe'
  });
  var $itemTitle = (0, _jquery.default)('<div>', {
    'class': 'explore-module__sub-item-title'
  });

  var buildIframe = function buildIframe(index) {
    if (!iframeCache[index]) {
      iframeCache[index] = $iframeBlueprint.clone().attr('src', exploreItems[index].Url);
    }

    (0, _jquery.default)('.js-explore-modal-title').text(exploreItems[index].Title);
    (0, _jquery.default)('.js-explore-modal-iframe-wrapper').html(iframeCache[index]).css('display', 'none');
    iframeCache[index].on('load', function () {
      var iframeBody = iframeCache[index].contents().find('body');
      iframeBody.addClass('explore-module--iframe');
      iframeBody.css({
        padding: '0 40px',
        overflowX: 'hidden'
      });
      iframeBody.prepend($itemTitle.clone().text(exploreItems[index].Title));
      (0, _jquery.default)('.js-explore-modal-iframe-wrapper').css('display', 'block');
    });
  }; // If there isn't already a placeholder modal container for Explore Modules, create one


  var appendExplorePlaceholder = function appendExplorePlaceholder() {
    if ((0, _jquery.default)('.explore-module__modal-container').length === 0) {
      var newExploreModuleModal = "\n          <div class=\"explore-module__modal-container\">\n            <div class=\"explore-module__modal-inner\">\n              <div class=\"explore-module__close-modal js-close-explore-module\">\n                <svg viewBox=\"0 0 16 14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 7l-6.6 6.6L8 7 1.4.4 8 7zm0 0L14.7.3 8 7l6.6 6.6L8 7z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>\n              </div>\n              <div class=\"explore-module__modal-iframe-wrapper js-explore-modal-iframe-wrapper\">\n              </div>\n              <div class=\"explore-module__modal-controller\">\n                <div class=\"explore-module__modal-controller-prev js-explore-modal-prev is-disabled\">\n                  <svg viewBox=\"0 0 11 19\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 18.5L1 9.7\"/><path d=\"M9.5.9L1 9.7\"/></g></svg>\n                </div>\n                <div class=\"explore-module__modal-controller-index\">\n                  <span class=\"js-explore-module-current-index\">1</span>/<span class=\"js-explore-module-total-count\">10</span>\n                </div>\n                <div class=\"explore-module__modal-controller-next js-explore-modal-next is-disabled\">\n                  <svg viewBox=\"0 0 11 19\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 18.5L10 9.7\"/><path d=\"M1.5.9L10 9.7\"/></g></svg>\n                </div>\n              </div>\n            </div>\n          </div>";
      (0, _jquery.default)(document.body).append(newExploreModuleModal);
    }
  };

  var closeExploreModal = function closeExploreModal() {
    (0, _jquery.default)('.explore-module__modal-container').removeClass('is-open').fadeOut(100);
    exploreIndex = 0;
    iframeCache = [];
    (0, _jquery.default)(document.body).removeClass('scroll-disabled');
  };

  var prevExploreModalItem = function prevExploreModalItem() {
    if (exploreIndex > 0) {
      (0, _jquery.default)('.js-explore-modal-prev').removeClass('is-disabled');
      exploreIndex -= 1;
      (0, _jquery.default)('.js-explore-module-current-index').text(exploreIndex + 1);
      buildIframe(exploreIndex);
    }

    if (exploreIndex === 0) {
      (0, _jquery.default)('.js-explore-modal-prev').addClass('is-disabled');
    }

    if (exploreItems.length > 1) {
      (0, _jquery.default)('.js-explore-modal-next').removeClass('is-disabled');
    }
  };

  var nextExploreModalItem = function nextExploreModalItem() {
    if (exploreIndex + 1 < exploreItems.length) {
      (0, _jquery.default)('.js-explore-modal-next').removeClass('is-disabled');
      exploreIndex += 1;
      (0, _jquery.default)('.js-explore-module-current-index').text(exploreIndex + 1);
      buildIframe(exploreIndex);

      if (exploreIndex + 1 === exploreItems.length) {
        (0, _jquery.default)('.js-explore-modal-next').addClass('is-disabled');
      }
    }

    if (exploreItems.length > 1) {
      (0, _jquery.default)('.js-explore-modal-prev').removeClass('is-disabled');
    }
  };

  appendExplorePlaceholder();
  (0, _jquery.default)('.js-open-explore-module').on('click', function () {
    exploreItems = JSON.parse((0, _jquery.default)(this).attr('data-explore')).Items; // On the first pass, allow users to paginate to the next Explore Module tab if more than one exists

    if (exploreItems.length > 1) {
      (0, _jquery.default)('.js-explore-modal-next').removeClass('is-disabled');
    }

    (0, _jquery.default)('.js-explore-module-current-index').text('1');
    (0, _jquery.default)('.js-explore-module-total-count').text(exploreItems.length);

    if (!iframeCache[0]) {
      buildIframe(0); // iframeCache[0] = $iframeBlueprint.clone().attr('src', exploreItems[0].Url);
      // $('.js-explore-modal-iframe-wrapper').append(iframeCache[0]);
    }

    (0, _jquery.default)('.explore-module__modal-container').addClass('is-open').fadeIn(200);
    (0, _jquery.default)(document.body).addClass('scroll-disabled');
    (0, _jquery.default)(document).on('click.exploreModule', function (e) {
      if ((0, _jquery.default)(e.target).hasClass('explore-module__modal-container')) {
        (0, _jquery.default)(document).off('click.exploreModule');
        closeExploreModal();
      }
    });
  });
  (0, _jquery.default)('.js-close-explore-module').on('click', function () {
    closeExploreModal();
  });
  (0, _jquery.default)('.js-explore-modal-next').on('click', function () {
    nextExploreModalItem();
  });
  (0, _jquery.default)('.js-explore-modal-prev').on('click', function () {
    prevExploreModalItem();
  });
  (0, _jquery.default)(document).on("keydown", function (e) {
    if ((0, _jquery.default)('.explore-module__modal-container.is-open').length) {
      if (e.which === 27) {
        closeExploreModal();
      }

      if (e.which === 37) {
        prevExploreModalItem();
      }

      if (e.which === 39) {
        nextExploreModalItem();
      }
    }
  });
});

},{"jquery":"jquery"}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlipBanner = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FlipBanner = /*#__PURE__*/function () {
  function FlipBanner($el) {
    var _this = this;

    _classCallCheck(this, FlipBanner);

    this.$el = $el;
    this.$front = this.$el.find(".js-front-flip");
    this.$back = this.$el.find(".js-back-flip");

    if (!this.$front.html().trim()) {
      // BE can't determine if a front panel was inserted, so using this hack
      this.$el.remove();
    }

    if (this.$back.html().trim()) {
      // BE can't determine if a back panel was inserted, so using this hack
      this.$el.addClass("has-flip");
      this.$front.addClass("is-loading");
      this.$back.addClass("is-loading");
      this.bindEvents();
      this.$front.removeClass("is-loading");
      this.$back.removeClass("is-loading");
    } else {
      this.$back.remove();
      this.$el.addClass("no-flip");
    }

    if (this.$el.width() < 770) {
      setTimeout(function () {
        _this.resize();
      }, 450);
    }
  }

  _createClass(FlipBanner, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this2 = this;

      (0, _jquery.default)(window).on("resize", function (event) {
        if (_this2.$el.width() > 769) {
          _this2.$back.css("height", "");

          _this2.$front.css("height", "");
        } else {
          setTimeout(function () {
            _this2.resize();
          }, 450);
        }
      });
      this.$front.on("click", function () {
        return _this2.flipToBack();
      });
      this.$front.keypress(function (e) {
        if (e.which == 13) {
          //Enter key pressed
          _this2.$front.click();
        }
      });
      this.$back.on("click", function () {
        return _this2.flipToFront();
      });
      this.$back.keypress(function (e) {
        if (e.which == 13) {
          //Enter key pressed
          _this2.$back.click();
        }
      }); // stop banner from flipping if link is clicked

      _jquery.default.makeArray(this.$el.find("a")).map(function (link) {
        (0, _jquery.default)(link).on("click", function (event) {
          event.stopPropagation();
        });
      });
    }
  }, {
    key: "flipToBack",
    value: function flipToBack() {
      var _this3 = this;

      this.resize();
      this.$back.addClass("is-active");
      this.$front.removeClass("is-active");

      if (window.dataLayer) {
        window.dataLayer.push({
          "event": "Flip Card Flip",
          "eventCategory": "Interactive",
          "eventAction": "Flip Card | Flip",
          "eventLabel": window.location.href
        });
      } // Shift focus to active element for accessibility


      setTimeout(function () {
        _this3.$back.focus();
      }, 450); // The duration of the css transition
    }
  }, {
    key: "flipToFront",
    value: function flipToFront() {
      var _this4 = this;

      this.resize();
      this.$back.removeClass("is-active");
      this.$front.addClass("is-active");

      if (window.dataLayer) {
        window.dataLayer.push({
          "event": "Flip Card Flip",
          "eventCategory": "Interactive",
          "eventAction": "Flip Card | Flip",
          "eventLabel": window.location.href
        });
      } // Shift focus to active element for accessibility


      setTimeout(function () {
        _this4.$front.focus();
      }, 450); // The duration of the css transition
    }
  }, {
    key: "resize",
    value: function resize() {
      //set the height of the flipper to largest container
      var largest = Math.max(this.$front.outerHeight(), this.$back.outerHeight());

      if (this.$el.width() < 769) {
        this.$front.children().outerHeight() > this.$back.children().outerHeight() ? this.$back.css("height", largest) : this.$front.css("height", largest);
      }
    }
  }]);

  return FlipBanner;
}();

exports.FlipBanner = FlipBanner;

},{"jquery":"jquery"}],8:[function(require,module,exports){
"use strict";

var _jquery = _interopRequireDefault(require("jquery"));

require("./custom-vendor/slick-carousel/slick/slick");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery.default)(document).ready(function () {
  if ((0, _jquery.default)('.is-page-editor').length == 0) {
    (0, _jquery.default)('.flip-tile__container').each(function (ind, elm) {
      if ((0, _jquery.default)(this).find('.flip-tile').length === 2) {
        (0, _jquery.default)(this).slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
          arrows: false
        });
      }

      if ((0, _jquery.default)(this).find('.flip-tile').length > 2) {
        (0, _jquery.default)(this).slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          dotsClass: 'flip-tile__slider-dots',
          infinite: false,
          arrows: true,
          prevArrow: "<button type=\"button\" class=\"flip-tile__arrow slick-prev\"><span class=\"accessibility-hidden\">Previous</span> <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n          <path fill=\"#424242\" d=\"M15.422 16.078l-1.406 1.406-6-6 6-6 1.406 1.406-4.594 4.594z\"></path>\n          </svg></button>",
          nextArrow: "<button type=\"button\" class=\"flip-tile__arrow slick-next\"><span class=\"accessibility-hidden\">Previous</span><svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n          <path fill=\"#424242\" d=\"M8.578 16.359l4.594-4.594-4.594-4.594 1.406-1.406 6 6-6 6z\"></path>\n          </svg></button>",
          responsive: [{
            breakpoint: 910,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }]
        });
      }
    });
    (0, _jquery.default)('.js-flip-tile').on('click', function (event) {
      if ((0, _jquery.default)('body.is-page-editor').length === 0 && (0, _jquery.default)(event.target).closest('.js-no-flip-tile-flip').length === 0) {
        (0, _jquery.default)(this).toggleClass('is-flipped');
      }
    });
  }
});

},{"./custom-vendor/slick-carousel/slick/slick":51,"jquery":"jquery"}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormDropdown = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

require("selectize");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FormDropdown = function FormDropdown($el) {
  _classCallCheck(this, FormDropdown);

  this.$el = $el;
  $el.prepend('<option value="#"> </option>');
  $el.selectize({
    placeholder: $el.data("placeholder")
  }); //allowEmptyOption config overrides placeholder so we're using this workaround https://github.com/selectize/selectize.js/issues/739

  var $field = (0, _jquery.default)(".selectized").selectize();
  $field.on("change", function () {
    if ((0, _jquery.default)(this).val() === "#") {
      (0, _jquery.default)(this).val("");
    }
  });
};

exports.FormDropdown = FormDropdown;

},{"jquery":"jquery","selectize":"selectize"}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericModal = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GenericModal = function GenericModal($el, $contentForModal, criteria) {
  _classCallCheck(this, GenericModal);

  if (!$contentForModal) {
    $contentForModal = $el;
  } // `criteria` is an optional function that can be passed to prevent the modal from popping in some cases
  // If not set, default to true — aka, always modal on click


  if (!criteria) {
    criteria = function criteria() {
      return true;
    };
  }

  var $body = (0, _jquery.default)('body');

  if (!(0, _jquery.default)('.modal-overlay').length) {
    (0, _jquery.default)('<div>', {
      'class': 'modal-overlay'
    }).appendTo($body).append('<div class="modal-overlay__inset-container"><span class="modal-overlay__close-modal js-close-modal"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M18.98 6.42L13.4 12 19 17.58l-1.4 1.4L12 13.4 6.42 19l-1.4-1.4L10.6 12 5 6.42l1.4-1.4L12 10.6 17.58 5z"></path></svg></span><div class="modal-overlay__content"></div></div>');
  }

  var $modalWrapper = (0, _jquery.default)('.modal-overlay');
  $el.find((0, _jquery.default)('.js-modal-trigger')).on('click', function () {
    if (criteria((0, _jquery.default)(this))) {
      // Swipe detection
      var touchstartX = 0;
      var touchstartY = 0;
      var touchendX = 0;
      var touchendY = 0;
      var $modalInset = $modalWrapper.find('.modal-overlay__content');
      $modalInset.append($contentForModal.clone());
      $modalWrapper.addClass('is-active').on('click', function (event) {
        if (!$modalInset[0].contains(event.target) || (0, _jquery.default)('.js-close-modal').find(event.target).length) {
          $modalWrapper.removeClass('is-active').off('click');
          $modalInset.html('');
        }
      }).on('touchstart', function (event) {
        // targetTouches gives us touch data for touches within target elm only
        touchstartX = event.targetTouches[0].screenX;
        touchstartY = event.targetTouches[0].screenY;
      }).on('touchend', function (event) {
        // touchend only returns event coords in changedTouches. targetTouches and touches are empty
        touchendX = event.changedTouches[0].screenX;
        touchendY = event.changedTouches[0].screenY; // find the absolute value of diff between starting and ending touch points
        // if there has been > 10 pixels of movement in any direction, let's assume it's a swipe

        if (Math.abs(touchendX - touchstartX) > 50 || Math.abs(touchendY - touchstartY) > 50) {
          $modalWrapper.removeClass('is-active').html('').off('click touchstart touchend');
        }
      });
    }
  });
};

exports.GenericModal = GenericModal;

},{"jquery":"jquery"}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiaDownload = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HiaDownload = /*#__PURE__*/function () {
  function HiaDownload($el) {
    _classCallCheck(this, HiaDownload);

    this.$el = $el;
    this.bindEvents();
  }

  _createClass(HiaDownload, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$el.on('click', function (event) {
        return _this.downloadCsv(event, event.target);
      });
    }
  }, {
    key: "downloadCsv",
    value: function downloadCsv(event, element) {
      event.preventDefault();
      var url = "https://" + window.location.hostname + "/api/hipmapapi/getdownload?";

      if (element.attributes.all.value == "false") {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
          vars[key] = value;
        });

        for (var part in vars) {
          url += part + "=" + vars[part] + "&";
        }

        url += "dl=true&loadAllPages=false&";
      } else {
        url += "dl=true&loadAllPages=true&";
      }

      url += "pageId={" + window.PewSearchConfigs[0].pageId + "}";
      console.log(url);
      window.open(url);
    }
  }]);

  return HiaDownload;
}();

exports.HiaDownload = HiaDownload;

},{"jquery":"jquery"}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HowWeWork = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HowWeWork = /*#__PURE__*/function () {
  function HowWeWork($el) {
    _classCallCheck(this, HowWeWork);

    this.$el = $el;
    this.bindEvents();
  }

  _createClass(HowWeWork, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$el.on('click', function (event) {
        return _this.toggleActive(event);
      }); //set first item to active

      var $firstItem = (0, _jquery.default)('.how-we-work__item').first();
      $firstItem.addClass('how-we-work__item--active');
      (0, _jquery.default)('.how-we-work__item-info-wrapper').append($firstItem.find('.how-we-work__item-info').clone());
    }
  }, {
    key: "toggleActive",
    value: function toggleActive(event) {
      event.stopPropagation();
      var $item = (0, _jquery.default)(event.currentTarget);
      var width = (0, _jquery.default)(window).width();
      var expanded = false;

      if (width > 910) {
        (0, _jquery.default)('.how-we-work__item--active').removeClass('how-we-work__item--active');
        $item.addClass('how-we-work__item--active');
        (0, _jquery.default)('.how-we-work__item-info-wrapper').html('');
        (0, _jquery.default)('.how-we-work__item-info-wrapper').append($item.find('.how-we-work__item-info').clone());
      } else {
        var parent = $item.parent();

        if ($item.hasClass('how-we-work__item--active')) {
          if (parent.hasClass('how-we-work__items-wrapper--expanded')) {
            parent.removeClass('how-we-work__items-wrapper--expanded');
          } else {
            parent.addClass('how-we-work__items-wrapper--expanded');
          }
        } else {
          (0, _jquery.default)('.how-we-work__item--active').removeClass('how-we-work__item--active');
          (0, _jquery.default)('.how-we-work__item-info-wrapper').html('');
          (0, _jquery.default)('.how-we-work__item-info-wrapper').append($item.find('.how-we-work__item-info').clone());
          parent.removeClass('how-we-work__items-wrapper--expanded');
          $item.addClass('how-we-work__item--active');
        }
      }
    }
  }]);

  return HowWeWork;
}();

exports.HowWeWork = HowWeWork;

},{"jquery":"jquery"}],13:[function(require,module,exports){
"use strict";

var _jquery = _interopRequireDefault(require("jquery"));

require("./custom-vendor/slick-carousel/slick/slick");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery.default)(document).ready(function () {
  if (!(0, _jquery.default)("body").hasClass("is-page-editor")) {
    var imageGalleryStore = [];
    var miniGalleryStore = [];
    var $imageGalleries = (0, _jquery.default)(".image-gallery");
    var $miniGalleryBlueprint = (0, _jquery.default)("<div>", {
      class: "image-gallery__mini-slider js-image-gallery-mini-slider"
    });

    var initImageGalleries = function initImageGalleries() {
      $imageGalleries.each(function () {
        if (!(0, _jquery.default)(this).hasClass("no-full-screen")) {
          // Init a new Slick slider for each primary gallery
          (0, _jquery.default)(this).clone().insertAfter((0, _jquery.default)(this)).addClass("is-full-screen gallery-is-hidden"); // $imageGalleries.push(this);
        }
      });
      var $clonedGalleries = (0, _jquery.default)(".js-image-gallery");
      $clonedGalleries.each(function (index) {
        // Init a new Slick slider for each primary gallery
        imageGalleryStore[index] = (0, _jquery.default)(this).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          fade: true,
          prevArrow: (0, _jquery.default)(this).closest(".image-gallery").find(".image-gallery__prev-arrow"),
          nextArrow: (0, _jquery.default)(this).closest(".image-gallery").find(".image-gallery__next-arrow")
        }); //Add id to each slide for accessibility

        imageGalleryStore[index].find(".slick-slide").each(function () {
          var $slide = (0, _jquery.default)(this);

          if ($slide.attr("aria-describedby") != undefined) {
            // ignore extra/cloned slides        
            (0, _jquery.default)(this).attr("id", $slide.attr("aria-describedby"));
          }
        }); // Build a mini gallery for each primary gallery

        miniGalleryStore[index] = buildMiniGallery((0, _jquery.default)(this), imageGalleryStore[index]);
        imageGalleryStore[index].on("beforeChange", function (event, slick, currentSlide, nextSlide) {
          (0, _jquery.default)(this).closest(".image-gallery").find(".js-image-gallery-current-index").text(nextSlide + 1);
          miniGalleryStore[index].slick("slickGoTo", nextSlide); // // Update Mini Gallery too

          (0, _jquery.default)(".js-mini-slider-caption-wrap").text((0, _jquery.default)(slick.$slides.get(nextSlide)).find("figcaption").text());
          (0, _jquery.default)(".js-mini-slider-title-wrap").text((0, _jquery.default)(slick.$slides.get(nextSlide)).find(".image-block__title").text());
          (0, _jquery.default)(".js-mini-slider-credit-wrap").text((0, _jquery.default)(slick.$slides.get(nextSlide)).find(".image-block__photo-credit").text());

          if ((0, _jquery.default)(slick.$slides.get(nextSlide)).find(".image-block__photo-credit").length > 0) {
            (0, _jquery.default)(".js-mini-slider-credit-wrap").addClass("mini-slider__image-has-credit");
          } else {
            (0, _jquery.default)(".js-mini-slider-credit-wrap").removeClass("mini-slider__image-has-credit");
          }

          (0, _jquery.default)(".js-mini-slider-copyright-wrap").text((0, _jquery.default)(slick.$slides.get(nextSlide)).find(".image-block__photo-copyright").text());

          if ((0, _jquery.default)(slick.$slides.get(nextSlide)).find(".image-block__photo-copyright").length > 0) {
            (0, _jquery.default)(".js-mini-slider-copyright-wrap").addClass("mini-slider__image-has-copyright");
          } else {
            (0, _jquery.default)(".js-mini-slider-copyright-wrap").removeClass("mini-slider__image-has-copyright");
          } //This to reset slides of videos/audios


          var current = (0, _jquery.default)(slick.$slides[currentSlide]); // Note: This refreshes slide markup and disables some JS functionality.
          // It is enabled for audio player since iframe cannot be interfaced with JS.
          // current.html(current.html());

          if (current.hasClass("audio-block")) {
            current.html(current.html());
          }
        });
      }); // Size/position everything once on init

      resizeAndRepositionImageGallery(); // Size/position everything every time the viewport resizes

      (0, _jquery.default)(window).on("resize", function () {
        resizeAndRepositionImageGallery();
      });
      (0, _jquery.default)(".js-launch-full-screen-gallery").on("click", function (e) {
        e.preventDefault();
        (0, _jquery.default)(this).closest(".image-gallery").next(".is-full-screen").removeClass("gallery-is-hidden");
        setTimeout(resizeAndRepositionImageGallery, 200);
      });
      (0, _jquery.default)(".js-image-gallery-leave-full-screen").on("click", function (e) {
        e.preventDefault();
        var $fullScreen = (0, _jquery.default)(this).closest(".is-full-screen");
        $fullScreen.addClass("gallery-is-hidden");
        setTimeout(resizeAndRepositionImageGallery, 200);
        $fullScreen.prev(".image-gallery").find(".image-block__media")[0].scrollIntoView();
      });
    }; //
    // Every image gallery will need its own mini slider
    //


    var buildMiniGallery = function buildMiniGallery($gallery, $slider) {
      //let $images = $gallery.find(".image-block__media");
      var $images = $gallery.find(".slick-slide");
      var $newGallery = $miniGalleryBlueprint.clone();
      $images.each(function (index) {
        if ((0, _jquery.default)(this).hasClass("audio-block")) {
          (0, _jquery.default)(this).find("picture img").addClass("xdbpe");
          (0, _jquery.default)(this).find("picture img").attr("data-xdbpe", "AA4F5A48-5554-4769-8378-DADCF2E947DD");
          var $imgSource = (0, _jquery.default)(this).find("picture img").clone();
          var $wrappedImg = (0, _jquery.default)("<div>", {
            class: "image-gallery__mini-slider-img-wrapper audio-slide"
          });
          $wrappedImg.append($imgSource); //Check if audio caption exist

          if ((0, _jquery.default)(this).find("figcaption").length == 1) {
            var $imgCaption = (0, _jquery.default)(this).find("figcaption").text();
            (0, _jquery.default)(this).find(".audio-block__media-wrapper").after((0, _jquery.default)(this).find("figcaption"));
            $wrappedImg.append('<div class="js-mini-slider-img-caption">' + $imgCaption + "</div>");
          } //Check if audio title exist


          if ((0, _jquery.default)(this).find(".audio-block__title").length == 1) {
            var $imgTitle = (0, _jquery.default)(this).find(".audio-block__title").html();

            if ((0, _jquery.default)(this).find("figcaption").length == 1) {
              (0, _jquery.default)(this).find(".audio-block__caption").prepend('<h3 class="image-block__title">' + $imgTitle + "</h3>");
            } else if ((0, _jquery.default)(this).find(".audio-block__links-wrapper").length == 1) {
              (0, _jquery.default)(this).find(".audio-block__links-wrapper").prepend('<h3 class="image-block__title">' + $imgTitle + "</h3>");
            } else {
              (0, _jquery.default)(this).find(".audio-block__media-wrapper").after('<div class="audio-block__caption"><h3 class="image-block__title">' + $imgTitle + "</h3></div>");
            }
          } //Check if audio subscribe links exist


          if ((0, _jquery.default)(this).find(".audio-block__links-wrapper").length == 1) {
            if ((0, _jquery.default)(this).find("figcaption").length == 1) {
              (0, _jquery.default)(this).find("figcaption").after((0, _jquery.default)(this).find(".audio-block__links-wrapper"));
            } else {
              (0, _jquery.default)(this).find(".audio-block__media-wrapper").after((0, _jquery.default)(this).find(".audio-block__links-wrapper"));
            }
          }

          $newGallery.append($wrappedImg);
          $wrappedImg.on("click", function () {
            $slider.slick("slickGoTo", index);
          });
        } else if ((0, _jquery.default)(this).hasClass("video-block")) {
          (0, _jquery.default)(this).find(".video-block__posterImage").addClass("xdbpe");
          (0, _jquery.default)(this).find(".video-block__posterImage").attr("data-xdbpe", "AA4F5A48-5554-4769-8378-DADCF2E947DD");

          var _$imgSource = (0, _jquery.default)(this).find(".video-block__posterImage").clone();

          var _$wrappedImg = (0, _jquery.default)("<div>", {
            class: "image-gallery__mini-slider-img-wrapper video-slide"
          });

          _$wrappedImg.append(_$imgSource);

          if ((0, _jquery.default)(this).find("figcaption").length == 1) {
            var _$imgCaption = (0, _jquery.default)(this).find("figcaption").text();

            _$wrappedImg.append('<div class="js-mini-slider-img-caption">' + _$imgCaption + "</div>");
          } //Check if Video title exist


          if ((0, _jquery.default)(this).find(".video-block__title").length == 1) {
            var _$imgTitle = (0, _jquery.default)(this).find(".video-block__title").html();

            if ((0, _jquery.default)(this).find("figcaption").length == 1) {
              (0, _jquery.default)(this).find(".video-block__meta-wrapper").prepend('<h3 class="image-block__title">' + _$imgTitle + "</h3>");
            } else {
              (0, _jquery.default)(this).find(".video-block__media-wrapper").after('<div class="video-block__meta-wrapper"><h3 class="image-block__title">' + _$imgTitle + "</h3></div>");
            }
          }

          $newGallery.append(_$wrappedImg);

          _$wrappedImg.on("click", function () {
            $slider.slick("slickGoTo", index);
          });
        } else {
          (0, _jquery.default)(this).find("picture img").addClass("xdbpe");
          (0, _jquery.default)(this).find("picture img").attr("data-xdbpe", "AA4F5A48-5554-4769-8378-DADCF2E947DD");

          var _$imgSource2 = (0, _jquery.default)(this).find("picture img").clone();
          /*let $imgTitle = $(this)
                        .find(".image-block__title")
                        .text();*/


          var _$imgCaption2 = (0, _jquery.default)(this).find("figcaption").text();

          var _$wrappedImg2 = (0, _jquery.default)("<div>", {
            class: "image-gallery__mini-slider-img-wrapper"
          });

          _$wrappedImg2.append(_$imgSource2);

          _$wrappedImg2.append('<div class="js-mini-slider-img-caption">' + _$imgCaption2 + "</div>");

          $newGallery.append(_$wrappedImg2);

          _$wrappedImg2.on("click", function () {
            $slider.slick("slickGoTo", index);
          });
        }
      });
      $newGallery.appendTo($gallery.closest(".image-gallery").find(".image-gallery__mini-slider-inner-wrapper")).slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        prevArrow: $gallery.closest(".image-gallery").find(".image-gallery__mini-prev-arrow"),
        nextArrow: $gallery.closest(".image-gallery").find(".image-gallery__mini-next-arrow")
      });
      (0, _jquery.default)(".js-toggle-mini-slider-panel").unbind("click").on("click", function () {
        (0, _jquery.default)(this).parent(".image-gallery__mini-slider-outer-wrapper").toggleClass("is-open");
      }); //Add id to each slide for accessibility

      $newGallery.find(".slick-slide").each(function () {
        var $slide = (0, _jquery.default)(this);

        if ($slide.attr("aria-describedby") != undefined) {
          // ignore extra/cloned slides        
          (0, _jquery.default)(this).attr("id", $slide.attr("aria-describedby"));
        }
      });
      return $newGallery;
    }; //
    // When the viewport changes, the max height of Image Gallery images and
    // the prev/next arrow positions will need to be recalculated.
    //


    var resizeAndRepositionImageGallery = function resizeAndRepositionImageGallery() {
      (0, _jquery.default)(imageGalleryStore).each(function (index, $gallery) {
        // Climb the tree up to this gallery's origin
        $gallery = $gallery.closest(".image-gallery"); // Image Galleries should never be taller than a 16:9 aspect ratio, using the container width as the "16"

        var sliderImageHeight = Math.round($gallery.outerWidth() * (9 / 16));
        var sliderArrowHeight = 27;
        var isFullScreen = $gallery.hasClass("is-full-screen");
        imageGalleryStore[index].slick("refresh");
        miniGalleryStore[index].slick("refresh"); // miniGalleryStore[index].slick('resize');

        if (isFullScreen) {
          // Images never taller than the full gallery itself
          $gallery.find(".image-block__media img").css({
            maxHeight: (0, _jquery.default)(window).outerHeight(),
            maxWidth: (0, _jquery.default)(window).outerWidth() //maxHeight: '',
            //maxWidth: ''

          }); // Position next/prev arrows vertically centered based on image height

          $gallery.find(".image-gallery__next-arrow, .image-gallery__prev-arrow").css("top", ((0, _jquery.default)(window).outerHeight() - sliderArrowHeight) / 2); // Current slide index needs doesn't need fancy positioning

          $gallery.find(".image-gallery__current-index").css("top", 0);
          (0, _jquery.default)(".image-gallery__mini-slider-img-wrapper").css({
            height: 80
          });
        } else {
          // Images never taller than the full gallery itself
          $gallery.find(".image-block__media img").css({
            maxHeight: sliderImageHeight,
            maxWidth: undefined
          }); // Position next/prev arrows vertically centered based on image height

          $gallery.find(".image-gallery__next-arrow, .image-gallery__prev-arrow").css("top", (sliderImageHeight - sliderArrowHeight) / 2); // Current slide index needs to sit just below the images

          $gallery.find(".image-gallery__current-index").css("top", sliderImageHeight + 25);
          (0, _jquery.default)(".image-gallery__mini-slider-img-wrapper").css({
            height: (0, _jquery.default)(".image-gallery__mini-slider-img-wrapper").width() * 0.5625
          });
        } //$gallery[0].scrollIntoView();
        //$("html")[0].scrollTop = $gallery.offset().top;

      });
      (0, _jquery.default)(document).on("keydown", function (e) {
        var imageGallery = (0, _jquery.default)(".image-gallery.is-full-screen .js-image-gallery");

        if (imageGallery) {
          if (e.which === 27) {
            (0, _jquery.default)(".image-gallery").removeClass("is-full-screen");
            setTimeout(resizeAndRepositionImageGallery, 200);
          }

          if (e.which === 37) {
            imageGallery.slick("slickPrev");
          }

          if (e.which === 39) {
            imageGallery.slick("slickNext");
          }
        }
      });
    };

    initImageGalleries(); //Add aria-label to slick-track for accessibility

    (0, _jquery.default)(".slick-track").each(function (index) {
      (0, _jquery.default)(this).attr("aria-label", "image-gallery" + index);
    });
  }
});

},{"./custom-vendor/slick-carousel/slick/slick":51,"jquery":"jquery"}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageSlider = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

require("./custom-vendor/slick-carousel/slick/slick");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ImageSlider = /*#__PURE__*/function () {
  function ImageSlider($el, conf) {
    _classCallCheck(this, ImageSlider);

    this.$el = $el;
    var slickConf = Object.assign(this.slickDefaults(), conf); // bind event prior to slick init

    this.bindEvents();
    this.$el.slick(slickConf);
  }

  _createClass(ImageSlider, [{
    key: "bindEvents",
    value: function bindEvents() {
      // bind an event on the arrows to de-focus them when
      // you mouse out, so the focus state doesn't get stuck
      this.$el.on('mouseleave', '.slick-next, .slick-prev', function (event) {
        event.currentTarget.blur();
      });
    }
  }, {
    key: "slickDefaults",
    value: function slickDefaults() {
      return {
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: "\n        <button type=\"button\" class=\"slick-prev\" tabindex=\"0\">\n            Previous\n            <div class=\"icon\"><svg><use xlink:href=\"/assets/build/img/svg-sprite.svg#chevron-left\"></use></svg></div>\n        </button>",
        nextArrow: "\n        <button type=\"button\" class=\"slick-next\" tabindex=\"0\">\n            Next\n            <div class=\"icon\"><svg></sbg><use xlink:href=\"/assets/build/img/svg-sprite.svg#chevron-right\"></use></svg></div>\n         </button>"
      };
    }
  }]);

  return ImageSlider;
}();

exports.ImageSlider = ImageSlider;

},{"./custom-vendor/slick-carousel/slick/slick":51,"jquery":"jquery"}],15:[function(require,module,exports){
"use strict";

var _jquery = _interopRequireDefault(require("jquery"));

require("selectize");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery.default)(document).ready(function () {
  var defaultInno = getParameterByName("inno");
  uncheckInnovationFundInvestigator(defaultInno); //https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript  searchparams didn't work soooo ¯\_(ツ)_/¯

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  function uncheckInnovationFundInvestigator(defaultInno) {
    var hiddenInput = "input[name='InnovationFundInvestigators']";

    if (defaultInno == "True") {
      (0, _jquery.default)(hiddenInput).prop("checked", true);
    }
  }
});

},{"jquery":"jquery","selectize":"selectize"}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  // Insert related facts slick slider arrow SVGs
  var relatedFactsStickySliderPrev = document.querySelector(".slick-slider .slick-prev");
  var relatedFactsStickySliderNext = document.querySelector(".slick-slider .slick-next");
  var sliderArrowSVG = "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 13 21' xml:space='preserve' fill='currentColor'><polygon class='st0' points='0,2.4 2.4,0 13,10.5 13,10.5 13,10.5 2.4,21 0,18.6 8.1,10.5 '/></svg>";
  relatedFactsStickySliderPrev && (relatedFactsStickySliderPrev.innerHTML = sliderArrowSVG);
  relatedFactsStickySliderNext && (relatedFactsStickySliderNext.innerHTML = sliderArrowSVG);
};

exports.default = _default;

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InterstitialModal = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var InterstitialModal = /*#__PURE__*/function () {
  function InterstitialModal($el) {
    _classCallCheck(this, InterstitialModal);

    this.$el = $el;
    this.$data = this.$el.data("model");
    this.delayAmt = this.$data.delayAmount;
    this.maxWidth = this.$data.maxWidth || "Large";
    this.overLayOpacity = this.$data.backgroundOverlayOpacity;
    this.delayMethod = this.$data.delayMethod;
    this.displayMode = this.$data.displayMode;
    this.borderColor = this.$data.borderColor;
    this.backgroundOverlayColor = this.$data.backgroundOverlayColor;
    this.datasourceGuid = this.$data.datasourceGuid;
    this.promoItemPath = this.$data.promoItemPath;
    this.fPromoFigures = this.$el.find(".flexible-promo__media"); // check interstitial personalization cookie

    var interCookie = this.getCookie("PewTrusts_Interstitial");
    this.cookieIDs = [];

    if (interCookie) {
      var interCookieRegex = /{(\S+?)}/gi;
      this.cookieIDs = interCookie.match(interCookieRegex);
    }

    if (this.cookieIDs.includes(this.datasourceGuid)) {
      return;
    }

    this.init();
    this.bindEvents();
  }

  _createClass(InterstitialModal, [{
    key: "init",
    value: function init() {
      // styles using input parameters
      this.$el.parent().css("background", "".concat(this.hexToRGBA(this.backgroundOverlayColor, this.overLayOpacity)));
      this.$el.parent().css("background", "rgba(0xF0, 0xF0, 0xF0, 0.7");
      this.$el.css("border", "2px solid ".concat(this.borderColor));
      this.setMaxWidth();
      this.makeCloseButton(); //CTAs

      this.$flexPromoLink = this.$el.find(".flexible-promo");
      this.$actionAlertDetails = this.$el.find(".action-alert-promo-details");
      this.$actionAlertLink = this.$el.find(".action-alert-promo__link");
      this.$newsletterFormWrapper = this.$el.find(".newsletter-signup__promo-form-wrapper");
      this.$newsletterForm = this.$newsletterFormWrapper.length > 0 ? this.$el.$newsletterFormWrapper : this.$el.find(".newsletter-signup__promo-form");
      this.$newsletterBtn = this.$el.find(".js-newsletter-signup--baseUrl");
      this.$newsletterBtnGUID = this.$el.find(".js-newsletter-signup--landingguid");
      this.$richText = this.$el.find(".rich-text");
      this.$showModalTrigger = true;
      this.delayMethod === "Scroll Depth" ? this.handleScrollDepthDelay() : this.addTimeOnPageDelay();
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$closeModal = this.$el.find(".js-close-modal");
      this.$closeModal.on("click", function (event) {
        return _this.closeModal(event);
      });
      var interPopup = this;
      (0, _jquery.default)(document).on("click", function (e) {
        var isPopupAncestor = (0, _jquery.default)(e.target).closest(".js-interstitial-popup");

        if (!isPopupAncestor.length && (0, _jquery.default)(".js-interstitial-popup").is(":visible")) {
          interPopup.closeModal();
        }
      });
      (0, _jquery.default)(document).on("keydown", function (e) {
        if (interPopup.$el.parent().css("display") === "block") {
          if (e.which === 27) {
            interPopup.closeModal();
          }
        }
      });
    }
  }, {
    key: "updateIDs",
    value: function updateIDs(idToUpdate) {
      var cookieData = this.getCookie("PewTrusts_Interstitial");

      if (!cookieData) {
        this.setCookie("PewTrusts_Interstitial", "");
        cookieData = this.getCookie("PewTrusts_Interstitial");
      }

      var pipeID = function pipeID() {
        if (cookieData === "") {
          return "".concat(idToUpdate);
        } else {
          return "|".concat(idToUpdate);
        }
      };

      this.setCookie("PewTrusts_Interstitial", cookieData.concat(pipeID()));
    }
  }, {
    key: "trackCTAs",
    value: function trackCTAs() {
      var thisInterTracking = this; // if Flex Promo CTA exists, run tracking script

      if (this.$flexPromoLink.length > 0) {
        this.$flexPromoLink.each(function (i) {
          var flexPromoDataSource = (0, _jquery.default)(this).attr("data-component-ds-path");
          var flexPromoDescription = (0, _jquery.default)(this).attr("data-component-description");
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            "event": "Interstitial Impression",
            "Interstitial Path": "".concat(thisInterTracking.promoItemPath),
            "Interstitial CTA": "".concat((0, _jquery.default)(this).attr("href")),
            "Interstitial Component": "Flexible Promo",
            "Interstitial Content": flexPromoDataSource || "",
            "Interstitial Content Description": flexPromoDescription || ""
          }); // set event handler to fire data layer script on click

          (0, _jquery.default)(this).on("click", function (e) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              "event": "Interstitial Interaction",
              "Interstitial Path": "".concat(thisInterTracking.promoItemPath),
              "Interstitial CTA": "".concat((0, _jquery.default)(this).attr("href")),
              "Interstitial Component": "Flexible Promo",
              "Interstitial Content": flexPromoDataSource || "",
              "Interstitial Content Description": flexPromoDescription || ""
            });
          });
        });
      } // if Action Alert CTA exists, run tracking script


      if (this.$actionAlertLink.length > 0) {
        this.$actionAlertLink.each(function (i) {
          var actionAlertSource = thisInterTracking.$actionAlertDetails.attr("data-component-ds-path");
          var actionAlertDescription = thisInterTracking.$actionAlertDetails.attr("data-component-description");
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            "event": "Interstitial Impression",
            "Interstitial Path": "".concat(thisInterTracking.promoItemPath),
            "Interstitial CTA": "".concat((0, _jquery.default)(this).attr("href")),
            "Interstitial Component": "Action Alert Promo",
            "Interstitial Content": actionAlertSource || "",
            "Interstitial Content Description": actionAlertDescription || ""
          }); // set event handler to fire data layer script on click

          (0, _jquery.default)(this).on("click", function (e) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              "event": "Interstitial Interaction",
              "Interstitial Path": "".concat(thisInterTracking.promoItemPath),
              "Interstitial CTA": "".concat((0, _jquery.default)(this).attr("href")),
              "Interstitial Component": "Action Alert Promo",
              "Interstitial Content": actionAlertSource || "",
              "Interstitial Content Description": actionAlertDescription || ""
            });
          });
        });
      } // if Newsletter CTA exists, run tracking script


      if (this.$newsletterForm.length > 0) {
        this.$newsletterForm.each(function (i) {
          var baseUrl = (0, _jquery.default)(this).find(".js-newsletter-signup--baseUrl").attr("value");
          var landingGUID = (0, _jquery.default)(this).find(".js-newsletter-signup--landingguid").attr("value");
          var newsletterFormSource = (0, _jquery.default)(this).attr("data-component-ds-path");
          var newsletterFormDescription = (0, _jquery.default)(this).attr("data-component-description");
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            "event": "Interstitial Impression",
            "Interstitial Path": "".concat(thisInterTracking.promoItemPath),
            "Interstitial CTA": "".concat(baseUrl).concat(landingGUID),
            "Interstitial Component": "Newsletter Signup",
            "Interstitial Content": newsletterFormSource || "",
            "Interstitial Content Description": newsletterFormDescription || ""
          }); // set event handler to fire data layer script on click

          (0, _jquery.default)(this).on("submit", function (e) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              "event": "Interstitial Interaction",
              "Interstitial Path": "".concat(thisInterTracking.promoItemPath),
              "Interstitial CTA": "".concat(baseUrl).concat(landingGUID),
              "Interstitial Component": "Newsletter Signup",
              "Interstitial Content": newsletterFormSource || "",
              "Interstitial Content Description": newsletterFormDescription || ""
            });
          });
        });
      } // if Rich Text exists, run tracking script


      if (this.$richText.length > 0) {
        this.$richText.each(function (i) {
          var richTextSource = (0, _jquery.default)(this).attr("data-component-ds-path");
          var richTextDescription = (0, _jquery.default)(this).attr("data-component-description");
          var richTextLinks = (0, _jquery.default)(this).find("a");
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            "event": "Interstitial Impression",
            "Interstitial Path": "".concat(thisInterTracking.promoItemPath),
            "Interstitial CTA": "",
            "Interstitial Component": "Rich Text",
            "Interstitial Content": richTextSource || "",
            "Interstitial Content Description": richTextDescription || ""
          }); // set event handler on links to fire data layer script on click

          if (richTextLinks.length > 0) {
            richTextLinks.each(function (i) {
              (0, _jquery.default)(this).on("click", function (e) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  "event": "Interstitial Interaction",
                  "Interstitial Path": "".concat(thisInterTracking.promoItemPath),
                  "Interstitial CTA": "".concat((0, _jquery.default)(this).attr("href")),
                  "Interstitial Component": "Rich Text",
                  "Interstitial Content": richTextSource || "",
                  "Interstitial Content Description": richTextDescription || ""
                });
              });
            });
          }
        });
      }
    }
  }, {
    key: "setMaxWidth",
    value: function setMaxWidth() {
      switch (this.maxWidth) {
        case "Large":
          return this.$el.addClass("js-interstitial-popup--large-max-width");

        case "Small":
          this.fPromoFigures.each(function (index, figure) {
            var lgMedia = (0, _jquery.default)("source[media='(min-width: 56.9375em)']");
            var mdMedia = (0, _jquery.default)("source[media='(min-width: 29.4375em)']");
            var mdSrc = (0, _jquery.default)(figure).find(mdMedia);
            var lgSrc = (0, _jquery.default)(figure).find(lgMedia);
            lgSrc.attr("srcset", mdSrc.attr("srcset"));
          });
          return this.$el.addClass("js-interstitial-popup--small-max-width");
      }
    }
  }, {
    key: "hexToRGBA",
    value: function hexToRGBA(hex, a) {
      var validHEXInput = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

      if (!validHEXInput) {
        return false;
      }

      var output = {
        r: parseInt(validHEXInput[1], 16),
        g: parseInt(validHEXInput[2], 16),
        b: parseInt(validHEXInput[3], 16)
      };
      return "rgba(".concat(output.r, ", ").concat(output.g, ", ").concat(output.b, ", ").concat(a, ")");
    }
  }, {
    key: "showModal",
    value: function showModal() {
      this.$el.parent().fadeIn();
      this.trackCTAs();
      (0, _jquery.default)(document.body).addClass("js-interstitial-disable-scroll");
      this.updateIDs(this.datasourceGuid);
      this.$showModalTrigger = false;
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.$el.parent().fadeOut();
      (0, _jquery.default)(document.body).removeClass("js-interstitial-disable-scroll");
    }
  }, {
    key: "makeCloseButton",
    value: function makeCloseButton() {
      var $closeButton = (0, _jquery.default)("\n      <div class=\"interstitial-popup__close-wrapper\">\n        <div class=\"interstitial-popup__close-modal js-close-modal\">\n          <svg viewBox=\"0 0 16 14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 7l-6.6 6.6L8 7 1.4.4 8 7zm0 0L14.7.3 8 7l6.6 6.6L8 7z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>\n        </div>\n      </div>\n    ");
      this.$el.prepend($closeButton);
    }
  }, {
    key: "handleScrollDepthDelay",
    value: function handleScrollDepthDelay() {
      var interPopup = this;
      var prevWintop = 0;
      var wintop, docheight, winheight, scrolltrigger;
      (0, _jquery.default)(window).on("scroll", function () {
        if (!interPopup.$showModalTrigger) {
          return;
        }

        wintop = (0, _jquery.default)(window).scrollTop();
        docheight = (0, _jquery.default)(document).height();
        winheight = (0, _jquery.default)(window).height();
        scrolltrigger = interPopup.delayAmt / 100;

        if (wintop > prevWintop && wintop / (docheight - winheight) > scrolltrigger) {
          interPopup.showModal();
        }

        prevWintop = wintop;
      });
    }
  }, {
    key: "addTimeOnPageDelay",
    value: function addTimeOnPageDelay() {
      var interPopup = this;
      setTimeout(function () {
        interPopup.showModal();
      }, this.delayAmt * 1000);
    }
  }, {
    key: "setCookie",
    value: function setCookie(cname, cvalue) {
      document.cookie = cname + "=" + cvalue + ";path=/;";
    }
  }, {
    key: "getCookie",
    value: function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }

      return false;
    }
  }]);

  return InterstitialModal;
}();

exports.InterstitialModal = InterstitialModal;

},{"jquery":"jquery"}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSelector = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LanguageSelector = /*#__PURE__*/function () {
  function LanguageSelector($el) {
    _classCallCheck(this, LanguageSelector);

    this.$el = $el;
    this.bindEvents();
  }

  _createClass(LanguageSelector, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$el.on('click', function (event) {
        return _this.toggleActive(event);
      });
    }
  }, {
    key: "toggleActive",
    value: function toggleActive(event) {
      event.stopPropagation(); //see if item is already selected

      var calloutItem = this.getCalloutItem(event.target);

      if ((0, _jquery.default)(calloutItem).hasClass('language-callout__item--current')) {
        return;
      } else {
        (0, _jquery.default)('.language-callout__item--current').removeClass('language-callout__item--current');
        (0, _jquery.default)(calloutItem).addClass('language-callout__item--current');
        (0, _jquery.default)('.language-selector__current-language').text((0, _jquery.default)('.language-callout__item--current').text());
        var text1 = (0, _jquery.default)(calloutItem).attr("name");
        (0, _jquery.default)(".language-selector__current-language").attr("value", text1);
        (0, _jquery.default)(calloutItem).parents('form').submit();
      }
    }
  }, {
    key: "getCalloutItem",
    value: function getCalloutItem(target) {
      if ((0, _jquery.default)(target).hasClass('language-callout__item')) {
        return target;
      } else {
        if ((0, _jquery.default)(target).parent().hasClass('language-callout__item')) {
          return (0, _jquery.default)(target).parent();
        } else {
          this.getCalloutItem((0, _jquery.default)(target).parent());
        }
      }
    }
  }]);

  return LanguageSelector;
}();

exports.LanguageSelector = LanguageSelector;

},{"jquery":"jquery"}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegacyVideoModal = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LegacyVideoModal = /*#__PURE__*/function () {
  function LegacyVideoModal($el) {
    var _this = this;

    _classCallCheck(this, LegacyVideoModal);

    var $body = (0, _jquery.default)('body');

    if (!(0, _jquery.default)('.video-block__modal-wrapper').length) {
      (0, _jquery.default)('<div>', {
        'class': 'video-block__modal-wrapper js-selection-sharer'
      }).appendTo($body);
    }

    var $modalWrapper = (0, _jquery.default)('.video-block__modal-wrapper');
    var data = this.cleanJSON($el.attr('data-modal'));
    var id = this.getVideoId($el.attr('href'));
    var autoplay = $el.hasClass("autoplay") ? 1 : 0; //image properties

    var imgSrc = data.image ? data.image : null;
    var imgAlt = data.imageAlt ? data.imageAlt : null;
    var imgWidth = data.imageWidth;
    var imgHeight = data.imageHeight; //html elements

    var dataType = data.type.trim().toLowerCase();
    var iframe = '<div class="video-block__media-wrapper"><iframe id="legacy-yt-player" src="//www.youtube.com/embed/' + id + '?autoplay=' + autoplay + '&mute=1?&enablejsapi=1" frameborder="0" autoplay="' + autoplay + '" allowfullscreen enablejsapi="true"></iframe></div>';
    var image = "<picture><img src=\"".concat(imgSrc, "\" alt=\"").concat(imgAlt, "\" style=\" width: 80%; max-width:").concat(imgWidth, "; height: auto;\"></picture>");
    var modalContent = dataType == "video" ? iframe : dataType.includes("photo") ? image : '';
    var modalType = dataType == "video" ? "video" : dataType.includes("photo") ? "image" : '';
    var fixedWidth = modalType == "image" ? dataType.includes("flex") ? '' : "640px" : "";
    var $block = (0, _jquery.default)('<section class="' + modalType + '-block" style="max-width:' + fixedWidth + '"><figure class="' + modalType + '-block__media ' + modalType + '-frame">' + modalContent + '</figure></section>');
    var $svgClose = (0, _jquery.default)('<span class="modal-overlay__close-modal js-close-video-modal"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M18.98 6.42L13.4 12 19 17.58l-1.4 1.4L12 13.4 6.42 19l-1.4-1.4L10.6 12 5 6.42l1.4-1.4L12 10.6 17.58 5z"></path></svg></span>');
    var $durationDiv = (0, _jquery.default)('<div class="video-block__duration"><svg class="video-block__duration-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path d="M512 64q91 0 174 35 81 34 143 96t96 143q35 83 35 174t-35 174q-34 81-96 143t-143 96q-83 35-174 35t-174-35q-81-34-143-96T99 686q-35-83-35-174t35-174q34-81 96-143t143-96q83-35 174-35zm0-64Q373 0 255 68.5T68.5 255 0 512t68.5 257T255 955.5t257 68.5 257-68.5T955.5 769t68.5-257-68.5-257T769 68.5 512 0zm222 512H576V225q0-13-9.5-22.5T544 193t-22.5 9.5T512 225v319q0 13 9.5 22.5T544 576h190q14 0 23-9.5t9-22.5-9-22.5-23-9.5z"></path></svg></div>');
    var $title = (0, _jquery.default)('<span class="video-block__title video-block__title--below">' + data.title + '</span>');
    var $caption = data.caption ? (0, _jquery.default)('<figcaption class="video-block__caption">' + data.caption + '</figcaption>') : '';
    this.modalType = modalType;
    this.modalContent = modalContent; //bind click event to close modal

    $el.on('click', function (event) {
      event.preventDefault(); //prevent the <a> tag from redirecting

      $modalWrapper.append($block).addClass('is-active').on('click', function (event) {
        var $modalInset = $modalWrapper.find('.' + _this.modalType + '-frame'); // let $modalInset = $modalWrapper.find('.video-frame');

        if (!$modalInset[0].contains(event.target) || (0, _jquery.default)('.js-close-video-modal').find(event.target).length) {
          $modalWrapper.removeClass('is-active').html('').off('click');
        }
      });
      var $thisModal = $modalWrapper.find('.' + _this.modalType + '-block__media');
      $svgClose.prependTo($thisModal);
      $title.appendTo($thisModal);

      if (_this.modalType == "video") {
        $durationDiv.appendTo($thisModal);
      }

      $caption.appendTo($thisModal);

      if (_this.modalType == "video") {
        var youtubeUrl = "https://www.googleapis.com/youtube/v3/videos?id=" + id + "&key=AIzaSyDlptEkRK4oZtR5R-esea21Ny63T1AstPI&part=snippet,contentDetails"; // var thisObject = this;

        _jquery.default.ajax({
          async: false,
          type: 'GET',
          url: youtubeUrl,
          success: function success(ytData) {
            var youtube_time = ytData.items[0].contentDetails.duration;
            var array = youtube_time.match(/(\d+)(?=[MHS])/ig) || [];
            var formatted = array.map(function (item) {
              if (item.length < 2) return '0' + item;
              return item;
            });
            (0, _jquery.default)('.legacy-duration').remove();
            var duration = (0, _jquery.default)("<span class='legacy-duration'>" + formatted[0] + "min " + formatted[1] + "sec</span>");
            duration.appendTo($durationDiv);
          }
        });
      }
    });
  }

  _createClass(LegacyVideoModal, [{
    key: "getVideoId",
    value: function getVideoId(url) {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = url.match(regExp);

      if (match && match[2].length == 11) {
        return match[2];
      } else {
        return false;
      }
    }
  }, {
    key: "getVideoDuration",
    value: function getVideoDuration(id, callback) {
      var youtubeUrl = "https://www.googleapis.com/youtube/v3/videos?id=" + id + "&key=AIzaSyDlptEkRK4oZtR5R-esea21Ny63T1AstPI&part=snippet,contentDetails";

      _jquery.default.ajax({
        async: false,
        type: 'GET',
        url: youtubeUrl,
        success: callback
      });
    }
  }, {
    key: "cleanJSON",
    value: function cleanJSON(data) {
      var str = data.replace(/'/g, '"');
      str = JSON.parse(str);
      return str;
    }
  }]);

  return LegacyVideoModal;
}();

exports.LegacyVideoModal = LegacyVideoModal;

},{"jquery":"jquery"}],20:[function(require,module,exports){
"use strict";

var _jquery = _interopRequireDefault(require("jquery"));

require("./custom-vendor/slick-carousel/slick/slick");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery.default)(document).ready(function () {
  if (!(0, _jquery.default)('body').hasClass('is-page-editor')) {
    var mobileWidth = 470;
    var $moreFromPewSlider = (0, _jquery.default)('.js-more-from-pew-slider');
    var sliderSettings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: true,
      arrows: false
    };

    if ((0, _jquery.default)(window).width() <= mobileWidth) {
      $moreFromPewSlider.slick(sliderSettings);
    } // reslick only if it's not slick()


    (0, _jquery.default)(window).on('resize', function () {
      if ((0, _jquery.default)(window).width() > mobileWidth) {
        if ($moreFromPewSlider.hasClass('slick-initialized')) {
          $moreFromPewSlider.slick('unslick');
        }

        return;
      }

      if (!$moreFromPewSlider.hasClass('slick-initialized')) {
        return $moreFromPewSlider.slick(sliderSettings);
      }
    });
  }
});

},{"./custom-vendor/slick-carousel/slick/slick":51,"jquery":"jquery"}],21:[function(require,module,exports){
"use strict";

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery.default)(document).ready(function () {
  // (function(i,s,o,g,r,a,m){
  //   i["GoogleAnalyticsObject"]=r;i[r]=i[r]||function(){
  //     (i[r].q=i[r].q||[]).push(arguments);
  //   },i[r].l=1*new Date();a=s.createElement(o),
  //   m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m);
  // })(window,document,"script","https://www.google-analytics.com/analytics.js","ga");
  var gaParams = function gaParams() {
    // querySelectorAll Polyfill
    if (!document.querySelectorAll) {
      var d = document,
          s = d.createStyleSheet();

      d.querySelectorAll = function (r, c, i, j, a) {
        a = d.all, c = [], r = r.replace(/\[for\b/gi, "[htmlFor").split(",");

        for (i = r.length; i--;) {
          s.addRule(r[i], "k:v");

          for (j = a.length; j--;) {
            a[j].currentStyle.k && c.push(a[j]);
          }

          s.removeRule(0);
        }

        return c;
      };
    } // Trim polyfill
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Compatibility


    if (!String.prototype.trim) {
      String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, "");
      };
    } // FF doesn't support innerHTML, so use textContent instead
    // Don't default to textContent due to possible performance issues in IE10+
    // http://bugs.jquery.com/ticket/11153#comment:6


    function getText(el) {
      if ("innerText" in document.body) {
        return el.innerText.trim();
      } else {
        return el.textContent.trim();
      }
    } // Get meta tag value


    function metaTag(name) {
      var $meta = document.querySelectorAll('meta[name="' + name + '"]');

      if ($meta.length) {
        return $meta[0].getAttribute("content");
      }
    } // Engagement Options


    var engagementOptions = [];
    var hasDownload = document.querySelectorAll(".pct-download").length ? engagementOptions.push("Download") : false;
    var hasExpandMore = document.querySelectorAll(".pct-expand-more").length ? engagementOptions.push("More Toggle") : false;
    var hasYouTube = document.querySelectorAll("iframe[src*=youtube]").length ? engagementOptions.push("YouTube") : false;
    engagementOptions = engagementOptions.length ? engagementOptions.join(", ") : "(not set)";
    var contentWrapper = document.querySelectorAll(".js-main-primary").length ? document.querySelectorAll(".js-main-primary") : document.querySelectorAll(".main-primary").length ? document.querySelectorAll(".main-primary") : document.querySelectorAll(".main-content"); // Word Count

    var wordCount = contentWrapper.length ? getText(contentWrapper[0]).split(" ").length : "(not set)"; //Word Count Group
    // var wordCountGroup;
    // var wordGroup1Max = {wordGroup1Count};
    // var wordGroup2Max = {wordGroup2Count};
    // var wordGroup3Max = {wordGroup3Count};
    // var wordGroup4Max = {wordGroup4Count};
    // var wordGroup5Max = {wordGroup5Count};
    // var wordGroup6Max = {wordGroup6Count};
    // if(wordCount <= wordGroup1Max){
    //   wordCountGroup = "0 - " + wordGroup1Max;
    // }
    // else if(wordCount > wordGroup1Max && wordCount <= wordGroup2Max){
    //   wordGroup1Max = wordGroup1Max + 1;
    //   wordCountGroup = wordGroup1Max + " - " + wordGroup2Max;
    // }
    // else if(wordCount > wordGroup2Max && wordCount <= wordGroup3Max){
    //   wordGroup2Max = wordGroup2Max + 1;
    //   wordCountGroup = wordGroup2Max + " - " + wordGroup3Max;
    // }
    // else if(wordCount > wordGroup3Max && wordCount <= wordGroup4Max){
    //   wordGroup3Max = wordGroup3Max + 1;
    //   wordCountGroup = wordGroup3Max + " - " + wordGroup4Max;
    // }
    // else if(wordCount > wordGroup4Max && wordCount <= wordGroup5Max){
    //   wordGroup4Max = wordGroup4Max + 1;
    //   wordCountGroup = wordGroup4Max + " - " + wordGroup5Max;
    // }
    // else if(wordCount > wordGroup5Max && wordCount <= wordGroup6Max){
    //   wordGroup5Max = wordGroup5Max + 1;
    //   wordCountGroup = wordGroup5Max + " - " + wordGroup6Max;
    // }
    // else if(wordCount > wordGroup6Max){
    //   wordGroup6Max = wordGroup6Max + 1;
    //   wordCountGroup = wordGroup6Max + " + ";
    // }
    // else{
    //   wordCountGroup = "Not Defined";
    // }
    // Image Count

    var imgCount = contentWrapper.length ? contentWrapper[0].querySelectorAll("img").length : "(not set)"; //Image Count Group

    var imgCountGroup;

    if (imgCount == 0) {
      imgCountGroup = "0";
    } else if (imgCount == 1) {
      imgCountGroup = "1";
    } else if (imgCount == 2) {
      imgCountGroup = "2";
    } else if (imgCount == 3) {
      imgCountGroup = "3";
    } else if (imgCount == 4) {
      imgCountGroup = "4";
    } else if (imgCount == 5) {
      imgCountGroup = "5";
    } else if (imgCount == 6) {
      imgCountGroup = "6";
    } else if (imgCount == 7) {
      imgCountGroup = "7";
    } else if (imgCount == 8) {
      imgCountGroup = "8";
    } else if (imgCount == 9) {
      imgCountGroup = "9";
    } else if (imgCount > 9) {
      imgCountGroup = "10+";
    } else {
      imgCountGroup = "Not Defined";
    }

    window.dataLayer.push({
      "event": "pageVarPush",
      "engagementOptions": engagementOptions,
      "wordCount": wordCount,
      // "wordCountGroup":wordCountGroup,
      "imgCount": imgCount,
      "imgCountGroup": imgCountGroup
    });
  }; //Send data to GTM


  gaParams();
});

},{"jquery":"jquery"}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadMode = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ReadMode = /*#__PURE__*/function () {
  function ReadMode($el) {
    _classCallCheck(this, ReadMode);

    this.$el = $el;
    this.bindEvents();
  }

  _createClass(ReadMode, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$el.on('click', function (event) {
        return _this.toggleActive(event);
      });
    }
  }, {
    key: "toggleActive",
    value: function toggleActive(event) {
      event.stopPropagation();
      var checkbox = (0, _jquery.default)(event.target);

      if (checkbox.is(":checked")) {
        (0, _jquery.default)('.container--70-30').addClass("container--70-30--readmode");
      } else {
        (0, _jquery.default)('.container--70-30').removeClass("container--70-30--readmode");
      }
    }
  }]);

  return ReadMode;
}();

exports.ReadMode = ReadMode;

},{"jquery":"jquery"}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadingTime = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

require("./custom-vendor/readingTime");

var _xDB = require("./xDB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

window.$ = _jquery.default;

var ReadingTime = /*#__PURE__*/function () {
  function ReadingTime($el) {
    _classCallCheck(this, ReadingTime);

    this.$el = $el;
    this.$readTime = (0, _jquery.default)(".read-time");
    this.$el.readingTime(this.readingTimeDefaults());
  }

  _createClass(ReadingTime, [{
    key: "readingTimeDefaults",
    value: function readingTimeDefaults() {
      var _this = this;

      return {
        readingTimeTarget: this.$readTime,
        error: function error(message) {
          _this.$readTime.parent().remove();
        },
        success: function success(data) {
          var time = _this.$readTime.text().replace(/\D/g, '') * 60000 * 0.75;

          if (time > 0 && (typeof dataLayer === "undefined" ? "undefined" : _typeof(dataLayer)) !== undefined) {
            setTimeout(function () {
              // register read time goal
              var eventId = (0, _jquery.default)(".xdbpe-read-time").attr("data-xdbpe");

              if (_xDB.scrollPercent >= 75) {
                (0, _xDB.registerEvent)(eventId);
              }

              dataLayer.push({
                'event': 'pageRead'
              });
            }, time);
          }
        }
      };
    }
  }]);

  return ReadingTime;
}();

exports.ReadingTime = ReadingTime;

},{"./custom-vendor/readingTime":49,"./xDB":116,"jquery":"jquery"}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RssListing = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RssListing = /*#__PURE__*/function () {
  function RssListing($el) {
    _classCallCheck(this, RssListing);

    this.$el = $el;
    this.bindEvents();
  }

  _createClass(RssListing, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$el.find('.js-rss-topics-tab').on('click', function (event) {
        return _this.showList(event, true);
      });
      this.$el.find('.js-rss-projects-tab').on('click', function (event) {
        return _this.showList(event, false);
      });
      this.$el.find('.js-rss-item').on('click', function (event) {
        return _this.showDetails(event);
      });
    }
  }, {
    key: "showList",
    value: function showList(event, isTopics) {
      this.$el.find('.rss-active').removeClass('rss-active');

      if (isTopics) {
        this.$el.find('.rss-listing__topics-list').addClass('rss-active');
        this.$el.find('.rss-listing__topics-tab').addClass('rss-active');
      } else {
        this.$el.find('.rss-listing__projects-list').addClass('rss-active');
        this.$el.find('.rss-listing__projects-tab').addClass('rss-active');
      }
    }
  }, {
    key: "showDetails",
    value: function showDetails(event) {
      var $item = (0, _jquery.default)(event.target);
      var identifier = $item.parent().attr('js-rss-index');
      var $details = (0, _jquery.default)('div[js-rss-index=' + identifier + ']');
      $details.each(function (index) {
        if ((0, _jquery.default)(this).hasClass('js-rss-expanded')) {
          (0, _jquery.default)(this).removeClass('js-rss-expanded');
        } else {
          (0, _jquery.default)(this).addClass('js-rss-expanded');
        }
      });
    }
  }]);

  return RssListing;
}();

exports.RssListing = RssListing;

},{"jquery":"jquery"}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScholarGrid = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

require("selectize");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ScholarGrid = /*#__PURE__*/function () {
  function ScholarGrid($el) {
    _classCallCheck(this, ScholarGrid);

    this.$el = $el;
    this.$dropdown = $el.find(".js-year-select");
    this.$dropdownArrow = $el.find(".js-select-icon");
    this.$tileMount = $el.find(".js-grid-mount");
    this.searchId = this.$el.data("id");
    this.searchUrl = this.$el.data("url");
    this.initDropdown();
    this.fetchData();
  }

  _createClass(ScholarGrid, [{
    key: "initDropdown",
    value: function initDropdown() {
      var _this = this;

      this.$dropdown.selectize({
        onDropdownOpen: function onDropdownOpen() {
          return _this.$dropdownArrow.addClass("is-open");
        },
        onDropdownClose: function onDropdownClose() {
          return _this.$dropdownArrow.removeClass("is-open");
        }
      });
      this.$dropdown.on("change", function () {
        _this.fetchData();
      });
      this.$dropdownArrow.on("mousedown", function () {
        var selectizeInstance = _this.$dropdown[0].selectize;
        _this.$dropdownArrow.hasClass("is-open") ? selectizeInstance.close() : selectizeInstance.open();
      });
    }
  }, {
    key: "currentYear",
    value: function currentYear() {
      return this.$dropdown.val();
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;

      var url = "".concat(this.searchUrl, "?root=").concat(this.searchId, "&year=").concat(this.currentYear());

      _jquery.default.ajax({
        url: url,
        method: "GET"
      }).then(function (response) {
        return _this2.renderTiles(response);
      });
    }
  }, {
    key: "renderTiles",
    value: function renderTiles(tileData) {
      var _this3 = this;

      var tiles = tileData.map(function (tileModel) {
        return _this3.makeTile(tileModel);
      }); // compact the array, removing falsey values, before rendering

      var tilesToRender = tiles.filter(function (t) {
        return t;
      });
      this.$tileMount.empty().append(tilesToRender);
      this.$tileMount.find(".scholar-grid__tile").animate({
        opacity: 1
      }, 200);
    }
  }, {
    key: "makeTile",
    value: function makeTile(model) {
      var fellowship_Institution = model.fellowship_Institution,
          fellowship_Job_Title = model.fellowship_Job_Title,
          full_Name = model.full_Name,
          imageAlt = model.imageAlt,
          imageUrl = model.imageUrl,
          itemUrl = model.itemUrl; // if image is missing, do not make a tile

      if (!imageUrl || imageUrl.trim().length === 0) {
        return null;
      }

      var $tile = (0, _jquery.default)("\n      <li class=\"scholar-grid__tile\" style=\"opacity: 0\">\n        <a href=\"".concat(itemUrl, "\">\n          <figure>\n            <img src=\"").concat(imageUrl, "\" alt=\"").concat(imageAlt, "\"/>\n            <figcaption>\n              <span class=\"scholar-grid__name\">").concat(full_Name, "</span>\n              <span class=\"scholar-grid__position\">").concat(fellowship_Job_Title, "</span>\n              <span class=\"scholar-grid__institution\">").concat(fellowship_Institution, "</span>\n            </figcaption>\n          </figure>\n        </a>\n      </li>\n    ")); // hide certain fields if no data present

      if (!full_Name || full_Name.trim().length === 0) {
        $tile.find(".scholar-grid__name").remove();
      }

      if (!fellowship_Job_Title || fellowship_Job_Title.trim().length === 0) {
        $tile.find(".scholar-grid__position").remove();
      }

      if (!fellowship_Institution || fellowship_Institution.trim().length === 0) {
        $tile.find(".scholar-grid__institution").remove();
      }

      return $tile;
    }
  }]);

  return ScholarGrid;
}();

exports.ScholarGrid = ScholarGrid;

},{"jquery":"jquery","selectize":"selectize"}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  document.querySelectorAll(".js-scroll-animation").forEach(function (targetEl) {
    // check when target element enters viewport from bottom
    var enterPageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          entry.target.classList.contains("js-fade-in-scroll") && entry.target.classList.add("fade-into-view");
          entry.target.classList.contains("js-slide-in-scroll") && entry.target.classList.add("slide-into-view");
        }
      });
    }, {
      root: null,
      rootMargin: "0px 0px -200px 0px"
    });
    enterPageObserver.observe(targetEl);
  });
};

exports.default = _default;

},{}],27:[function(require,module,exports){
"use strict";

var _jquery = _interopRequireDefault(require("jquery"));

require("./custom-vendor/selection-shrarer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import require from "./custom-vendor/require";
(0, _jquery.default)('.js-selection-sharer').selectionSharer();

},{"./custom-vendor/selection-shrarer":50,"jquery":"jquery"}],28:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareBar = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var Stickyfill = _interopRequireWildcard(require("./stickyfill.js"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ShareBar = /*#__PURE__*/function () {
  function ShareBar($el) {
    _classCallCheck(this, ShareBar);

    this.$el = $el;
    this.container = this.$el.closest(".container__inner");
    this.insertClone();
  }

  _createClass(ShareBar, [{
    key: "refreshPosition_absolute",
    value: function refreshPosition_absolute(event) {
      this.headerHeight = (0, _jquery.default)(".global-header__inner-wrapper").first().outerHeight(true);
      var windowPosition = (0, _jquery.default)(window).scrollTop();
      var maxTop = this.containerBottom - this.$el.outerHeight();

      if (windowPosition + this.headerHeight > this.containerTop) {
        if (windowPosition - this.containerTop + this.headerHeight < maxTop) {
          this.$el.css({
            top: windowPosition - this.containerTop + this.headerHeight + "px"
          });
        } else {
          this.$el.css({
            top: maxTop + "px"
          });
        }
      }
    }
  }, {
    key: "refreshPosition_sticky",
    value: function refreshPosition_sticky(event) {
      var windowPosition = (0, _jquery.default)(window).scrollTop() + 85;

      if (windowPosition > this.barStart) {
        if (!this.$el.hasClass("is-sticky")) {
          this.$el.addClass("is-sticky");
          Stickyfill.addOne(this.$el);
        }
      } else {
        this.$el.removeClass("is-sticky");
        Stickyfill.removeOne(this.$el);
      }

      Stickyfill.refreshAll();
    }
  }, {
    key: "insertClone",
    value: function insertClone() {
      if (this.$el.hasClass("plf-share-bar--btm-only")) {
        return;
      }

      var clone = this.$el.clone();
      clone.addClass("plf-share-bar--clone");
      this.container.prepend(clone);
    }
  }]);

  return ShareBar;
}();

exports.ShareBar = ShareBar;

},{"./stickyfill.js":115,"jquery":"jquery"}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareButton = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ShareButton = /*#__PURE__*/function () {
  function ShareButton($el) {
    _classCallCheck(this, ShareButton);

    this.$el = $el;
    this.$openBtn = this.$el.find(".js-share-open");
    this.$closeBtn = this.$el.find(".js-share-close");
    this.$menu = this.$el.find(".js-share-menu");
    this.$parent = this.$el.parent(); // The share component should always be a direct child of the shareable component

    this.$sibling = this.$el.siblings(); //this.$minHeight = window.innerWidth > 768 ? "200px" : "300px";

    this.bindEvents();
  }

  _createClass(ShareButton, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$parent.css("transition", "min-height 0.3s linear");
      this.$openBtn.on("click", function (event) {
        return _this.openMenu(event);
      });
      this.$closeBtn.on("click", function (event) {
        return _this.closeMenu(event);
      }); //$(window).on("resize", () => this.$minHeight = window.innerWidth > 768 ? "200px" : "300px");
    }
  }, {
    key: "openMenu",
    value: function openMenu() {
      this.$menu.addClass("is-open");
      this.$sibling.css("visibility", "hidden");
      this.$openBtn.css("visibility", "hidden");
      this.$closeBtn.focus();
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      this.$menu.removeClass("is-open");
      this.$sibling.css("visibility", "visible");
      this.$openBtn.css("visibility", "visible");
      this.$openBtn.focus();
    }
  }]);

  return ShareButton;
}();

exports.ShareButton = ShareButton;

},{"jquery":"jquery"}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

require("../Pew/custom-vendor/slick-carousel/slick/slick");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Slider = /*#__PURE__*/function () {
  function Slider($el, useDefaults, conf) {
    _classCallCheck(this, Slider);

    this.$el = $el;
    var slickConf;

    if (useDefaults) {
      slickConf = Object.assign(this.slickDefaults(), conf.slick);
    } else {
      slickConf = conf.slick;
    } // bind event prior to slick init


    this.bindEvents(this.$el);
    this.$el.slick(slickConf);
    this.$el.hasClass("fact-slider") ? this.$el.css("visibility", "visible") : null;
  }

  _createClass(Slider, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      // bind an event on the arrows to de-focus them when
      // you mouse out, so the focus state doesn't get stuck
      this.$el.on("mouseleave", ".slick-next, .slick-prev", function (event) {
        event.currentTarget.blur();
      });
      (0, _jquery.default)(window).on("resize", function (event) {
        _this.$el.slick("resize");
      });
    }
  }, {
    key: "slickDefaults",
    value: function slickDefaults() {
      return {
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        arrows: true,
        dots: true,
        infinite: false,
        responsive: [{
          breakpoint: 470,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true
          }
        }, {
          breakpoint: 911,
          settings: "unslick"
        }]
      };
    }
  }]);

  return Slider;
}();

exports.Slider = Slider;

},{"../Pew/custom-vendor/slick-carousel/slick/slick":51,"jquery":"jquery"}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sticky30 = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Sticky30 = /*#__PURE__*/function () {
  function Sticky30($el) {
    _classCallCheck(this, Sticky30);

    this.$el = $el;
    this.init();
  }

  _createClass(Sticky30, [{
    key: "init",
    value: function init() {
      var sticky30Inner = this.$el.find(".container__inner");
      var globalHeaderHeight = (0, _jquery.default)(".global-header").outerHeight();
      var pageToolbar = (0, _jquery.default)(".page-toolbar");

      if (pageToolbar.length) {
        sticky30Inner.css("top", "".concat(globalHeaderHeight + pageToolbar.outerHeight() + 10, "px"));
      }
    }
  }]);

  return Sticky30;
}();

exports.Sticky30 = Sticky30;

},{"jquery":"jquery"}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toolbar = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Toolbar = /*#__PURE__*/function () {
  function Toolbar($el) {
    _classCallCheck(this, Toolbar);

    this.$el = $el;
    this.bindEvents();
  }

  _createClass(Toolbar, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$el.on('click mouseover', function (event) {
        return _this.toggleActive(event);
      }); // Add a document click handler to detect clicks
      // with the intent to dismiss navigation

      (0, _jquery.default)(document).on('click', function (event) {
        return _this.onOtherClick(event);
      });
      (0, _jquery.default)('.toolbar-callout').on('mouseleave', function (event) {
        return _this.onOtherClick(event);
      });
    }
  }, {
    key: "removeActive",
    value: function removeActive() {
      (0, _jquery.default)('.page-toolbar__selector').removeClass('page-toolbar__selector--active');
      (0, _jquery.default)('.toolbar-callout').removeClass('toolbar-callout--active');
    }
  }, {
    key: "toggleActive",
    value: function toggleActive(event) {
      event.stopPropagation();
      var toolbarSelector = this.getSelector(event.target);
      var callout = (0, _jquery.default)(toolbarSelector).find('.toolbar-callout');

      if ((0, _jquery.default)(toolbarSelector).hasClass('page-toolbar__selector--active') && event.type !== 'mouseover') {
        this.removeActive();
      } else {
        (0, _jquery.default)('.toolbar-callout--active').removeClass('toolbar-callout--active');
        (0, _jquery.default)('.page-toolbar__selector--active').removeClass('page-toolbar__selector--active');
        (0, _jquery.default)(toolbarSelector).addClass('page-toolbar__selector--active');
        callout.addClass('toolbar-callout--active');
      }
    }
  }, {
    key: "onOtherClick",
    value: function onOtherClick(event) {
      this.removeActive();
    }
  }, {
    key: "getSelector",
    value: function getSelector(target) {
      if ((0, _jquery.default)(target).hasClass('page-toolbar__selector')) {
        return target;
      } else {
        var parent = (0, _jquery.default)(target).parents('.page-toolbar__selector');

        if (parent) {
          return parent;
        } else {
          this.getSelector((0, _jquery.default)(target).parent());
        }
      }
    }
  }]);

  return Toolbar;
}();

exports.Toolbar = Toolbar;

},{"jquery":"jquery"}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTypeahead = initTypeahead;

var _jquery = _interopRequireDefault(require("jquery"));

var _lodash = _interopRequireDefault(require("lodash"));

var _breakpoint = require("./breakpoint");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * PCTDR-179 - Interim Typeahead Search
 * @param {node} el - either desktop or mobile search
 */
function initTypeahead(el) {
  var _el$closest, _el$closest2, _el$closest2$dataset;

  var searchInput = el;
  var quickSearchBox = (_el$closest = el.closest('.quick-search-box')) !== null && _el$closest !== void 0 ? _el$closest : el.closest('.search-box__input'); // Parent el

  var closeButtonEl = quickSearchBox === null || quickSearchBox === void 0 ? void 0 : quickSearchBox.querySelector('.js-quick-search-clear-and-close');
  var searchForm = el.closest('form');
  var searchForLabel = (el === null || el === void 0 ? void 0 : (_el$closest2 = el.closest("[data-search-for-label]")) === null || _el$closest2 === void 0 ? void 0 : (_el$closest2$dataset = _el$closest2.dataset) === null || _el$closest2$dataset === void 0 ? void 0 : _el$closest2$dataset.searchForLabel) || "Search for:"; // Track combo-box active item

  var activeIndex = -1;

  var init = function init() {
    searchInput.setAttribute('role', 'combobox');
    searchInput.setAttribute('aria-haspopup', 'listbox'); // The list of options is announced to screen reader users

    var srText = document.createElement("span");
    srText.classList.add('search-box__sr-only');
    srText.setAttribute('aria-live', 'polite');
    srText.setAttribute('aria-atomic', true);
    quickSearchBox === null || quickSearchBox === void 0 ? void 0 : quickSearchBox.append(srText);
    bindEvents();
  };

  var bindEvents = function bindEvents() {
    searchInput.addEventListener('focus', handleOpen);
    searchInput.addEventListener('click', handleOpen);
    searchInput.addEventListener('input', function (e) {
      closeSuggestions();
      handleType(e);
    });
    window.addEventListener('click', handleClickAway);
    quickSearchBox === null || quickSearchBox === void 0 ? void 0 : quickSearchBox.addEventListener('keydown', handleKeyboard);
    closeButtonEl === null || closeButtonEl === void 0 ? void 0 : closeButtonEl.addEventListener('click', clear);
    searchForm === null || searchForm === void 0 ? void 0 : searchForm.addEventListener('submit', closeSuggestions);
  };

  var handleClickItem = function handleClickItem(e) {
    e.preventDefault();
    searchInput.value = e.target.innerText;
    closeSuggestions();
    searchInput.setSelectionRange(0, 0);

    if (searchForm.classList.contains("quick-search-box")) {
      searchForm.submit();
    } else {
      // Fire react search
      searchForm.dispatchEvent(new Event("submit", {
        cancelable: true
      }));
    }
  };

  var handleClickAway = function handleClickAway(e) {
    if (quickSearchBox.classList.contains("is-active") && e.target !== quickSearchBox && !quickSearchBox.contains(e.target)) {
      var _document$querySelect;

      closeSuggestions();
      quickSearchBox === null || quickSearchBox === void 0 ? void 0 : quickSearchBox.classList.remove("is-active");
      (_document$querySelect = document.querySelector(".global-header")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.remove("search-is-open"); // for smartphone widths        
    }
  }; // Expand search field


  var handleOpen = function handleOpen() {
    quickSearchBox === null || quickSearchBox === void 0 ? void 0 : quickSearchBox.classList.add("is-active");
    var primaryNav = document.querySelector(".primary-nav");
    primaryNav === null || primaryNav === void 0 ? void 0 : primaryNav.classList.remove("is-open");
    primaryNav === null || primaryNav === void 0 ? void 0 : primaryNav.setAttribute("aria-expanded", false);
    setTimeout(function () {
      return searchInput.focus();
    });

    if ((0, _breakpoint.breakpoint)() !== "large") {
      (0, _jquery.default)(".js-menu").hide();
    }
  };

  var clear = function clear() {
    searchInput.value = "";
    closeSuggestions();
    searchInput.focus();
  }; // Reset previous result(s)


  var closeSuggestions = function closeSuggestions() {
    var srText = quickSearchBox === null || quickSearchBox === void 0 ? void 0 : quickSearchBox.querySelector('.search-box__sr-only');
    var suggestionEl = quickSearchBox === null || quickSearchBox === void 0 ? void 0 : quickSearchBox.querySelector('.search-box__suggestion-box');
    srText.innerHTML = '';
    suggestionEl === null || suggestionEl === void 0 ? void 0 : suggestionEl.remove();
    activeIndex = -1;
    searchInput.setAttribute('aria-expanded', false);
    searchInput.setAttribute('aria-activedescendant', '');
  };

  var handleType = _lodash.default.debounce( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var input, response, data, suggestionBox, strRegExp;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              input = e.target.value;

              if (!((input === null || input === void 0 ? void 0 : input.length) >= 3)) {
                _context.next = 12;
                break;
              }

              _context.next = 4;
              return fetch("".concat(window.location.origin, "/api/SearchSuggestApi/GetSuggestions?term=").concat(input, "&url=").concat(window.location.origin), {
                method: "get"
              });

            case 4:
              response = _context.sent;
              _context.next = 7;
              return response.json();

            case 7:
              data = _context.sent;
              suggestionBox = document.createElement('div');
              suggestionBox.classList.add('search-box__suggestion-box');
              strRegExp = new RegExp(input, 'gi');

              if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
                // Build suggestion list
                suggestionBox.innerHTML = "\n            <div class=\"search-box__suggestion-item search-box__user-input\">\n              <span class=\"search-box__suggestion-label\">".concat(searchForLabel, ":</span>\n              <button class=\"search-box__suggestion\" id=\"quick-search-item-0\">").concat(input.replace(strRegExp, function (match) {
                  return "<strong class=\"search-box__matched-text\">".concat(match, "</strong>");
                }), "</button>\n            </div>\n            <ul class=\"search-box__suggestion-list\" role=\"listbox\">\n              ").concat(data === null || data === void 0 ? void 0 : data.map(function (d, index) {
                  return "\n                <li class=\"search-box__suggestion-item\" role=\"option\" id=\"quick-search-item-".concat(index + 1, "\">\n                  <button class=\"search-box__suggestion\" type=\"button\">\n                    ").concat(d.replace(strRegExp, function (match) {
                    return "<strong class=\"search-box__matched-text\">".concat(match, "</strong>");
                  }), "\n                  </button>\n                </li>\n              ");
                }).join(""), "\n            </ul>\n          ");
                quickSearchBox === null || quickSearchBox === void 0 ? void 0 : quickSearchBox.append(suggestionBox);

                _toConsumableArray(quickSearchBox.querySelectorAll(".search-box__suggestion")).forEach(function (suggestion) {
                  suggestion.addEventListener('click', handleClickItem);
                });

                searchInput.setAttribute('aria-expanded', true); // Populate live announcement with result text

                setTimeout(function () {
                  var srText = quickSearchBox === null || quickSearchBox === void 0 ? void 0 : quickSearchBox.querySelector('.search-box__sr-only');

                  if (srText) {
                    srText.innerHTML = "There are currently ".concat(data === null || data === void 0 ? void 0 : data.length, " options starting with ").concat(input, ". Press down arrow for options");
                  }
                }, 1200);
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), 500);

  var handleKeyboard = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
      var prevActiveIndex, suggestions, suggestionEl, prevActive, activeItem;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              prevActiveIndex = activeIndex;
              suggestions = quickSearchBox === null || quickSearchBox === void 0 ? void 0 : quickSearchBox.querySelectorAll('.search-box__suggestion');
              suggestionEl = quickSearchBox === null || quickSearchBox === void 0 ? void 0 : quickSearchBox.querySelector('.search-box__suggestion-box');

              if (suggestionEl) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              suggestions === null || suggestions === void 0 ? void 0 : suggestions.forEach(function (el) {
                return el.setAttribute('aria-selected', false);
              });
              _context2.t0 = e.key;
              _context2.next = _context2.t0 === "ArrowDown" ? 9 : _context2.t0 === 'ArrowUp' ? 12 : _context2.t0 === 'Escape' ? 15 : _context2.t0 === 'Enter' ? 18 : 20;
              break;

            case 9:
              e.preventDefault();

              if (activeIndex === -1 || activeIndex >= (suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) - 1) {
                activeIndex = 0;
              } else {
                activeIndex++;
              }

              return _context2.abrupt("break", 20);

            case 12:
              e.preventDefault();

              if (activeIndex <= 0) {
                activeIndex = (suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) - 1;
              } else {
                activeIndex--;
              }

              return _context2.abrupt("break", 20);

            case 15:
              closeSuggestions();
              searchInput.focus();
              return _context2.abrupt("break", 20);

            case 18:
              closeSuggestions();
              return _context2.abrupt("break", 20);

            case 20:
              prevActive = quickSearchBox.querySelector("#quick-search-item-".concat(prevActiveIndex));
              activeItem = quickSearchBox.querySelector("#quick-search-item-".concat(activeIndex));

              if (prevActive) {
                prevActive.classList.remove('selected');
                prevActive.setAttribute('aria-selected', 'false');
              }

              if (activeItem) {
                activeItem.setAttribute('aria-selected', true);
                activeItem.classList.add('selected');
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.setAttribute('aria-activedescendant', "quick-search-item-".concat(activeIndex));
                searchInput.value = activeItem.innerText;
              } else {
                searchInput.setAttribute('aria-activedescendant', '');
              }

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleKeyboard(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  init();
}

},{"./breakpoint":48,"jquery":"jquery","lodash":"lodash"}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoModal = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var VideoModal = /*#__PURE__*/function () {
  function VideoModal($el) {
    _classCallCheck(this, VideoModal);

    this.$el = $el;
    this.$body = (0, _jquery.default)("body");
    this.$videoWrapper = $el.find((0, _jquery.default)(".video-block__media-wrapper"));
    this.$iframe = this.$videoWrapper.find("iframe");
    this.$placeholderWrapper = this.$el.find(".video-block__media-placeholder-wrapper");
    this.$modalWrapper = (0, _jquery.default)("<div>", {
      "class": "video-block__modal-wrapper js-selection-sharer"
    });
    this.$modalWrapper.appendTo(this.$body);
    this.$modalWrapper.append(this.$el.clone());
    this.$modalIframe = this.$modalWrapper.find("iframe");
    this.init();
    this.bindEvents();
  }

  _createClass(VideoModal, [{
    key: "init",
    value: function init() {}
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$placeholderWrapper.on("click", function (event) {
        return _this.onPlaceholderWrapperClick(event);
      });
      this.$modalWrapper.on("click", function (event) {
        return _this.onModalWrapperClick(event);
      }); // image gallery: pause video when switching to new slide

      window.addEventListener("load", function () {
        _this.$slideArrows = _this.$body.find(".slick-arrow");

        _this.$slideArrows.each(function (i, slideArrow) {
          slideArrow.addEventListener("click", function () {
            _this.pauseVideo(_this.$iframe);
          });
        });
      });
    }
  }, {
    key: "onPlaceholderWrapperClick",
    value: function onPlaceholderWrapperClick(event) {
      if (this.$placeholderWrapper.width() < 649) {
        this.playVideo(this.$modalIframe);
        this.$modalWrapper.addClass("is-active");
      } else {
        this.playVideo(this.$iframe);
        this.$placeholderWrapper.hide();
        this.$videoWrapper.show();
      }
    }
  }, {
    key: "onModalWrapperClick",
    value: function onModalWrapperClick(event) {
      if (event.target === event.currentTarget || (0, _jquery.default)(".js-close-video-modal").find(event.target).length) {
        this.$modalWrapper.removeClass("is-active");
        this.pauseVideo(this.$modalIframe);
      }
    }
  }, {
    key: "playVideo",
    value: function playVideo($iframe) {
      if (this.isYoutubeVideo($iframe)) {
        this.postYoutubeMessage($iframe, "playVideo");
      }
    }
  }, {
    key: "pauseVideo",
    value: function pauseVideo($iframe) {
      if (this.isYoutubeVideo($iframe)) {
        this.postYoutubeMessage($iframe, "pauseVideo");
      }
    }
  }, {
    key: "isYoutubeVideo",
    value: function isYoutubeVideo($iframe) {
      if (!$iframe || !$iframe.length) {
        return false;
      }

      var videoSrc = $iframe.attr("src");
      return videoSrc && videoSrc.includes("youtube");
    }
  }, {
    key: "postYoutubeMessage",
    value: function postYoutubeMessage($iframe, func) {
      if (!$iframe || !$iframe.length || !func || !func.length) {
        return;
      }

      var messageObject = {
        event: "command",
        func: func,
        args: ""
      };
      $iframe[0].contentWindow.postMessage(JSON.stringify(messageObject), "*");
    }
  }]);

  return VideoModal;
}();

exports.VideoModal = VideoModal;

},{"jquery":"jquery"}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewAllExpand = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ViewAllExpand = /*#__PURE__*/function () {
  function ViewAllExpand($el) {
    _classCallCheck(this, ViewAllExpand);

    this.$el = $el;
    this.$button = $el.find('.js-more');
    this.$expandTarget = $el.find('.js-expand-target');
    this.bindEvents();
  }

  _createClass(ViewAllExpand, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$el.on('click', '.js-more', function (event) {
        return _this.expand(event);
      });
    }
  }, {
    key: "expand",
    value: function expand(event) {
      event.preventDefault();
      this.$expandTarget.slideDown(200).attr('aria-expanded', true);
      this.$button.hide();
    }
  }]);

  return ViewAllExpand;
}();

exports.ViewAllExpand = ViewAllExpand;

},{"jquery":"jquery"}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WhatWeDo = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var WhatWeDo = /*#__PURE__*/function () {
  function WhatWeDo($el) {
    _classCallCheck(this, WhatWeDo);

    this.$el = $el;
    this.bindEvents();
  }

  _createClass(WhatWeDo, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$el.on('click', function (event) {
        return _this.toggleActive(event);
      });
    }
  }, {
    key: "toggleActive",
    value: function toggleActive(event) {
      event.stopPropagation();
      (0, _jquery.default)('.what-we-do__topic-info-wrapper').remove();
      var $topic = (0, _jquery.default)(event.currentTarget); //if clicked topic is currently selected, return it to collapsed state

      if ($topic.hasClass('what-we-do__topic--active')) {
        (0, _jquery.default)('.what-we-do__topic').removeClass('what-we-do__topic--active');
        return;
      }

      var index = $topic.index(); //add bottom border class

      (0, _jquery.default)('.what-we-do__topic').removeClass('what-we-do__topic--active');
      $topic.addClass('what-we-do__topic--active');
      var $mediumWrapper = (0, _jquery.default)('<div>', {
        'class': 'what-we-do__topic-info-wrapper wrapper-medium'
      });
      var $smallWrapper = (0, _jquery.default)('<div>', {
        'class': 'what-we-do__topic-info-wrapper wrapper-small'
      });
      var $largeWrapper = (0, _jquery.default)('<div>', {
        'class': 'what-we-do__topic-info-wrapper wrapper-large'
      });
      var element = null; //place the wrapper for small/mobile display

      if (index < 2) {
        element = (0, _jquery.default)('.what-we-do__topic').get(1);
        (0, _jquery.default)(element).after($smallWrapper);
      } else if (index > 1 && index < 4) {
        element = (0, _jquery.default)('.what-we-do__topic').get(3);
        (0, _jquery.default)(element).after($smallWrapper);
      } else {
        (0, _jquery.default)('.what-we-do').after($smallWrapper);
      } //place the wrapper for medium/tablet display


      if (index < 3) {
        element = (0, _jquery.default)('.what-we-do__topic').get(2);
        (0, _jquery.default)(element).after($mediumWrapper);
      } else {
        (0, _jquery.default)('.what-we-do').after($mediumWrapper);
      } //place the wrapper for large display


      (0, _jquery.default)('.what-we-do').after($largeWrapper);
      (0, _jquery.default)('.what-we-do__topic-info-wrapper').append($topic.children('.what-we-do__topic-info').clone());
    }
  }]);

  return WhatWeDo;
}();

exports.WhatWeDo = WhatWeDo;

},{"jquery":"jquery"}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = void 0;

// Collection Utilities (for a11y)
var toArray = function toArray(arraylike) {
  return Array.prototype.slice.call(arraylike);
};

exports.toArray = toArray;

},{}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.destroyTabTrap = exports.initTabTrap = exports.getLastFocusableChild = exports.getPrevFocusableChild = exports.getNextFocusableChild = exports.getFirstFocusableChild = exports.isVisiblyHidden = exports.focusableQuery = void 0;

var _selectionUtils = require("./selectionUtils.js");

// Focus Utilities (for a11y)
// export const focusableQuery =
//   'input:not([tabindex^="-"]), select:not([tabindex^="-"]), textarea:not([tabindex^="-"]), button:not([tabindex^="-"]), object:not([tabindex^="-"]), [href], [tabindex]:not([tabindex^="-"]):not(.tabtrap)';
var focusableQuery = "input, select, textarea, button, object, [href], [tabindex]:not(.tabtrap)";
exports.focusableQuery = focusableQuery;

var isVisiblyHidden = function isVisiblyHidden(target) {
  var targetStyle = getComputedStyle(target);

  if (targetStyle.clip.indexOf("rect") === -1 && targetStyle.display !== "none" && targetStyle.visibility !== "hidden") {
    return false;
  }

  return true;
};

exports.isVisiblyHidden = isVisiblyHidden;

var getFirstFocusableChild = function getFirstFocusableChild(element) {
  return element.querySelector(focusableQuery);
};

exports.getFirstFocusableChild = getFirstFocusableChild;

var getNextFocusableChild = function getNextFocusableChild(element, current) {
  var all = (0, _selectionUtils.queryAll)(focusableQuery, element);
  var targetReturnIndex = all.indexOf(current) + 1;

  if (targetReturnIndex <= all.length - 1) {
    return all[targetReturnIndex];
  }

  return null;
};

exports.getNextFocusableChild = getNextFocusableChild;

var getPrevFocusableChild = function getPrevFocusableChild(element, current) {
  var all = (0, _selectionUtils.queryAll)(focusableQuery, element);
  var targetReturnIndex = all.indexOf(current) - 1;

  if (targetReturnIndex <= all.length - 1) {
    return all[targetReturnIndex];
  }

  return null;
};

exports.getPrevFocusableChild = getPrevFocusableChild;

var getLastFocusableChild = function getLastFocusableChild(element) {
  var all = element.querySelectorAll(focusableQuery);
  return all[all.length - 1];
};

exports.getLastFocusableChild = getLastFocusableChild;

var initTabTrap = function initTabTrap(element) {
  // The initTabTrap function will trap tab focus inside an element, making sure that you can't accidentally tab to other elements.  Useful for modal windows or other contexts where we want the tab focus to stay inside the element until it is dismissed.
  // "element" in this case means the menu panel div.
  var createTrap = function createTrap() {
    var trap = document.createElement("div");
    trap.classList.add("tabtrap");
    trap.setAttribute("tabindex", "0");
    return trap;
  };

  var applyTraps = function applyTraps(element, firstTrap, lastTrap) {
    firstTrap.addEventListener("focus", function () {
      getLastFocusableChild(element).focus();
    });
    lastTrap.addEventListener("focus", function () {
      getFirstFocusableChild(element).focus();
    });
    element.insertBefore(firstTrap, element.firstChild);
    element.appendChild(lastTrap);
  };

  var firstTrap = createTrap();
  var lastTrap = createTrap();
  applyTraps(element, firstTrap, lastTrap);
};

exports.initTabTrap = initTabTrap;

var destroyTabTrap = function destroyTabTrap(element) {
  // "element" in this case means the menu panel div.
  var traps = element.querySelectorAll("tabtrap");
  Array.from(traps).forEach(function (item) {
    item.removeEventListener("focus");
    item.parentNode.removeChild(item);
  });
};

exports.destroyTabTrap = destroyTabTrap;

},{"./selectionUtils.js":40}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trapEnter = exports.onElementCharacter = exports.isAlphaNumeric = exports.onElementF10 = exports.onElementPageDown = exports.onElementPageUp = exports.onElementEnd = exports.onElementHome = exports.onElementDown = exports.onElementUp = exports.onElementRight = exports.onElementLeft = exports.onElementSpace = exports.onElementEscape = exports.onElementTab = exports.onElementEnter = exports.bindElementToKeydownValue = exports.bindElementToKeypressValue = exports.bindElementToEventValue = exports.KEYS = void 0;
// Keyboard Utilities (for a11y)
var KEYS = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  ESCAPE: 27,
  SPACE: 32,
  LEFT: 37,
  RIGHT: 39,
  UP: 38,
  DOWN: 40,
  F10: 121,
  HOME: 36,
  END: 35,
  PAGE_UP: 33,
  PAGE_DOWN: 34
};
exports.KEYS = KEYS;

var bindElementToEventValue = function bindElementToEventValue(element, eventName, testValue, handler) {
  var localHandler = function localHandler(e) {
    if (e.which === testValue) {
      handler(e);
    }
  };

  element.addEventListener(eventName, localHandler);
  return function () {
    element.removeEventListener(eventName, localHandler);
  };
};

exports.bindElementToEventValue = bindElementToEventValue;

var bindElementToKeypressValue = function bindElementToKeypressValue(element, testValue, handler) {
  return bindElementToEventValue(element, "keypress", testValue, handler);
};

exports.bindElementToKeypressValue = bindElementToKeypressValue;

var bindElementToKeydownValue = function bindElementToKeydownValue(element, testValue, handler) {
  return bindElementToEventValue(element, "keydown", testValue, handler);
};

exports.bindElementToKeydownValue = bindElementToKeydownValue;

var onElementEnter = function onElementEnter(element, handler) {
  return bindElementToKeypressValue(element, KEYS.ENTER, handler);
};

exports.onElementEnter = onElementEnter;

var onElementTab = function onElementTab(element, handler) {
  return bindElementToKeydownValue(element, KEYS.TAB, handler);
};

exports.onElementTab = onElementTab;

var onElementEscape = function onElementEscape(element, handler) {
  return bindElementToKeydownValue(element, KEYS.ESCAPE, handler);
};

exports.onElementEscape = onElementEscape;

var onElementSpace = function onElementSpace(element, handler) {
  return bindElementToKeypressValue(element, KEYS.SPACE, handler);
};

exports.onElementSpace = onElementSpace;

var onElementLeft = function onElementLeft(element, handler) {
  return bindElementToKeydownValue(element, KEYS.LEFT, handler);
};

exports.onElementLeft = onElementLeft;

var onElementRight = function onElementRight(element, handler) {
  return bindElementToKeydownValue(element, KEYS.RIGHT, handler);
};

exports.onElementRight = onElementRight;

var onElementUp = function onElementUp(element, handler) {
  return bindElementToKeydownValue(element, KEYS.UP, handler);
};

exports.onElementUp = onElementUp;

var onElementDown = function onElementDown(element, handler) {
  return bindElementToKeydownValue(element, KEYS.DOWN, handler);
};

exports.onElementDown = onElementDown;

var onElementHome = function onElementHome(element, handler) {
  return bindElementToKeydownValue(element, KEYS.HOME, handler);
};

exports.onElementHome = onElementHome;

var onElementEnd = function onElementEnd(element, handler) {
  return bindElementToKeydownValue(element, KEYS.END, handler);
};

exports.onElementEnd = onElementEnd;

var onElementPageUp = function onElementPageUp(element, handler) {
  return bindElementToKeydownValue(element, KEYS.PAGE_UP, handler);
};

exports.onElementPageUp = onElementPageUp;

var onElementPageDown = function onElementPageDown(element, handler) {
  return bindElementToKeydownValue(element, KEYS.PAGE_DOWN, handler);
};

exports.onElementPageDown = onElementPageDown;

var onElementF10 = function onElementF10(element, handler) {
  return bindElementToKeydownValue(element, KEYS.F10, handler);
};

exports.onElementF10 = onElementF10;

var isAlphaNumeric = function isAlphaNumeric(charCode) {
  return charCode >= 48 && charCode <= 90 || charCode >= 97 && charCode <= 122
  /* lowercase letters */
  ;
};

exports.isAlphaNumeric = isAlphaNumeric;

var onElementCharacter = function onElementCharacter(element, handler) {
  var localHandler = function localHandler(e) {
    var charCode = e.which;

    if (isAlphaNumeric(charCode)) {
      handler(e);
    }
  };

  element.addEventListener("keypress", localHandler);
  return function () {
    element.removeEventListener("keypress", localHandler);
  };
}; // To stop the Enter key from doing something


exports.onElementCharacter = onElementCharacter;

var trapEnter = function trapEnter(element) {
  onElementEnter(element, function (e) {
    e.stopPropagation();
    e.preventDefault();
  });
};

exports.trapEnter = trapEnter;

},{}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryAll = void 0;

var _collectionUtils = require("./collectionUtils.js");

// Selection Utilities (for a11y)
var queryAll = function queryAll(selector, context) {
  context = context || document;
  return (0, _collectionUtils.toArray)(context.querySelectorAll(selector));
};

exports.queryAll = queryAll;

},{"./collectionUtils.js":37}],41:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BlogItem = _interopRequireWildcard(require("./BlogItem.jsx"));

var _Pagination = _interopRequireDefault(require("../../search/components/Pagination.jsx"));

var _SearchStatus = _interopRequireDefault(require("../../search/components/SearchStatus.jsx"));

var _paging = require("../../search/paging");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var BlogContentList = function BlogContentList(_ref) {
  var title = _ref.title,
      results = _ref.results,
      totalResults = _ref.totalResults,
      query = _ref.query,
      nextPage = _ref.nextPage,
      viewAllUrl = _ref.viewAllUrl,
      loading = _ref.loading,
      token = _ref.token,
      dictionary = _ref.dictionary,
      isFirstLoad = _ref.isFirstLoad,
      displayDates = _ref.displayDates,
      pagination = _ref.pagination,
      gotoPage = _ref.gotoPage;
  var dictionaryBindings = {};

  function dictEntryFor(key) {
    // if name is a dictionary key, grab it
    var entry = dictionary[key];

    if (!entry) {
      // if not a dictionary key, check if it's bound to a dictionary key
      var lowerKey = key.toLowerCase();
      entry = dictionary[dictionaryBindings[lowerKey]];
    } // if no entry found, simply return the name


    return entry || key;
  }

  function resultsRange() {
    // Upper bound of visible results
    var ceiling = query.page * query.perPage; // Lower bound of visible results

    var floor = ceiling - query.perPage + 1; // make sure the ceiling does not exceed total results

    if (ceiling > totalResults) {
      ceiling = totalResults;
    } // if results are only one page, eschew the range entirely


    if (totalResults <= query.perPage) {
      return "".concat(totalResults);
    } // if we're using load more, we want to show only
    // the ceiling of results displayed


    if (!pagination) {
      return "".concat(ceiling);
    } // otherwise, return the full range


    return "".concat(floor, " - ").concat(ceiling);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "blog-content-listing"
  }, title && /*#__PURE__*/_react.default.createElement("h2", {
    className: "blog-content-listing__title"
  }, title), token && /*#__PURE__*/_react.default.createElement("h2", {
    className: "blog-content-listing__title"
  }, token.title), results.length === 0 && !isFirstLoad && /*#__PURE__*/_react.default.createElement("p", null, "No results found."), results.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(_BlogItem.default, _extends({
      key: i,
      displayDate: displayDates
    }, item));
  }), loading && /*#__PURE__*/_react.default.createElement("div", {
    className: "blog-content-listing__loading-spinner"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/assets/img/loading.gif"
  })), results.length > 0 && pagination && /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__bottom"
  }, /*#__PURE__*/_react.default.createElement(_SearchStatus.default, {
    resultsRange: resultsRange(),
    totalResults: totalResults,
    handleFacetDismiss: function handleFacetDismiss() {}
  }), /*#__PURE__*/_react.default.createElement(_Pagination.default, {
    totalResults: totalResults,
    resultsPerPage: query.perPage,
    currentPage: query.page,
    handlePageChange: gotoPage
  })), !pagination && !(0, _paging.isLastPage)(totalResults, query.perPage, query.page) && /*#__PURE__*/_react.default.createElement("div", {
    className: "blog-content-listing__load-more-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "blog-content-listing__load-more"
  }, !viewAllUrl && /*#__PURE__*/_react.default.createElement("button", {
    className: "pct-btn",
    onClick: function onClick(e) {
      return nextPage();
    },
    type: "button"
  }, dictEntryFor("loadMoreLabel")), viewAllUrl && /*#__PURE__*/_react.default.createElement("a", {
    href: viewAllUrl,
    className: "pct-btn"
  }, dictEntryFor("viewAllLabel")))));
};

var _default = BlogContentList;
exports.default = _default;
var _React$PropTypes = _react.default.PropTypes,
    arrayOf = _React$PropTypes.arrayOf,
    object = _React$PropTypes.object,
    func = _React$PropTypes.func,
    number = _React$PropTypes.number,
    bool = _React$PropTypes.bool,
    string = _React$PropTypes.string;
BlogContentList.propTypes = {
  title: string,
  totalResults: number,
  results: arrayOf(_BlogItem.blogItemShape).isRequired,
  query: object,
  token: object,
  nextPage: func.isRequired,
  dictionary: object,
  displayDates: bool,
  pagination: bool
};

},{"../../search/components/Pagination.jsx":85,"../../search/components/SearchStatus.jsx":91,"../../search/paging":103,"./BlogItem.jsx":42,"react":"react"}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blogItemShape = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlogItem = function BlogItem(_ref) {
  var featureItemAuthors = _ref.featureItemAuthors,
      featureItemContentType = _ref.featureItemContentType,
      featureItemDisplayDate = _ref.featureItemDisplayDate,
      featureItemId = _ref.featureItemId,
      featureItemImage = _ref.featureItemImage,
      featureItemImage1x1Src = _ref.featureItemImage1x1Src,
      featureItemSummary = _ref.featureItemSummary,
      featureItemTitle = _ref.featureItemTitle,
      featureItemUrl = _ref.featureItemUrl,
      suppressContentType = _ref.suppressContentType,
      suppressPublicationDate = _ref.suppressPublicationDate;

  if (featureItemTitle !== "$name") {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "blog-content-listing__content"
    }, featureItemImage1x1Src && /*#__PURE__*/_react.default.createElement("a", {
      className: "blog-content-listing__image",
      href: featureItemUrl
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "".concat(featureItemImage1x1Src, "?w=280&h=280")
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "blog-content-listing__details"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "blog-content-listing__listing-title",
      href: featureItemUrl,
      dangerouslySetInnerHTML: {
        __html: featureItemTitle
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "blog-content-listing__meta-data"
    }, featureItemContentType && !suppressContentType && /*#__PURE__*/_react.default.createElement("span", {
      className: "blog-content-listing__content-type"
    }, featureItemContentType), featureItemDisplayDate && !suppressPublicationDate && /*#__PURE__*/_react.default.createElement("span", {
      className: "blog-content-listing__date"
    }, featureItemDisplayDate), featureItemAuthors && featureItemAuthors.length > 0 ? /*#__PURE__*/_react.default.createElement("span", {
      className: "blog-content-listing__authors"
    }, " by ", /*#__PURE__*/_react.default.createElement("strong", null, featureItemAuthors.join(", "))) : null), featureItemSummary && /*#__PURE__*/_react.default.createElement("span", {
      className: "blog-content-listing__listing-summary",
      dangerouslySetInnerHTML: {
        __html: featureItemSummary
      }
    })));
  } else {
    return /*#__PURE__*/_react.default.createElement("span", null);
  }
};

var _default = BlogItem;
exports.default = _default;
var _React$PropTypes = _react.default.PropTypes,
    string = _React$PropTypes.string,
    shape = _React$PropTypes.shape,
    objectOf = _React$PropTypes.objectOf,
    bool = _React$PropTypes.bool;
var featureItemProps = {
  featureItemAuthors: (0, _propTypes.arrayOf)(string),
  featureItemContentType: string,
  featureItemDisplayDate: string,
  featureItemId: string.isRequired,
  featureItemImage1x1Src: string,
  featureItemTitle: string.isRequired,
  featureItemSummary: string,
  featureItemUrl: string.isRequired,
  displayDate: bool,
  suppressContentType: bool,
  suppressPublicationDate: bool
};
var blogItemShape = shape(featureItemProps);
exports.blogItemShape = blogItemShape;
BlogItem.propTypes = featureItemProps;

},{"prop-types":"prop-types","react":"react"}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _BlogContentList = _interopRequireDefault(require("../components/BlogContentList.jsx"));

var _search = require("../../search/redux/search/search.actions");

var _facets = require("../../search/redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    results: state.results,
    resultsDisplayStrategy: state.resultsDisplayStrategy,
    totalResults: state.totalResults,
    loading: state.loading,
    isFirstLoad: state.isFirstLoad,
    query: state.query,
    pagination: state.pagination,
    displayDates: state.displayDates,
    dictionary: state.dictionary,
    viewAllUrl: state.viewAllUrl,
    token: state.token,
    title: state.title
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    nextPage: function nextPage() {
      dispatch((0, _search.loadNextPage)());
    },
    dismissFacet: function dismissFacet(facetId) {
      dispatch((0, _search.loadFacetChange)(facetId, false));
    },
    showMobileFacets: function showMobileFacets() {
      dispatch((0, _search.showMobileFacets)());
    },
    gotoPage: function gotoPage(pageNum) {
      dispatch((0, _search.loadNewPage)(pageNum));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BlogContentList.default);

exports.default = _default;

},{"../../search/redux/facets":106,"../../search/redux/search/search.actions":111,"../components/BlogContentList.jsx":41,"react-redux":"react-redux"}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSearchApp = initSearchApp;

var _ramda = _interopRequireDefault(require("ramda"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reactRedux = require("react-redux");

var _rootReducer = _interopRequireDefault(require("../search/redux/rootReducer"));

var _search = require("../search/redux/search/search.reducer");

var _search2 = require("../search/redux/search/search.actions");

var _configureStore = _interopRequireDefault(require("../search/redux/configureStore"));

var _service = require("../search/redux/service");

var _service2 = require("./redux/service");

var _resultsDisplay = require("../search/redux/resultsDisplay");

var _BlogContentContainer = _interopRequireDefault(require("./containers/BlogContentContainer.js"));

var _FacetsContainer = _interopRequireDefault(require("../search/containers/FacetsContainer.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the mount nodes are the elements we want to include
// as part of the search app
function initSearchApp(mountNodes) {
  if (!mountNodes.length) {
    return;
  } // extract the searchId from the mountNodes
  // while also checking mountNodes share same id


  var searchId = mountNodes.reduce(function (id, node) {
    var nodeId = $(node).data("searchId"); // if id is null, we want to set it
    // with the first node's value

    if (id === null) {
      return nodeId;
    } // if node id does not equal current
    // id value, it's invalid and return undefined


    if (id !== nodeId) {
      return;
    }

    return id;
  }, null); // if we have an invalid or non-matching id, raise an error

  if (!searchId) {
    throw new Error("Could not initialize Pew search app. searchId was either not present, or provided mount nodes did not share the same searchId");
  } // define the canonical inital state of our redux store here
  // including some value taken from the data-attrs of the
  // mount node.


  var config = window.PewSearchConfigs.find(function (c) {
    return c.searchId === searchId;
  });

  if (!config) {
    throw new Error("Could not initialize Pew search app instance with id of \"".concat(searchId, "\". Configuration data not found."));
  }

  var facetDisplayOverride = {
    "contentType": config.displayContentTypeFilter,
    "places": config.displayPlacesFilter,
    "project": config.displayProjectsFilter,
    "tag": config.displayTagsFilter,
    "topic": config.displayTopicsFilter
  };
  var featuredPosts = $('.featured-posts').attr('data-posts'); // create a starting state object,
  // which includes and intitial state
  // from individual reducers

  var initialState = _ramda.default.merge(_search.initialState, {
    url: config.url,
    pagination: config.pagination,
    resultsDisplayStrategy: config.pagination ? _resultsDisplay.RESULTS_DISPLAY_REFRESH : _resultsDisplay.RESULTS_DISPLAY_APPEND,
    viewAllUrl: config.viewAllUrl,
    dictionary: config.dictionary,
    displayDates: config.displayDates,
    facetDisplayOverride: facetDisplayOverride,
    query: _ramda.default.merge(_search.initialState.query, {
      pageId: config.pageId,
      page: config.page,
      perPage: config.perPage,
      componentId: config.componentId,
      featuredGuids: featuredPosts ? featuredPosts : null
    })
  }); // determine if we want to load all page results in our cold load


  var doLoadAllPages = initialState.resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND && initialState.isFirstLoad;
  initialState = _ramda.default.merge(initialState, {
    query: _ramda.default.merge(initialState.query, {
      loadAllPages: doLoadAllPages
    })
  });

  var thunkMiddleware = _reduxThunk.default.withExtraArgument({
    mapResponseToState: _service.mapResponseToState,
    fetchSearchResults: _service2.fetchSearchResults
  });

  var store = (0, _configureStore.default)(_rootReducer.default, initialState, [thunkMiddleware]);
  store.dispatch((0, _search2.loadResults)());
  mountNodes.forEach(function (node) {
    if (node.className.indexOf("js-blog-content") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_BlogContentContainer.default, null)), node);
    }

    if (node.className.indexOf("js-blog-content-search-facets") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_FacetsContainer.default, null)), node);
    }
  });
}

},{"../search/containers/FacetsContainer.jsx":95,"../search/redux/configureStore":104,"../search/redux/resultsDisplay":108,"../search/redux/rootReducer":109,"../search/redux/search/search.actions":111,"../search/redux/search/search.reducer":112,"../search/redux/service":113,"./containers/BlogContentContainer.js":43,"./redux/service":45,"ramda":"ramda","react":"react","react-dom":"react-dom","react-redux":"react-redux","redux-thunk":"redux-thunk"}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSearchResults = fetchSearchResults;

var _ramda = _interopRequireDefault(require("ramda"));

var _jquery = _interopRequireDefault(require("jquery"));

var _util = require("../../search/util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchSearchResults(url, query) {
  // dynamic content needs to remap some stuff on the request
  // that's normally part of vanilla search.
  // lose params we don't need. PageGuid and ComponentGuid are added automatically to the URL
  var removeInvalidParams = _ramda.default.omit(["q", "sortBy", "sortOrder", "loadAllPages", "numberOfItems", "startOffset", "pageGuid", "pageId", "componentGuid"]); // any facet/filter group params get changed to filter.<groupName>.
  // Keep track of which params are not filters/


  var nonFilters = ["pageId", "componentGuid", "page", "perPage", "featuredGuids"];

  var stringifyArrayParams = _ramda.default.map(function (v) {
    return v instanceof Array ? v.join(";") : v;
  });

  var keyName = function keyName(key) {
    return _ramda.default.contains(key, nonFilters) ? key : "filters.".concat(key);
  };

  var filterizeKeys = _ramda.default.partial(_util.renameKeysWith, [keyName]);

  var fixQuery = _ramda.default.pipe(removeInvalidParams, stringifyArrayParams, filterizeKeys);

  var searchPromise = _jquery.default.ajax({
    url: url,
    data: fixQuery(query)
  });

  var featuredPromise = _jquery.default.Deferred().resolve([]);

  return [searchPromise, featuredPromise];
}

},{"../../search/util":114,"jquery":"jquery","ramda":"ramda"}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSearchApp = initSearchApp;

var _ramda = _interopRequireDefault(require("ramda"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reactRedux = require("react-redux");

var _rootReducer = _interopRequireDefault(require("../search/redux/rootReducer"));

var _search = require("../search/redux/search/search.reducer");

var _search2 = require("../search/redux/search/search.actions");

var _configureStore = _interopRequireDefault(require("../search/redux/configureStore"));

var _service = require("./redux/service");

var _resultsDisplay = require("../search/redux/resultsDisplay");

var _BlogContentContainer = _interopRequireDefault(require("../blog-content/containers/BlogContentContainer.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the mount nodes are the elements we want to include
// as part of the search app
function initSearchApp(mountNodes) {
  if (!mountNodes.length) {
    return;
  } // extract the searchId from the mountNodes
  // while also checking mountNodes share same id


  var searchId = mountNodes.reduce(function (id, node) {
    var nodeId = $(node).data("searchId"); // if id is null, we want to set it
    // with the first node's value

    if (id === null) {
      return nodeId;
    } // if node id does not equal current
    // id value, it's invalid and return undefined


    if (id !== nodeId) {
      return;
    }

    return id;
  }, null); // if we have an invalid or non-matching id, raise an error

  if (!searchId) {
    throw new Error("Could not initialize Pew search app. searchId was either not present, or provided mount nodes did not share the same searchId");
  } // define the canonical inital state of our redux store here
  // including some value taken from the data-attrs of the
  // mount node.


  var config = window.PewSearchConfigs.find(function (c) {
    return c.searchId === searchId;
  });

  if (!config) {
    throw new Error("Could not initialize Pew search app instance with id of \"".concat(searchId, "\". Configuration data not found."));
  } // create a starting state object,
  // which includes and intitial state
  // from individual reducers


  var initialState = _ramda.default.merge(_search.initialState, {
    url: config.url,
    pagination: config.pagination,
    resultsDisplayStrategy: config.pagination ? _resultsDisplay.RESULTS_DISPLAY_REFRESH : _resultsDisplay.RESULTS_DISPLAY_APPEND,
    viewAllUrl: config.viewAllUrl,
    dictionary: config.dictionary,
    displayDates: config.displayDates,
    query: _ramda.default.merge(_search.initialState.query, {
      pageId: config.pageId,
      page: config.page,
      perPage: config.perPage,
      componentId: config.componentId
    })
  }); // determine if we want to load all page results in our cold load


  var doLoadAllPages = initialState.resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND && initialState.isFirstLoad;
  initialState = _ramda.default.merge(initialState, {
    query: _ramda.default.merge(initialState.query, {
      loadAllPages: doLoadAllPages
    })
  });

  var thunkMiddleware = _reduxThunk.default.withExtraArgument({
    mapResponseToState: _service.mapResponseToState,
    fetchSearchResults: _service.fetchSearchResults
  });

  var store = (0, _configureStore.default)(_rootReducer.default, initialState, [thunkMiddleware]);
  store.dispatch((0, _search2.loadResults)());
  mountNodes.forEach(function (node) {
    if (node.className.indexOf("js-blog-search") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_BlogContentContainer.default, null)), node);
    }
  });
}

},{"../blog-content/containers/BlogContentContainer.js":43,"../search/redux/configureStore":104,"../search/redux/resultsDisplay":108,"../search/redux/rootReducer":109,"../search/redux/search/search.actions":111,"../search/redux/search/search.reducer":112,"./redux/service":47,"ramda":"ramda","react":"react","react-dom":"react-dom","react-redux":"react-redux","redux-thunk":"redux-thunk"}],47:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapResponseToState = mapResponseToState;
exports.fetchSearchResults = fetchSearchResults;

var _ramda = _interopRequireDefault(require("ramda"));

var _urijs = _interopRequireDefault(require("urijs"));

var _jquery = _interopRequireDefault(require("jquery"));

var _resultsDisplay = require("../../search/redux/resultsDisplay");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newResults = _ramda.default.curry(function (newResults, oldResults, strategy) {
  return strategy === _resultsDisplay.RESULTS_DISPLAY_APPEND ? _ramda.default.concat(oldResults || [], newResults || []) : newResults || [];
});

function mapResponseToState(response, state) {
  var request = response.request;

  var castToInt = _ramda.default.curry(parseInt)(_ramda.default.__, 10);

  var newState = _ramda.default.evolve({
    totalResults: function totalResults() {
      return parseInt(response.totalResults, 10);
    },
    results: newResults(response.results, _ramda.default.__, state.resultsDisplayStrategy),
    facets: function facets() {
      return [];
    },
    token: function token() {
      return response.token;
    },
    query: _ramda.default.merge(_ramda.default.__, {
      pageId: request.pageId,
      page: castToInt(request.page || 0),
      perPage: castToInt(request.perPage || 10),
      sortOrder: request.sortOrder,
      loadAllPages: false
    })
  }, state);

  newState.title = response.title;
  return newState;
}

;

function fetchSearchResults(url, query) {
  // there are no dynamic facets or filters on blog-search
  // but we do want to send filter and value to the api
  // we'll read it directly from the query string
  var field = (0, _urijs.default)(window.location).search(true)["field"];
  var value = (0, _urijs.default)(window.location).search(true)["value"];
  var pageGuid = (0, _urijs.default)(window.location).search(true)["pageGuid"];
  var componentGuid = (0, _urijs.default)(window.location).search(true)["componentGuid"];

  var omitFields = _ramda.default.omit(["q", "sortBy", "sortOrder", "loadAllPages", "startOffset", "pageId"]);

  var newQuery = value && field ? _ramda.default.merge({
    field: field,
    value: value
  }, query) : query;
  newQuery = pageGuid && componentGuid ? _ramda.default.merge({
    pageGuid: pageGuid,
    componentGuid: componentGuid
  }, newQuery) : newQuery;

  var searchPromise = _jquery.default.ajax({
    url: url,
    data: omitFields(newQuery)
  });

  var featuredPromise = _jquery.default.Deferred().resolve([]);

  return [searchPromise, featuredPromise];
}

},{"../../search/redux/resultsDisplay":108,"jquery":"jquery","ramda":"ramda","urijs":"urijs"}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpoint = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Extract current breakpoint name as string from DOM
// More details: https://www.lullabot.com/articles/importing-css-breakpoints-into-javascript
var breakpoint = function breakpoint() {
  return window.getComputedStyle(document.querySelector("body"), "::before").getPropertyValue("content").replace(/\"/g, "");
};

exports.breakpoint = breakpoint;

},{"jquery":"jquery"}],49:[function(require,module,exports){
"use strict";

/*!
Name: Reading Time
Dependencies: jQuery
Author: Michael Lynch
Author URL: http://michaelynch.com
Date Created: August 14, 2013
Date Updated: July 11, 2016
Licensed under the MIT license
*/
(function (factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports !== 'undefined') {
    module.exports = factory(require('jquery'));
  } else {
    factory(jQuery);
  }
})(function ($) {
  var totalReadingTimeSeconds;

  $.fn.readingTime = function (options) {
    //define default parameters
    var defaults = {
      readingTimeTarget: '.eta',
      readingTimeAsNumber: false,
      wordCountTarget: null,
      wordsPerMinute: 270,
      round: true,
      lang: 'en',
      lessThanAMinuteString: '',
      prependTimeString: '',
      prependWordString: '',
      remotePath: null,
      remoteTarget: null,
      success: function success() {},
      error: function error() {}
    },
        plugin = this,
        el = $(this); //merge defaults and options

    plugin.settings = $.extend({}, defaults, options); //define vars

    var s = plugin.settings; //if no element was bound

    if (!this.length) {
      //run error callback
      s.error.call(this); //return so chained events can continue

      return this;
    } //if s.lang is set to italian


    if (s.lang == 'it') {
      var lessThanAMinute = s.lessThanAMinuteString || "Meno di un minuto";
      var minShortForm = 'min'; //if s.lang is set to french
    } else if (s.lang == 'fr') {
      var lessThanAMinute = s.lessThanAMinuteString || "Moins d'une minute";
      var minShortForm = 'min'; //if s.lang is set to german
    } else if (s.lang == 'de') {
      var lessThanAMinute = s.lessThanAMinuteString || "Weniger als eine Minute";
      var minShortForm = 'min'; //if s.lang is set to spanish
    } else if (s.lang == 'es') {
      var lessThanAMinute = s.lessThanAMinuteString || "Menos de un minuto";
      var minShortForm = 'min'; //if s.lang is set to dutch
    } else if (s.lang == 'nl') {
      var lessThanAMinute = s.lessThanAMinuteString || "Minder dan een minuut";
      var minShortForm = 'min'; //if s.lang is set to slovak
    } else if (s.lang == 'sk') {
      var lessThanAMinute = s.lessThanAMinuteString || "Menej než minútu";
      var minShortForm = 'min'; //if s.lang is set to czech
    } else if (s.lang == 'cz') {
      var lessThanAMinute = s.lessThanAMinuteString || "Méně než minutu";
      var minShortForm = 'min'; //if s.lang is set to Hungarian
    } else if (s.lang == 'hu') {
      var lessThanAMinute = s.lessThanAMinuteString || "Kevesebb mint egy perc";
      var minShortForm = 'perc'; // if s.lang is set to Russian
    } else if (s.lang == 'ru') {
      var lessThanAMinute = s.lessThanAMinuteString || "Меньше минуты";
      var minShortForm = 'мин'; //if s.lang is set to Arabic
    } else if (s.lang == 'ar') {
      var lessThanAMinute = s.lessThanAMinuteString || "أقل من دقيقة";
      var minShortForm = 'دقيقة'; //if s.lang is set to Danish
    } else if (s.lang == 'da') {
      var lessThanAMinute = s.lessThanAMinuteString || "Mindre end et minut";
      var minShortForm = 'min'; //if s.lang is set to Icelandic
    } else if (s.lang == 'is') {
      var lessThanAMinute = s.lessThanAMinuteString || "Minna en eina mínútu";
      var minShortForm = 'min'; //if s.lang is set to Norwegian
    } else if (s.lang == 'no') {
      var lessThanAMinute = s.lessThanAMinuteString || "Mindre enn ett minutt";
      var minShortForm = 'min'; //if s.lang is set to Polish
    } else if (s.lang == 'pl') {
      var lessThanAMinute = s.lessThanAMinuteString || "Mniej niż minutę";
      var minShortForm = 'min'; //if s.lang is set to Russian
    } else if (s.lang == 'ru') {
      var lessThanAMinute = s.lessThanAMinuteString || "Меньше минуты";
      var minShortForm = 'мой'; //if s.lang is set to Swedish
    } else if (s.lang == 'sv') {
      var lessThanAMinute = s.lessThanAMinuteString || "Mindre än en minut";
      var minShortForm = 'min'; //if s.lang is set to Turkish
    } else if (s.lang == 'tr') {
      var lessThanAMinute = s.lessThanAMinuteString || "Bir dakikadan az";
      var minShortForm = 'dk'; //default s.lang is english
    } else {
      var lessThanAMinute = s.lessThanAMinuteString || 'Less than a minute';
      var minShortForm = 'min';
    }

    var setTime = function setTime(text) {
      if (text !== '') {
        //split text by spaces to define total words
        var totalWords = text.trim().split(/\s+/g).length; //define words per second based on words per minute (s.wordsPerMinute)

        var wordsPerSecond = s.wordsPerMinute / 60; //define total reading time in seconds

        totalReadingTimeSeconds = totalWords / wordsPerSecond; //define reading time in minutes
        //if s.round is set to true

        if (s.round === true) {
          var readingTimeMinutes = Math.round(totalReadingTimeSeconds / 60); //if s.round is set to false
        } else {
          var readingTimeMinutes = Math.floor(totalReadingTimeSeconds / 60);
        } //define remaining reading time seconds


        var readingTimeSeconds = Math.round(totalReadingTimeSeconds - readingTimeMinutes * 60); //if s.round is set to true

        if (s.round === true) {
          //if minutes are greater than 0
          if (readingTimeMinutes > 0) {
            //set reading time by the minute
            $(s.readingTimeTarget).text(s.prependTimeString + readingTimeMinutes + (!s.readingTimeAsNumber ? ' ' + minShortForm : ''));
          } else {
            //set reading time as less than a minute
            $(s.readingTimeTarget).text(!s.readingTimeAsNumber ? s.prependTimeString + lessThanAMinute : readingTimeMinutes);
          } //if s.round is set to false

        } else {
          //format reading time
          var readingTime = readingTimeMinutes + ':' + readingTimeSeconds; //set reading time in minutes and seconds

          $(s.readingTimeTarget).text(s.prependTimeString + readingTime);
        } //if word count container isn't blank or undefined


        if (s.wordCountTarget !== '' && s.wordCountTarget !== undefined) {
          //set word count
          $(s.wordCountTarget).text(s.prependWordString + totalWords);
        } //run success callback


        s.success.call(this);
      } else {
        //run error callback
        s.error.call(this, 'The element is empty.');
      }
    }; //for each element


    el.each(function () {
      //if s.remotePath and s.remoteTarget aren't null
      if (s.remotePath != null && s.remoteTarget != null) {
        //get contents of remote file
        $.get(s.remotePath, function (data) {
          //set time using the remote target found in the remote file
          setTime($('<div>').html(data).find(s.remoteTarget).text());
        });
      } else {
        //set time using the targeted element
        setTime(el.text());
      }
    });
    return totalReadingTimeSeconds;
  };
});

},{"jquery":"jquery"}],50:[function(require,module,exports){
"use strict";

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

//I had to do this instead of loading it thru npm because of the module's requirejs dependency. I'm so so so so sorry.

/*
 * selection-sharer: Medium like popover menu to share on Twitter or by email any text selected on the page
 *
 * -- Requires jQuery --
 * -- AMD compatible  --
 *
 * Author: Xavier Damman (@xdamman)
 * GIT: https://github.com/xdamman/share-selection
 * MIT License
 */
(function ($) {
  var SelectionSharer = function SelectionSharer(options) {
    var self = this;
    options = options || {};
    if (typeof options == "string") options = {
      elements: options
    };
    this.sel = null;
    this.textSelection = "";
    this.htmlSelection = "";
    this.appId = $('meta[property="fb:app_id"]').attr("content") || $('meta[property="fb:app_id"]').attr("value");
    this.url2share = $('meta[property="og:url"]').attr("content") || $('meta[property="og:url"]').attr("value") || window.location.href;
    self.viaTwitterAccount = $('meta[name="selshare:viatwitter"]').attr("content") || $('meta[name="selshare:viatwitter"]').attr("value");

    this.getSelectionText = function (sel) {
      var html = "",
          text = "";
      sel = sel || window.getSelection();

      if (sel.rangeCount) {
        var container = document.createElement("div");

        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents());
        }

        text = container.textContent;
        html = container.innerHTML;
      }

      self.textSelection = text;
      self.htmlSelection = html || text;
      return text;
    };

    this.selectionDirection = function (selection) {
      var sel = selection || window.getSelection();
      var range = document.createRange();
      if (!sel.anchorNode) return 0;
      range.setStart(sel.anchorNode, sel.anchorOffset);
      range.setEnd(sel.focusNode, sel.focusOffset);
      var direction = range.collapsed ? "backward" : "forward";
      range.detach();
      return direction;
    };

    this.showPopunder = function () {
      self.popunder = self.popunder || document.getElementById("selectionSharerPopunder");
      var sel = window.getSelection();
      var selection = self.getSelectionText(sel);
      if (sel.isCollapsed || selection.length < 10 || !selection.match(/ /)) return self.hidePopunder();

      if (self.popunder.classList.contains("fixed")) {
        self.popunder.style.bottom = 0;
        return self.popunder.style.bottom;
      }

      var range = sel.getRangeAt(0);
      var node = range.endContainer.parentNode; // The <p> where the selection ends
      // If the popunder is currently displayed

      if (self.popunder.classList.contains("show")) {
        // If the popunder is already at the right place, we do nothing
        if (Math.ceil(self.popunder.getBoundingClientRect().top) == Math.ceil(node.getBoundingClientRect().bottom)) return; // Otherwise, we first hide it and the we try again

        return self.hidePopunder(self.showPopunder);
      }

      if (node.nextElementSibling) {
        // We need to push down all the following siblings
        self.pushSiblings(node);
      } else {
        // We need to append a new element to push all the content below
        if (!self.placeholder) {
          self.placeholder = document.createElement("div");
          self.placeholder.className = "selectionSharerPlaceholder";
        } // If we add a div between two <p> that have a 1em margin, the space between them
        // will become 2x 1em. So we give the placeholder a negative margin to avoid that


        var margin = window.getComputedStyle(node).marginBottom;
        self.placeholder.style.height = margin;
        self.placeholder.style.marginBottom = -2 * parseInt(margin, 10) + "px";
        node.parentNode.insertBefore(self.placeholder);
      } // scroll offset


      var offsetTop = window.pageYOffset + node.getBoundingClientRect().bottom;
      self.popunder.style.top = Math.ceil(offsetTop) + "px";
      setTimeout(function () {
        if (self.placeholder) self.placeholder.classList.add("show");
        self.popunder.classList.add("show");
      }, 0);
    };

    this.pushSiblings = function (el) {
      while (el = el.nextElementSibling) {
        el.classList.add("selectionSharer");
        el.classList.add("moveDown");
      }
    };

    this.hidePopunder = function (cb) {
      cb = cb || function () {};

      if (self.popunder == "fixed") {
        self.popunder.style.bottom = "-50px";
        return cb();
      }

      self.popunder.classList.remove("show");
      if (self.placeholder) self.placeholder.classList.remove("show"); // We need to push back up all the siblings

      var els = document.getElementsByClassName("moveDown");

      while (el = els[0]) {
        el.classList.remove("moveDown");
      } // CSS3 transition takes 0.6s


      setTimeout(function () {
        if (self.placeholder) document.body.insertBefore(self.placeholder);
        cb();
      }, 600);
    };

    this.show = function (e) {
      setTimeout(function () {
        var sel = window.getSelection();
        var selection = self.getSelectionText(sel);

        if (!sel.isCollapsed && selection && selection.length > 10 && selection.match(/ /)) {
          var range = sel.getRangeAt(0);
          var topOffset = range.getBoundingClientRect().top - 5;
          var top = topOffset + self.getPosition().y - self.$popover.height();
          var left = 0;

          if (e) {
            left = e.pageX;
          } else {
            var obj = sel.anchorNode.parentNode;
            left += obj.offsetWidth / 2;

            do {
              left += obj.offsetLeft;
            } while (obj = obj.offsetParent);
          }

          switch (self.selectionDirection(sel)) {
            case "forward":
              left -= self.$popover.width();
              break;

            case "backward":
              left += self.$popover.width();
              break;

            default:
              return;
          }

          self.$popover.removeClass("anim").css("top", top + 10).css("left", left).show();
          setTimeout(function () {
            self.$popover.addClass("anim").css("top", top);
          }, 0);
        }
      }, 10);
    };

    this.hide = function (e) {
      self.$popover.hide();
    };

    this.smart_truncate = function (str, n) {
      if (!str || !str.length) return str;
      var toLong = str.length > n,
          s_ = toLong ? str.substr(0, n - 1) : str;
      s_ = toLong ? s_.substr(0, s_.lastIndexOf(" ")) : s_;
      return toLong ? s_ + "..." : s_;
    };

    this.getRelatedTwitterAccounts = function () {
      var usernames = [];
      var creator = $('meta[name="twitter:creator"]').attr("content") || $('meta[name="twitter:creator"]').attr("value");
      if (creator) usernames.push(creator); // We scrape the page to find a link to http(s)://twitter.com/username

      var anchors = document.getElementsByTagName("a");

      for (var i = 0, len = anchors.length; i < len; i++) {
        if (anchors[i].attributes.href && typeof anchors[i].attributes.href.value == "string") {
          var matches = anchors[i].attributes.href.value.match(/^https?:\/\/twitter\.com\/([a-z0-9_]{1,20})/i);
          if (matches && matches.length > 1 && ["widgets", "intent"].indexOf(matches[1]) == -1) usernames.push(matches[1]);
        }
      }

      if (usernames.length > 0) return usernames.join(",");else return "";
    };

    this.shareTwitter = function (e) {
      e.preventDefault();
      var suffix = " " + self.url2share + " via " + self.viaTwitterAccount;
      var text = "“" + self.smart_truncate(self.textSelection.trim(), 140 - (suffix.length + 2)) + "”";
      var url = "http://twitter.com/intent/tweet?text=" + encodeURIComponent(text) + "&related=" + self.getRelatedTwitterAccounts() + "&url=" + encodeURIComponent(self.url2share); // We only show the via @twitter:site if we have enough room

      if (self.viaTwitterAccount && text.length < 120 - 6 - self.viaTwitterAccount.length) url += "&via=" + self.viaTwitterAccount;
      var w = 640,
          h = 440;
      var left = screen.width / 2 - w / 2;
      var top = screen.height / 2 - h / 2 - 100;
      window.open(url, "share_twitter", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
      self.hide();
      return false;
    };

    this.shareFacebook = function (e) {
      e.preventDefault();
      var text = self.htmlSelection.replace(/<p[^>]*>/gi, "\n").replace(/<\/p>|  /gi, "").trim();
      var url = "https://www.facebook.com/dialog/feed?" + "app_id=" + self.appId + "&display=popup" + "&caption=" + encodeURIComponent(text) + "&link=" + encodeURIComponent(self.url2share) + "&href=" + encodeURIComponent(self.url2share) + "&redirect_uri=" + encodeURIComponent(self.url2share);
      var w = 640,
          h = 440;
      var left = screen.width / 2 - w / 2;
      var top = screen.height / 2 - h / 2 - 100;
      window.open(url, "share_facebook", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
    };

    this.shareEmail = function (e) {
      var text = self.textSelection.replace(/<p[^>]*>/gi, "\n").replace(/<\/p>|  /gi, "").trim();
      var email = {};
      var suffix;

      if ($('meta[name="selshare:subject-suffix"]').length) {
        var suffixAttr = $('meta[name="selshare:subject-suffix"]') ? $('meta[name="selshare:subject-suffix"]').attr("content") ? $('meta[name="selshare:subject-suffix"]').attr("content") : $('meta[name="selshare:subject-suffix"]').attr("value") : null;
        var suffixArr = document.title.toLowerCase().split("|").map(function (x) {
          return x.trim();
        });

        if (!suffixArr.includes(suffixAttr.trim().toLowerCase())) {
          suffix = " | " + ($('meta[name="selshare:subject-suffix"]').attr("content") || $('meta[name="selshare:subject-suffix"]').attr("value"));
        } else {
          suffix = "";
        }
      } else {
        suffix = "";
      }

      email.subject = encodeURIComponent("Quote from " + document.title + suffix);
      email.body = encodeURIComponent("“" + text + "”") + "%0D%0A%0D%0AFrom: " + encodeURIComponent(document.title) + "%0D%0A" + encodeURIComponent(self.url2share);
      $(e.target).attr("href", "mailto:?subject=" + email.subject + "&body=" + email.body);
      self.hide(e);
      return true;
    };

    this.render = function () {
      var popoverHTML = '<div class="selectionSharer" id="selectionSharerPopover" style="position:absolute;">' + '  <div id="selectionSharerPopover-inner">' + "    <ul>" + '      <li><a class="action tweet" href="" title="Share this selection on Twitter" target="_blank">Tweet</a></li>' + '      <li><a class="action facebook" href="" title="Share this selection on Facebook" target="_blank">Facebook</a></li>' + '      <li><a class="action email" href="" title="Share this selection by email"><svg width="20" height="20"><path stroke="%23FFF" stroke-width="6" d="m16,25h82v60H16zl37,37q4,3 8,0l37-37M16,85l30-30m22,0 30,30"/></svg></a></li>' + "    </ul>" + "  </div>" + '  <div class="selectionSharerPopover-clip"><span class="selectionSharerPopover-arrow"></span></div>' + "</div>";
      var popunderHTML = '<div id="selectionSharerPopunder" class="selectionSharer">' + '  <div id="selectionSharerPopunder-inner">' + "    <label>Share this selection</label>" + "    <ul>" + '      <li><a class="action tweet" href="" title="Share this selection on Twitter" target="_blank">Tweet</a></li>' + '      <li><a class="action facebook" href="" title="Share this selection on Facebook" target="_blank">Facebook</a></li>' + '      <li><a class="action email" href="" title="Share this selection by email"><svg width="20" height="20"><path stroke="%23FFF" stroke-width="6" d="m16,25h82v60H16zl37,37q4,3 8,0l37-37M16,85l30-30m22,0 30,30"/></svg></a></li>' + "    </ul>" + "  </div>" + "</div>";
      self.$popover = $(popoverHTML);
      self.$popover.find("a.tweet").on("click", function (e) {
        self.shareTwitter(e);
      });
      self.$popover.find("a.facebook").on("click", function (e) {
        self.shareFacebook(e);
      });
      self.$popover.find("a.email").on("click", function (e) {
        self.shareEmail(e);
      });
      $("body").append(self.$popover);
      self.$popunder = $(popunderHTML);
      self.$popunder.find("a.tweet").on("click", function (e) {
        self.shareTwitter(e);
      });
      self.$popunder.find("a.facebook").on("click", function (e) {
        self.shareFacebook(e);
      });
      self.$popunder.find("a.email").on("click", function (e) {
        self.shareEmail(e);
      });
      $("body").append(self.$popunder);

      if (self.appId && self.url2share) {
        $(".selectionSharer a.facebook").css("display", "inline-block");
      }
    };

    this.setElements = function (elements) {
      if (typeof elements == "string") elements = $(elements);
      self.$elements = elements instanceof $ ? elements : $(elements);
      self.$elements.on({
        mouseup: function mouseup(e) {
          self.show(e);
        },
        mousedown: function mousedown(e) {
          self.hide(e);
        },
        touchstart: function touchstart(e) {
          self.isMobile = true;
        }
      }).addClass("selectionShareable");
      document.onselectionchange = self.selectionChanged;
    };

    this.selectionChanged = function (e) {
      if (!self.isMobile) return;

      if (self.lastSelectionChanged) {
        clearTimeout(self.lastSelectionChanged);
      }

      self.lastSelectionChanged = setTimeout(function () {
        self.showPopunder(e);
      }, 300);
    };

    this.getPosition = function () {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      var x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
      var y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
      return {
        x: x,
        y: y
      };
    };

    this.render();

    if (options.elements) {
      this.setElements(options.elements);
    }
  }; // jQuery plugin
  // Usage: $( "p" ).selectionSharer();


  $.fn.selectionSharer = function () {
    var sharer = new SelectionSharer();
    sharer.setElements(this);
    return this;
  }; // For AMD / requirejs
  // Usage: require(["selection-sharer!"]);
  //     or require(["selection-sharer"], function(selectionSharer) { var sharer = new SelectionSharer('p'); });


  if (typeof define == "function") {
    define(function () {
      SelectionSharer.load = function (name, req, onLoad, config) {
        var sharer = new SelectionSharer();
        sharer.setElements("p");
        onLoad();
      };

      return SelectionSharer;
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
    module.exports = SelectionSharer;
  } else {
    // Registering SelectionSharer as a global
    // Usage: var sharer = new SelectionSharer('p');
    window.SelectionSharer = SelectionSharer;
  }
})(_jquery.default);

},{"jquery":"jquery"}],51:[function(require,module,exports){
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */

/* global window, document, define, jQuery, setInterval, clearInterval */
(function (factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports !== 'undefined') {
    module.exports = factory(require('jquery'));
  } else {
    factory(jQuery);
  }
})(function ($) {
  'use strict';

  var Slick = window.Slick || {};

  Slick = function () {
    var instanceUid = 0;

    function Slick(element, settings) {
      var _ = this,
          dataSettings;

      _.defaults = {
        accessibility: true,
        adaptiveHeight: false,
        appendArrows: $(element),
        appendDots: $(element),
        arrows: true,
        asNavFor: null,
        prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
        nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
        centerPadding: '50px',
        cssEase: 'ease',
        customPaging: function (slider, i) {
          return $('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1);
        },
        dots: false,
        dotsClass: 'slick-dots',
        draggable: true,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: false,
        focusOnSelect: false,
        infinite: true,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        mobileFirst: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        pauseOnDotsHover: false,
        respondTo: 'window',
        responsive: null,
        rows: 1,
        rtl: false,
        slide: '',
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: true,
        swipeToSlide: false,
        touchMove: true,
        touchThreshold: 5,
        useCSS: true,
        useTransform: true,
        variableWidth: false,
        vertical: false,
        verticalSwiping: false,
        waitForAnimate: true,
        zIndex: 1000
      };
      _.initials = {
        animating: false,
        dragging: false,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: false,
        slideOffset: 0,
        swipeLeft: null,
        $list: null,
        touchObject: {},
        transformsEnabled: false,
        unslicked: false
      };
      $.extend(_, _.initials);
      _.activeBreakpoint = null;
      _.animType = null;
      _.animProp = null;
      _.breakpoints = [];
      _.breakpointSettings = [];
      _.cssTransitions = false;
      _.focussed = false;
      _.interrupted = false;
      _.hidden = 'hidden';
      _.paused = true;
      _.positionProp = null;
      _.respondTo = null;
      _.rowCount = 1;
      _.shouldClick = true;
      _.$slider = $(element);
      _.$slidesCache = null;
      _.transformType = null;
      _.transitionType = null;
      _.visibilityChange = 'visibilitychange';
      _.windowWidth = 0;
      _.windowTimer = null;
      dataSettings = $(element).data('slick') || {};
      _.options = $.extend({}, _.defaults, settings, dataSettings);
      _.currentSlide = _.options.initialSlide;
      _.originalSettings = _.options;

      if (typeof document.mozHidden !== 'undefined') {
        _.hidden = 'mozHidden';
        _.visibilityChange = 'mozvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        _.hidden = 'webkitHidden';
        _.visibilityChange = 'webkitvisibilitychange';
      }

      _.autoPlay = $.proxy(_.autoPlay, _);
      _.autoPlayClear = $.proxy(_.autoPlayClear, _);
      _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
      _.changeSlide = $.proxy(_.changeSlide, _);
      _.clickHandler = $.proxy(_.clickHandler, _);
      _.selectHandler = $.proxy(_.selectHandler, _);
      _.setPosition = $.proxy(_.setPosition, _);
      _.swipeHandler = $.proxy(_.swipeHandler, _);
      _.dragHandler = $.proxy(_.dragHandler, _);
      _.keyHandler = $.proxy(_.keyHandler, _);
      _.instanceUid = instanceUid++; // A simple way to check for HTML strings
      // Strict HTML recognition (must start with <)
      // Extracted from jQuery v1.11 source

      _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;

      _.registerBreakpoints();

      _.init(true);
    }

    return Slick;
  }();

  Slick.prototype.activateADA = function () {
    var _ = this;

    _.$slideTrack.find('.slick-active').attr({
      'aria-hidden': 'false'
    }).find('a, input, button, select').attr({
      'tabindex': '0'
    });
  };

  Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {
    var _ = this;

    if (typeof index === 'boolean') {
      addBefore = index;
      index = null;
    } else if (index < 0 || index >= _.slideCount) {
      return false;
    }

    _.unload();

    if (typeof index === 'number') {
      if (index === 0 && _.$slides.length === 0) {
        $(markup).appendTo(_.$slideTrack);
      } else if (addBefore) {
        $(markup).insertBefore(_.$slides.eq(index));
      } else {
        $(markup).insertAfter(_.$slides.eq(index));
      }
    } else {
      if (addBefore === true) {
        $(markup).prependTo(_.$slideTrack);
      } else {
        $(markup).appendTo(_.$slideTrack);
      }
    }

    _.$slides = _.$slideTrack.children(this.options.slide);

    _.$slideTrack.children(this.options.slide).detach();

    _.$slideTrack.append(_.$slides);

    _.$slides.each(function (index, element) {
      $(element).attr('data-slick-index', index);
    });

    _.$slidesCache = _.$slides;

    _.reinit();
  };

  Slick.prototype.animateHeight = function () {
    var _ = this;

    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);

      _.$list.animate({
        height: targetHeight
      }, _.options.speed);
    }
  };

  Slick.prototype.animateSlide = function (targetLeft, callback) {
    var animProps = {},
        _ = this;

    _.animateHeight();

    if (_.options.rtl === true && _.options.vertical === false) {
      targetLeft = -targetLeft;
    }

    if (_.transformsEnabled === false) {
      if (_.options.vertical === false) {
        _.$slideTrack.animate({
          left: targetLeft
        }, _.options.speed, _.options.easing, callback);
      } else {
        _.$slideTrack.animate({
          top: targetLeft
        }, _.options.speed, _.options.easing, callback);
      }
    } else {
      if (_.cssTransitions === false) {
        if (_.options.rtl === true) {
          _.currentLeft = -_.currentLeft;
        }

        $({
          animStart: _.currentLeft
        }).animate({
          animStart: targetLeft
        }, {
          duration: _.options.speed,
          easing: _.options.easing,
          step: function (now) {
            now = Math.ceil(now);

            if (_.options.vertical === false) {
              animProps[_.animType] = 'translate(' + now + 'px, 0px)';

              _.$slideTrack.css(animProps);
            } else {
              animProps[_.animType] = 'translate(0px,' + now + 'px)';

              _.$slideTrack.css(animProps);
            }
          },
          complete: function () {
            if (callback) {
              callback.call();
            }
          }
        });
      } else {
        _.applyTransition();

        targetLeft = Math.ceil(targetLeft);

        if (_.options.vertical === false) {
          animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
        } else {
          animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
        }

        _.$slideTrack.css(animProps);

        if (callback) {
          setTimeout(function () {
            _.disableTransition();

            callback.call();
          }, _.options.speed);
        }
      }
    }
  };

  Slick.prototype.getNavTarget = function () {
    var _ = this,
        asNavFor = _.options.asNavFor;

    if (asNavFor && asNavFor !== null) {
      asNavFor = $(asNavFor).not(_.$slider);
    }

    return asNavFor;
  };

  Slick.prototype.asNavFor = function (index) {
    var _ = this,
        asNavFor = _.getNavTarget();

    if (asNavFor !== null && typeof asNavFor === 'object') {
      asNavFor.each(function () {
        var target = $(this).slick('getSlick');

        if (!target.unslicked) {
          target.slideHandler(index, true);
        }
      });
    }
  };

  Slick.prototype.applyTransition = function (slide) {
    var _ = this,
        transition = {};

    if (_.options.fade === false) {
      transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
    } else {
      transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
    }

    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };

  Slick.prototype.autoPlay = function () {
    var _ = this;

    _.autoPlayClear();

    if (_.slideCount > _.options.slidesToShow) {
      _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    }
  };

  Slick.prototype.autoPlayClear = function () {
    var _ = this;

    if (_.autoPlayTimer) {
      clearInterval(_.autoPlayTimer);
    }
  };

  Slick.prototype.autoPlayIterator = function () {
    var _ = this,
        slideTo = _.currentSlide + _.options.slidesToScroll;

    if (!_.paused && !_.interrupted && !_.focussed) {
      if (_.options.infinite === false) {
        if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
          _.direction = 0;
        } else if (_.direction === 0) {
          slideTo = _.currentSlide - _.options.slidesToScroll;

          if (_.currentSlide - 1 === 0) {
            _.direction = 1;
          }
        }
      }

      _.slideHandler(slideTo);
    }
  };

  Slick.prototype.buildArrows = function () {
    var _ = this;

    if (_.options.arrows === true) {
      _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
      _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

      if (_.slideCount > _.options.slidesToShow) {
        _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

        _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

        if (_.htmlExpr.test(_.options.prevArrow)) {
          _.$prevArrow.prependTo(_.options.appendArrows);
        }

        if (_.htmlExpr.test(_.options.nextArrow)) {
          _.$nextArrow.appendTo(_.options.appendArrows);
        }

        if (_.options.infinite !== true) {
          _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        }
      } else {
        _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
          'aria-disabled': 'true',
          'tabindex': '-1'
        });
      }
    }
  };

  Slick.prototype.buildDots = function () {
    var _ = this,
        i,
        dot;

    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$slider.addClass('slick-dotted');

      dot = $('<ul />').addClass(_.options.dotsClass);

      for (i = 0; i <= _.getDotCount(); i += 1) {
        dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
      }

      _.$dots = dot.appendTo(_.options.appendDots);

      _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');
    }
  };

  Slick.prototype.buildOut = function () {
    var _ = this;

    _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
    _.slideCount = _.$slides.length;

    _.$slides.each(function (index, element) {
      $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
    });

    _.$slider.addClass('slick-slider');

    _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
    _.$list = _.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent();

    _.$slideTrack.css('opacity', 0);

    if (_.options.centerMode === true || _.options.swipeToSlide === true) {
      _.options.slidesToScroll = 1;
    }

    $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

    _.setupInfinite();

    _.buildArrows();

    _.buildDots();

    _.updateDots();

    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

    if (_.options.draggable === true) {
      _.$list.addClass('draggable');
    }
  };

  Slick.prototype.buildRows = function () {
    var _ = this,
        a,
        b,
        c,
        newSlides,
        numOfSlides,
        originalSlides,
        slidesPerSection;

    newSlides = document.createDocumentFragment();
    originalSlides = _.$slider.children();

    if (_.options.rows > 1) {
      slidesPerSection = _.options.slidesPerRow * _.options.rows;
      numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);

      for (a = 0; a < numOfSlides; a++) {
        var slide = document.createElement('div');

        for (b = 0; b < _.options.rows; b++) {
          var row = document.createElement('div');

          for (c = 0; c < _.options.slidesPerRow; c++) {
            var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);

            if (originalSlides.get(target)) {
              row.appendChild(originalSlides.get(target));
            }
          }

          slide.appendChild(row);
        }

        newSlides.appendChild(slide);
      }

      _.$slider.empty().append(newSlides);

      _.$slider.children().children().children().css({
        'width': 100 / _.options.slidesPerRow + '%',
        'display': 'inline-block'
      });
    }
  };

  Slick.prototype.checkResponsive = function (initial, forceUpdate) {
    var _ = this,
        breakpoint,
        targetBreakpoint,
        respondToWidth,
        triggerBreakpoint = false;

    var sliderWidth = _.$slider.width();

    var windowWidth = window.innerWidth || $(window).width();

    if (_.respondTo === 'window') {
      respondToWidth = windowWidth;
    } else if (_.respondTo === 'slider') {
      respondToWidth = sliderWidth;
    } else if (_.respondTo === 'min') {
      respondToWidth = Math.min(windowWidth, sliderWidth);
    }

    if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
      targetBreakpoint = null;

      for (breakpoint in _.breakpoints) {
        if (_.breakpoints.hasOwnProperty(breakpoint)) {
          if (_.originalSettings.mobileFirst === false) {
            if (respondToWidth < _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          } else {
            if (respondToWidth > _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          }
        }
      }

      if (targetBreakpoint !== null) {
        if (_.activeBreakpoint !== null) {
          if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
            _.activeBreakpoint = targetBreakpoint;

            if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
              _.unslick(targetBreakpoint);
            } else {
              _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);

              if (initial === true) {
                _.currentSlide = _.options.initialSlide;
              }

              _.refresh(initial);
            }

            triggerBreakpoint = targetBreakpoint;
          }
        } else {
          _.activeBreakpoint = targetBreakpoint;

          if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
            _.unslick(targetBreakpoint);
          } else {
            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);

            if (initial === true) {
              _.currentSlide = _.options.initialSlide;
            }

            _.refresh(initial);
          }

          triggerBreakpoint = targetBreakpoint;
        }
      } else {
        if (_.activeBreakpoint !== null) {
          _.activeBreakpoint = null;
          _.options = _.originalSettings;

          if (initial === true) {
            _.currentSlide = _.options.initialSlide;
          }

          _.refresh(initial);

          triggerBreakpoint = targetBreakpoint;
        }
      } // only trigger breakpoints during an actual break. not on initialize.


      if (!initial && triggerBreakpoint !== false) {
        _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
      }
    }
  };

  Slick.prototype.changeSlide = function (event, dontAnimate) {
    var _ = this,
        $target = $(event.currentTarget),
        indexOffset,
        slideOffset,
        unevenOffset; // If target is a link, prevent default action.


    if ($target.is('a')) {
      event.preventDefault();
    } // If target is not the <li> element (ie: a child), find the <li>.


    if (!$target.is('li')) {
      $target = $target.closest('li');
    }

    unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

    switch (event.data.message) {
      case 'previous':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;

        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
        }

        break;

      case 'next':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;

        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
        }

        break;

      case 'index':
        var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;

        _.slideHandler(_.checkNavigable(index), false, dontAnimate);

        $target.children().trigger('focus');
        break;

      default:
        return;
    }
  };

  Slick.prototype.checkNavigable = function (index) {
    var _ = this,
        navigables,
        prevNavigable;

    navigables = _.getNavigableIndexes();
    prevNavigable = 0;

    if (index > navigables[navigables.length - 1]) {
      index = navigables[navigables.length - 1];
    } else {
      for (var n in navigables) {
        if (index < navigables[n]) {
          index = prevNavigable;
          break;
        }

        prevNavigable = navigables[n];
      }
    }

    return index;
  };

  Slick.prototype.cleanUpEvents = function () {
    var _ = this;

    if (_.options.dots && _.$dots !== null) {
      $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }

    _.$slider.off('focus.slick blur.slick');

    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
      _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
    }

    _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);

    _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);

    _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);

    _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

    _.$list.off('click.slick', _.clickHandler);

    $(document).off(_.visibilityChange, _.visibility);

    _.cleanUpSlideEvents();

    if (_.options.accessibility === true) {
      _.$list.off('keydown.slick', _.keyHandler);
    }

    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().off('click.slick', _.selectHandler);
    }

    $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
    $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
    $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
    $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
    $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);
  };

  Slick.prototype.cleanUpSlideEvents = function () {
    var _ = this;

    _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));

    _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
  };

  Slick.prototype.cleanUpRows = function () {
    var _ = this,
        originalSlides;

    if (_.options.rows > 1) {
      originalSlides = _.$slides.children().children();
      originalSlides.removeAttr('style');

      _.$slider.empty().append(originalSlides);
    }
  };

  Slick.prototype.clickHandler = function (event) {
    var _ = this;

    if (_.shouldClick === false) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
    }
  };

  Slick.prototype.destroy = function (refresh) {
    var _ = this;

    _.autoPlayClear();

    _.touchObject = {};

    _.cleanUpEvents();

    $('.slick-cloned', _.$slider).detach();

    if (_.$dots) {
      _.$dots.remove();
    }

    if (_.$prevArrow && _.$prevArrow.length) {
      _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

      if (_.htmlExpr.test(_.options.prevArrow)) {
        _.$prevArrow.remove();
      }
    }

    if (_.$nextArrow && _.$nextArrow.length) {
      _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

      if (_.htmlExpr.test(_.options.nextArrow)) {
        _.$nextArrow.remove();
      }
    }

    if (_.$slides) {
      _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
        $(this).attr('style', $(this).data('originalStyling'));
      });

      _.$slideTrack.children(this.options.slide).detach();

      _.$slideTrack.detach();

      _.$list.detach();

      _.$slider.append(_.$slides);
    }

    _.cleanUpRows();

    _.$slider.removeClass('slick-slider');

    _.$slider.removeClass('slick-initialized');

    _.$slider.removeClass('slick-dotted');

    _.unslicked = true;

    if (!refresh) {
      _.$slider.trigger('destroy', [_]);
    }
  };

  Slick.prototype.disableTransition = function (slide) {
    var _ = this,
        transition = {};

    transition[_.transitionType] = '';

    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };

  Slick.prototype.fadeSlide = function (slideIndex, callback) {
    var _ = this;

    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).css({
        zIndex: _.options.zIndex
      });

      _.$slides.eq(slideIndex).animate({
        opacity: 1
      }, _.options.speed, _.options.easing, callback);
    } else {
      _.applyTransition(slideIndex);

      _.$slides.eq(slideIndex).css({
        opacity: 1,
        zIndex: _.options.zIndex
      });

      if (callback) {
        setTimeout(function () {
          _.disableTransition(slideIndex);

          callback.call();
        }, _.options.speed);
      }
    }
  };

  Slick.prototype.fadeSlideOut = function (slideIndex) {
    var _ = this;

    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).animate({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      }, _.options.speed, _.options.easing);
    } else {
      _.applyTransition(slideIndex);

      _.$slides.eq(slideIndex).css({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      });
    }
  };

  Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {
    var _ = this;

    if (filter !== null) {
      _.$slidesCache = _.$slides;

      _.unload();

      _.$slideTrack.children(this.options.slide).detach();

      _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

      _.reinit();
    }
  };

  Slick.prototype.focusHandler = function () {
    var _ = this;

    _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*:not(.slick-arrow)', function (event) {
      event.stopImmediatePropagation();
      var $sf = $(this);
      setTimeout(function () {
        if (_.options.pauseOnFocus) {
          _.focussed = $sf.is(':focus');

          _.autoPlay();
        }
      }, 0);
    });
  };

  Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {
    var _ = this;

    return _.currentSlide;
  };

  Slick.prototype.getDotCount = function () {
    var _ = this;

    var breakPoint = 0;
    var counter = 0;
    var pagerQty = 0;

    if (_.options.infinite === true) {
      while (breakPoint < _.slideCount) {
        ++pagerQty;
        breakPoint = counter + _.options.slidesToScroll;
        counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
      }
    } else if (_.options.centerMode === true) {
      pagerQty = _.slideCount;
    } else if (!_.options.asNavFor) {
      pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
    } else {
      while (breakPoint < _.slideCount) {
        ++pagerQty;
        breakPoint = counter + _.options.slidesToScroll;
        counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
      }
    }

    return pagerQty - 1;
  };

  Slick.prototype.getLeft = function (slideIndex) {
    var _ = this,
        targetLeft,
        verticalHeight,
        verticalOffset = 0,
        targetSlide;

    _.slideOffset = 0;
    verticalHeight = _.$slides.first().outerHeight(true);

    if (_.options.infinite === true) {
      if (_.slideCount > _.options.slidesToShow) {
        _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
        verticalOffset = verticalHeight * _.options.slidesToShow * -1;
      }

      if (_.slideCount % _.options.slidesToScroll !== 0) {
        if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
          if (slideIndex > _.slideCount) {
            _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
            verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
          } else {
            _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
            verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
          }
        }
      }
    } else {
      if (slideIndex + _.options.slidesToShow > _.slideCount) {
        _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
        verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
      }
    }

    if (_.slideCount <= _.options.slidesToShow) {
      _.slideOffset = 0;
      verticalOffset = 0;
    }

    if (_.options.centerMode === true && _.options.infinite === true) {
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
    } else if (_.options.centerMode === true) {
      _.slideOffset = 0;
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
    }

    if (_.options.vertical === false) {
      targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
    } else {
      targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
    }

    if (_.options.variableWidth === true) {
      if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
      } else {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
      }

      if (_.options.rtl === true) {
        if (targetSlide[0]) {
          targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
        } else {
          targetLeft = 0;
        }
      } else {
        targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
      }

      if (_.options.centerMode === true) {
        if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
        } else {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
        }

        if (_.options.rtl === true) {
          if (targetSlide[0]) {
            targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
          } else {
            targetLeft = 0;
          }
        } else {
          targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
        }

        targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
      }
    }

    return targetLeft;
  };

  Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {
    var _ = this;

    return _.options[option];
  };

  Slick.prototype.getNavigableIndexes = function () {
    var _ = this,
        breakPoint = 0,
        counter = 0,
        indexes = [],
        max;

    if (_.options.infinite === false) {
      max = _.slideCount;
    } else {
      breakPoint = _.options.slidesToScroll * -1;
      counter = _.options.slidesToScroll * -1;
      max = _.slideCount * 2;
    }

    while (breakPoint < max) {
      indexes.push(breakPoint);
      breakPoint = counter + _.options.slidesToScroll;
      counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
    }

    return indexes;
  };

  Slick.prototype.getSlick = function () {
    return this;
  };

  Slick.prototype.getSlideCount = function () {
    var _ = this,
        slidesTraversed,
        swipedSlide,
        centerOffset;

    centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

    if (_.options.swipeToSlide === true) {
      _.$slideTrack.find('.slick-slide').each(function (index, slide) {
        if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      });

      slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
      return slidesTraversed;
    } else {
      return _.options.slidesToScroll;
    }
  };

  Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {
    var _ = this;

    _.changeSlide({
      data: {
        message: 'index',
        index: parseInt(slide)
      }
    }, dontAnimate);
  };

  Slick.prototype.init = function (creation) {
    var _ = this;

    if (!$(_.$slider).hasClass('slick-initialized')) {
      $(_.$slider).addClass('slick-initialized');

      _.buildRows();

      _.buildOut();

      _.setProps();

      _.startLoad();

      _.loadSlider();

      _.initializeEvents();

      _.updateArrows();

      _.updateDots();

      _.checkResponsive(true);

      _.focusHandler();
    }

    if (creation) {
      _.$slider.trigger('init', [_]);
    }

    if (_.options.accessibility === true) {
      _.initADA();
    }

    if (_.options.autoplay) {
      _.paused = false;

      _.autoPlay();
    }
  };

  Slick.prototype.initADA = function () {
    var _ = this; // VELIR - remove tabindex: -1


    _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
      'aria-hidden': 'true'
    }).find('a, input, button, select').attr({
      'tabindex': '-1'
    });

    _.$slideTrack.attr('role', 'listbox');

    _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
      $(this).attr({
        'role': 'option',
        'aria-describedby': 'slick-slide' + _.instanceUid + i + ''
      });
    });
    /* VELIR
        - removed adding tablish role to dots
        - removed adding role tab to li
        - removed adding aria-selected to li
        - removed adding aria-controls to li
     */


    if (_.$dots !== null) {
      _.$dots.find('li').each(function (i) {
        $(this).attr({
          'id': 'slick-slide' + _.instanceUid + i + ''
        });
      }).find('button').attr('role', 'button').end().closest('div').attr('role', 'toolbar');
    }

    _.activateADA();
  };

  Slick.prototype.initArrowEvents = function () {
    var _ = this;

    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.off('click.slick').on('click.slick', {
        message: 'previous'
      }, _.changeSlide);

      _.$nextArrow.off('click.slick').on('click.slick', {
        message: 'next'
      }, _.changeSlide);
    }
  };

  Slick.prototype.initDotEvents = function () {
    var _ = this;

    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('click.slick', {
        message: 'index'
      }, _.changeSlide);
    }

    if (_.options.dots === true && _.options.pauseOnDotsHover === true) {
      $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };

  Slick.prototype.initSlideEvents = function () {
    var _ = this;

    if (_.options.pauseOnHover) {
      _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));

      _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };

  Slick.prototype.initializeEvents = function () {
    var _ = this;

    _.initArrowEvents();

    _.initDotEvents();

    _.initSlideEvents();

    _.$list.on('touchstart.slick mousedown.slick', {
      action: 'start'
    }, _.swipeHandler);

    _.$list.on('touchmove.slick mousemove.slick', {
      action: 'move'
    }, _.swipeHandler);

    _.$list.on('touchend.slick mouseup.slick', {
      action: 'end'
    }, _.swipeHandler);

    _.$list.on('touchcancel.slick mouseleave.slick', {
      action: 'end'
    }, _.swipeHandler);

    _.$list.on('click.slick', _.clickHandler);

    $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

    if (_.options.accessibility === true) {
      _.$list.on('keydown.slick', _.keyHandler);
    }

    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }

    $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
    $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
    $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
    $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
    $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);
  };

  Slick.prototype.initUI = function () {
    var _ = this;

    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.show();

      _.$nextArrow.show();
    }

    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.show();
    }
  };

  Slick.prototype.keyHandler = function (event) {
    var _ = this; //Dont slide if the cursor is inside the form fields and arrow keys are pressed


    if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
      if (event.keyCode === 37 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'next' : 'previous'
          }
        });
      } else if (event.keyCode === 39 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'previous' : 'next'
          }
        });
      }
    }
  };

  Slick.prototype.lazyLoad = function () {
    var _ = this,
        loadRange,
        cloneRange,
        rangeStart,
        rangeEnd;

    function loadImages(imagesScope) {
      $('img[data-lazy]', imagesScope).each(function () {
        var image = $(this),
            imageSource = $(this).attr('data-lazy'),
            imageToLoad = document.createElement('img');

        imageToLoad.onload = function () {
          image.animate({
            opacity: 0
          }, 100, function () {
            image.attr('src', imageSource).animate({
              opacity: 1
            }, 200, function () {
              image.removeAttr('data-lazy').removeClass('slick-loading');
            });

            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
          });
        };

        imageToLoad.onerror = function () {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
        };

        imageToLoad.src = imageSource;
      });
    }

    if (_.options.centerMode === true) {
      if (_.options.infinite === true) {
        rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
        rangeEnd = rangeStart + _.options.slidesToShow + 2;
      } else {
        rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
        rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
      }
    } else {
      rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
      rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);

      if (_.options.fade === true) {
        if (rangeStart > 0) rangeStart--;
        if (rangeEnd <= _.slideCount) rangeEnd++;
      }
    }

    loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
    loadImages(loadRange);

    if (_.slideCount <= _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-slide');
      loadImages(cloneRange);
    } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
      loadImages(cloneRange);
    } else if (_.currentSlide === 0) {
      cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
      loadImages(cloneRange);
    }
  };

  Slick.prototype.loadSlider = function () {
    var _ = this;

    _.setPosition();

    _.$slideTrack.css({
      opacity: 1
    });

    _.$slider.removeClass('slick-loading');

    _.initUI();

    if (_.options.lazyLoad === 'progressive') {
      _.progressiveLazyLoad();
    }
  };

  Slick.prototype.next = Slick.prototype.slickNext = function () {
    var _ = this;

    _.changeSlide({
      data: {
        message: 'next'
      }
    });
  };

  Slick.prototype.orientationChange = function () {
    var _ = this;

    _.checkResponsive();

    _.setPosition();
  };

  Slick.prototype.pause = Slick.prototype.slickPause = function () {
    var _ = this;

    _.autoPlayClear();

    _.paused = true;
  };

  Slick.prototype.play = Slick.prototype.slickPlay = function () {
    var _ = this;

    _.autoPlay();

    _.options.autoplay = true;
    _.paused = false;
    _.focussed = false;
    _.interrupted = false;
  };

  Slick.prototype.postSlide = function (index) {
    var _ = this;

    if (!_.unslicked) {
      _.$slider.trigger('afterChange', [_, index]);

      _.animating = false;

      _.setPosition();

      _.swipeLeft = null;

      if (_.options.autoplay) {
        _.autoPlay();
      }

      if (_.options.accessibility === true) {
        _.initADA();
      }
    }
  };

  Slick.prototype.prev = Slick.prototype.slickPrev = function () {
    var _ = this;

    _.changeSlide({
      data: {
        message: 'previous'
      }
    });
  };

  Slick.prototype.preventDefault = function (event) {
    event.preventDefault();
  };

  Slick.prototype.progressiveLazyLoad = function (tryCount) {
    tryCount = tryCount || 1;

    var _ = this,
        $imgsToLoad = $('img[data-lazy]', _.$slider),
        image,
        imageSource,
        imageToLoad;

    if ($imgsToLoad.length) {
      image = $imgsToLoad.first();
      imageSource = image.attr('data-lazy');
      imageToLoad = document.createElement('img');

      imageToLoad.onload = function () {
        image.attr('src', imageSource).removeAttr('data-lazy').removeClass('slick-loading');

        if (_.options.adaptiveHeight === true) {
          _.setPosition();
        }

        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);

        _.progressiveLazyLoad();
      };

      imageToLoad.onerror = function () {
        if (tryCount < 3) {
          /**
           * try to load the image 3 times,
           * leave a slight delay so we don't get
           * servers blocking the request.
           */
          setTimeout(function () {
            _.progressiveLazyLoad(tryCount + 1);
          }, 500);
        } else {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

          _.progressiveLazyLoad();
        }
      };

      imageToLoad.src = imageSource;
    } else {
      _.$slider.trigger('allImagesLoaded', [_]);
    }
  };

  Slick.prototype.refresh = function (initializing) {
    var _ = this,
        currentSlide,
        lastVisibleIndex;

    lastVisibleIndex = _.slideCount - _.options.slidesToShow; // in non-infinite sliders, we don't want to go past the
    // last visible index.

    if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
      _.currentSlide = lastVisibleIndex;
    } // if less slides than to show, go to start.


    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }

    currentSlide = _.currentSlide;

    _.destroy(true);

    $.extend(_, _.initials, {
      currentSlide: currentSlide
    });

    _.init();

    if (!initializing) {
      _.changeSlide({
        data: {
          message: 'index',
          index: currentSlide
        }
      }, false);
    }
  };

  Slick.prototype.registerBreakpoints = function () {
    var _ = this,
        breakpoint,
        currentBreakpoint,
        l,
        responsiveSettings = _.options.responsive || null;

    if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
      _.respondTo = _.options.respondTo || 'window';

      for (breakpoint in responsiveSettings) {
        l = _.breakpoints.length - 1;
        currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

        if (responsiveSettings.hasOwnProperty(breakpoint)) {
          // loop through the breakpoints and cut out any existing
          // ones with the same breakpoint number, we don't want dupes.
          while (l >= 0) {
            if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
              _.breakpoints.splice(l, 1);
            }

            l--;
          }

          _.breakpoints.push(currentBreakpoint);

          _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
        }
      }

      _.breakpoints.sort(function (a, b) {
        return _.options.mobileFirst ? a - b : b - a;
      });
    }
  };

  Slick.prototype.reinit = function () {
    var _ = this;

    _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
    _.slideCount = _.$slides.length;

    if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
      _.currentSlide = _.currentSlide - _.options.slidesToScroll;
    }

    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }

    _.registerBreakpoints();

    _.setProps();

    _.setupInfinite();

    _.buildArrows();

    _.updateArrows();

    _.initArrowEvents();

    _.buildDots();

    _.updateDots();

    _.initDotEvents();

    _.cleanUpSlideEvents();

    _.initSlideEvents();

    _.checkResponsive(false, true);

    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }

    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

    _.setPosition();

    _.focusHandler();

    _.paused = !_.options.autoplay;

    _.autoPlay();

    _.$slider.trigger('reInit', [_]);
  };

  Slick.prototype.resize = function () {
    var _ = this;

    if ($(window).width() !== _.windowWidth) {
      clearTimeout(_.windowDelay);
      _.windowDelay = window.setTimeout(function () {
        _.windowWidth = $(window).width();

        _.checkResponsive();

        if (!_.unslicked) {
          _.setPosition();
        }
      }, 50);
    }
  };

  Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {
    var _ = this;

    if (typeof index === 'boolean') {
      removeBefore = index;
      index = removeBefore === true ? 0 : _.slideCount - 1;
    } else {
      index = removeBefore === true ? --index : index;
    }

    if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
      return false;
    }

    _.unload();

    if (removeAll === true) {
      _.$slideTrack.children().remove();
    } else {
      _.$slideTrack.children(this.options.slide).eq(index).remove();
    }

    _.$slides = _.$slideTrack.children(this.options.slide);

    _.$slideTrack.children(this.options.slide).detach();

    _.$slideTrack.append(_.$slides);

    _.$slidesCache = _.$slides;

    _.reinit();
  };

  Slick.prototype.setCSS = function (position) {
    var _ = this,
        positionProps = {},
        x,
        y;

    if (_.options.rtl === true) {
      position = -position;
    }

    x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
    y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
    positionProps[_.positionProp] = position;

    if (_.transformsEnabled === false) {
      _.$slideTrack.css(positionProps);
    } else {
      positionProps = {};

      if (_.cssTransitions === false) {
        positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';

        _.$slideTrack.css(positionProps);
      } else {
        positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';

        _.$slideTrack.css(positionProps);
      }
    }
  };

  Slick.prototype.setDimensions = function () {
    var _ = this;

    if (_.options.vertical === false) {
      if (_.options.centerMode === true) {
        _.$list.css({
          padding: '0px ' + _.options.centerPadding
        });
      }
    } else {
      _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);

      if (_.options.centerMode === true) {
        _.$list.css({
          padding: _.options.centerPadding + ' 0px'
        });
      }
    }

    _.listWidth = _.$list[0].getBoundingClientRect().width;
    _.listHeight = _.$list.height();

    if (_.options.vertical === false && _.options.variableWidth === false) {
      _.slideWidth = Math.floor(_.listWidth / _.options.slidesToShow);

      _.$slideTrack.width(_.slideWidth * _.$slideTrack.children('.slick-slide').length);
    } else if (_.options.variableWidth === true) {
      _.$slideTrack.width(5000 * _.slideCount);
    } else {
      _.slideWidth = _.listWidth;

      _.$slideTrack.height(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length);
    }

    var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();

    if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
  };

  Slick.prototype.setFade = function () {
    var _ = this,
        targetLeft;

    _.$slides.each(function (index, element) {
      targetLeft = _.slideWidth * index * -1;

      if (_.options.rtl === true) {
        $(element).css({
          position: 'relative',
          right: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      } else {
        $(element).css({
          position: 'relative',
          left: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      }
    });

    _.$slides.eq(_.currentSlide).css({
      zIndex: _.options.zIndex - 1,
      opacity: 1
    });
  };

  Slick.prototype.setHeight = function () {
    var _ = this;

    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);

      _.$list.css('height', targetHeight);
    }
  };

  Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {
    /**
     * accepts arguments in format of:
     *
     *  - for changing a single option's value:
     *     .slick("setOption", option, value, refresh )
     *
     *  - for changing a set of responsive options:
     *     .slick("setOption", 'responsive', [{}, ...], refresh )
     *
     *  - for updating multiple values at once (not responsive)
     *     .slick("setOption", { 'option': value, ... }, refresh )
     */
    var _ = this,
        l,
        item,
        option,
        value,
        refresh = false,
        type;

    if ($.type(arguments[0]) === 'object') {
      option = arguments[0];
      refresh = arguments[1];
      type = 'multiple';
    } else if ($.type(arguments[0]) === 'string') {
      option = arguments[0];
      value = arguments[1];
      refresh = arguments[2];

      if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {
        type = 'responsive';
      } else if (typeof arguments[1] !== 'undefined') {
        type = 'single';
      }
    }

    if (type === 'single') {
      _.options[option] = value;
    } else if (type === 'multiple') {
      $.each(option, function (opt, val) {
        _.options[opt] = val;
      });
    } else if (type === 'responsive') {
      for (item in value) {
        if ($.type(_.options.responsive) !== 'array') {
          _.options.responsive = [value[item]];
        } else {
          l = _.options.responsive.length - 1; // loop through the responsive object and splice out duplicates.

          while (l >= 0) {
            if (_.options.responsive[l].breakpoint === value[item].breakpoint) {
              _.options.responsive.splice(l, 1);
            }

            l--;
          }

          _.options.responsive.push(value[item]);
        }
      }
    }

    if (refresh) {
      _.unload();

      _.reinit();
    }
  };

  Slick.prototype.setPosition = function () {
    var _ = this;

    _.setDimensions();

    _.setHeight();

    if (_.options.fade === false) {
      _.setCSS(_.getLeft(_.currentSlide));
    } else {
      _.setFade();
    }

    _.$slider.trigger('setPosition', [_]);
  };

  Slick.prototype.setProps = function () {
    var _ = this,
        bodyStyle = document.body.style;

    _.positionProp = _.options.vertical === true ? 'top' : 'left';

    if (_.positionProp === 'top') {
      _.$slider.addClass('slick-vertical');
    } else {
      _.$slider.removeClass('slick-vertical');
    }

    if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
      if (_.options.useCSS === true) {
        _.cssTransitions = true;
      }
    }

    if (_.options.fade) {
      if (typeof _.options.zIndex === 'number') {
        if (_.options.zIndex < 3) {
          _.options.zIndex = 3;
        }
      } else {
        _.options.zIndex = _.defaults.zIndex;
      }
    }

    if (bodyStyle.OTransform !== undefined) {
      _.animType = 'OTransform';
      _.transformType = '-o-transform';
      _.transitionType = 'OTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }

    if (bodyStyle.MozTransform !== undefined) {
      _.animType = 'MozTransform';
      _.transformType = '-moz-transform';
      _.transitionType = 'MozTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
    }

    if (bodyStyle.webkitTransform !== undefined) {
      _.animType = 'webkitTransform';
      _.transformType = '-webkit-transform';
      _.transitionType = 'webkitTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }

    if (bodyStyle.msTransform !== undefined) {
      _.animType = 'msTransform';
      _.transformType = '-ms-transform';
      _.transitionType = 'msTransition';
      if (bodyStyle.msTransform === undefined) _.animType = false;
    }

    if (bodyStyle.transform !== undefined && _.animType !== false) {
      _.animType = 'transform';
      _.transformType = 'transform';
      _.transitionType = 'transition';
    }

    _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
  };

  Slick.prototype.setSlideClasses = function (index) {
    var _ = this,
        centerOffset,
        allSlides,
        indexOffset,
        remainder; // VELIR - adding  tabindex: -1


    allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true').attr('tabindex', -1); // VELIR - adding tabindex: 0

    _.$slides.eq(index).addClass('slick-current').attr('tabindex', 0);

    if (_.options.centerMode === true) {
      centerOffset = Math.floor(_.options.slidesToShow / 2);

      if (_.options.infinite === true) {
        if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
          _.$slides.slice(index - centerOffset, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          indexOffset = _.options.slidesToShow + index;
          allSlides.slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
        }

        if (index === 0) {
          allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
        } else if (index === _.slideCount - 1) {
          allSlides.eq(_.options.slidesToShow).addClass('slick-center');
        }
      }

      _.$slides.eq(index).addClass('slick-center');
    } else {
      if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {
        _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
      } else if (allSlides.length <= _.options.slidesToShow) {
        allSlides.addClass('slick-active').attr('aria-hidden', 'false');
      } else {
        remainder = _.slideCount % _.options.slidesToShow;
        indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

        if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {
          allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
        }
      }
    }

    if (_.options.lazyLoad === 'ondemand') {
      _.lazyLoad();
    }
  };

  Slick.prototype.setupInfinite = function () {
    var _ = this,
        i,
        slideIndex,
        infiniteCount;

    if (_.options.fade === true) {
      _.options.centerMode = false;
    }

    if (_.options.infinite === true && _.options.fade === false) {
      slideIndex = null;

      if (_.slideCount > _.options.slidesToShow) {
        if (_.options.centerMode === true) {
          infiniteCount = _.options.slidesToShow + 1;
        } else {
          infiniteCount = _.options.slidesToShow;
        }

        for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
          slideIndex = i - 1;
          $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
        }

        for (i = 0; i < infiniteCount; i += 1) {
          slideIndex = i;
          $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
        }

        _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
          $(this).attr('id', '');
        });
      }
    }
  };

  Slick.prototype.interrupt = function (toggle) {
    var _ = this;

    if (!toggle) {
      _.autoPlay();
    }

    _.interrupted = toggle;
  };

  Slick.prototype.selectHandler = function (event) {
    var _ = this;

    var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
    var index = parseInt(targetElement.attr('data-slick-index'));
    if (!index) index = 0;

    if (_.slideCount <= _.options.slidesToShow) {
      _.setSlideClasses(index);

      _.asNavFor(index);

      return;
    }

    _.slideHandler(index);
  };

  Slick.prototype.slideHandler = function (index, sync, dontAnimate) {
    var targetSlide,
        animSlide,
        oldSlide,
        slideLeft,
        targetLeft = null,
        _ = this,
        navTarget;

    sync = sync || false;

    if (_.animating === true && _.options.waitForAnimate === true) {
      return;
    }

    if (_.options.fade === true && _.currentSlide === index) {
      return;
    }

    if (_.slideCount <= _.options.slidesToShow) {
      return;
    }

    if (sync === false) {
      _.asNavFor(index);
    }

    targetSlide = index;
    targetLeft = _.getLeft(targetSlide);
    slideLeft = _.getLeft(_.currentSlide);
    _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

    if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;

        if (dontAnimate !== true) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }

      return;
    } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;

        if (dontAnimate !== true) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }

      return;
    }

    if (_.options.autoplay) {
      clearInterval(_.autoPlayTimer);
    }

    if (targetSlide < 0) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
      } else {
        animSlide = _.slideCount + targetSlide;
      }
    } else if (targetSlide >= _.slideCount) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = 0;
      } else {
        animSlide = targetSlide - _.slideCount;
      }
    } else {
      animSlide = targetSlide;
    }

    _.animating = true;

    _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

    oldSlide = _.currentSlide;
    _.currentSlide = animSlide;

    _.setSlideClasses(_.currentSlide);

    if (_.options.asNavFor) {
      navTarget = _.getNavTarget();
      navTarget = navTarget.slick('getSlick');

      if (navTarget.slideCount <= navTarget.options.slidesToShow) {
        navTarget.setSlideClasses(_.currentSlide);
      }
    }

    _.updateDots();

    _.updateArrows();

    if (_.options.fade === true) {
      if (dontAnimate !== true) {
        _.fadeSlideOut(oldSlide);

        _.fadeSlide(animSlide, function () {
          _.postSlide(animSlide);
        });
      } else {
        _.postSlide(animSlide);
      }

      _.animateHeight();

      return;
    }

    if (dontAnimate !== true) {
      _.animateSlide(targetLeft, function () {
        _.postSlide(animSlide);
      });
    } else {
      _.postSlide(animSlide);
    }
  };

  Slick.prototype.startLoad = function () {
    var _ = this;

    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.hide();

      _.$nextArrow.hide();
    }

    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.hide();
    }

    _.$slider.addClass('slick-loading');
  };

  Slick.prototype.swipeDirection = function () {
    var xDist,
        yDist,
        r,
        swipeAngle,
        _ = this;

    xDist = _.touchObject.startX - _.touchObject.curX;
    yDist = _.touchObject.startY - _.touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);

    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }

    if (swipeAngle <= 45 && swipeAngle >= 0) {
      return _.options.rtl === false ? 'left' : 'right';
    }

    if (swipeAngle <= 360 && swipeAngle >= 315) {
      return _.options.rtl === false ? 'left' : 'right';
    }

    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return _.options.rtl === false ? 'right' : 'left';
    }

    if (_.options.verticalSwiping === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 'down';
      } else {
        return 'up';
      }
    }

    return 'vertical';
  };

  Slick.prototype.swipeEnd = function (event) {
    var _ = this,
        slideCount,
        direction;

    _.dragging = false;
    _.interrupted = false;
    _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;

    if (_.touchObject.curX === undefined) {
      return false;
    }

    if (_.touchObject.edgeHit === true) {
      _.$slider.trigger('edge', [_, _.swipeDirection()]);
    }

    if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
      direction = _.swipeDirection();

      switch (direction) {
        case 'left':
        case 'down':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
          _.currentDirection = 0;
          break;

        case 'right':
        case 'up':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
          _.currentDirection = 1;
          break;

        default:
      }

      if (direction != 'vertical') {
        _.slideHandler(slideCount);

        _.touchObject = {};

        _.$slider.trigger('swipe', [_, direction]);
      }
    } else {
      if (_.touchObject.startX !== _.touchObject.curX) {
        _.slideHandler(_.currentSlide);

        _.touchObject = {};
      }
    }
  };

  Slick.prototype.swipeHandler = function (event) {
    var _ = this;

    if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) {
      return;
    } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
      return;
    }

    _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
    _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;

    if (_.options.verticalSwiping === true) {
      _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
    }

    switch (event.data.action) {
      case 'start':
        _.swipeStart(event);

        break;

      case 'move':
        _.swipeMove(event);

        break;

      case 'end':
        _.swipeEnd(event);

        break;
    }
  };

  Slick.prototype.swipeMove = function (event) {
    var _ = this,
        edgeWasHit = false,
        curLeft,
        swipeDirection,
        swipeLength,
        positionOffset,
        touches;

    touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

    if (!_.dragging || touches && touches.length !== 1) {
      return false;
    }

    curLeft = _.getLeft(_.currentSlide);
    _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
    _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
    _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

    if (_.options.verticalSwiping === true) {
      _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
    }

    swipeDirection = _.swipeDirection();

    if (swipeDirection === 'vertical') {
      return;
    }

    if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
      event.preventDefault();
    }

    positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);

    if (_.options.verticalSwiping === true) {
      positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
    }

    swipeLength = _.touchObject.swipeLength;
    _.touchObject.edgeHit = false;

    if (_.options.infinite === false) {
      if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
        swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
        _.touchObject.edgeHit = true;
      }
    }

    if (_.options.vertical === false) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    } else {
      _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
    }

    if (_.options.verticalSwiping === true) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    }

    if (_.options.fade === true || _.options.touchMove === false) {
      return false;
    }

    if (_.animating === true) {
      _.swipeLeft = null;
      return false;
    }

    _.setCSS(_.swipeLeft);
  };

  Slick.prototype.swipeStart = function (event) {
    var _ = this,
        touches;

    _.interrupted = true;

    if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
      _.touchObject = {};
      return false;
    }

    if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
      touches = event.originalEvent.touches[0];
    }

    _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
    _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
    _.dragging = true;
  };

  Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {
    var _ = this;

    if (_.$slidesCache !== null) {
      _.unload();

      _.$slideTrack.children(this.options.slide).detach();

      _.$slidesCache.appendTo(_.$slideTrack);

      _.reinit();
    }
  };

  Slick.prototype.unload = function () {
    var _ = this;

    $('.slick-cloned', _.$slider).remove();

    if (_.$dots) {
      _.$dots.remove();
    }

    if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
      _.$prevArrow.remove();
    }

    if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
      _.$nextArrow.remove();
    }

    _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
  };

  Slick.prototype.unslick = function (fromBreakpoint) {
    var _ = this;

    _.$slider.trigger('unslick', [_, fromBreakpoint]);

    _.destroy();
  };

  Slick.prototype.updateArrows = function () {
    var _ = this,
        centerOffset;

    centerOffset = Math.floor(_.options.slidesToShow / 2);

    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
      _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

      _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

      if (_.currentSlide === 0) {
        _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');

        _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');

        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');

        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      }
    }
  };

  Slick.prototype.updateDots = function () {
    var _ = this;

    if (_.$dots !== null) {
      _.$dots.find('li').removeClass('slick-active').attr('aria-hidden', 'true');

      _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active').attr('aria-hidden', 'false');
    }
  };

  Slick.prototype.visibility = function () {
    var _ = this;

    if (_.options.autoplay) {
      if (document[_.hidden]) {
        _.interrupted = true;
      } else {
        _.interrupted = false;
      }
    }
  };

  $.fn.slick = function () {
    var _ = this,
        opt = arguments[0],
        args = Array.prototype.slice.call(arguments, 1),
        l = _.length,
        i,
        ret;

    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);else ret = _[i].slick[opt].apply(_[i].slick, args);
      if (typeof ret != 'undefined') return ret;
    }

    return _;
  };
});

},{"jquery":"jquery"}],52:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FeatureItem = _interopRequireWildcard(require("./FeatureItem.jsx"));

var _LoadingSpinner = _interopRequireDefault(require("../../search/components/LoadingSpinner.jsx"));

var _paging = require("../../search/paging");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DynamicItemList = function DynamicItemList(_ref) {
  var results = _ref.results,
      totalResults = _ref.totalResults,
      query = _ref.query,
      nextPage = _ref.nextPage,
      viewAllUrl = _ref.viewAllUrl,
      loading = _ref.loading,
      dictionary = _ref.dictionary,
      displayDates = _ref.displayDates;
  var dictionaryBindings = {};

  function dictEntryFor(key) {
    // if name is a dictionary key, grab it
    var entry = dictionary[key];

    if (!entry) {
      // if not a dictionary key, check if it's bound to a dictionary key
      var lowerKey = key.toLowerCase();
      entry = dictionary[dictionaryBindings[lowerKey]];
    } // if no entry found, simply return the name


    return entry || key;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "dynamic-content-listing"
  }, results.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(_FeatureItem.default, _extends({
      key: i,
      displayDates: displayDates
    }, item));
  }), loading && /*#__PURE__*/_react.default.createElement("div", {
    className: "dynamic-content-listing__loading-spinner"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "",
    src: "/assets/img/loading.gif"
  })), !(0, _paging.isLastPage)(totalResults, query.perPage, query.page) && /*#__PURE__*/_react.default.createElement("div", {
    className: "dynamic-content-listing__load-more-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dynamic-content-listing__load-more"
  }, !viewAllUrl && /*#__PURE__*/_react.default.createElement("button", {
    className: "pct-btn",
    onClick: function onClick(e) {
      return nextPage();
    },
    type: "button"
  }, dictEntryFor("loadMoreLabel")), viewAllUrl && /*#__PURE__*/_react.default.createElement("a", {
    href: viewAllUrl,
    className: "pct-btn"
  }, dictEntryFor("viewAllLabel")))));
};

var _default = DynamicItemList;
exports.default = _default;
var _React$PropTypes = _react.default.PropTypes,
    arrayOf = _React$PropTypes.arrayOf,
    object = _React$PropTypes.object,
    func = _React$PropTypes.func,
    number = _React$PropTypes.number,
    bool = _React$PropTypes.bool;
DynamicItemList.propTypes = {
  totalResults: number,
  results: arrayOf(_FeatureItem.featureItemShape).isRequired,
  query: object,
  nextPage: func.isRequired,
  displayDates: bool,
  dictionary: object
};

},{"../../search/components/LoadingSpinner.jsx":84,"../../search/paging":103,"./FeatureItem.jsx":53,"react":"react"}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureItemShape = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderIcon(icon) {
  if (icon == "download") {
    return /*#__PURE__*/_react.default.createElement("svg", {
      width: "20px",
      height: "20px",
      viewBox: "0 0 20 20",
      version: "1.1"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "HIA",
      transform: "translate(-630.000000, -1183.000000)"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "Group-2-Copy",
      transform: "translate(528.000000, 1092.333333)"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "ii-/-download_Circle_Grey",
      transform: "translate(94.000000, 85.000000)"
    }, /*#__PURE__*/_react.default.createElement("circle", {
      id: "Oval",
      cx: "15",
      cy: "15",
      r: "13.3333333"
    }), /*#__PURE__*/_react.default.createElement("g", {
      id: "Group-2",
      strokeWidth: "1",
      fillRule: "evenodd",
      transform: "translate(15.055555, 15.555556) rotate(90.000000) translate(-15.055555, -15.555556) translate(4.222222, 8.333333)",
      stroke: "#296EC3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M1.77335451,7.22222222 L14.4444444,7.22222222",
      id: "Line"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M18.0555556,0.902777778 L18.0555556,13.5416667",
      id: "Line"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M8.55905338,1.33683116 L14.4444444,7.22222222",
      id: "Line"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M8.55905338,13.1076133 L14.4444444,7.22222222",
      id: "Line"
    })))))));
  } else if (icon == "external") {
    return /*#__PURE__*/_react.default.createElement("svg", {
      width: "20px",
      height: "20px",
      viewBox: "0 0 20 20",
      version: "1.1"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "HIA"
    }, /*#__PURE__*/_react.default.createElement("rect", {
      fill: "#FFFFFF",
      x: "0",
      y: "0",
      width: "20",
      height: "20"
    }), /*#__PURE__*/_react.default.createElement("g", {
      id: "Group-2-Copy-2",
      stroke: "#296EC3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "ii-/-External_Link_Grey"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "Group-2"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M1.04166667,17.7083333 L15.7730579,2.97694206",
      id: "Line"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M5.20729592,2.97694206 L15.7730579,2.97694206",
      id: "Line"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M15.7730579,13.5427041 L15.7730579,2.97694206",
      id: "Line"
    })))))));
  } else {
    return;
  }
}

var FeatureItem = function FeatureItem(_ref) {
  var featureItemContentType = _ref.featureItemContentType,
      featureItemDisplayDate = _ref.featureItemDisplayDate,
      featureItemId = _ref.featureItemId,
      featureItemImage = _ref.featureItemImage,
      featureItemImage1x1Src = _ref.featureItemImage1x1Src,
      featureItemSummary = _ref.featureItemSummary,
      featureItemTitle = _ref.featureItemTitle,
      featureItemUrl = _ref.featureItemUrl,
      displayDates = _ref.displayDates,
      iconType = _ref.iconType,
      suppressContentType = _ref.suppressContentType,
      suppressPublicationDate = _ref.suppressPublicationDate;

  var shouldDisplayDate = function shouldDisplayDate() {
    return featureItemDisplayDate && displayDates;
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "dynamic-content-listing__content"
  }, featureItemImage1x1Src && /*#__PURE__*/_react.default.createElement("a", {
    className: "dynamic-content-listing__image",
    href: featureItemUrl
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "",
    src: "".concat(featureItemImage1x1Src, "?w=280&h=280")
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "dynamic-content-listing__details"
  }, featureItemContentType && !suppressContentType && /*#__PURE__*/_react.default.createElement("h4", {
    className: "dynamic-content-listing__content-type"
  }, featureItemContentType), shouldDisplayDate() && !suppressPublicationDate && /*#__PURE__*/_react.default.createElement("span", {
    className: "dynamic-content-listing__date"
  }, featureItemDisplayDate), /*#__PURE__*/_react.default.createElement("h2", {
    className: "dynamic-content-listing__listing-title"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: featureItemUrl,
    dangerouslySetInnerHTML: {
      __html: featureItemTitle
    }
  }), iconType && renderIcon(iconType)), featureItemSummary && /*#__PURE__*/_react.default.createElement("span", {
    className: "dynamic-content-listing__listing-summary",
    dangerouslySetInnerHTML: {
      __html: featureItemSummary
    }
  })));
};

var _default = FeatureItem;
exports.default = _default;
var _React$PropTypes = _react.default.PropTypes,
    string = _React$PropTypes.string,
    shape = _React$PropTypes.shape,
    objectOf = _React$PropTypes.objectOf,
    bool = _React$PropTypes.bool;
var featureItemProps = {
  featureItemContentType: string,
  featureItemDisplayDate: string,
  featureItemId: string.isRequired,
  featureItemImage1x1Src: string,
  featureItemTitle: string.isRequired,
  featureItemSummary: string,
  featureItemUrl: string.isRequired,
  displayDates: bool,
  iconType: string,
  suppressContentType: bool,
  suppressPublicationDate: bool
};
var featureItemShape = shape(featureItemProps);
exports.featureItemShape = featureItemShape;
FeatureItem.propTypes = featureItemProps;

},{"react":"react"}],54:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _DynamicItemList = _interopRequireDefault(require("../components/DynamicItemList.jsx"));

var _search = require("../../search/redux/search/search.actions");

var _facets = require("../../search/redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    results: state.results,
    resultsDisplayStrategy: state.resultsDisplayStrategy,
    totalResults: state.totalResults,
    loading: state.loading,
    isFirstLoad: state.isFirstLoad,
    query: state.query,
    pagination: state.pagination,
    displayDates: state.displayDates,
    dictionary: state.dictionary,
    viewAllUrl: state.viewAllUrl
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    nextPage: function nextPage() {
      dispatch((0, _search.loadNextPage)());
    },
    dismissFacet: function dismissFacet(facetId) {
      dispatch((0, _search.loadFacetChange)(facetId, false));
    },
    showMobileFacets: function showMobileFacets() {
      dispatch((0, _search.showMobileFacets)());
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_DynamicItemList.default);

exports.default = _default;

},{"../../search/redux/facets":106,"../../search/redux/search/search.actions":111,"../components/DynamicItemList.jsx":52,"react-redux":"react-redux"}],55:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSearchApp = initSearchApp;

var _jquery = _interopRequireDefault(require("jquery"));

var _ramda = _interopRequireDefault(require("ramda"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reactRedux = require("react-redux");

var _rootReducer = _interopRequireDefault(require("../search/redux/rootReducer"));

var _search = require("../search/redux/search/search.reducer");

var _search2 = require("../search/redux/search/search.actions");

var _configureStore = _interopRequireDefault(require("../search/redux/configureStore"));

var _service = require("../search/redux/service");

var _service2 = require("./redux/service");

var _resultsDisplay = require("../search/redux/resultsDisplay");

var _DynamicItemsContainer = _interopRequireDefault(require("./containers/DynamicItemsContainer.jsx"));

var _FacetsContainer = _interopRequireDefault(require("../search/containers/FacetsContainer.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the mount nodes are the elements we want to include
// as part of the search app
function initSearchApp(mountNodes) {
  if (!mountNodes.length) {
    return;
  } // extract the searchId from the mountNodes
  // while also checking mountNodes share same id


  var searchId = mountNodes.reduce(function (id, node) {
    var nodeId = (0, _jquery.default)(node).data("searchId"); // if id is null, we want to set it
    // with the first node's value

    if (id === null) {
      return nodeId;
    } // if node id does not equal current
    // id value, it's invalid and return undefined


    if (id !== nodeId) {
      return;
    }

    return id;
  }, null); // if we have an invalid or non-matching id, raise an error

  if (!searchId) {
    throw new Error("Could not initialize Pew search app. searchId was either not present, or provided mount nodes did not share the same searchId");
  } // define the canonical inital state of our redux store here
  // including some value taken from the data-attrs of the
  // mount node.


  var config = window.PewSearchConfigs.find(function (c) {
    return c.searchId === searchId;
  });

  if (!config) {
    throw new Error("Could not initialize Pew search app instance with id of \"".concat(searchId, "\". Configuration data not found."));
  }

  var facetDisplayOverride = {
    "contentType": config.displayContentTypeFilter,
    "places": config.displayPlacesFilter,
    "project": config.displayProjectsFilter,
    "tag": config.displayTagsFilter,
    "topic": config.displayTopicsFilter
  }; // create a starting state object,
  // which includes and intitial state
  // from individual reducers

  var initialState = _ramda.default.merge(_search.initialState, {
    url: config.url,
    pagination: config.pagination,
    resultsDisplayStrategy: config.pagination ? _resultsDisplay.RESULTS_DISPLAY_REFRESH : _resultsDisplay.RESULTS_DISPLAY_APPEND,
    viewAllUrl: config.viewAllUrl,
    dictionary: config.dictionary,
    facetDisplayOverride: facetDisplayOverride,
    displayDates: config.displayDates,
    query: _ramda.default.merge(_search.initialState.query, {
      pageId: config.pageId,
      page: config.page,
      perPage: config.perPage,
      componentGuid: config.componentId
    })
  }); // determine if we want to load all page results in our cold load


  var doLoadAllPages = initialState.resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND && initialState.isFirstLoad;
  initialState = _ramda.default.merge(initialState, {
    query: _ramda.default.merge(initialState.query, {
      loadAllPages: doLoadAllPages
    })
  });

  var thunkMiddleware = _reduxThunk.default.withExtraArgument({
    mapResponseToState: _service.mapResponseToState,
    fetchSearchResults: _service2.fetchSearchResults
  });

  var store = (0, _configureStore.default)(_rootReducer.default, initialState, [thunkMiddleware]);
  store.dispatch((0, _search2.loadResults)());
  mountNodes.forEach(function (node) {
    if (node.className.indexOf("js-dynamic-items") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_DynamicItemsContainer.default, null)), node);
    }

    if (node.className.indexOf("js-dynamic-items-search-facets") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_FacetsContainer.default, null)), node);
    }
  });
}

},{"../search/containers/FacetsContainer.jsx":95,"../search/redux/configureStore":104,"../search/redux/resultsDisplay":108,"../search/redux/rootReducer":109,"../search/redux/search/search.actions":111,"../search/redux/search/search.reducer":112,"../search/redux/service":113,"./containers/DynamicItemsContainer.jsx":54,"./redux/service":56,"jquery":"jquery","ramda":"ramda","react":"react","react-dom":"react-dom","react-redux":"react-redux","redux-thunk":"redux-thunk"}],56:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSearchResults = fetchSearchResults;

var _ramda = _interopRequireDefault(require("ramda"));

var _jquery = _interopRequireDefault(require("jquery"));

var _util = require("../../search/util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchSearchResults(url, query) {
  // dynamic content needs to remap some stuff on the request
  // that's normally part of vanilla search.
  // lose params we don't need. PageGuid and ComponentGuid are added automatically to the URL
  var removeInvalidParams = _ramda.default.omit(["q", "sortBy", "sortOrder", "loadAllPages", "numberOfItems", "startOffset", "pageId", "componentGuid"]); // any facet/filter group params get changed to filter.<groupName>.
  // Keep track of which params are not filters/


  var nonFilters = ["pageId", "componentGuid", "page", "perPage"];

  var stringifyArrayParams = _ramda.default.map(function (v) {
    return v instanceof Array ? v.join(";") : v;
  });

  var keyName = function keyName(key) {
    return _ramda.default.contains(key, nonFilters) ? key : "filters.".concat(key);
  };

  var filterizeKeys = _ramda.default.partial(_util.renameKeysWith, [keyName]);

  var fixQuery = _ramda.default.pipe(removeInvalidParams, stringifyArrayParams, filterizeKeys);

  var searchPromise = _jquery.default.ajax({
    url: url,
    data: fixQuery(query)
  });

  var featuredPromise = _jquery.default.Deferred().resolve([]);

  return [searchPromise, featuredPromise];
}

},{"../../search/util":114,"jquery":"jquery","ramda":"ramda"}],57:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var _classnames = _interopRequireDefault(require("classnames"));

var _dataShapes = require("../dataShapes");

var _hiaFacets = require("../../search/redux/hia-facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MAX_FACETS_SHOWN = 5;
/**
 * 
 * An accordion like section for a single grouping of facets
 * ```
 *  <FacetGroup
      group={group}
      isOpen={false}
      handleFacetChange={func}
      handleClearAll={func} />
 * ```
 * @component
 * @param {object} props
 * @param {bool} props.isOpen Flag for the open state of the accordion
 * @param {object} props.group The group of facets to show
 * @param {function} props.handleFacetChange Function called when a facet is selected/deselected
 * @params {function} prop.handleClearGroup Function called when clearing all selected facets
 */

var FacetGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(FacetGroup, _React$Component);

  var _super = _createSuper(FacetGroup);

  function FacetGroup(props) {
    var _this;

    _classCallCheck(this, FacetGroup);

    _this = _super.call(this, props);
    _this.state = {
      isGroupOpen: _this.props.isOpen,
      isGroupExpanded: false,
      valuesExpanded: [],
      hidden: []
    };
    return _this;
  } // Lifecycle


  _createClass(FacetGroup, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // if group is closed, but has selected
      // values, open it
      var group = this.props.group;
      var selected = (0, _hiaFacets.selectedFacetsFromGroup)(group);
      var shouldOpen = this.state.isGroupOpen;

      if (selected.length > 0) {
        shouldOpen = true;
      } // Some facets will be expanded by default due to
      // children being pre-selected


      var hasSelected = (0, _hiaFacets.valuesWithSelectedChildren)(group);
      var selectedIds = hasSelected.map(function (v) {
        return v.id;
      }); // similarly, if group's values or value children
      // are selected, auto-expand that group

      var tailValues = _ramda.default.drop(MAX_FACETS_SHOWN, group.values);

      var shouldExpand = tailValues.reduce(function (should, tv) {
        if (tv.selected === true || selectedIds.indexOf(tv.id) >= 0) {
          should = true;
        }

        return should;
      }, false);
      this.setState({
        isGroupOpen: shouldOpen,
        isGroupExpanded: shouldExpand,
        valuesExpanded: selectedIds
      });
    }
  }, {
    key: "chunkValues",
    value: function chunkValues(values) {
      // divide the values into two arrays, the first for the Top X facets
      // and the second for overflow. If recursion level is over zero, put
      // all values in first array.
      return values.length > MAX_FACETS_SHOWN ? _ramda.default.splitAt(MAX_FACETS_SHOWN, values) : [values, []];
    }
  }, {
    key: "showExpandButton",
    value: function showExpandButton() {
      return !this.state.isGroupExpanded;
    }
  }, {
    key: "shouldRenderTailValues",
    value: function shouldRenderTailValues(tailValues) {
      return this.state.isGroupExpanded && tailValues.length > 0;
    }
  }, {
    key: "shouldRenderChildGroups",
    value: function shouldRenderChildGroups(group) {
      return group.isOpen && !!group.childGroups && group.childGroups.length > 0;
    }
  }, {
    key: "toggleGroup",
    value: function toggleGroup() {
      var isOpen = !this.state.isGroupOpen;
      this.setState({
        isGroupOpen: isOpen
      });
    }
  }, {
    key: "toggleExpand",
    value: function toggleExpand() {
      var isExpanded = !this.state.isGroupExpanded;
      this.setState({
        isGroupExpanded: isExpanded
      });
    }
  }, {
    key: "toggleValueExpand",
    value: function toggleValueExpand(valueId) {
      // check if the valueId is in the list. Remove it
      // if found, add it if not.
      var valueIdx = this.state.valuesExpanded.indexOf(valueId);
      var selectedValues = valueIdx >= 0 ? _ramda.default.remove(valueIdx, 1, this.state.valuesExpanded) : _ramda.default.append(valueId, this.state.valuesExpanded);
      this.setState({
        valuesExpanded: selectedValues
      });
    }
  }, {
    key: "valueIsExpanded",
    value: function valueIsExpanded(value) {
      return this.state.valuesExpanded.indexOf(value.id) >= 0;
    }
  }, {
    key: "onFacetChange",
    value: function onFacetChange(event, valueId, groupId) {
      this.props.handleFacetChange(groupId, valueId, event.target.checked);
    }
  }, {
    key: "onClearGroup",
    value: function onClearGroup() {
      var group = this.props.group;
      this.props.handleClearGroup(group);
    }
  }, {
    key: "handleInlineFilterChange",
    value: function handleInlineFilterChange(group, query) {
      // we want to update the facets in state, but make sure to always
      // read facets from props, so state changes don't mess with the
      // original list of facets
      var hiddenValues = (0, _hiaFacets.filterVisibleFacetsInGroup)(group, query); //this.setState(R.merge(this.state, { facets: newFacets, activeQuery: query }));

      this.setState({
        hidden: hiddenValues,
        activeQuery: query
      });
    } //

  }, {
    key: "renderInlineSearch",
    value: function renderInlineSearch(group) {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets-bar__inline-filter"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        onChange: function onChange(e) {
          return _this2.handleInlineFilterChange(group, e.target.value);
        },
        placeholder: "Search ".concat(group.label, "..."),
        value: this.state.activeQuery || ""
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "icon"
      }, this.searchIcon()));
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      return /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 924 922.666015625"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M456.667 1.333c126.667-1.333 235.333 42 326 130s137.333 195.333 140 322C924 580 880.334 689 791.667 780.333s-196.333 138.333-323 141C342 922.666 233 879 141.667 790.333S4 594 2.667 467.333c-2.667-126.667 40.667-235.667 130-327s197.333-137.667 324-139m52 152c-28 0-49.667 8-65 24-15.333 16-23 32.667-23 50-1.333 18.667 3.667 33.333 15 44 11.333 10.667 27.667 16 49 16 25.333 0 45.667-7.333 61-22 15.333-14.667 23-32.667 23-54 0-38.667-20-58-60-58m-120 594c20 0 48-8.667 84-26s71.333-43.333 106-78l-18-24c-32 24-56 36-72 36-9.333 0-10.667-12.667-4-38l42-160c17.333-64 10-96-22-96-20 0-49.667 9.667-89 29s-77.667 44.333-115 75l16 26c34.667-22.667 59.333-34 74-34 8 0 8 11.333 0 34l-36 152c-17.333 69.333-6 104 34 104"
      }));
    }
  }, {
    key: "searchIcon",
    value: function searchIcon() {
      return /*#__PURE__*/_react.default.createElement("svg", {
        viewBox: "0 0 20 20"
      }, /*#__PURE__*/_react.default.createElement("use", {
        xlinkHref: "#a",
        transform: "translate(1.11 1.11)",
        fill: "#296EC3"
      }), /*#__PURE__*/_react.default.createElement("use", {
        xlinkHref: "#b",
        transform: "translate(13.33 13.333)",
        fill: "#296EC3"
      }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
        id: "a",
        d: "M7.22 15.44c4.54 0 8.22-3.68 8.22-8.22h-2c0 3.44-2.78 6.22-6.22 6.22v2zm8.22-8.22C15.44 2.68 11.76-1 7.22-1v2c3.44 0 6.22 2.8 6.22 6.22h2zM7.22-1C2.68-1-1 2.68-1 7.22h2C1 3.8 3.8 1 7.22 1v-2zM-1 7.22c0 4.54 3.68 8.22 8.22 8.22v-2C3.8 13.44 1 10.66 1 7.22h-2z"
      }), /*#__PURE__*/_react.default.createElement("path", {
        id: "b",
        d: "M1.26-.15c-.4-.4-1.02-.4-1.4 0-.4.4-.4 1.02 0 1.4l1.4-1.4zM4.3 5.7c.38.4 1.02.4 1.4 0 .4-.38.4-1.02 0-1.4L4.3 5.7zM-.16 1.27L4.3 5.7l1.4-1.4L1.27-.16l-1.4 1.4z"
      })));
    }
  }, {
    key: "arrowIcon",
    value: function arrowIcon() {
      return /*#__PURE__*/_react.default.createElement("svg", {
        viewBox: "0 0 11 19",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.5 18.5L1 9.7"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.5.9L1 9.7"
      })));
    }
  }, {
    key: "checkmark",
    value: function checkmark() {
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: "11px",
        height: "9px",
        viewBox: "0 0 11 9",
        version: "1.1"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "Symbols",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "HIA-/-filter",
        transform: "translate(-256.000000, -110.000000)",
        stroke: "#333333"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "Group-2"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "Group",
        transform: "translate(1.000000, 99.000000)"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "ii-/-Check_Icon_Grey",
        transform: "translate(253.000000, 8.000000)"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "Group",
        transform: "translate(2.500000, 2.500000)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M3.125,9.375 L9.46249962,0.537499785",
        id: "Line"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M0.625,6.875 L3.125,9.375",
        id: "Line"
      }))))))));
    } // Rendering

  }, {
    key: "renderOpenButton",
    value: function renderOpenButton() {
      var openClass = (0, _classnames.default)("search-facets__group-toggle", {
        "is-open": this.state.isGroupOpen
      });
      return /*#__PURE__*/_react.default.createElement("button", {
        className: openClass,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("svg", {
        className: "icon",
        viewBox: "0 0 11 19",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.5 18.5L1 9.7"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.5.9L1 9.7"
      }))));
    }
  }, {
    key: "renderValueItem",
    value: function renderValueItem(value, recursionLevel) {
      var _this3 = this;

      var childValues = value.childValues;
      var hasChildValues = !!childValues && childValues.length > 0;
      var isExpanded = this.valueIsExpanded(value);
      var renderChildValues = hasChildValues && isExpanded;
      var toggleClass = (0, _classnames.default)("search-facets__value-expand", {
        "is-open": isExpanded
      });
      return /*#__PURE__*/_react.default.createElement("li", {
        key: value.id,
        className: "search-facets-bar__group"
      }, /*#__PURE__*/_react.default.createElement("input", {
        id: value.id,
        checked: value.selected,
        onChange: function onChange(e) {
          return _this3.onFacetChange(e, value.id);
        },
        type: "checkbox"
      }), /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: value.id
      }, value.name, " (", value.count, ")"), hasChildValues && /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: toggleClass,
        onClick: function onClick() {
          return _this3.toggleValueExpand(value.id);
        }
      }, /*#__PURE__*/_react.default.createElement("svg", {
        className: "icon"
      }, /*#__PURE__*/_react.default.createElement("use", {
        xlinkHref: "/assets/build/img/svg-sprite.svg#chevron-down"
      }))), renderChildValues && this.renderValues(childValues, recursionLevel + 1));
    }
  }, {
    key: "getVisibleValues",
    value: function getVisibleValues(allFacets) {
      var _this4 = this;

      return _ramda.default.reject(function (facet) {
        return _ramda.default.contains(facet.id, _ramda.default.pluck("id", _this4.state.hidden));
      }, allFacets);
    }
  }, {
    key: "renderFlatValues",
    value: function renderFlatValues(values, groupId) {
      var _this5 = this;

      var valuesToShow = this.getVisibleValues(values);

      var renderValue = function renderValue(value) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: value.id
        }, /*#__PURE__*/_react.default.createElement("input", {
          id: value.id,
          checked: value.selected,
          className: "u-visuallyhidden",
          onChange: function onChange(e) {
            return _this5.onFacetChange(e, value.id, groupId);
          },
          type: "checkbox"
        }), /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: value.id
        }, value.name, " (", value.count, ") ", _this5.checkmark()));
      };

      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "search-facets__group-values"
      }, valuesToShow.map(function (value) {
        return renderValue(value);
      }));
    }
  }, {
    key: "renderValues",
    value: function renderValues(values, recursionLevel) {
      var _this6 = this;

      var chunkedValues;

      if (recursionLevel === 0) {
        chunkedValues = this.chunkValues(values);
      } else {
        chunkedValues = [values, []];
      }

      var headValues = chunkedValues[0];
      var tailValues = chunkedValues[1];
      var stateClass = "search-facets__group-values is-level-".concat(recursionLevel, " search-facets-bar__facet-list");
      var valuesWrapperClass = (0, _classnames.default)("search-facets__values-wrapper", {
        "has-no-values": !values.length
      });
      var shouldRenderTailValues = this.shouldRenderTailValues(tailValues);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: valuesWrapperClass
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: stateClass
      }, headValues.map(function (val) {
        return _this6.renderValueItem(val, recursionLevel);
      })), shouldRenderTailValues && /*#__PURE__*/_react.default.createElement("ul", {
        className: (0, _classnames.default)(stateClass, "is-overflow")
      }, tailValues.map(function (val) {
        return _this6.renderValueItem(val, recursionLevel);
      })));
    } //

  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      //
      var group = this.props.group;
      var selectedValues = (0, _hiaFacets.selectedFacetsFromGroup)(group);
      var showDupeSelected = selectedValues.length > 0 && this.props.dupeSelected;
      var groupClass = (0, _classnames.default)("search-facets__group", {
        "is-open": this.state.isGroupOpen
      });

      if (group.values.length > 0) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: groupClass
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "search-facets__group-heading",
          onClick: function onClick(e) {
            return _this7.toggleGroup(e);
          }
        }, group.label, /*#__PURE__*/_react.default.createElement("span", {
          className: "facet-group__tooltip-icon"
        }, group.tooltip && this.renderTooltip(), /*#__PURE__*/_react.default.createElement("div", {
          className: "tooltip-content"
        }, group.tooltip)), this.renderOpenButton()), /*#__PURE__*/_react.default.createElement("div", {
          className: "search-facets__group-wrapper"
        }, this.state.isGroupOpen && /*#__PURE__*/_react.default.createElement("div", {
          className: "search-facets__group-body"
        }, group.values.length > 20 && this.renderInlineSearch(group), this.renderFlatValues(group.values, group.id))));
      } else {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "search-facets__group is-disabled"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "search-facets__group-heading"
        }, group.label, /*#__PURE__*/_react.default.createElement("span", {
          className: "facet-group__tooltip-icon"
        }, group.tooltip && this.renderTooltip(), /*#__PURE__*/_react.default.createElement("div", {
          className: "tooltip-content"
        }, group.tooltip)), this.renderOpenButton()));
      }
    }
  }]);

  return FacetGroup;
}(_react.default.Component);

var _default = FacetGroup;
exports.default = _default;
var _React$PropTypes = _react.default.PropTypes,
    func = _React$PropTypes.func,
    shape = _React$PropTypes.shape,
    bool = _React$PropTypes.bool,
    number = _React$PropTypes.number,
    string = _React$PropTypes.string,
    oneOfType = _React$PropTypes.oneOfType,
    arrayOf = _React$PropTypes.arrayOf;
FacetGroup.propTypes = {
  isOpen: bool,
  dupeSelected: bool,
  handleFacetChange: func.isRequired,
  handleClearGroup: func.isRequired,
  group: _dataShapes.facetGroupShape,
  facets: arrayOf(shape({
    id: oneOfType([number, string])
  }))
};
FacetGroup.defaultProps = {
  isOpen: false,
  dupeSelected: true,
  facets: []
};

},{"../../search/redux/hia-facets":107,"../dataShapes":63,"classnames":"classnames","ramda":"ramda","react":"react"}],58:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _HiaFacetGroup = _interopRequireDefault(require("./HiaFacetGroup.jsx"));

var _filterSlider = require("../../search/filterSlider");

var _ramda = _interopRequireDefault(require("ramda"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FacetList = /*#__PURE__*/function (_React$Component) {
  _inherits(FacetList, _React$Component);

  var _super = _createSuper(FacetList);

  function FacetList(props) {
    var _this;

    _classCallCheck(this, FacetList);

    _this = _super.call(this, props);
    _this.state = {
      showGroups: true
    };
    return _this;
  }

  _createClass(FacetList, [{
    key: "componentDidMount",
    value: function componentDidMount() {//setFiltersOpenDirection();
      // manageContainerWhitespace();
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this.props.handleClearAll();
    }
  }, {
    key: "hideFilters",
    value: function hideFilters() {
      // closeFilters(); // DOM ops
      this.props.hideMobileFacets(); // action creator
    }
  }, {
    key: "toggleGroups",
    value: function toggleGroups() {
      this.setState(_ramda.default.merge(this.state, {
        showGroups: !this.state.showGroups
      }));
    }
  }, {
    key: "filterIcon",
    value: function filterIcon() {
      return /*#__PURE__*/_react.default.createElement("svg", {
        className: "icon",
        viewBox: "0 0 10 7"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "Symbols"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "nav-/-search,-filter-active",
        transform: "translate(-97.000000, -17.000000)",
        stroke: "#333333"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "ii-/-Filter_Icon_Grey",
        transform: "translate(93.000000, 11.000000)"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "Group-2",
        transform: "translate(4.000000, 5.000000)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M2.5,7.5 L7.5,7.5",
        id: "Line"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M1.5,4.5 L8.5625,4.5",
        id: "Line"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M0.5,1.5 L9.5,1.5",
        id: "Line-Copy"
      }))))));
    }
  }, {
    key: "renderMobileHeader",
    value: function renderMobileHeader() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets__header--mobile"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets__filter-close"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn--primary",
        onClick: function onClick() {
          return _this2.toggleGroups();
        }
      }, this.props.dictionary.filterByLabel, this.filterIcon())), this.renderClearAll());
    }
  }, {
    key: "renderFacetGroups",
    value: function renderFacetGroups() {
      var _this3 = this;

      return this.props.facets.map(function (group, i) {
        var numOpenGroups = _this3.props.numOpenGroups;
        var isOpen = typeof numOpenGroups !== "undefined" && numOpenGroups !== null && i < numOpenGroups && group.values.length > 0;
        return /*#__PURE__*/_react.default.createElement(_HiaFacetGroup.default, {
          key: group.id,
          handleFacetChange: _this3.props.handleFacetChange,
          handleClearGroup: _this3.props.handleClearGroup,
          isOpen: isOpen,
          group: group,
          facets: _this3.props.facets
        });
      });
    }
  }, {
    key: "renderClearAll",
    value: function renderClearAll() {
      var _this4 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets__clear-all"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return _this4.clearAll();
        }
      }, this.props.dictionary.clearAllLabel));
    }
  }, {
    key: "render",
    value: function render() {
      var facetGroups = this.renderFacetGroups();
      return /*#__PURE__*/_react.default.createElement("div", null, this.renderMobileHeader(), /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets__header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets__header-title"
      }, this.props.dictionary.filterYourResultsLabel), this.renderClearAll()), this.state.showGroups && this.renderFacetGroups()));
    }
  }]);

  return FacetList;
}(_react.default.Component);

exports.default = FacetList;
var _React$PropTypes = _react.default.PropTypes,
    string = _React$PropTypes.string,
    arrayOf = _React$PropTypes.arrayOf,
    bool = _React$PropTypes.bool,
    shape = _React$PropTypes.shape,
    number = _React$PropTypes.number,
    oneOfType = _React$PropTypes.oneOfType,
    func = _React$PropTypes.func,
    object = _React$PropTypes.object;
FacetList.propTypes = {
  title: string,
  mobileFiltersShown: bool,
  hideMobileFacets: func,
  dictionary: object,
  facets: arrayOf(shape({
    id: oneOfType([number, string])
  })),
  numOpenGroups: number,
  handleFacetChange: func.isRequired,
  handleClearGroup: func.isRequired,
  handleClearAll: func.isRequired
};
FacetList.defaultProps = {
  facets: [],
  numOpenGroups: 1
};

},{"../../search/filterSlider":101,"./HiaFacetGroup.jsx":57,"ramda":"ramda","react":"react"}],59:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hiaItemShape = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderIcon(icon) {
  if (icon == "download") {
    return /*#__PURE__*/_react.default.createElement("svg", {
      width: "20px",
      height: "25px",
      viewBox: "0 0 20 20",
      version: "1.1"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "Page-1",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "HIA",
      transform: "translate(-630.000000, -1183.000000)"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "Group-2-Copy",
      transform: "translate(528.000000, 1092.333333)"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "ii-/-download_Circle_Grey",
      transform: "translate(94.000000, 85.000000)"
    }, /*#__PURE__*/_react.default.createElement("circle", {
      id: "Oval",
      cx: "15",
      cy: "15",
      r: "13.3333333"
    }), /*#__PURE__*/_react.default.createElement("g", {
      id: "Group-2",
      "stroke-width": "1",
      "fill-rule": "evenodd",
      transform: "translate(15.055555, 15.555556) rotate(90.000000) translate(-15.055555, -15.555556) translate(4.222222, 8.333333)",
      stroke: "#333333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M1.77335451,7.22222222 L14.4444444,7.22222222",
      id: "Line"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M18.0555556,0.902777778 L18.0555556,13.5416667",
      id: "Line"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M8.55905338,1.33683116 L14.4444444,7.22222222",
      id: "Line"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M8.55905338,13.1076133 L14.4444444,7.22222222",
      id: "Line"
    })))))));
  } else if (icon == "external") {
    return /*#__PURE__*/_react.default.createElement("svg", {
      width: "20px",
      height: "20px",
      viewBox: "0 0 20 20",
      version: "1.1"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "HIA"
    }, /*#__PURE__*/_react.default.createElement("rect", {
      fill: "#FFFFFF",
      x: "0",
      y: "0",
      width: "20",
      height: "20"
    }), /*#__PURE__*/_react.default.createElement("g", {
      id: "Group-2-Copy-2",
      stroke: "#333333",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "ii-/-External_Link_Grey"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "Group-2"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M1.04166667,17.7083333 L15.7730579,2.97694206",
      id: "Line"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M5.20729592,2.97694206 L15.7730579,2.97694206",
      id: "Line"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M15.7730579,13.5427041 L15.7730579,2.97694206",
      id: "Line"
    })))))));
  } else {
    return;
  }
}

function displayDate(completionDate, publicationDate) {
  var date = null;

  if (completionDate != null) {
    date = completionDate;
  } else if (publicationDate != null) {
    date = publicationDate;
  }

  return date;
}

var HiaResultItem = function HiaResultItem(_ref) {
  var title = _ref.title,
      resourceType = _ref.resourceType,
      dateOfPublication = _ref.dateOfPublication,
      summary = _ref.summary,
      hipStatus = _ref.hipStatus,
      linkUrl = _ref.linkUrl,
      linkTarget = _ref.linkTarget,
      source = _ref.source,
      referenceType = _ref.referenceType,
      citation = _ref.citation,
      hipLocation = _ref.hipLocation,
      cityCounty = _ref.cityCounty,
      country = _ref.country,
      state = _ref.state,
      documentLanguageAbbrs = _ref.documentLanguageAbbrs,
      dateOfCompletion = _ref.dateOfCompletion,
      dictionary = _ref.dictionary,
      icon = _ref.icon;

  var renderLocation = function renderLocation() {
    if (cityCounty && hipLocation && country) {
      return "".concat(cityCounty, ", ").concat(hipLocation, ", ").concat(country);
    } else if (cityCounty && (hipLocation || country)) {
      return "".concat(cityCounty, ", ").concat(hipLocation || country);
    } else if (!cityCounty && hipLocation && country) {
      return "".concat(hipLocation, ", ").concat(country);
    } else {
      return "".concat(cityCounty || hipLocation || country);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "hia-result-item"
  }, title && /*#__PURE__*/_react.default.createElement("a", {
    href: linkUrl,
    target: linkTarget,
    className: "hia-result-item__title"
  }, title), icon && renderIcon(icon), /*#__PURE__*/_react.default.createElement("div", {
    className: "hia-result-item__meta-data hia-result-item__meta-data--top"
  }, resourceType && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "hia-meta-data-name"
  }, dictionary.resourceTypeLabel, ": "), resourceType), displayDate(dateOfCompletion, dateOfPublication) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "hia-meta-data-name"
  }, dictionary.dateLabel, ": "), displayDate(dateOfCompletion, dateOfPublication))), summary && /*#__PURE__*/_react.default.createElement("div", {
    className: "hia-result-item__summary"
  }, summary), /*#__PURE__*/_react.default.createElement("div", {
    className: "hia-result-item__meta-data hia-result-item__meta-data--bottom"
  }, source && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "hia-meta-data-name"
  }, dictionary.sourceLabel, ": "), source), referenceType && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "hia-meta-data-name"
  }, dictionary.referenceTypeLabel, ": "), referenceType), citation && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "hia-meta-data-name"
  }, dictionary.citationLabel, ": "), citation), (cityCounty || country || hipLocation) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "hia-meta-data-name"
  }, dictionary.locationLabel, ": "), renderLocation()), hipStatus && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "hia-meta-data-name"
  }, dictionary.statusLabel, ": "), hipStatus), documentLanguageAbbrs && documentLanguageAbbrs.length > 0 && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "hia-meta-data-name"
  }, dictionary.languageLabel, ": "), documentLanguageAbbrs.map(function (value, i) {
    return (i ? ', ' : '') + value;
  }))));
};

var _default = HiaResultItem; // 

exports.default = _default;
var _React$PropTypes = _react.default.PropTypes,
    string = _React$PropTypes.string,
    shape = _React$PropTypes.shape,
    object = _React$PropTypes.object,
    objectOf = _React$PropTypes.objectOf,
    arrayOf = _React$PropTypes.arrayOf,
    bool = _React$PropTypes.bool;
var hiaItemProps = {
  title: string.isRequired,
  resourceType: string,
  dateOfPublication: string,
  dateOfCompletion: string,
  summary: string,
  hipStatus: string,
  dictionary: object,
  linkUrl: string,
  linkTarget: string,
  source: string,
  referenceType: string,
  citation: string,
  hipLocation: string,
  documentLanguageAbbrs: arrayOf(string),
  icon: string
};
/*
props that Liz removed because they werent in the response: 

organizations: arrayOf(string)
completionDate: string,
*/

var hiaItemShape = shape(hiaItemProps);
exports.hiaItemShape = hiaItemShape;
HiaResultItem.propTypes = hiaItemProps;

},{"react":"react"}],60:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _HiaResultItem = _interopRequireWildcard(require("./HiaResultItem.jsx"));

var _LoadingSpinner = _interopRequireDefault(require("../../search/components/LoadingSpinner.jsx"));

var _paging = require("../../search/paging");

var _SortBar = _interopRequireDefault(require("../../search/components/SortBar.jsx"));

var _Pagination = _interopRequireDefault(require("../../search/components/Pagination.jsx"));

var _SearchStatus = _interopRequireDefault(require("../../search/components/SearchStatus.jsx"));

var _resultsDisplay = require("../../search/redux/resultsDisplay");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var HiaResultList = function HiaResultList(_ref) {
  var results = _ref.results,
      totalResults = _ref.totalResults,
      query = _ref.query,
      nextPage = _ref.nextPage,
      gotoPage = _ref.gotoPage,
      viewAllUrl = _ref.viewAllUrl,
      changeSort = _ref.changeSort,
      resultsDisplayStrategy = _ref.resultsDisplayStrategy,
      sorters = _ref.sorters,
      loading = _ref.loading,
      dictionary = _ref.dictionary,
      displayDates = _ref.displayDates;
  var dictionaryBindings = {};

  function dictEntryFor(key) {
    // if name is a dictionary key, grab it
    var entry = dictionary[key];

    if (!entry) {
      // if not a dictionary key, check if it's bound to a dictionary key
      var lowerKey = key.toLowerCase();
      entry = dictionary[dictionaryBindings[lowerKey]];
    } // if no entry found, simply return the name


    return entry || key;
  }

  function renderPagingControl() {
    return /*#__PURE__*/_react.default.createElement(_Pagination.default, {
      totalResults: totalResults,
      resultsPerPage: query.perPage,
      currentPage: query.page,
      handlePageChange: gotoPage
    });
  }

  function renderSearchStatus() {
    return /*#__PURE__*/_react.default.createElement(_SearchStatus.default, {
      resultsRange: resultsRange(),
      totalResults: totalResults,
      dictionary: dictionary
    });
  }

  function resultsRange() {
    // Upper bound of visible results
    var ceiling = query.page * query.perPage; // Lower bound of visible results

    var floor = ceiling - query.perPage + 1; // make sure the ceiling does not exceed total results

    if (ceiling > totalResults) {
      ceiling = totalResults;
    } // if results are only one page, eschew the range entirely


    if (totalResults <= query.perPage) {
      return "".concat(totalResults);
    } //return the full range


    return "".concat(floor, " - ").concat(ceiling);
  }

  function wrapperClass() {
    var isRefreshing = loading && resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_REFRESH; //const isAppending = loading && resultsDisplayStrategy === RESULTS_DISPLAY_APPEND;

    return (0, _classnames.default)("hia-results-listing", {
      "is-refreshing": isRefreshing
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_SortBar.default, {
    sorters: sorters,
    handleSortClick: changeSort
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: wrapperClass()
  }, loading && /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__loader"
  }, /*#__PURE__*/_react.default.createElement(_LoadingSpinner.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "hia-results-listing__items-wrapper"
  }, results.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(_HiaResultItem.default, _extends({
      key: i,
      displayDates: displayDates,
      dictionary: dictionary
    }, item));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__bottom"
  }, renderSearchStatus(), renderPagingControl()));
};

var _default = HiaResultList;
exports.default = _default;
var _React$PropTypes = _react.default.PropTypes,
    arrayOf = _React$PropTypes.arrayOf,
    object = _React$PropTypes.object,
    func = _React$PropTypes.func,
    number = _React$PropTypes.number,
    bool = _React$PropTypes.bool,
    shape = _React$PropTypes.shape,
    oneOfType = _React$PropTypes.oneOfType,
    string = _React$PropTypes.string;
HiaResultList.propTypes = {
  totalResults: number,
  results: arrayOf(_HiaResultItem.hiaItemShape).isRequired,
  query: object,
  nextPage: func.isRequired,
  displayDates: bool,
  dictionary: object,
  gotoPage: func,
  resultsDisplayStrategy: number,
  changeSort: func,
  sorters: arrayOf(shape({
    id: oneOfType([number, string]).isRequired,
    label: string.isRequired,
    value: string.isRequired,
    direction: oneOfType([bool, string]),
    isActive: bool.isRequired
  }))
};

},{"../../search/components/LoadingSpinner.jsx":84,"../../search/components/Pagination.jsx":85,"../../search/components/SearchStatus.jsx":91,"../../search/components/SortBar.jsx":94,"../../search/paging":103,"../../search/redux/resultsDisplay":108,"./HiaResultItem.jsx":59,"classnames":"classnames","react":"react"}],61:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _HiaFacetList = _interopRequireDefault(require("../components/HiaFacetList.jsx"));

var _search = require("../../search/redux/search/search.actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    title: state.dictionary.facetsTitle,
    facets: state.facets,
    dictionary: state.dictionary,
    numOpenGroups: state.numOpenGroups,
    mobileFacetsShown: state.mobileFacetsShown
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleFacetChange: function handleFacetChange(groupId, facetId, facetValue) {
      dispatch((0, _search.loadFacetChange)(groupId, facetId, facetValue));
    },
    handleClearGroup: function handleClearGroup(group) {
      dispatch((0, _search.loadClearFacetGroup)(group));
    },
    handleClearAll: function handleClearAll() {
      dispatch((0, _search.loadClearAllFacets)());
    },
    hideMobileFacets: function hideMobileFacets() {
      dispatch(_search.hideMobileFacets);
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_HiaFacetList.default);

exports.default = _default;

},{"../../search/redux/search/search.actions":111,"../components/HiaFacetList.jsx":58,"react-redux":"react-redux"}],62:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _HiaResultList = _interopRequireDefault(require("../components/HiaResultList.jsx"));

var _search = require("../../search/redux/search/search.actions");

var _facets = require("../../search/redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    results: state.results,
    resultsDisplayStrategy: state.resultsDisplayStrategy,
    totalResults: state.totalResults,
    loading: state.loading,
    isFirstLoad: state.isFirstLoad,
    query: state.query,
    sorters: state.sorters,
    pagination: state.pagination,
    displayDates: state.displayDates,
    dictionary: state.dictionary,
    viewAllUrl: state.viewAllUrl
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    nextPage: function nextPage() {
      dispatch((0, _search.loadNextPage)());
    },
    changeSort: function changeSort(sorters) {
      dispatch((0, _search.loadNewSort)(sorters));
    },
    gotoPage: function gotoPage(pageNum) {
      dispatch((0, _search.loadNewPage)(pageNum));
    },
    dismissFacet: function dismissFacet(facetId) {
      dispatch((0, _search.loadFacetChange)(facetId, false));
    },
    showMobileFacets: function showMobileFacets() {
      dispatch((0, _search.showMobileFacets)());
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_HiaResultList.default);

exports.default = _default;

},{"../../search/redux/facets":106,"../../search/redux/search/search.actions":111,"../components/HiaResultList.jsx":60,"react-redux":"react-redux"}],63:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.facetGroupShape = exports.facetValueShape = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// allows us to define propTypes recursively
// https://github.com/facebook/react/issues/5676
var lazyF = function lazyF(f) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return f().apply(_this, args);
  };
};

var shape = _propTypes.default.shape,
    oneOfType = _propTypes.default.oneOfType,
    string = _propTypes.default.string,
    number = _propTypes.default.number,
    bool = _propTypes.default.bool,
    arrayOf = _propTypes.default.arrayOf;
var facetValueShape = shape({
  id: oneOfType([number, string]).isRequired,
  name: string.isRequired,
  count: number.isRequired,
  tooltip: string,
  selected: bool.isRequired,
  childValues: arrayOf(lazyF(function () {
    return facetValueShape;
  }))
});
exports.facetValueShape = facetValueShape;
var facetGroupShape = shape({
  id: oneOfType([number, string]).isRequired,
  label: string,
  values: arrayOf(facetValueShape).isRequired,
  childGroups: arrayOf(lazyF(function () {
    return facetGroupShape;
  }))
});
exports.facetGroupShape = facetGroupShape;

},{"prop-types":"prop-types"}],64:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSearchApp = initSearchApp;

var _jquery = _interopRequireDefault(require("jquery"));

var _ramda = _interopRequireDefault(require("ramda"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reactRedux = require("react-redux");

var _rootReducer = _interopRequireDefault(require("../search/redux/rootReducer"));

var _createRoutingMiddleware = _interopRequireDefault(require("../search/redux/createRoutingMiddleware"));

var _search = require("../search/redux/search/search.reducer");

var _search2 = require("../search/redux/search/search.actions");

var _configureStore = _interopRequireDefault(require("../search/redux/configureStore"));

var _service = require("../search/redux/service");

var _service2 = require("./redux/service");

var _routing = require("../search/redux/routing");

var _resultsDisplay = require("../search/redux/resultsDisplay");

var _HiaResultsContainer = _interopRequireDefault(require("./containers/HiaResultsContainer.jsx"));

var _HiaFacetsContainer = _interopRequireDefault(require("./containers/HiaFacetsContainer.jsx"));

var _QueryContainer = _interopRequireDefault(require("../search/containers/QueryContainer.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import FacetsContainer from "../search/containers/FacetsContainer.jsx";
// the mount nodes are the elements we want to include
// as part of the search app
function initSearchApp(mountNodes) {
  if (!mountNodes.length) {
    return;
  } // extract the searchId from the mountNodes
  // while also checking mountNodes share same id


  var searchId = mountNodes.reduce(function (id, node) {
    var nodeId = (0, _jquery.default)(node).data("searchId"); // if id is null, we want to set it
    // with the first node's value

    if (id === null) {
      return nodeId;
    } // if node id does not equal current
    // id value, it's invalid and return undefined


    if (id !== nodeId) {
      return;
    }

    return id;
  }, null); // if we have an invalid or non-matching id, raise an error

  if (!searchId) {
    throw new Error("Could not initialize Pew search app. searchId was either not present, or provided mount nodes did not share the same searchId");
  } // define the canonical inital state of our redux store here
  // including some value taken from the data-attrs of the
  // mount node.


  var config = window.PewSearchConfigs.find(function (c) {
    return c.searchId === searchId;
  });

  if (!config) {
    throw new Error("Could not initialize Pew search app instance with id of \"".concat(searchId, "\". Configuration data not found."));
  }

  var facetDisplayOverride = {
    "contentType": config.displayContentTypeFilter,
    "places": config.displayPlacesFilter,
    "project": config.displayProjectsFilter,
    "tag": config.displayTagsFilter,
    "topic": config.displayTopicsFilter
  }; // create a starting state object,
  // which includes and intitial state
  // from individual reducers

  var initialState = _ramda.default.merge(_search.initialState, {
    url: config.url,
    pagination: config.pagination,
    resultsDisplayStrategy: config.pagination ? _resultsDisplay.RESULTS_DISPLAY_REFRESH : _resultsDisplay.RESULTS_DISPLAY_APPEND,
    dictionary: config.dictionary,
    numOpenGroups: 1,
    sorters: config.sorters,
    query: _ramda.default.merge(_search.initialState.query, {
      pageId: config.pageId,
      page: config.page,
      perPage: config.perPage
    })
  }); // determine if we want to load all page results in our cold load


  var doLoadAllPages = initialState.resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND && initialState.isFirstLoad;
  initialState = _ramda.default.merge(initialState, {
    query: _ramda.default.merge(initialState.query, {
      loadAllPages: doLoadAllPages
    })
  });

  var thunkMiddleware = _reduxThunk.default.withExtraArgument({
    mapResponseToState: _service.mapResponseToState,
    fetchSearchResults: _service2.fetchSearchResults
  });

  var routingMiddleware = (0, _createRoutingMiddleware.default)(_routing.mapStateToUrl, _routing.handleUrlChange);
  var store = (0, _configureStore.default)(_rootReducer.default, initialState, [thunkMiddleware, routingMiddleware]); //store.dispatch(loadResults());

  if (initialState.initialResults) {
    store.dispatch(loadSuccess(initialState.initialResults, initialState.resultsDisplayStrategy, _service.mapResponseToState));
  } else {
    store.dispatch((0, _search2.loadResults)());
  }

  mountNodes.forEach(function (node) {
    if (node.className.indexOf("js-search-query") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_QueryContainer.default, null)), node);
    }

    if (node.className.indexOf("js-hia-search-results") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_HiaResultsContainer.default, null)), node);
    }

    if (node.className.indexOf("js-hia-search-facets") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_HiaFacetsContainer.default, null)), node);
    }
  });
}

},{"../search/containers/QueryContainer.jsx":97,"../search/redux/configureStore":104,"../search/redux/createRoutingMiddleware":105,"../search/redux/resultsDisplay":108,"../search/redux/rootReducer":109,"../search/redux/routing":110,"../search/redux/search/search.actions":111,"../search/redux/search/search.reducer":112,"../search/redux/service":113,"./containers/HiaFacetsContainer.jsx":61,"./containers/HiaResultsContainer.jsx":62,"./redux/service":65,"jquery":"jquery","ramda":"ramda","react":"react","react-dom":"react-dom","react-redux":"react-redux","redux-thunk":"redux-thunk"}],65:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSearchResults = fetchSearchResults;
exports.handleMultipleResponses = handleMultipleResponses;
exports.mapResponseToState = mapResponseToState;
exports.mapFiltersToFacets = mapFiltersToFacets;

var _ramda = _interopRequireDefault(require("ramda"));

var _jquery = _interopRequireDefault(require("jquery"));

var _util = require("../../search/util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newResults = _ramda.default.curry(function (newResults, oldResults, strategy) {
  return strategy === RESULTS_DISPLAY_APPEND ? _ramda.default.concat(oldResults || [], newResults || []) : newResults || [];
});

function fetchSearchResults(url, query) {
  var stringifyArrayParams = _ramda.default.map(function (v) {
    return v instanceof Array ? v.join(";") : v;
  });

  var featuredResultsPromise = {};

  var searchPromise = _jquery.default.ajax({
    url: url,
    data: _ramda.default.merge({
      pageId: query.pageId
    }, query)
  });

  return [searchPromise, featuredResultsPromise];
} // for handling queries that include a call to get Featured Items,
// which have result items that need to get merged into 
// the response


function handleMultipleResponses(responses) {
  return _ramda.default.reduce(function (obj, resp) {
    var data = resp[0];

    if (data) {
      // NOTE: this assumes that the response for Featured Items
      // occurs first in the array, respecting the order they
      // were passed into $.when()
      if (data.results) {
        return _ramda.default.merge(obj, data); // handle a normal search query case
      } else {
        // otherwise, seed the new results into the response,
        // update result totals and perPage count
        obj = _ramda.default.assoc("results", _ramda.default.insertAll(0, data, obj.results), obj);
        obj = _ramda.default.assoc("totalResults", obj.totalResults + data.length, obj);
        obj = _ramda.default.assocPath(["request", "perPage"], obj.request.perPage, obj);
        return obj;
      }
    } else {
      return obj; // pass through  if no response data found
    }
  }, {
    results: []
  }, responses);
}

function mapResponseToState(response, state) {
  var request = response.request;

  var castToInt = _ramda.default.curry(parseInt)(_ramda.default.__, 10);

  var mapFilters = _ramda.default.compose(_ramda.default.partial(mapFiltersToFacets, [response.filters]));

  return _ramda.default.evolve({
    totalResults: function totalResults() {
      return parseInt(response.totalResults, 10);
    },
    results: newResults(response.results, _ramda.default.__, state.resultsDisplayStrategy),
    facets: function facets() {
      return response.filters ? mapFilters(response.facets) : response.facets;
    },
    spellcheckSuggestion: function spellcheckSuggestion() {
      return response.spellcheckSuggestion;
    },
    query: _ramda.default.merge(_ramda.default.__, {
      pageId: request.pageId,
      page: castToInt(request.page || 0),
      perPage: castToInt(request.perPage || 10),
      sortOrder: request.sortOrder,
      loadAllPages: false
    })
  }, state);
} // The search API returns some facet data outside of
// facets, and formatted in an incompatible manner. Clean it up here.


function mapFiltersToFacets(filters, facets) {
  var addNamesAsIds = _ramda.default.map(function (v) {
    return _ramda.default.evolve({
      id: function id() {
        return v.name;
      },
      childValues: addNamesAsIds
    }, v);
  });

  var rehabFilters = _ramda.default.pipe(_ramda.default.map(function (filter) {
    return _ramda.default.assoc("id", filter.name.toLowerCase(), filter);
  }), // subgroups do not come with ids, add one
  _ramda.default.map(function (filter) {
    return (0, _util.renameKeys)({
      locations: "values",
      name: "label"
    })(filter);
  }), // subgroup keys are not correct, rename them
  _ramda.default.map(function (filter) {
    return _ramda.default.over(_ramda.default.lensProp("values"), addNamesAsIds, filter);
  }) // the location ids we get from the backend aren't valid to use on the backend. Replace them with the display name
  );

  var locationIdx = _ramda.default.findIndex(_ramda.default.propEq("id", "places"))(facets);

  return locationIdx !== -1 ? _ramda.default.assocPath([locationIdx, "childGroups"], rehabFilters(filters), facets) : facets;
}

},{"../../search/util":114,"jquery":"jquery","ramda":"ramda"}],66:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(el, i) {
  if (el.dataset.location) {
    el.addEventListener("click", function (event) {
      window.location.href = el.dataset.location;
    });
  }
};

exports.default = _default;

},{}],67:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _EncodeHTMLEntities = _interopRequireDefault(require("../EncodeHTMLEntities.js"));

var _focusUtils = require("../a11y/focusUtils.js");

var _keyboardUtils = require("../a11y/keyboardUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

_jquery.default.extend(_jquery.default.expr[":"], {
  focusable: function focusable(el, index, selector) {
    var $element = (0, _jquery.default)(el);
    return $element.is(":input:enabled, a[href], area[href], object, [tabindex]") && !$element.is(":hidden");
  }
});

// When calculating scroll position or element offset from top, we need to compensate for the sticky nav bars
var globalHeaderHeight = (0, _jquery.default)(".global-header").outerHeight() ? (0, _jquery.default)(".global-header").outerHeight() : 0;
var toolbarHeight = (0, _jquery.default)(".page-toolbar__wrapper").outerHeight() ? (0, _jquery.default)(".page-toolbar__wrapper").outerHeight() : 0; //const stickyNavOffset = globalHeaderHeight + toolbarHeight + 20;

var stickyNavOffset = globalHeaderHeight + toolbarHeight - 40;

var LocalNav = /*#__PURE__*/function () {
  function LocalNav() {
    _classCallCheck(this, LocalNav);

    // DOM caching, creating empty <li>s for cloning later
    this.headersMenu = (0, _jquery.default)(".js-local-nav-headers");
    this.$currentPageEl = (0, _jquery.default)(".local-navigation__is-current-page");
    this.newH1 = (0, _jquery.default)("<li>", {
      class: "local-navigation__menu-h1 js-local-nav-header-link"
    });
    this.newH2 = (0, _jquery.default)("<li>", {
      class: "local-navigation__menu-h2 js-local-nav-header-link"
    });
    this.newH3 = (0, _jquery.default)("<li>", {
      class: "local-navigation__menu-h3 js-local-nav-header-link"
    });
    this.$localNavHeaders = [];
    this.cachedHeaderElms = []; // Creating global scope function placeholders for use later

    this.unbindEscape = function () {};

    this.unbindTriggerDown = function () {};

    this.unbindTriggerUp = function () {};
  }

  _createClass(LocalNav, [{
    key: "bindScrollEvents",
    value: function bindScrollEvents() {
      var parentThis = this;

      if (!(0, _jquery.default)("div.js-local.nav").hasClass("js-local-nav-events-bound")) {
        (0, _jquery.default)(window).on("scroll", function () {
          // Add sticky nav offset
          var scrollOffset = (0, _jquery.default)(window).scrollTop() + stickyNavOffset;
          var scrolledHeaders = [];
          parentThis.cachedHeaderElms.forEach(function (elm, ind, arr) {
            // Magic number -10px gives us a bit of padding for readability and better scrollTo UX
            // And, only check visible elements. Hidden elements have an offset of 0, breaks logic
            if (scrollOffset - (0, _jquery.default)(elm).offset().top >= -10 && (0, _jquery.default)(elm).is(":visible")) {
              scrolledHeaders.push(elm);
            }
          });

          if (scrolledHeaders.length) {
            if ((0, _jquery.default)(window).scrollTop() + (0, _jquery.default)(window).height() == (0, _jquery.default)(document).height()) {
              // if user has scrolled to the bottom, select the last header no matter what
              parentThis.updateSelectedNav(parentThis.$localNavHeaders.last().text(), parentThis.$localNavHeaders.last().attr("id"));
            } else {
              // Otherwise, find the single element with the greatest offsetTop value
              // All these elements should have less than 0, so the greatest = closest to 0 = last one user scrolled past
              var max = scrolledHeaders.reduce(function (a, b) {
                return Math.max((0, _jquery.default)(a).offset().top, (0, _jquery.default)(b).offset().top) === (0, _jquery.default)(a).offset().top ? a : b;
              });
              parentThis.updateSelectedNav((0, _jquery.default)(max).text(), (0, _jquery.default)(max).attr("id"));
            }
          } else {
            // Need to strip out any links (ex. "View all other issues")
            var text = (0, _jquery.default)(".js-local-nav-back-to-top").clone().find("a").remove().end().text();

            if (text.length === 0) {
              text = (0, _jquery.default)(".js-force-local-nav-header").first().text();
            }

            parentThis.updateSelectedNav(text);
          }
        });
        (0, _jquery.default)("div.js-local.nav").addClass("js-local-nav-events-bound");
      }
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      var parentThis = this;
      (0, _jquery.default)(".local-navigation").removeClass("is-active");
      parentThis.toggleAria(); // Remove the click-off-menu binding after closing

      (0, _jquery.default)(document).off(".close-local-nav");
    }
  }, {
    key: "openMenu",
    value: function openMenu() {
      var parentThis = this;
      (0, _jquery.default)(".local-navigation").addClass("is-active");
      parentThis.toggleAria(); // When it opens, bind an event to close the menu if you click off it

      (0, _jquery.default)(document).on("click.close-local-nav", function (e) {
        if (!(0, _jquery.default)(".local-navigation__pop-out-menu")[0].contains(e.target)) {
          parentThis.closeMenu();
        }
      }); // Focus the current option
      // Needs a timeout because the menu needs to open
      // before its items can be focusable

      setTimeout(function () {
        parentThis.focusCurrentOption();
      }, 100);
    }
  }, {
    key: "focusTrigger",
    value: function focusTrigger() {
      setTimeout(function () {
        (0, _jquery.default)(".js-local-nav-toolbar-trigger").focus();
      }, 10);
    }
  }, {
    key: "focusCurrentOption",
    value: function focusCurrentOption() {
      (0, _jquery.default)(".local-navigation__is-current-page").last().focus();
    }
  }, {
    key: "focusTarget",
    value: function focusTarget($target) {
      if (!$target.length) {
        return;
      }

      if (!$target.is(":focusable")) {
        // add tabindex to make focusable and remove again
        $target.attr("tabindex", -1).on("blur focusout", function () {
          (0, _jquery.default)(this).removeAttr("tabindex");
        });
      }

      $target.focus();
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(anchorDest) {
      if (anchorDest !== "local-navigation-toolbar-trigger") {
        // Scroll to the destination offset
        (0, _jquery.default)("html, body").scrollTop((0, _jquery.default)("#" + anchorDest).offset().top - stickyNavOffset);
      } else {
        // Scroll to top
        (0, _jquery.default)("html, body").scrollTop(0);
      }
    }
  }, {
    key: "bindClickEvents",
    value: function bindClickEvents() {
      var parentThis = this; // On menu trigger click

      (0, _jquery.default)(".js-local-nav-toolbar-trigger").on("click", function (linkEvent) {
        if ((0, _jquery.default)(".local-navigation").hasClass("is-active")) {
          parentThis.closeMenu(); // Return focus to the trigger

          parentThis.focusTrigger();
        } else {
          parentThis.openMenu(); // Prevent initial menu opening click from immediately closing itself

          linkEvent.stopPropagation();
          return false;
        }
      }); // On menu link click

      (0, _jquery.default)(".js-local-nav-header-link, .js-combined-nav-list-item").on("click", function (e) {
        var anchorDest = (0, _jquery.default)(this).attr("data-anchor-dest");
        var linkDest = (0, _jquery.default)(this).attr("data-link-url");

        if (anchorDest) {
          parentThis.closeMenu();
          parentThis.updateSelectedNav((0, _jquery.default)(this).text());
          parentThis.scrollTo(anchorDest);
          var $headerObj = (0, _jquery.default)("#" + anchorDest);
          parentThis.focusTarget($headerObj);
          e.preventDefault();
        } else if (linkDest) {
          // Is it an external or download link?
          var $linkSVG = (0, _jquery.default)(this).find(".icon--internal-link, .icon--external-link");

          if ($linkSVG.length > 0) {
            // Open in a new window/tab
            window.open(linkDest, "_blank");
          } else {
            // Open in the same window
            window.location.href = linkDest;
          }
        }
      });
    }
  }, {
    key: "bindKeyboardEvents",
    value: function bindKeyboardEvents() {
      var parentThis = this;
      var $menuList = (0, _jquery.default)(".js-local-nav-headers");
      var allMenuItems = Array.from((0, _jquery.default)(".js-local-nav-header-link, .js-combined-nav-list-item"));
      var firstMenuFocusable = (0, _focusUtils.getFirstFocusableChild)($menuList.get(0));
      var lastMenuFocusable = (0, _focusUtils.getLastFocusableChild)($menuList.get(0)); // Menu trigger button keyboard binding - Down arrow

      parentThis.unbindTriggerDown = (0, _keyboardUtils.onElementDown)((0, _jquery.default)(".js-local-nav-toolbar-trigger").get(0), function (e) {
        e.preventDefault();
        e.stopPropagation();
        (0, _jquery.default)(e.currentTarget).click();
      }); // Menu trigger button keyboard binding - Up arrow

      parentThis.unbindTriggerUp = (0, _keyboardUtils.onElementUp)((0, _jquery.default)(".js-local-nav-toolbar-trigger").get(0), function (e) {
        e.preventDefault();
        e.stopPropagation();
        (0, _jquery.default)(e.currentTarget).click();
      }); // Menu keyboard bindings

      allMenuItems.forEach(function (item, index) {
        // Tab key
        // If you tab while the menu is open, the menu should close.
        (0, _keyboardUtils.onElementTab)(item, function (e) {
          parentThis.closeMenu();
        }); // Enter key

        (0, _keyboardUtils.onElementEnter)(item, function (e) {
          e.preventDefault();
          e.stopPropagation();
          (0, _jquery.default)(e.currentTarget).click();
        }); // Space key

        (0, _keyboardUtils.onElementSpace)(item, function (e) {
          e.preventDefault();
          e.stopPropagation();
          (0, _jquery.default)(e.currentTarget).click();
        }); // Down arrow

        (0, _keyboardUtils.onElementDown)(item, function (e) {
          var current = e.target;
          var parentMenu = current.closest(".js-local-nav-headers");
          e.preventDefault();
          e.stopPropagation();
          var target = (0, _focusUtils.getNextFocusableChild)(parentMenu, current);

          if (target) {
            // Some links may be hidden, so skip past them if needed.
            if ((0, _focusUtils.isVisiblyHidden)(target)) {
              target = (0, _focusUtils.getNextFocusableChild)(parentMenu, target);
            } // Redundant, but required because we might have reset it to null


            if (target) {
              target.focus();
            }
          }
        }); // Up arrow

        (0, _keyboardUtils.onElementUp)(item, function (e) {
          var current = e.target;
          var parentMenu = current.closest(".js-local-nav-headers");
          e.preventDefault();
          e.stopPropagation();
          var target = (0, _focusUtils.getPrevFocusableChild)(parentMenu, current);

          if (target) {
            // Some links may be hidden, so skip past them if needed.
            if ((0, _focusUtils.isVisiblyHidden)(target)) {
              target = (0, _focusUtils.getPrevFocusableChild)(parentMenu, target);
            } // Redundant, but required because we might have reset it to null


            if (target) {
              target.focus();
            }
          }
        }); // Home key

        (0, _keyboardUtils.onElementHome)(item, function (e) {
          e.preventDefault();
          e.stopPropagation();
          firstMenuFocusable.focus();
        }); // End key

        (0, _keyboardUtils.onElementEnd)(item, function (e) {
          e.preventDefault();
          e.stopPropagation();

          if ((0, _focusUtils.isVisiblyHidden)(lastMenuFocusable)) {
            // We're on desktop and the screenreader-only link has been focused
            // We need to move the visible keyboard focus to the next item
            var parentMenu = lastMenuFocusable.closest(".js-local-nav-headers");
            var target = (0, _focusUtils.getPrevFocusableChild)(parentMenu, lastMenuFocusable);

            if (target) {
              target.focus();
            }
          } else {
            // The item is visible; focus it
            lastMenuFocusable.focus();
          }
        });
      }); // Escape key
      // This construction binds the escape key to a function immediately, and
      // also creates the "unbindEscape" function which can then be called
      // separately to unbind the escape key.

      parentThis.unbindEscape = (0, _keyboardUtils.onElementEscape)(window, function (e) {
        var menuActive = (0, _jquery.default)(".local-navigation.is-active"); // If the menu is open

        if (menuActive.length > 0) {
          // Close the menu
          parentThis.closeMenu(); // Return focus to the trigger

          parentThis.focusTrigger();
        }
      });
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      var parentThis = this;
      (0, _jquery.default)(".js-local-nav-toolbar-trigger").off("click");
      (0, _jquery.default)(".js-local-nav-header-link").off("click");
      parentThis.unbindEscape();
      parentThis.unbindTriggerDown();
      parentThis.unbindTriggerUp();
    } // Helper function to create a slug for anchor links

  }, {
    key: "slugify",
    value: function slugify(text) {
      // If we somehow have an empty header, return out so this doesn't blow up
      if (!text) {
        return;
      }

      return text.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w\-]+/g, "") // Remove all non-word chars
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, "") // Trim - from end of text
      .substring(0, 30); // only return 30 chars in case a header is extra long
    }
  }, {
    key: "updateSelectedNav",
    value: function updateSelectedNav(text, slug) {
      // Check for short text, swap in the shorter text if needed
      text = text.trim();
      var encodedText = (0, _EncodeHTMLEntities.default)(text);
      var shortTextSelector = "[data-long-text='" + encodedText + "']";
      var $hasShortText = (0, _jquery.default)(shortTextSelector);

      if ($hasShortText.length > 0) {
        text = $hasShortText.text();
        encodedText = (0, _EncodeHTMLEntities.default)($hasShortText.text());
      } // Title attr to show full title on hover if truncated


      (0, _jquery.default)(".js-local-nav-toolbar-link").attr("title", text); // Update the appropriate text in the trigger button

      if ((0, _jquery.default)(".local-navigation__active-header-text").length > 0) {
        (0, _jquery.default)(".local-navigation__active-header-text").text(text);
      } else {
        (0, _jquery.default)(".js-local-nav-toolbar-link").text(text);
      }

      var matchingCombinedLink = ".js-combined-nav-list-item:contains(" + text + ")"; // Add current page class if scrolled to section between header and next selected menu item
      // AND current page class does not already exist

      if ((0, _jquery.default)(matchingCombinedLink).length > 0) {
        !(0, _jquery.default)(matchingCombinedLink).hasClass("local-navigation__is-current-page") && (0, _jquery.default)(matchingCombinedLink).addClass("local-navigation__is-current-page");
      } else {
        // Remove current page class if scrolled to a selected menu item
        (0, _jquery.default)(".js-combined-nav-list-item").removeClass("local-navigation__is-current-page");
      }

      ; // Unselect any currently selected menu items

      (0, _jquery.default)(".js-local-nav-header-link").removeClass("local-navigation__is-current-page").attr("aria-selected", "false").attr("tabindex", -1); // Find the matching menu item, and mark it selected

      var matchingLink = ".js-local-nav-header-link:contains(" + text + ")";
      (0, _jquery.default)(matchingLink).addClass("local-navigation__is-current-page").attr("aria-selected", "true").attr("tabindex", 0);
    }
  }, {
    key: "buildLocalNav",
    value: function buildLocalNav() {
      var parentThis = this;
      var preventHeaderSlug = (0, _jquery.default)(".js-no-header-slug").length;
      (0, _jquery.default)(".js-local-nav-header-link").not(".js-local-nav-back-to-top").remove();

      if ((0, _jquery.default)(".js-force-local-nav-header").length > 0) {
        var firstHeader = (0, _jquery.default)(".js-force-local-nav-header").first();
        this.updateSelectedNav(firstHeader.text());
        firstHeader.hide();
      } else {
        // Need to strip out any links (ex. "View all other issues")
        var text = (0, _jquery.default)(".js-local-nav-back-to-top").clone().find("a").remove().end().text();
        parentThis.updateSelectedNav(text);
      }

      if (parentThis.$currentPageEl) {
        parentThis.$currentPageEl.append('<ul class="js-combined-items ps-combined-items"></ul>');
      }

      parentThis.$localNavHeaders.each(function (index) {
        var originalTextValueOfHeader = (0, _jquery.default)(this).text();
        var textValueOfHeader = (0, _EncodeHTMLEntities.default)(originalTextValueOfHeader);
        var longTextValueOfHeader = null;

        if ((0, _jquery.default)(this).attr("data-short-text") && (0, _jquery.default)(this).attr("data-short-text") !== "-SHORTTEXT-") {
          longTextValueOfHeader = textValueOfHeader;
          textValueOfHeader = (0, _EncodeHTMLEntities.default)((0, _jquery.default)(this).attr("data-short-text"));
        } // Give each tag an ID so we can faux-anchor link to it


        var headerSlug = parentThis.slugify(originalTextValueOfHeader);

        if (!preventHeaderSlug) {
          headerSlug = index + "-" + headerSlug;
        }

        (0, _jquery.default)(this).attr("id", headerSlug); // cache each header for sticky header scrollTop check later

        parentThis.cachedHeaderElms.push(this);
        var elemItem = null;

        switch (this.tagName) {
          case "H1":
            elemItem = parentThis.newH1.clone();
            break;

          case "H2":
            elemItem = parentThis.newH2.clone();
            break;

          case "H3":
            elemItem = parentThis.newH3.clone();
            break;

          default:
            elemItem = null;
        }

        if (elemItem !== null) {
          elemItem.html(textValueOfHeader).attr({
            "data-anchor-dest": headerSlug,
            "tabindex": "-1",
            "role": "option"
          }); // Add a "long header" data attribute for matching, if the header
          // has a short name

          if (longTextValueOfHeader !== null) {
            elemItem.attr("data-long-text", longTextValueOfHeader);
          }
        }

        if (elemItem !== null && (0, _jquery.default)(".js-combined-items").length > 0) {
          elemItem.appendTo((0, _jquery.default)(".js-combined-items"));
        } else {
          elemItem.appendTo(parentThis.headersMenu);
        }
      }); // Move the nested children of $(".js-combined-items") up a level,
      // as listboxes can't have nested children

      if (parentThis.$currentPageEl) {
        var $localPageMenuItems = (0, _jquery.default)(".js-combined-items").children(); // Change all children based on the level of the parent.  Max capped at 6.

        var currentPageLevel = parentThis.$currentPageEl.hasClass("local-navigation__menu-h2") ? 2 : parentThis.$currentPageEl.hasClass("local-navigation__menu-h3") ? 3 : 4;
        var offsetAmount = 1;

        if (currentPageLevel === 3) {
          offsetAmount = 2;
        } else if (currentPageLevel > 3) {
          offsetAmount = 3;
        }

        $localPageMenuItems.each(function () {
          // Get the original level of the header
          var originalHeaderLevel = 2;

          if ((0, _jquery.default)(this).hasClass("local-navigation__menu-h3")) {
            originalHeaderLevel = 3;
          } else if ((0, _jquery.default)(this).hasClass("local-navigation__menu-h4")) {
            originalHeaderLevel = 4;
          } else if ((0, _jquery.default)(this).hasClass("local-navigation__menu-h5")) {
            originalHeaderLevel = 5;
          } else if ((0, _jquery.default)(this).hasClass("local-navigation__menu-h6")) {
            originalHeaderLevel = 6;
          } // Calculate the new level of the header


          var newHeaderLevel = 0;
          newHeaderLevel = originalHeaderLevel + offsetAmount;

          if (newHeaderLevel > 6) {
            newHeaderLevel = 6;
          } // Redo the classes to match the new level


          (0, _jquery.default)(this).removeClass();

          switch (newHeaderLevel) {
            case 3:
              (0, _jquery.default)(this).addClass("local-navigation__menu-h3");
              break;

            case 4:
              (0, _jquery.default)(this).addClass("local-navigation__menu-h4");
              break;

            case 5:
              (0, _jquery.default)(this).addClass("local-navigation__menu-h5");
              break;

            case 6:
              (0, _jquery.default)(this).addClass("local-navigation__menu-h6");
              break;
          } // Add the local nav header class for JS manipulation


          (0, _jquery.default)(this).addClass("js-local-nav-header-link");
        }); // Move all the altered children to follow the current page

        $localPageMenuItems.insertAfter(parentThis.$currentPageEl); // Remove the original nested UL

        (0, _jquery.default)(".js-combined-items").remove();
      }

      if (document.location.hash) {
        // If a dom object with that ID exists on the page...
        if ((0, _jquery.default)(document.location.hash).length > 0) {
          // Scroll to the destination offset
          var headerOffset = (0, _jquery.default)(document.location.hash).offset();

          if (headerOffset) {
            (0, _jquery.default)("html, body").scrollTop(headerOffset.top - stickyNavOffset);
          }
        }
      }
    }
  }, {
    key: "toggleAria",
    value: function toggleAria() {
      if ((0, _jquery.default)(".local-navigation").hasClass("is-active")) {
        (0, _jquery.default)(".js-local-nav-toolbar-trigger").attr("aria-expanded", true);
      } else {
        (0, _jquery.default)(".js-local-nav-toolbar-trigger").attr("aria-expanded", false);
      }
    }
  }, {
    key: "init",
    value: function init() {
      var parentThis = this;
      parentThis.$localNavHeaders = (0, _jquery.default)("div.rich-text h2, div.rich-text h3.with_nav, .js-force-local-nav-header, .js-projects-container h2, .js-projects-container h3, div.rich-text h1").not(".no_nav"); // Should show local nav if local nav class exists,
      // or if there are enough headers for the menu (2 or more)
      // or there's an explicit override to ignore the min number of headers

      var shouldShowLocalNav = (0, _jquery.default)(".js-local-nav").length && (parentThis.$localNavHeaders.length >= 2 || (0, _jquery.default)(".js-no-local-nav-min").length) || (0, _jquery.default)(".js-combined-nav").length;

      if (shouldShowLocalNav) {
        this.unbindEvents(); // needed for Topics/Projects pages

        parentThis.buildLocalNav();
        parentThis.bindScrollEvents(); // Initialize Aria

        (0, _jquery.default)(".js-local-nav-toolbar-trigger").attr({
          "aria-controls": "local-navigation__pop-out-menu",
          "aria-expanded": false
        });
      } // Should show section nav if section nav class exists


      var shouldShowSectionNav = (0, _jquery.default)(".js-section-nav").length;

      if (!shouldShowLocalNav && !shouldShowSectionNav) {
        if ((0, _jquery.default)(".js-local-nav").length) {
          (0, _jquery.default)(".js-local-nav").addClass("js-show-page-title-in-nav").hide();
        }

        if ((0, _jquery.default)(".js-section-nav").length) {
          (0, _jquery.default)(".js-section-nav").addClass("js-show-page-title-in-nav").hide();
        } // This was fighting with the index.js scroll functionality.
        // The page title shouldn't show from page load, but should stay hidden
        // until the sticky toolbar reaches the top of the page.
        // if (!$(".page-toolbar__page-title--only-title").length) {
        //   $(".page-toolbar__page-title").removeClass("u-hidden");
        // }

      } else {
        parentThis.bindClickEvents();
        parentThis.bindKeyboardEvents();
      }
    }
  }]);

  return LocalNav;
}();

var _default = new LocalNav();

exports.default = _default;

},{"../EncodeHTMLEntities.js":5,"../a11y/focusUtils.js":38,"../a11y/keyboardUtils.js":39,"jquery":"jquery"}],68:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _lodash = _interopRequireDefault(require("lodash.uniqueid"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Version 1.1a
//
// closeButton added for 1.1a
//
// author: Jonathan Dallas
// date: November 2020
//
// pass these props when intializing this module
//
// props: {
//   animationDelay: number
//   closed: boolean
//   reversed: boolean
//   direction: string (horizontal or vertical)
//   menuButton: string.isRequired (class or id selector)
//   closeButton: string.isRequired (class or id selector)
//   menuContainer: string.isRequired (class or id selector)
//   navigationLink: string.isRequired (class selector)
//   openClass: string (class name)
//   onClose: function (callback when the menu opens)
//   onOpen: function (callback when the menu opens)
//   parent: node_element.isRequired
// }
var timeoutId = window.setTimeout(function () {}, 0);

function _default(initProps) {
  var propsFail = false;

  if (!initProps.menuButton || initProps.menuButton.length === 0) {
    console.error("'menuButton' selector is required");
    propsFail = true;
  }

  if (!initProps.menuContainer || initProps.menuContainer.length === 0) {
    console.error("'menuContainer' selector is required");
    propsFail = true;
  }

  if (!initProps.navigationLink || initProps.navigationLink.length === 0) {
    console.error("'navigationLink' selector is required");
    propsFail = true;
  }

  if (!initProps.parent) {
    console.error("'parent' node element is required");
    propsFail = true;
  }

  if (propsFail) {
    return;
  }

  var defaultProps = {
    animationDelay: 600,
    closed: true,
    direction: "vertical",
    reversed: false,
    openClass: "is-open"
  };
  var props = Object.assign({}, defaultProps, initProps);
  var closedState = props.closed;
  var direction = props.direction;
  var animationDelay = props.animationDelay;
  var elParent = props.parent;
  var elMenuButton = elParent.querySelector(props.menuButton);
  var elCloseButton = elParent.querySelector(props.closeButton);
  var elMenuContainer = elParent.querySelector(props.menuContainer);
  var elMenuLinks = elMenuContainer.querySelectorAll(props.navigationLink);
  bindEvents();
  init();

  function init() {
    var controlId = elMenuContainer.id || (0, _lodash.default)("menu");
    var buttonId = elMenuButton.id || (0, _lodash.default)("menu");
    elMenuButton.id = buttonId;
    elMenuButton.setAttribute("aria-haspopup", true);
    elMenuButton.setAttribute("aria-controls", controlId);
    elMenuContainer.id = controlId;
    elMenuContainer.setAttribute("aria-labelledby", buttonId);

    if (closedState) {
      closeMenu(false);
    } else {
      openMenu(false);
    }
  }

  function bindEvents() {
    // close button (used on mobile share button)
    if (elCloseButton) {
      elCloseButton.addEventListener("click", function (e) {
        e.preventDefault();
        closeMenu();
      });
      elCloseButton.addEventListener("keydown", handleMenuKeyEvent);
    }

    var title = document.title;
    var url = document.querySelector("link[rel=canonical]") ? document.querySelector("link[rel=canonical]").href : document.location.href;
    var nativeShare = navigator.share;
    var isMobileMenu = parentHasClass(elParent, "js-mobile-menu");
    var isMobileShare = elParent.classList.contains("js-mobile-share");
    var isMobileSearch = parentHasClass(elParent, "js-mobile-search-menu"); // open megamenu and nav items on click (mobile, search)

    if (isMobileMenu || isMobileSearch || isMobileShare) {
      elMenuButton.addEventListener("click", function (e) {
        if (nativeShare && isMobileShare) {
          navigator.share({
            title: title,
            url: url
          }).then(function () {// console.log("Thanks for sharing!");
          }).catch(console.error);
        } else {
          e.preventDefault();
          toggleMenu();
        }
      });
    } // open mega menu on hover (desktop)
    else {
      elMenuButton.addEventListener("mouseenter", function (e) {
        e.preventDefault();
        !elMenuButton.parentNode.classList.contains("is-open") && toggleMenu();
      });
      elMenuButton.parentNode.addEventListener("mouseleave", function (e) {
        e.preventDefault(); // check for unique case where hovering over newsletter input autocomplete list closes menu

        var newsletterInput = elMenuButton.parentNode.querySelector(".newsletter-signup__email-input");

        if (newsletterInput !== document.activeElement) {
          toggleMenu();
        }
      });
    }

    elMenuButton.addEventListener("keydown", handleMenuKeyEvent); // .forEach() requires an array in IE11, but queryselectorAll returns a NodeList.

    var elMenuLinksArray = Array.from(elMenuLinks);
    elMenuLinksArray.forEach(function (link, index) {
      link.addEventListener("keydown", function (e) {
        handleLinkKeyEvent(e, link, index);
      });

      if (link.tagName === "A") {
        link.addEventListener("click", function (e) {
          closeMenu(false);
        });
      }
    });
  }

  function parentHasClass(element, classname) {
    if (element.className.split(" ").indexOf(classname) >= 0) {
      return true;
    }

    return element.parentElement && parentHasClass(element.parentElement, classname);
  }

  function setDirection(newDirection) {
    direction = newDirection;
  }

  function clickAway(e) {
    if (!elParent.contains(e.target) && !closedState) {
      closeMenu(false);
    }
  }

  function toggleMenu(moveFocus) {
    if (closedState) {
      openMenu(moveFocus);
    } else {
      closeMenu(moveFocus);
    }
  }

  function openMenu() {
    var moveFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    closedState = false;
    elMenuButton.setAttribute("aria-expanded", true);
    elParent.classList.add(props.openClass);
    elMenuContainer.removeAttribute("aria-hidden");

    if (moveFocus) {
      window.clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        if (typeof elMenuLinks[0] !== "undefined") {
          // check if first menu link is hidden (mobile search)
          if (elMenuLinks[0] && elMenuLinks[0].getAttribute("type") === "hidden") {
            elMenuLinks[1].focus();
          } // otherwise, set focus onto first menu link
          else {
            elMenuLinks[0].focus();
          }
        }
      }, animationDelay);
    }

    if (props.onOpen) {
      props.onOpen();
    }

    window.addEventListener("click", clickAway);
    var currentWidth = window.innerWidth;
    window.addEventListener("resize", function () {
      // ignore browsers with headers that show/hide on scroll
      if (currentWidth !== window.innerWidth) {
        currentWidth = window.innerWidth;
        closeMenu();
      }
    });

    if (moveFocus) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        type: "Menu Opened",
        event: "dropdownClick",
        dropdownSelection: elMenuButton.innerText
      });
    }
  }

  function closeMenu() {
    var moveFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    closedState = true;

    if (moveFocus) {
      elMenuButton && elMenuButton.focus();
    }

    elMenuButton.setAttribute("aria-expanded", false);
    elParent.classList.remove(props.openClass);
    elMenuContainer.setAttribute("aria-hidden", true);

    if (props.onClose) {
      props.onClose();
    }

    window.removeEventListener("click", clickAway);
    window.removeEventListener("resize", closeMenu);

    if (moveFocus) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        type: "Menu Closed",
        event: "dropdownClick",
        dropdownSelection: elMenuButton.innerText
      });
    }
  }

  function handleMenuKeyEvent(e) {
    switch (e.key) {
      case "Escape":
        e.preventDefault();
        closeMenu();
        break;
      // "Enter" used as default to click link

      case "Down":
      case "ArrowDown":
      case " ":
        e.preventDefault();
        toggleMenu(true);
        break;

      default:
    }
  }

  function handleLinkKeyEvent(e, link, index) {
    var target = index;

    switch (e.key) {
      case "Escape":
        e.preventDefault();
        closeMenu(true);
        break;

      case "Tab":
        if (e.shiftKey) {
          if (index === 0) {
            if (!props.reversed) {
              e.preventDefault();
            }

            closeMenu(!props.reversed);
          }
        } else {
          if (index === elMenuLinks.length - 1) {
            if (props.reversed) {
              e.preventDefault();
            }

            closeMenu(props.reversed);
          }
        }

        break;

      default:
    }

    if (direction === "vertical") {
      switch (e.key) {
        case "Up":
        case "ArrowUp":
          e.preventDefault();
          focusPrevious(elMenuLinks, index, target);
          break;

        case "Down":
        case "ArrowDown":
          e.preventDefault();
          focusNext(elMenuLinks, index, target);
          break;

        default:
      }
    }

    if (direction === "horizontal") {
      switch (e.key) {
        case "Left":
        case "ArrowLeft":
          e.preventDefault();
          focusPrevious(elMenuLinks, index, target);
          break;

        case "Right":
        case "ArrowRight":
          e.preventDefault();
          focusNext(elMenuLinks, index, target);
          break;

        default:
      }
    }

    function focusPrevious(elList, index, target) {
      if (index === 0) {
        target = elMenuLinks.length;
      }

      elMenuLinks[target - 1] && elMenuLinks[target - 1].focus();
    }

    function focusNext(elList, index, target) {
      if (index === elMenuLinks.length - 1) {
        target = -1;
      }

      elMenuLinks[target + 1] && elMenuLinks[target + 1].focus();
    }
  }

  return {
    init: init,
    toggleMenu: toggleMenu,
    openMenu: openMenu,
    closeMenu: closeMenu,
    setDirection: setDirection
  };
}

},{"lodash.uniqueid":"lodash.uniqueid"}],69:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryNav = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _breakpoint = require("../breakpoint");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var KEY_CODES = {
  tab: 9,
  enter: 13,
  leftArrow: 37,
  rightArrow: 39,
  upArrow: 38,
  downArrow: 40,
  esc: 27,
  space: 32
};

var PrimaryNav = /*#__PURE__*/function () {
  function PrimaryNav($el) {
    _classCallCheck(this, PrimaryNav);

    this.$el = $el;
    this.$navMenu = $el.find('.js-menu');
    this.$navItems = $el.find('.js-nav-item');
    this.$navToggle = $el.find('.js-nav-toggle');
    this.openClass = 'is-open';
    this.bindEvents(); // this.$navItems.each(this.adjustFlyoutMenuAlignment);

    this.onBreakpointChange((0, _breakpoint.breakpoint)()); // run any breakpoint changes immediately
  }

  _createClass(PrimaryNav, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      // Show sub menus on click
      //moved these bindings to the onBreakPointChange to prevent weird behavior in medium view < Chrome
      // Toggle entire navigation when hidden
      // in some viewports
      this.$navToggle.on('click', function (event) {
        return _this.onNavToggleClick(event);
      }); // bind keypress events for keyboard navigation

      this.$navMenu.on('keydown', function (event) {
        return _this.onKeyPress(event);
      }); // close the flyout menu when user mouse leaves

      this.$navMenu.on('mouseleave', function (event) {
        return _this.onOtherClick(event);
      }); // Add a document click handler to detect clicks
      // with the intent to dismiss navigation

      (0, _jquery.default)(document).on('click', function (event) {
        return _this.onOtherClick(event);
      }); // tie in certain responsive behaviors to a throttled
      // resize event

      (0, _jquery.default)(window).on('resize', function (event) {
        window.clearTimeout(throttler);
        var throttler = setTimeout(function () {
          // this.$navItems.each(this.adjustFlyoutMenuAlignment);
          _this.onBreakpointChange((0, _breakpoint.breakpoint)());
        }, 400);
      });
    }
  }, {
    key: "onNavToggleClick",
    value: function onNavToggleClick(event) {
      // Prevent this click from being counted
      // as a document click
      event.stopPropagation();
      this.toggleNavMenu();
    }
  }, {
    key: "onItemClick",
    value: function onItemClick(event) {
      // Prevent this click from being counted
      // as a document click
      event.stopPropagation();
      var $clickedItem = (0, _jquery.default)(event.target).closest('.js-nav-item');
      this.operateSubMenu($clickedItem);
    }
  }, {
    key: "onOtherClick",
    value: function onOtherClick(event) {
      if ((0, _breakpoint.breakpoint)() === 'large') {
        this.toggleFlyoutMenus([this.$openItem()]);
      }
    }
  }, {
    key: "onBreakpointChange",
    value: function onBreakpointChange(bp) {
      var _this2 = this;

      switch (bp) {
        case "large":
          this.$navItems.filter(".has-submenu").on('mouseenter click', function (event) {
            return _this2.onItemClick(event);
          });
          this.$navMenu.show();
          this.ariaExpand(this.$el);
          break;

        case "medium":
          this.$navItems.filter(".has-submenu").off();
          this.$navItems.filter(".has-submenu").on('click', function (event) {
            return _this2.onItemClick(event);
          });
          this.ariaCollapse(this.$el);
          break;

        case "small":
          this.$navItems.filter(".has-submenu").off();
          this.$navItems.filter(".has-submenu").on('click', function (event) {
            return _this2.onItemClick(event);
          });

        default:
          return;
      }
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(event) {
      switch (event.which) {
        case KEY_CODES.enter:
        case KEY_CODES.space:
          this.toggleInContext(this.focusContext());
          break;

        case KEY_CODES.rightArrow:
          this.rightInContext(this.focusContext());
          break;

        case KEY_CODES.leftArrow:
          this.leftInContext(this.focusContext());
          break;

        case KEY_CODES.upArrow:
          this.upInContext(this.focusContext());
          break;

        case KEY_CODES.downArrow:
          this.downInContext(this.focusContext());
          break;

        case KEY_CODES.esc:
          this.collapseInContext(this.focusContext());
          break;

        default:
          return;
      }
    }
  }, {
    key: "operateSubMenu",
    value: function operateSubMenu($el) {
      // the behavior of the menus changes depending
      // on the active breakpoint
      switch ((0, _breakpoint.breakpoint)()) {
        case 'large':
          this.toggleFlyoutMenus([$el, this.$openItem()]);
          break;

        case 'medium':
        case 'small':
          this.toggleCollapsingMenu($el);
          break;

        default:
          return;
      }
    } // explicity close a submenu

  }, {
    key: "closeSubMenu",
    value: function closeSubMenu($el) {
      switch ((0, _breakpoint.breakpoint)()) {
        case 'large':
          this.closeFlyoutMenu($el);
          break;

        case 'medium':
        case 'small':
          this.closeCollapsingMenu($el);
          break;

        default:
          return;
      }
    }
  }, {
    key: "toggleNavMenu",
    value: function toggleNavMenu() {
      if (this.$el.hasClass(this.openClass)) {
        this.$navMenu.slideUp(300);
        this.ariaCollapse(this.$el);
      } else {
        this.$navMenu.slideDown(300);
        this.ariaExpand(this.$el); // Nav and search shouldn't be open at the same time

        (0, _jquery.default)('.global-header').removeClass('search-is-open');
      }

      this.$el.toggleClass(this.openClass);
    }
  }, {
    key: "ariaExpand",
    value: function ariaExpand($el) {
      $el.attr('aria-expanded', true);
    }
  }, {
    key: "ariaCollapse",
    value: function ariaCollapse($el) {
      $el.attr('aria-expanded', false);
    }
  }, {
    key: "toggleFlyoutMenus",
    value: function toggleFlyoutMenus(items) {
      var _this3 = this;

      // In case the same item is added twice (by clicking on the currently open item, for example)
      // only apply behavior to each element once
      items.reduce(function ($toggled, $item) {
        if ($toggled.index($item) === -1) {
          if ($item.hasClass(_this3.openClass)) {
            _this3.closeFlyoutMenu($item);

            _this3.closeMenuAttributes($item);

            _this3.ariaCollapse($item.find('.js-submenu'));
          } else {
            _this3.openFlyoutMenu($item);

            _this3.openMenuAttributes($item);

            _this3.ariaExpand($item.find('.js-submenu'));
          }

          return $toggled.add($item);
        }
      }, (0, _jquery.default)());
    }
  }, {
    key: "openFlyoutMenu",
    value: function openFlyoutMenu($item) {
      this.openMenuAttributes($item);
    }
  }, {
    key: "closeFlyoutMenu",
    value: function closeFlyoutMenu($item) {
      this.closeMenuAttributes($item);
    }
  }, {
    key: "toggleCollapsingMenu",
    value: function toggleCollapsingMenu($item) {
      if ($item.hasClass(this.openClass)) {
        this.closeCollapsingMenu($item);
        this.closeMenuAttributes($item);
      } else {
        this.openCollapsingMenu($item);
        this.openMenuAttributes($item);
      }
    }
  }, {
    key: "openCollapsingMenu",
    value: function openCollapsingMenu($item) {
      var $submenu = $item.find('.js-submenu');
      $submenu.slideDown(300);
    }
  }, {
    key: "closeCollapsingMenu",
    value: function closeCollapsingMenu($item) {
      var $submenu = $item.find('.js-submenu');
      $submenu.slideUp(300);
    }
  }, {
    key: "openMenuAttributes",
    value: function openMenuAttributes($item) {
      $item.addClass(this.openClass);
      $item.find('a').attr('tabindex', 0);
    }
  }, {
    key: "closeMenuAttributes",
    value: function closeMenuAttributes($item) {
      $item.removeClass(this.openClass);
      $item.find('a').attr('tabindex', -1);
    }
  }, {
    key: "adjustFlyoutMenuAlignment",
    value: function adjustFlyoutMenuAlignment(idx, item) {
      // if the menu is going to be rendered offscreen,
      // we need to push it back.
      var $item = (0, _jquery.default)(item);
      var $menu = $item.find('.js-submenu');
      var left = $item.offset().left;
      var menuWidth = $menu.outerWidth();
      var windowWidth = (0, _jquery.default)(window).width();
      var diff = windowWidth - (left + menuWidth);
      var newLeft = diff < 0 ? diff : 0;
      $menu.css({
        left: "".concat(newLeft, "px")
      });
    }
  }, {
    key: "$openItem",
    value: function $openItem() {
      return this.$el.find(".".concat(this.openClass));
    }
  }, {
    key: "downInContext",
    value: function downInContext(context) {
      if (!context) {
        return;
      }

      if (!context.$parent && context.$el.hasClass('js-has-submenu')) {
        this.operateSubMenu(context.$el);
        context.$el.find('a:first').trigger('focus');
      } else if (context.$parent && context.$next) {
        context.$next.trigger('focus');
      }
    }
  }, {
    key: "upInContext",
    value: function upInContext(context) {
      if (!context) {
        return;
      }

      if (context.$parent && !context.$prev) {
        this.operateSubMenu(context.$el);
        context.$parent.trigger('focus');
      } else if (context.$parent && context.$prev) {
        context.$prev.trigger('focus');
      }
    }
  }, {
    key: "collapseInContext",
    value: function collapseInContext(context) {
      this.closeSubMenu(context.$el);
    }
  }, {
    key: "toggleInContext",
    value: function toggleInContext(context) {
      this.operateSubMenu(context.$el);
    }
  }, {
    key: "rightInContext",
    value: function rightInContext(context) {
      if (!context) {
        return;
      }

      if (context.$parent) {
        var $nextMenu = context.$parent.nextAll('.js-has-submenu').first();
        this.operateSubMenu($nextMenu);
        $nextMenu.find('li a').first().trigger('focus');
      } else if (context.$next) {
        context.$next.trigger('focus');
      }
    }
  }, {
    key: "leftInContext",
    value: function leftInContext(context) {
      if (!context) {
        return;
      }

      if (context.$parent) {
        var $prevMenu = context.$parent.prevAll('.js-has-submenu').first();
        this.operateSubMenu($prevMenu);
        $prevMenu.find('li a').first().trigger('focus');
      } else if (context.$prev) {
        context.$prev.trigger('focus');
      }
    } // Provides an object with the currently focused element,
    // prev and next focusable elements, and the menu parent
    // if applicable

  }, {
    key: "focusContext",
    value: function focusContext() {
      var $focusEl = (0, _jquery.default)(document.activeElement); // return nothing if focus doesn't exist, or is not in our menu

      if (!$focusEl.length || $focusEl.closest('.js-menu').length === 0) {
        return;
      } // get the next focusable item


      var $next = function $next($el) {
        // If we're focused on an <a>, move up to parent <li>
        if ($el[0].nodeName === 'A') {
          $el = $el.parent();
        } // get immediate sibling


        var $nextEl = $el.next(); // if no tabindex defined, select the inner <a> instead

        if ($nextEl.attr('tabindex') === undefined) {
          $nextEl = $nextEl.children('a:first');
        }

        return $nextEl.length === 0 ? null : $nextEl;
      }; // get the prev focusable item


      var $prev = function $prev($el) {
        // If we're focused on an <a>, move up to parent <li>
        if ($el[0].nodeName === 'A') {
          $el = $el.parent();
        } // Get the immediate sibling


        var $prevEl = $el.prev(); // if no tabindex defined, select the inner <a> instead

        if ($prevEl.attr('tabindex') === undefined) {
          $prevEl = $prevEl.children('a:first');
        }

        return $prevEl.length === 0 ? null : $prevEl;
      }; // get a parent


      var $parent = function $parent($el) {
        var $parentEl = $el.parents('ul').parents('.js-nav-item');
        return $parentEl.length === 0 ? null : $parentEl;
      };

      return {
        $el: $focusEl,
        $next: $next($focusEl),
        $prev: $prev($focusEl),
        $parent: $parent($focusEl)
      };
    }
  }]);

  return PrimaryNav;
}();

exports.PrimaryNav = PrimaryNav;

},{"../breakpoint":48,"jquery":"jquery"}],70:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryNav = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SecondaryNav = /*#__PURE__*/function () {
  function SecondaryNav($el) {
    _classCallCheck(this, SecondaryNav);

    this.$el = $el;
    this.$menu = this.$el.find('.js-menu');
    this.$toggle = this.$el.find('.js-nav-toggle');
    this.bindEvents();
  }

  _createClass(SecondaryNav, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      // the menu should expand/collapse on click
      // use mousedown as it will be handled before focus
      this.$toggle.on('mousedown', function (event) {
        _this.toggleNav(event);
      }); // Still need to handle click to
      // prevent default

      this.$toggle.on('click', function (event) {
        event.preventDefault();
      }); // howver, for focus we should only expand
      // if we collapse on blur, then just about
      // any other page interaction will collapse
      // the menu unexpectedly

      this.$toggle.on('focus', function (event) {
        if (!_this.isOpen()) {
          _this.openNav(event);
        }
      });
    }
  }, {
    key: "toggleNav",
    value: function toggleNav(event) {
      if (this.isOpen()) {
        this.closeNav(event);
      } else {
        this.openNav(event);
      }
    }
  }, {
    key: "openNav",
    value: function openNav(event) {
      this.$menu.slideDown(250);
      this.$el.addClass('is-open');
    }
  }, {
    key: "closeNav",
    value: function closeNav(event) {
      this.$menu.slideUp(250);
      this.$el.removeClass('is-open');
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.$el.hasClass('is-open');
    }
  }]);

  return SecondaryNav;
}();

exports.SecondaryNav = SecondaryNav;

},{"jquery":"jquery"}],71:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _NavMenu = _interopRequireDefault(require("./NavMenu.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(el, index, callback) {
  var contentEl = el.querySelector(".js-mobile-menu-content");

  var _onOpen = function onOpen(contentEl) {
    contentEl.classList.add("js-enable-scroll");
  };

  var _onClose = function onClose(contentEl) {
    contentEl.classList.remove("js-enable-scroll");
  };

  (0, _NavMenu.default)({
    animationDelay: 800,
    closed: true,
    direction: "vertical",
    menuButton: ".js-nav-toggle",
    menuContainer: ".js-mobile-menu-content",
    navigationLink: ".js-primary-nav-top-link",
    openClass: "is-open",
    onClose: function onClose() {
      return _onClose(contentEl);
    },
    onOpen: function onOpen() {
      return _onOpen(contentEl);
    },
    parent: el
  });
};

exports.default = _default;

},{"./NavMenu.js":68}],72:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _NavMenu = _interopRequireDefault(require("./NavMenu.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(el, index, callback) {
  var searchMenuBtn = document.querySelector(".js-mobile-search-menu-button");
  var clearCloseBtn = document.querySelector(".js-mobile-search-clear-and-close");
  var searchInput = document.querySelector(".js-mobile-search-input");
  clearCloseBtn.addEventListener("click", function (e) {
    searchInput.value = "";
    searchMenuBtn.click();
  });

  var onClose = function onClose() {};

  var onOpen = function onOpen() {};

  (0, _NavMenu.default)({
    animationDelay: 800,
    closed: true,
    direction: "vertical",
    menuButton: ".js-mobile-search-menu-button",
    menuContainer: ".js-mobile-search-menu-content",
    navigationLink: "input, button",
    openClass: "is-open",
    onClose: onClose,
    onOpen: onOpen,
    parent: el
  });
};

exports.default = _default;

},{"./NavMenu.js":68}],73:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _NavMenu = _interopRequireDefault(require("./NavMenu.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(el, index, callback) {
  var onClose = function onClose() {};

  var onOpen = function onOpen() {};

  (0, _NavMenu.default)({
    animationDelay: 800,
    closed: true,
    direction: "vertical",
    menuButton: ".js-mobile-share-btn",
    closeButton: ".js-mobile-share-close",
    menuContainer: ".js-mobile-share-content",
    navigationLink: ".js-mobile-share-link",
    openClass: "is-open",
    onClose: onClose,
    onOpen: onOpen,
    parent: el
  });
};

exports.default = _default;

},{"./NavMenu.js":68}],74:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _NavMenu = _interopRequireDefault(require("./NavMenu.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(el, index, callback) {
  var getScrollBarWidth = function getScrollBarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  };

  var debounce = function debounce(callback, wait) {
    var timeoutId = null;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(function () {
        callback.apply(null, args);
      }, wait);
    };
  };

  var scrollbarWidth = getScrollBarWidth();
  var handleResize = debounce(function () {
    scrollbarWidth = getScrollBarWidth();
  }, 250);
  window.addEventListener("resize", handleResize);

  var _onOpen = function onOpen(i, contentEl, scrollbarWidth) {
    if (contentEl.offsetHeight > window.innerHeight) {
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = scrollbarWidth + "px";
      }

      document.body.style.overflow = "hidden";
      contentEl.classList.add("js-enable-scroll");
    }
  };

  var _onClose = function onClose(i, contentEl) {
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
    contentEl.classList.remove("js-enable-scroll");
  }; // .forEach() requires an array in IE11, but queryselectorAll returns a NodeList.


  var primaryLinks = el.querySelectorAll(".primary-nav__main-nav-link");
  var primaryLinksArray = Array.from(primaryLinks);
  primaryLinksArray.forEach(function (el, i) {
    el.addEventListener("keydown", function (e) {
      handleKeyDown(e, i);
    });
  }); // .forEach() requires an array in IE11, but queryselectorAll returns a NodeList.

  var primaryNavMenus = el.querySelectorAll(".js-primary-nav-menu");
  var primaryNavMenusArray = Array.from(primaryNavMenus);
  primaryNavMenusArray.forEach(function (el, i) {
    var contentEl = el.querySelector(".js-submenu");
    (0, _NavMenu.default)({
      animationDelay: 500,
      closed: true,
      direction: "vertical",
      menuButton: ".js-primary-nav-top-link",
      menuContainer: ".js-submenu",
      navigationLink: ".js-primary-nav-sub-link",
      openClass: "is-open",
      onClose: function onClose() {
        return _onClose(i, contentEl);
      },
      onOpen: function onOpen() {
        return _onOpen(i, contentEl, scrollbarWidth);
      },
      parent: el
    });
  });

  function handleKeyDown(event, index) {
    switch (event.key) {
      case "Left":
      case "ArrowLeft":
        if (index > 0) {
          event.preventDefault();
          primaryLinks[index - 1].focus();
        }

        break;

      case "Right":
      case "ArrowRight":
        if (index < primaryLinks.length - 1) {
          event.preventDefault();
          primaryLinks[index + 1].focus();
        }

        break;

      default:
    }
  }
};

exports.default = _default;

},{"./NavMenu.js":68}],75:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureItemShape = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["showLink", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ConditionalLink = function ConditionalLink(props) {
  var showLink = props.showLink,
      children = props.children,
      otherProps = _objectWithoutProperties(props, _excluded);

  return showLink ? /*#__PURE__*/_react.default.createElement("a", otherProps, children) : /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: "700"
    }
  }, children);
};

var getIcon = function getIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: "people-listing__link-arrow",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/_react.default.createElement("use", {
    href: "#read-more-arrow-a",
    transform: "translate(4.5 8)"
  }), /*#__PURE__*/_react.default.createElement("use", {
    href: "#read-more-arrow-b",
    transform: "translate(9.5 5)"
  }), /*#__PURE__*/_react.default.createElement("use", {
    href: "#read-more-arrow-c",
    transform: "translate(9.5 9)"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
    id: "read-more-arrow-a",
    d: "M0 .5c-.28 0-.5.22-.5.5s.22.5.5.5v-1zm9 1c.28 0 .5-.22.5-.5S9.28.5 9 .5v1zm-9 0h9v-1H0v1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "read-more-arrow-b",
    d: "M1.1.4C.9.2.57.2.4.4.2.57.2.9.4 1.1l.7-.7zm2.55 3.95c.2.2.5.2.7 0 .2-.2.2-.5 0-.7l-.7.7zM.4 1.1l3.25 3.25.7-.7L1.1.4l-.7.7z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "read-more-arrow-c",
    d: "M.4 2.9c-.2.2-.2.52 0 .7.18.2.5.2.7 0l-.7-.7zM4.34.36c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l.7.7zM1.1 3.6L4.34.36l-.7-.7L.4 2.9l.7.7z"
  })));
};

var FeatureItem = function FeatureItem(_ref) {
  var target = _ref.target,
      name = _ref.name,
      image1x1Src = _ref.image1x1Src,
      primaryTitle = _ref.primaryTitle,
      secondaryTitle = _ref.secondaryTitle,
      summary = _ref.summary,
      areaOfExpertise = _ref.areaOfExpertise,
      email = _ref.email,
      twitterLink = _ref.twitterLink,
      url = _ref.url,
      status = _ref.status,
      displayAsLink = _ref.displayAsLink;

  var shouldDisplayDate = function shouldDisplayDate() {
    return featureItemDisplayDate && displayDates;
  };

  var showLink = url && status == "Active" ? true : false;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "people-listing__person"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "people-listing__photo-wrapper"
  }, image1x1Src != null && /*#__PURE__*/_react.default.createElement(ConditionalLink, {
    showLink: showLink,
    href: url
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "people-listing__photo",
    src: image1x1Src
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "people-listing__primary-info"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "people-listing__primary-person"
  }, /*#__PURE__*/_react.default.createElement(ConditionalLink, {
    showLink: showLink,
    href: url
  }, "".concat(name, " ")), primaryTitle), /*#__PURE__*/_react.default.createElement("span", {
    className: "people-listing__area-of-expertise"
  }, areaOfExpertise), /*#__PURE__*/_react.default.createElement("p", {
    className: "people-listing__primary-details"
  }, summary.slice(0, 250) + "..."), url && status == "Active" && /*#__PURE__*/_react.default.createElement("span", {
    className: "project-listing__read-more-link"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: url,
    target: target,
    className: "read-more__link"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Read More"), getIcon()))));
};

var _default = FeatureItem;
exports.default = _default;
var _React$PropTypes = _react.default.PropTypes,
    string = _React$PropTypes.string,
    shape = _React$PropTypes.shape,
    objectOf = _React$PropTypes.objectOf,
    bool = _React$PropTypes.bool;
var featureItemProps = {
  target: string,
  name: string.isRequired,
  image1x1Src: string,
  summary: string.isRequired,
  primaryTitle: string,
  areaOfExpertise: string
};
var featureItemShape = shape(featureItemProps);
exports.featureItemShape = featureItemShape;
FeatureItem.propTypes = featureItemProps;

},{"classnames":"classnames","react":"react"}],76:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FeatureItem = _interopRequireWildcard(require("./FeatureItem.jsx"));

var _LoadingSpinner = _interopRequireDefault(require("../../search/components/LoadingSpinner.jsx"));

var _paging = require("../../search/paging");

var _classNames = _interopRequireDefault(require("classNames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PeopleItemList = function PeopleItemList(_ref) {
  var results = _ref.results,
      totalResults = _ref.totalResults,
      query = _ref.query,
      nextPage = _ref.nextPage,
      viewAllUrl = _ref.viewAllUrl,
      loading = _ref.loading,
      dictionary = _ref.dictionary,
      displayDates = _ref.displayDates,
      numberOfColumns = _ref.numberOfColumns,
      hideBio = _ref.hideBio;
  var dictionaryBindings = {};

  function dictEntryFor(key) {
    // if name is a dictionary key, grab it
    var entry = dictionary[key];

    if (!entry) {
      // if not a dictionary key, check if it's bound to a dictionary key
      var lowerKey = key.toLowerCase();
      entry = dictionary[dictionaryBindings[lowerKey]];
    } // if no entry found, simply return the name


    return entry || key;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classNames.default)("people-listing", {
      "hide-bio": hideBio === true
    }, {
      "people-listing--two-column": numberOfColumns === 2
    }, {
      "people-listing--three-column": numberOfColumns === 3
    })
  }, results.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(_FeatureItem.default, _extends({
      key: i,
      displayDates: displayDates
    }, item));
  }));
};

var _default = PeopleItemList;
exports.default = _default;
var _React$PropTypes = _react.default.PropTypes,
    arrayOf = _React$PropTypes.arrayOf,
    object = _React$PropTypes.object,
    func = _React$PropTypes.func,
    number = _React$PropTypes.number,
    bool = _React$PropTypes.bool;
PeopleItemList.propTypes = {
  totalResults: number,
  results: arrayOf(_FeatureItem.featureItemShape).isRequired,
  query: object,
  nextPage: func.isRequired,
  displayDates: bool,
  dictionary: object
};
/*
Code for when we add the Load More functionality. Not ready yet
Update Oct 2021: Check the below code against other instances of load more, as
it may have changed since this was originally written.

{ loading && (
          <div className="dynamic-content-listing__loading-spinner">
              <img src="/assets/img/loading.gif"/>
          </div>)}
      {!isLastPage(totalResults, query.perPage, query.page) && (
        <div className="dynamic-content-listing__load-more-wrapper">
          <div className="dynamic-content-listing__load-more">
            {!viewAllUrl && (
              <button onClick={ (e) => nextPage() }>
                {dictEntryFor("loadMoreLabel")}
              </button>
            )}
            {viewAllUrl && (
              <a href={viewAllUrl}>{dictEntryFor("viewAllLabel")}</a>
            )}
          </div>
        </div>
      )}
*/

},{"../../search/components/LoadingSpinner.jsx":84,"../../search/paging":103,"./FeatureItem.jsx":75,"classNames":"classNames","react":"react"}],77:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _PeopleItemList = _interopRequireDefault(require("../components/PeopleItemList.jsx"));

var _search = require("../../search/redux/search/search.actions");

var _facets = require("../../search/redux/facets");

var _reactSelect = _interopRequireDefault(require("react-select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    results: state.results,
    resultsDisplayStrategy: state.resultsDisplayStrategy,
    totalResults: state.totalResults,
    loading: state.loading,
    isFirstLoad: state.isFirstLoad,
    query: state.query,
    pagination: state.pagination,
    displayDates: state.displayDates,
    dictionary: state.dictionary,
    viewAllUrl: state.viewAllUrl,
    numberOfColumns: state.numberOfColumns,
    hideBio: state.hideBio
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    nextPage: function nextPage() {
      dispatch((0, _search.loadNextPage)());
    },
    dismissFacet: function dismissFacet(facetId) {
      dispatch((0, _search.loadFacetChange)(facetId, false));
    },
    showMobileFacets: function showMobileFacets() {
      dispatch((0, _search.showMobileFacets)());
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PeopleItemList.default);

exports.default = _default;

},{"../../search/redux/facets":106,"../../search/redux/search/search.actions":111,"../components/PeopleItemList.jsx":76,"react-redux":"react-redux","react-select":"react-select"}],78:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSearchApp = initSearchApp;

var _jquery = _interopRequireDefault(require("jquery"));

var _ramda = _interopRequireDefault(require("ramda"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reactRedux = require("react-redux");

var _rootReducer = _interopRequireDefault(require("../search/redux/rootReducer"));

var _search = require("../search/redux/search/search.reducer");

var _search2 = require("../search/redux/search/search.actions");

var _configureStore = _interopRequireDefault(require("../search/redux/configureStore"));

var _service = require("../search/redux/service");

var _service2 = require("./redux/service");

var _resultsDisplay = require("../search/redux/resultsDisplay");

var _PeopleItemsContainer = _interopRequireDefault(require("./containers/PeopleItemsContainer.jsx"));

var _FacetsContainer = _interopRequireDefault(require("../search/containers/FacetsContainer.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the mount nodes are the elements we want to include
// as part of the search app
function initSearchApp(mountNodes) {
  if (!mountNodes.length) {
    return;
  } // extract the searchId from the mountNodes
  // while also checking mountNodes share same id


  var searchId = mountNodes.reduce(function (id, node) {
    var nodeId = (0, _jquery.default)(node).data("searchId"); // if id is null, we want to set it
    // with the first node's value

    if (id === null) {
      return nodeId;
    } // if node id does not equal current
    // id value, it's invalid and return undefined


    if (id !== nodeId) {
      return;
    }

    return id;
  }, null); // if we have an invalid or non-matching id, raise an error

  if (!searchId) {
    throw new Error("Could not initialize Pew search app. searchId was either not present, or provided mount nodes did not share the same searchId");
  } // define the canonical inital state of our redux store here
  // including some value taken from the data-attrs of the
  // mount node.


  var config = window.PewSearchConfigs.find(function (c) {
    return c.searchId === searchId;
  });

  if (!config) {
    throw new Error("Could not initialize Pew search app instance with id of \"".concat(searchId, "\". Configuration data not found."));
  }

  var facetDisplayOverride = {
    "contentType": config.displayContentTypeFilter,
    "places": config.displayPlacesFilter,
    "project": config.displayProjectsFilter,
    "tag": config.displayTagsFilter,
    "topic": config.displayTopicsFilter
  }; // create a starting state object,
  // which includes and intitial state
  // from individual reducers

  var initialState = _ramda.default.merge(_search.initialState, {
    url: config.url,
    pagination: config.pagination,
    resultsDisplayStrategy: config.pagination ? _resultsDisplay.RESULTS_DISPLAY_REFRESH : _resultsDisplay.RESULTS_DISPLAY_APPEND,
    viewAllUrl: config.viewAllUrl,
    dictionary: config.dictionary,
    facetDisplayOverride: facetDisplayOverride,
    displayDates: config.displayDates,
    query: _ramda.default.merge(_search.initialState.query, {
      pageId: config.pageId,
      page: config.page,
      perPage: config.perPage,
      componentGuid: config.componentId
    }),
    numberOfColumns: config.numberOfColumns,
    hideBio: config.hideBio
  }); // determine if we want to load all page results in our cold load


  var doLoadAllPages = initialState.resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND && initialState.isFirstLoad;
  initialState = _ramda.default.merge(initialState, {
    query: _ramda.default.merge(initialState.query, {
      loadAllPages: doLoadAllPages
    })
  });

  var thunkMiddleware = _reduxThunk.default.withExtraArgument({
    mapResponseToState: _service.mapResponseToState,
    fetchSearchResults: _service2.fetchSearchResults
  });

  var store = (0, _configureStore.default)(_rootReducer.default, initialState, [thunkMiddleware]);
  store.dispatch((0, _search2.loadResults)());
  mountNodes.forEach(function (node) {
    if (node.className.indexOf("js-people-items") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_PeopleItemsContainer.default, null)), node);
    }

    if (node.className.indexOf("js-people-items-search-facets") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_FacetsContainer.default, null)), node);
    }
  });
}

},{"../search/containers/FacetsContainer.jsx":95,"../search/redux/configureStore":104,"../search/redux/resultsDisplay":108,"../search/redux/rootReducer":109,"../search/redux/search/search.actions":111,"../search/redux/search/search.reducer":112,"../search/redux/service":113,"./containers/PeopleItemsContainer.jsx":77,"./redux/service":79,"jquery":"jquery","ramda":"ramda","react":"react","react-dom":"react-dom","react-redux":"react-redux","redux-thunk":"redux-thunk"}],79:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSearchResults = fetchSearchResults;

var _ramda = _interopRequireDefault(require("ramda"));

var _jquery = _interopRequireDefault(require("jquery"));

var _util = require("../../search/util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchSearchResults(url, query) {
  // dynamic content needs to remap some stuff on the request
  // that's normally part of vanilla search.
  // lose params we don't need. PageGuid and ComponentGuid are added automatically to the URL
  var removeInvalidParams = _ramda.default.omit(["q", "sortBy", "sortOrder", "loadAllPages", "numberOfItems", "startOffset", "pageGuid", "pageId", "componentGuid"]); // any facet/filter group params get changed to filter.<groupName>.
  // Keep track of which params are not filters/


  var nonFilters = ["pageId", "componentGuid", "page", "perPage"];

  var stringifyArrayParams = _ramda.default.map(function (v) {
    return v instanceof Array ? v.join(";") : v;
  });

  var keyName = function keyName(key) {
    return _ramda.default.contains(key, nonFilters) ? key : "filters.".concat(key);
  };

  var filterizeKeys = _ramda.default.partial(_util.renameKeysWith, [keyName]);

  var fixQuery = _ramda.default.pipe(removeInvalidParams, stringifyArrayParams, filterizeKeys);

  var searchPromise = _jquery.default.ajax({
    url: url,
    data: fixQuery(query)
  });

  var featuredPromise = _jquery.default.Deferred().resolve([]);

  return [searchPromise, featuredPromise];
}

},{"../../search/util":114,"jquery":"jquery","ramda":"ramda"}],80:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSearchApp = initSearchApp;

var _jquery = _interopRequireDefault(require("jquery"));

var _ramda = _interopRequireDefault(require("ramda"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reactRedux = require("react-redux");

var _rootReducer = _interopRequireDefault(require("../search/redux/rootReducer"));

var _search = require("../search/redux/search/search.reducer");

var _search2 = require("../search/redux/search/search.actions");

var _configureStore = _interopRequireDefault(require("../search/redux/configureStore"));

var _createRoutingMiddleware = _interopRequireDefault(require("../search/redux/createRoutingMiddleware"));

var _service = require("../search/redux/service");

var _routing = require("../search/redux/routing");

var _resultsDisplay = require("../search/redux/resultsDisplay");

var _FacetsContainer = _interopRequireDefault(require("../search/containers/FacetsContainer.jsx"));

var _ProjectsContainer = _interopRequireDefault(require("../search/containers/ProjectsContainer.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the mount nodes are the elements we want to include
// as part of the search app
function initSearchApp(mountNodes) {
  if (!mountNodes.length) {
    return;
  } // extract the searchId from the mountNodes
  // while also checking mountNodes share same id


  var searchId = mountNodes.reduce(function (id, node) {
    var nodeId = (0, _jquery.default)(node).data("searchId"); // if id is null, we want to set it
    // with the first node's value

    if (id === null) {
      return nodeId;
    } // if node id does not equal current
    // id value, it's invalid and return undefined


    if (id !== nodeId) {
      return;
    }

    return id;
  }, null); // if we have an invalid or non-matching id, raise an error

  if (!searchId) {
    throw new Error("Could not initialize Pew search app. searchId was either not present, or provided mount nodes did not share the same searchId");
  } // define the canonical inital state of our redux store here
  // including some value taken from the data-attrs of the
  // mount node.


  var config = window.PewSearchConfigs.find(function (c) {
    return c.searchId === searchId;
  });

  if (!config) {
    throw new Error("Could not initialize Pew search app instance with id of \"".concat(searchId, "\". Configuration data not found."));
  } // create a starting state object,
  // which includes and intitial state
  // from individual reducers


  var initialState = _ramda.default.merge(_search.initialState, {
    url: config.url,
    pagination: config.pagination,
    resultsDisplayStrategy: config.pagination ? _resultsDisplay.RESULTS_DISPLAY_REFRESH : _resultsDisplay.RESULTS_DISPLAY_APPEND,
    sorters: config.sorters,
    dictionary: config.dictionary,
    initialResults: config.initialQueryResults || null,
    numOpenGroups: config.numOpenGroups,
    query: _ramda.default.merge(_search.initialState.query, {
      pageId: config.pageId,
      page: config.page,
      status: 'active'
    })
  }); // determine if we want to load all page results in our cold load


  var doLoadAllPages = initialState.resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND && initialState.isFirstLoad;
  initialState = _ramda.default.merge(initialState, {
    query: _ramda.default.merge(initialState.query, {
      loadAllPages: doLoadAllPages
    })
  });

  var thunkMiddleware = _reduxThunk.default.withExtraArgument({
    mapResponseToState: _service.mapResponseToState,
    fetchSearchResults: _service.fetchSearchResults
  });

  var routingMiddleware = (0, _createRoutingMiddleware.default)(_routing.mapStateToUrl, _routing.handleUrlChange);
  var store = (0, _configureStore.default)(_rootReducer.default, initialState, [thunkMiddleware, routingMiddleware]);

  if (initialState.initialResults) {
    store.dispatch((0, _search2.loadSuccess)(initialState.initialResults, initialState.resultsDisplayStrategy, _service.mapResponseToState));
  } else {
    store.dispatch((0, _search2.loadResults)());
  }

  mountNodes.forEach(function (node) {
    if (node.className.indexOf("js-search-facets") > -1 || node.className.indexOf("js-projects-search-facets") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_FacetsContainer.default, null)), node);
    }

    if (node.className.indexOf("js-projects-container") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_ProjectsContainer.default, null)), node);
    }
  });
}

},{"../search/containers/FacetsContainer.jsx":95,"../search/containers/ProjectsContainer.jsx":96,"../search/redux/configureStore":104,"../search/redux/createRoutingMiddleware":105,"../search/redux/resultsDisplay":108,"../search/redux/rootReducer":109,"../search/redux/routing":110,"../search/redux/search/search.actions":111,"../search/redux/search/search.reducer":112,"../search/redux/service":113,"jquery":"jquery","ramda":"ramda","react":"react","react-dom":"react-dom","react-redux":"react-redux","redux-thunk":"redux-thunk"}],81:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ramda = _interopRequireDefault(require("ramda"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentFilterBar = function ContentFilterBar(_ref) {
  var contentFilters = _ref.contentFilters,
      selectedFilter = _ref.selectedFilter,
      onSelection = _ref.onSelection,
      dictionary = _ref.dictionary;

  var handleTypeChange = function handleTypeChange(event) {
    var newFilter = event.target.value;

    if (newFilter && newFilter !== selectedFilter) {
      return onSelection(newFilter);
    }
  };

  var totalResults = contentFilters && contentFilters.values ? contentFilters.values.reduce(function (total, filter) {
    return total + filter.count;
  }, 0) : 0;

  var isAllActive = contentFilters && _ramda.default.none(_ramda.default.propEq("selected", true), _ramda.default.prop("values", contentFilters));

  var resultLabels = {
    "all": dictionary.allResultsLabel || "All Results",
    "content": dictionary.contentResultsLabel || "Content",
    "project": dictionary.projectResultsLabel || "Project",
    "people": dictionary.peopleResultsLabel || "People"
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__content-types"
  }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)({
      "is-active": isAllActive
    })
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "u-visuallyhidden",
    type: "radio",
    id: "search-content-types__all",
    name: "search-content-types",
    value: "all",
    checked: selectedFilter === "all",
    onChange: handleTypeChange
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "search-content-types__all"
  }, resultLabels.all, " (", totalResults, ")")), contentFilters && contentFilters.values.map(function (ct) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _classnames.default)("search-results__content-type-item", {
        "is-active": ct.selected
      }),
      key: ct.id
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "u-visuallyhidden",
      type: "radio",
      id: "search-content-types__".concat(ct.name),
      name: "search-content-types",
      value: ct.name,
      checked: ct.name === selectedFilter,
      onChange: handleTypeChange
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "search-content-types__".concat(ct.name)
    }, resultLabels[ct.name], " (", ct.count, ")"));
  })));
};

var _React$PropTypes = _react.default.PropTypes,
    shape = _React$PropTypes.shape,
    string = _React$PropTypes.string,
    number = _React$PropTypes.number,
    oneOfType = _React$PropTypes.oneOfType,
    func = _React$PropTypes.func,
    object = _React$PropTypes.object;
var filterShape = shape({
  id: oneOfType[(number, string)]
});
ContentFilterBar.propTypes = {
  contentFilters: filterShape,
  selectedFilter: string,
  onSelection: func,
  dictionary: object
};
var _default = ContentFilterBar;
exports.default = _default;

},{"classnames":"classnames","ramda":"ramda","react":"react"}],82:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var _classnames = _interopRequireDefault(require("classnames"));

var _facets = require("../redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MOBILE_BREAKPOINT = 600;
var dateId = "date"; //id of the date facet where we want to alter the display

function arrowIcon() {
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "icon icon--chevron-down"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.6 6.1",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.4 0 6.8 4 1.2 0 0 1.2l6.8 4.9 6.8-4.9z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m1.2 0 5.6 4 5.6-4 1.2 1.2-6.8 4.9L0 1.2z"
  })));
}

function xIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 1195 1195",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M643.333 640l195-191q9-10 9.5-23t-8.5-23q-10-9-23-9t-23 9l-196 192-196-192q-10-9-23-9t-23 10q-9 9-9 22.5t10 22.5l195 191-195 191q-9 10-9.5 23t8.5 23q10 9 23 9t23-9l196-192 196 192q10 9 23 9t23-10q9-9 9-22.5t-10-22.5zm-46-448q91 0 174 35 81 34 143 96t96 143q35 83 35 174t-35 174q-34 81-96 143t-143 96q-83 35-174 35t-174-35q-81-34-143-96t-96-143q-35-83-35-174t35-174q34-81 96-143t143-96q83-35 174-35zm0-64q-139 0-257 68.5T153.833 383t-68.5 257 68.5 257 186.5 186.5 257 68.5 257-68.5 186.5-186.5 68.5-257-68.5-257-186.5-186.5-257-68.5z"
  }));
}

function searchIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(1.11 1.11)",
    fill: "#296EC3"
  }), /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(13.33 13.333)",
    fill: "#296EC3"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
    id: "a",
    d: "M7.22 15.44c4.54 0 8.22-3.68 8.22-8.22h-2c0 3.44-2.78 6.22-6.22 6.22v2zm8.22-8.22C15.44 2.68 11.76-1 7.22-1v2c3.44 0 6.22 2.8 6.22 6.22h2zM7.22-1C2.68-1-1 2.68-1 7.22h2C1 3.8 3.8 1 7.22 1v-2zM-1 7.22c0 4.54 3.68 8.22 8.22 8.22v-2C3.8 13.44 1 10.66 1 7.22h-2z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "b",
    d: "M1.26-.15c-.4-.4-1.02-.4-1.4 0-.4.4-.4 1.02 0 1.4l1.4-1.4zM4.3 5.7c.38.4 1.02.4 1.4 0 .4-.38.4-1.02 0-1.4L4.3 5.7zM-.16 1.27L4.3 5.7l1.4-1.4L1.27-.16l-1.4 1.4z"
  })));
}

function filterIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 10 7"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "nav-/-search,-filter-active",
    transform: "translate(-97.000000, -17.000000)",
    stroke: "#333333"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "ii-/-Filter_Icon_Grey",
    transform: "translate(93.000000, 11.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group-2",
    transform: "translate(4.000000, 5.000000)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.5,7.5 L7.5,7.5",
    id: "Line"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.5,4.5 L8.5625,4.5",
    id: "Line"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0.5,1.5 L9.5,1.5",
    id: "Line-Copy"
  }))))));
}

var FacetBar = /*#__PURE__*/function (_React$Component) {
  _inherits(FacetBar, _React$Component);

  var _super = _createSuper(FacetBar);

  function FacetBar(props) {
    var _this;

    _classCallCheck(this, FacetBar);

    _this = _super.call(this, props);
    _this.searchableGroups = ["people", "tag", "expert"];
    _this.groupWrapperRefs = {};
    _this.dictionaryBindings = {
      continents: "continents",
      oceans: "oceans",
      "countries and territories": "countriesAndTerritories",
      "united states and territories": "unitedStatesAndTerritories"
    };
    _this.state = {
      showGroups: true,
      activeGroup: [],
      activeSubGroups: [],
      activeQuery: "",
      facets: props.facets
    };
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FacetBar, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      document.addEventListener("mousedown", this.handleClickOutside);
      document.body.clientWidth <= 600 && this.setState(_ramda.default.merge(this.state, {
        showGroups: false
      }));
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState(_ramda.default.merge(this.state, {
        facets: nextProps.facets,
        activeQuery: ""
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      _ramda.default.forEach(function (e) {
        return _this2.repositionPopOut(e);
      }, _ramda.default.values(this.groupWrapperRefs));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
  }, {
    key: "aggregateSelectedCount",
    value: function aggregateSelectedCount(group) {
      return (0, _facets.selectedFacetsFromGroup)(group).length;
    }
  }, {
    key: "allSelectedCount",
    value: function allSelectedCount() {
      var _this3 = this;

      return _ramda.default.reduce(function (sum, group) {
        return sum + _this3.aggregateSelectedCount(group);
      }, 0, this.props.facets);
    }
  }, {
    key: "groupIsActive",
    value: function groupIsActive(groupId, groups) {
      return _ramda.default.contains(groupId, groups);
    }
  }, {
    key: "isMultiGroup",
    value: function isMultiGroup(group) {
      return group.childGroups.length > 0;
    }
  }, {
    key: "dictEntryFor",
    value: function dictEntryFor(key) {
      // if name is a dictionary key, grab it
      var entry = this.props.dictionary[key];

      if (!entry) {
        // if not a dictionary key, check if it's bound to a dictionary key
        var lowerKey = key.toLowerCase();
        entry = this.props.dictionary[this.dictionaryBindings[lowerKey]];
      } // if no entry found, simply return the name


      return entry || key;
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      // if clicking outside of a group or subgroup menu,
      // we want to close that menu
      var target = event.target; // refs won't exist before we've opened a menu

      if (!_ramda.default.keys(this.groupWrapperRefs).length) {
        return;
      } // double check our target isn't a toggle button


      if (_ramda.default.contains("js-group-toggle", Array.from(target.classList)) || target.closest(".js-group-toggle")) {
        return;
      } // Look through the wrapper refs to determine which
      // wrappers our target may be a descendant of


      var wrappers = _ramda.default.reduce(function (instances, wrapperPair) {
        var groupId = wrapperPair[0];
        var wrapper = wrapperPair[1];

        if (wrapper && wrapper.contains(target)) {
          instances.push(target);
        }

        return instances;
      }, [], _ramda.default.toPairs(this.groupWrapperRefs));

      var newGroups = {}; // if no wrappers matched, we've clicked outside
      // and can close groups

      if (wrappers.length === 0) {
        newGroups = {
          activeGroup: []
        };
      } // if we only matched a single wrapper,
      // just close all subgroups


      if (wrappers.length === 1) {
        newGroups = {
          activeSubGroups: []
        };
      } // check to see if state actually needs to change. Otherwise, it will trigger
      // a re-render we don't need


      var groupChange = newGroups.activeGroup && newGroups.activeGroup.length !== this.state.activeGroup.length;
      var subGroupChange = newGroups.activeSubGroups && newGroups.activeSubGroups.length !== this.state.activeSubGroups.length;

      if (groupChange || subGroupChange) {
        this.setState(_ramda.default.merge(this.state, newGroups));
      }
    }
  }, {
    key: "handleGroupClick",
    value: function handleGroupClick(groupId) {
      var toggleActiveGroup = _ramda.default.ifElse(_ramda.default.contains(groupId), _ramda.default.reject(_ramda.default.equals(groupId)), function () {
        return [groupId];
      });

      this.setState(_ramda.default.merge(this.state, {
        activeGroup: toggleActiveGroup(this.state.activeGroup),
        activeQuery: "",
        facets: this.props.facets
      }));
    }
  }, {
    key: "handleSubGroupClick",
    value: function handleSubGroupClick(groupId) {
      var toggleActiveSubGroups = _ramda.default.ifElse(_ramda.default.contains(groupId), _ramda.default.reject(_ramda.default.equals(groupId)), function () {
        return [groupId];
      });

      this.setState(_ramda.default.merge(this.state, {
        activeSubGroups: toggleActiveSubGroups(this.state.activeSubGroups)
      }));
    }
  }, {
    key: "handleInlineFilterChange",
    value: function handleInlineFilterChange(group, query) {
      // we want to update the facets in state, but make sure to always
      // read facets from props, so state changes don't mess with the
      // original list of facets
      var newFacets = (0, _facets.filterVisibleFacetsInGroup)(group.id, query, this.props.facets);
      this.setState(_ramda.default.merge(this.state, {
        facets: newFacets,
        activeQuery: query
      }));
    }
  }, {
    key: "handleFacetClick",
    value: function handleFacetClick(value, groupId) {
      // dates should behave like radio buttons
      if (groupId === "date" || groupId === "status") {
        this.props.handleFacetChangeSingular(groupId, value.id, !value.selected);
      } else {
        this.props.handleFacetChange(groupId, value.id, !value.selected);
      } // if we are selecting a facet (not de-selecting),
      // scroll up to the top of the menu where the new
      // selected facet is shown


      if (!value.selected) {
        _ramda.default.map(function (ref) {
          if (ref) {
            var scrolled = ref.querySelector(".search-facets-bar__facet-list");

            if (scrolled) {
              scrolled.scrollTop = 0;
            }
          }
        }, this.groupWrapperRefs);
      }
    }
  }, {
    key: "repositionPopOut",
    value: function repositionPopOut(elem) {
      if (!elem) {
        return;
      }

      if (elem.closest(".search-facets-bar__subgroup")) {
        return;
      } // if a popout draws beyond the edge of the window, move it until it fits


      var rect = elem.getBoundingClientRect();

      if (rect.left < 0) {
        elem.style.right = "".concat(rect.left, "px");
      }
    } // compute the label to highlight queried letter fragments
    // if an active value query is present

  }, {
    key: "computedName",
    value: function computedName(name) {
      if (!this.state.activeQuery || !this.state.activeQuery.trim()) {
        return name;
      }

      var newName = name.replace(new RegExp(this.state.activeQuery, "gi"), function (match) {
        return "<em>".concat(match, "</em>");
      });
      return /*#__PURE__*/_react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: newName
        }
      });
    }
  }, {
    key: "toggleGroups",
    value: function toggleGroups() {
      this.setState(_ramda.default.merge(this.state, {
        showGroups: !this.state.showGroups
      }));
    }
  }, {
    key: "hideValue",
    value: function hideValue(value) {
      if (value.count <= 0) {
        return true;
      } else {
        return value.hide && _ramda.default.all(_ramda.default.propEq("hide", true), value.childValues);
      }
    }
  }, {
    key: "disableValue",
    value: function disableValue(value) {
      return value.hide && _ramda.default.any(_ramda.default.not(_ramda.default.has("hide"), value.childValues));
    }
  }, {
    key: "getInlinePlaceholder",
    value: function getInlinePlaceholder(group) {
      var value = "";

      if (group.label == "Experts") {
        value = this.dictEntryFor("searchExpertsPlaceholder");
      } else {
        value = "Search " + group.label + "...";
      }

      return value;
    }
  }, {
    key: "renderInlineSearch",
    value: function renderInlineSearch(group) {
      var _this4 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets-bar__inline-filter"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        onChange: function onChange(e) {
          return _this4.handleInlineFilterChange(group, e.target.value);
        },
        placeholder: this.getInlinePlaceholder(group),
        value: this.state.activeQuery || ""
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "icon"
      }, " ", searchIcon(), " "));
    }
  }, {
    key: "renderFacetValues",
    value: function renderFacetValues(values, groupId) {
      var _this5 = this;

      var searchable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      // create a version of the facet values that includes an array index field
      var valuesWithIndex = values.map(function (v, i) {
        return _ramda.default.merge(v, {
          idx: i
        });
      }); // re-sort list so selected values are at the top, but make sure
      // to maintain original order otherwise

      var valueSorter = _ramda.default.sort(function (a, b) {
        if (groupId != dateId) {
          if (a.selected === b.selected) {
            return a.idx - b.idx;
          }

          if (a.selected) {
            return -1;
          }

          if (b.selected) {
            return 1;
          }
        }

        return a.idx - b.idx;
      });

      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "search-facets-bar__facet-list"
      }, valueSorter(valuesWithIndex).map(function (v) {
        var hide = _this5.hideValue(v);

        var disabled = _this5.disableValue(v);

        var valueClass = disabled ? "is-disabled" : "";
        return !hide && /*#__PURE__*/_react.default.createElement("li", {
          key: v.id,
          className: valueClass
        }, /*#__PURE__*/_react.default.createElement("input", {
          className: "u-visuallyhidden",
          type: groupId == dateId ? "radio" : "checkbox",
          onChange: function onChange(e) {
            return _this5.handleFacetClick(v, groupId);
          },
          id: v.id,
          checked: v.selected === "on" || v.selected
        }), /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: v.id
        }, _this5.computedName(v.name), "\xA0", v.name != "Institutional News" ? "(".concat(v.count, ")") : ""), v.childValues && !!v.childValues.length && _this5.renderFacetValues(v.childValues, groupId));
      }));
    }
  }, {
    key: "handleStatusFacetClick",
    value: function handleStatusFacetClick(value, group) {
      this.props.handleProjectStatusChange(group, value.id, !value.selected);
    }
  }, {
    key: "renderGroup",
    value: function renderGroup(group) {
      var _this6 = this;

      var selectedCount = this.aggregateSelectedCount(group);
      var selectedLabel = selectedCount ? "(".concat(selectedCount, ")") : null;
      var selectedCountClass = selectedCount ? "" : "is-zero";
      var inactiveLabel = this.dictEntryFor("projectListingInactiveLabel");

      if (group.id === "status") {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: group.id
        }, group.values.map(function (value, i) {
          {}
          return /*#__PURE__*/_react.default.createElement("span", {
            key: value.id,
            className: (0, _classnames.default)("search-facets__status-facet", {
              "is-checked": value.selected
            }),
            onClick: function onClick() {
              return !value.selected && _this6.handleStatusFacetClick(value, group.id);
            }
          }, value.name);
        }));
      } else {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: group.id,
          className: (0, _classnames.default)("search-facets-bar__group", {
            "is-open": this.groupIsActive(group.id, this.state.activeGroup)
          })
        }, /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          className: "js-group-toggle",
          onClick: function onClick() {
            return _this6.handleGroupClick(group.id);
          }
        }, group.label, selectedLabel && /*#__PURE__*/_react.default.createElement("span", {
          className: selectedCountClass
        }, selectedLabel), arrowIcon()), this.groupIsActive(group.id, this.state.activeGroup) && (this.isMultiGroup(group) ? this.renderMultiGroup(group) : this.renderSingleGroup(group)));
      }
    }
  }, {
    key: "checkIfDatesEmpty",
    value: function checkIfDatesEmpty(group) {
      var dateEq = _ramda.default.propEq("count", 0);

      var newDateArr;

      if (group.id == dateId) {
        newDateArr = _ramda.default.filter(dateEq, group.values);

        if (newDateArr.length === group.values.length) {
          return true;
        } else {
          return false;
        }
      }
    }
  }, {
    key: "renderSingleGroup",
    value: function renderSingleGroup(group) {
      var _this7 = this;

      var parentGroupId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var groupKey = parentGroupId != null ? parentGroupId : group.id;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets-bar__group-wrap"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets-bar__group-inner",
        ref: function ref(e) {
          return _this7.groupWrapperRefs[group.id] = e;
        }
      }, (group.values.length === 0 || this.checkIfDatesEmpty(group) === true) && /*#__PURE__*/_react.default.createElement("p", null, "No ".concat(group.label.toLowerCase(), " in current results")), group.values.length > 0 && group.id != dateId && /*#__PURE__*/_react.default.createElement("p", {
        className: "search-facets-bar__group-select"
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: function onClick() {
          return _this7.props.handleSelectGroup(group);
        }
      }, this.dictEntryFor("selectAll")), /*#__PURE__*/_react.default.createElement("span", null, "|"), /*#__PURE__*/_react.default.createElement("button", {
        onClick: function onClick() {
          return _this7.props.handleClearGroup(group);
        }
      }, this.dictEntryFor("deselectAll"))), _ramda.default.contains(group.id, this.searchableGroups) && this.renderInlineSearch(group), group.values.length > 0 && this.renderFacetValues(group.values, groupKey)));
    }
  }, {
    key: "renderMultiGroup",
    value: function renderMultiGroup(group) {
      var _this8 = this;

      // divide the groups into chunks of 2 for easier layout
      var subGroupChunks = _ramda.default.splitEvery(2, group.childGroups);

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets-bar__group-wrap is-multi"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets-bar__group-inner",
        ref: function ref(e) {
          return _this8.groupWrapperRefs["_".concat(group.id)] = e;
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets-bar__multi-top"
      }, /*#__PURE__*/_react.default.createElement("h4", {
        className: "small-caps-header"
      }, this.dictEntryFor("filterPlaces")), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return _this8.props.handleClearGroup(group);
        }
      }, this.dictEntryFor("clearAll"), " ", xIcon())), /*#__PURE__*/_react.default.createElement("div", {
        className: "search-facets-bar__multi-body"
      }, subGroupChunks.map(function (chunk, i) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: i,
          className: "search-facets-bar__multi-row"
        }, chunk.map(function (subGroup) {
          var selectedCount = _this8.aggregateSelectedCount(subGroup);

          var selectedLabel = selectedCount ? "Selected (".concat(selectedCount, ")") : "Select";
          var subGroupClass = (0, _classnames.default)("search-facets-bar__subgroup", {
            "is-open": _this8.groupIsActive(subGroup.id, _this8.state.activeSubGroups)
          });
          return /*#__PURE__*/_react.default.createElement("div", {
            key: subGroup.id,
            className: subGroupClass
          }, /*#__PURE__*/_react.default.createElement("h5", null, _this8.dictEntryFor(subGroup.label)), /*#__PURE__*/_react.default.createElement("button", {
            className: "js-group-toggle",
            type: "button",
            onClick: function onClick() {
              return _this8.handleSubGroupClick(subGroup.id);
            }
          }, selectedLabel, " ", arrowIcon()), _this8.groupIsActive(subGroup.id, _this8.state.activeSubGroups) && _this8.renderSingleGroup(subGroup, group.id));
        }));
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      var shouldRenderGroup = function shouldRenderGroup(groupId) {
        if (!_this9.props.facetDisplayOverride) {
          return true;
        } else {
          return _this9.props.facetDisplayOverride[groupId];
        }
      };

      return /*#__PURE__*/_react.default.createElement("section", {
        className: "search-facets-bar"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return _this9.toggleGroups();
        },
        className: "search-facets-bar__toggle-all-button"
      }, /*#__PURE__*/_react.default.createElement("span", null, this.dictEntryFor("filterBy"), /*#__PURE__*/_react.default.createElement("span", {
        className: "icon"
      }, filterIcon())), /*#__PURE__*/_react.default.createElement("span", null, this.allSelectedCount(), " selected")), this.state.showGroups && /*#__PURE__*/_react.default.createElement("ul", {
        className: "search-facets-bar__group-list"
      }, this.state.facets.map(function (g) {
        return shouldRenderGroup(g.id) && _this9.renderGroup(g);
      })));
    }
  }]);

  return FacetBar;
}(_react.default.Component);

exports.default = FacetBar;
var _React$PropTypes = _react.default.PropTypes,
    string = _React$PropTypes.string,
    arrayOf = _React$PropTypes.arrayOf,
    bool = _React$PropTypes.bool,
    shape = _React$PropTypes.shape,
    number = _React$PropTypes.number,
    oneOfType = _React$PropTypes.oneOfType,
    func = _React$PropTypes.func,
    object = _React$PropTypes.object;
FacetBar.propTypes = {
  title: string,
  mobileFiltersShown: bool,
  hideMobileFacets: func,
  facets: arrayOf(shape({
    id: oneOfType([number, string])
  })),
  numOpenGroups: number,
  handleFacetChange: func.isRequired,
  handleFacetChangeSingular: func.isRequired,
  handleProjectStatusChange: func.isRequired,
  handleClearGroup: func.isRequired,
  handleSelectGroup: func.isRequired,
  handleClearAll: func.isRequired,
  dictionary: object.isRequired,
  facetDisplayOverride: object
};
FacetBar.defaultProps = {
  facets: [],
  numOpenGroups: null
};

},{"../redux/facets":106,"classnames":"classnames","ramda":"ramda","react":"react"}],83:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _LoadingSpinner = _interopRequireDefault(require("./LoadingSpinner.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var LoadMore = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadMore, _React$Component);

  var _super = _createSuper(LoadMore);

  function LoadMore(props) {
    var _this;

    _classCallCheck(this, LoadMore);

    _this = _super.call(this, props);
    _this.state = {
      initiatedLoad: false
    };
    return _this;
  }

  _createClass(LoadMore, [{
    key: "onClick",
    value: function onClick(event) {
      event.preventDefault();
      this.props.handleClick();
      this.setState({
        initiatedLoad: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var dictionary = this.props.dictionary; // const shouldShowSpinner = this.props.loading && this.state.initiatedLoad;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "search-results__load-more"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--primary",
        type: "button",
        onClick: function onClick(e) {
          return _this2.onClick(e);
        }
      }, dictionary.loadMoreLabel));
    }
  }]);

  return LoadMore;
}(_react.default.Component);

exports.default = LoadMore;
var _React$PropTypes = _react.default.PropTypes,
    func = _React$PropTypes.func,
    shape = _React$PropTypes.shape,
    string = _React$PropTypes.string,
    bool = _React$PropTypes.bool;
LoadMore.propTypes = {
  handleClick: func.isRequired,
  loading: bool,
  dictionary: shape({
    loadMoreLabel: string
  })
};

},{"./LoadingSpinner.jsx":84,"react":"react"}],84:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__spinner"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/assets/img/transparent-loader.svg"
  }));
};

exports.default = _default;

},{"react":"react"}],85:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var _paging = require("../paging");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pagination = function Pagination(_ref) {
  var totalResults = _ref.totalResults,
      resultsPerPage = _ref.resultsPerPage,
      currentPage = _ref.currentPage,
      handlePageChange = _ref.handlePageChange;
  var block = (0, _paging.pageBlock)(totalResults, resultsPerPage, currentPage);
  var isLast = (0, _paging.isLastPage)(totalResults, resultsPerPage, currentPage);
  var isFirst = (0, _paging.isFirstPage)(currentPage);
  var lastPage = (0, _paging.totalPages)(totalResults, resultsPerPage);

  function arrowIcon() {
    return /*#__PURE__*/_react.default.createElement("svg", {
      viewBox: "0 0 11 19",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
      d: "M9.5 18.5L1 9.7"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M9.5.9L1 9.7"
    })));
  }

  function getPage(label, value, isDisabled) {
    var addClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    return /*#__PURE__*/_react.default.createElement("button", {
      className: "btn btn--link ".concat(addClass),
      key: label + addClass,
      type: "button",
      onClick: function onClick() {
        return onPageClick(value, isDisabled);
      },
      disabled: isDisabled
    }, label);
  }

  function onPageClick(pageNum, isDisabled) {
    if (!isDisabled) {
      handlePageChange(pageNum);
    }
  }

  function renderEllipsis(pageBlock) {
    var leftPage = _ramda.default.prop("num", pageBlock[0]);

    var rightPage = _ramda.default.prop("num", _ramda.default.last(pageBlock));

    return {
      left: !(0, _paging.isFirstPage)(leftPage),
      right: !(0, _paging.isLastPage)(totalResults, resultsPerPage, rightPage)
    };
  }

  var ellipsis = renderEllipsis(block);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__pagination"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__pages"
  }, getPage(arrowIcon(), currentPage - 1, isFirst, "is-prev"), ellipsis.left && getPage("...", 1, false, "go-first"), block.map(function (page) {
    return getPage(page.label, page.num, page.current);
  }), ellipsis.right && getPage("...", lastPage, false, "go-last"), getPage(arrowIcon(), currentPage + 1, isLast, "is-next")));
};

var _React$PropTypes = _react.default.PropTypes,
    number = _React$PropTypes.number,
    func = _React$PropTypes.func;
Pagination.propTypes = {
  totalResults: number.isRequired,
  resultsPerPage: number.isRequired,
  currentPage: number.isRequired,
  handlePageChange: func.isRequired
};
var _default = Pagination;
exports.default = _default;

},{"../paging":103,"ramda":"ramda","react":"react"}],86:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ProjectTile = _interopRequireDefault(require("../components/ProjectTile.jsx"));

var _LocalNav = _interopRequireDefault(require("../../navigation/LocalNav"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ProjectList = /*#__PURE__*/function (_React$Component) {
  _inherits(ProjectList, _React$Component);

  var _super = _createSuper(ProjectList);

  function ProjectList(props) {
    _classCallCheck(this, ProjectList);

    return _super.call(this, props);
  }

  _createClass(ProjectList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _LocalNav.default.init();

      if (window.location.hash.length) {
        var top = document.getElementById(window.location.hash.substring(1).toLowerCase());

        if (top) {
          setTimeout(function () {
            window.scrollTo(0, top.offsetTop + 140); // Scroll a bit farther than the title itself to prevent redundant text
          }, 500);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      _LocalNav.default.init();
    }
  }, {
    key: "renderProjectTitle",
    value: function renderProjectTitle(title, borderColor) {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
        className: "project-listing__section-title js-force-local-nav-header",
        style: {
          borderBottomColor: borderColor
        }
      }, title));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/_react.default.createElement("div", null, this.props.results.map(function (project, i) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "project-".concat(i),
          className: "project-listing__project-wrapper"
        }, project.title && _this.renderProjectTitle(project.title, project.color), project.description && /*#__PURE__*/_react.default.createElement("p", {
          className: "project-listing__section-desc"
        }, project.description), project.tiles.map(function (tile, i) {
          return /*#__PURE__*/_react.default.createElement(_ProjectTile.default, {
            key: "tile-".concat(i),
            tile: tile
          });
        }));
      }));
    }
  }]);

  return ProjectList;
}(_react.default.Component);

exports.default = ProjectList;

},{"../../navigation/LocalNav":67,"../components/ProjectTile.jsx":87,"classnames":"classnames","ramda":"ramda","react":"react"}],87:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ProjectTile = /*#__PURE__*/function (_React$Component) {
  _inherits(ProjectTile, _React$Component);

  var _super = _createSuper(ProjectTile);

  function ProjectTile(props) {
    _classCallCheck(this, ProjectTile);

    return _super.call(this, props);
  }

  _createClass(ProjectTile, [{
    key: "readMoreArrow",
    value: function readMoreArrow() {
      return /*#__PURE__*/_react.default.createElement("svg", {
        className: "project-listing__link-arrow",
        width: "18",
        height: "18",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, /*#__PURE__*/_react.default.createElement("use", {
        xlinkHref: "#read-more-arrow-a",
        transform: "translate(4.5 8)"
      }), /*#__PURE__*/_react.default.createElement("use", {
        xlinkHref: "#read-more-arrow-b",
        transform: "translate(9.5 5)"
      }), /*#__PURE__*/_react.default.createElement("use", {
        xlinkHref: "#read-more-arrow-c",
        transform: "translate(9.5 9)"
      }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
        id: "read-more-arrow-a",
        d: "M0 .5c-.28 0-.5.22-.5.5s.22.5.5.5v-1zm9 1c.28 0 .5-.22.5-.5S9.28.5 9 .5v1zm-9 0h9v-1H0v1z"
      }), /*#__PURE__*/_react.default.createElement("path", {
        id: "read-more-arrow-b",
        d: "M1.1.4C.9.2.57.2.4.4.2.57.2.9.4 1.1l.7-.7zm2.55 3.95c.2.2.5.2.7 0 .2-.2.2-.5 0-.7l-.7.7zM.4 1.1l3.25 3.25.7-.7L1.1.4l-.7.7z"
      }), /*#__PURE__*/_react.default.createElement("path", {
        id: "read-more-arrow-c",
        d: "M.4 2.9c-.2.2-.2.52 0 .7.18.2.5.2.7 0l-.7-.7zM4.34.36c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l.7.7zM1.1 3.6L4.34.36l-.7-.7L.4 2.9l.7.7z"
      })));
    }
  }, {
    key: "tileHasTopicTitle",
    value: function tileHasTopicTitle() {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "project-listing__item-topic"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.page.url
      }, this.props.topicTitle));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "project-listing__item"
      }, (this.props.tile.page.image1X1 || this.props.tile.page.image16X9) && /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.tile.page.url
      }, /*#__PURE__*/_react.default.createElement("picture", {
        className: "project-listing__item-image"
      }, /*#__PURE__*/_react.default.createElement("source", {
        srcSet: this.props.tile.page.image1X1 || this.props.tile.page.image16X9,
        media: "(min-width: 471px)"
      }), /*#__PURE__*/_react.default.createElement("source", {
        srcSet: this.props.tile.page.image16X9 || this.props.tile.page.image1X1,
        media: "(max-width: 470px)"
      }), /*#__PURE__*/_react.default.createElement("img", {
        src: this.props.tile.page.image1X1 || ""
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "project-listing__item-details"
      }, this.props.tile.topicTitle && tileHasTopicTitle(), /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.tile.page.url,
        className: "project-listing__item-project"
      }, this.props.tile.page.title), /*#__PURE__*/_react.default.createElement("p", {
        className: "project-listing__item-summary"
      }, this.props.tile.page.summary), /*#__PURE__*/_react.default.createElement("span", {
        className: "project-listing__read-more-link"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.tile.page.url
      }, "Read More", this.readMoreArrow()))), /*#__PURE__*/_react.default.createElement("div", {
        className: "project-listing__item-latest"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "project-listing__item-latest-title"
      }, "Latest from ", this.props.tile.page.title), this.props.tile.mostRecentItems.map(function (item, i) {
        if (item.title !== "$name") {
          return /*#__PURE__*/_react.default.createElement("a", {
            key: "latest-link-".concat(i),
            href: item.url,
            className: "project-listing__item-latest-link"
          }, item.title);
        }
      })));
    }
  }]);

  return ProjectTile;
}(_react.default.Component);

exports.default = ProjectTile;

},{"classnames":"classnames","ramda":"ramda","react":"react"}],88:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ResultItem = /*#__PURE__*/function (_React$Component) {
  _inherits(ResultItem, _React$Component);

  var _super = _createSuper(ResultItem);

  function ResultItem(props) {
    var _this;

    _classCallCheck(this, ResultItem);

    _this = _super.call(this, props);
    _this.itemWrapper = null;
    return _this;
  }

  _createClass(ResultItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.itemWrapper.className = this.itemWrapper.className + " is-visible";
    }
  }, {
    key: "formatDate",
    value: function formatDate(dateStr) {
      var date = new Date(dateStr);
      return (0, _moment.default)(date).format("MMMM Do, YYYY");
    }
  }, {
    key: "truncateSummary",
    value: function truncateSummary(summary) {
      if (summary) {
        return summary.length > 250 ? "".concat(summary.substr(0, 250), "...") : summary;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          summary = _this$props.summary,
          contentType = _this$props.contentType,
          date = _this$props.date,
          displayMetadata = _this$props.displayMetadata,
          authors = _this$props.authors,
          url = _this$props.url,
          imageSrc = _this$props.imageSrc,
          projectTitle = _this$props.projectTitle,
          projectLink = _this$props.projectLink,
          isPeople = _this$props.isPeople,
          featured = _this$props.featured,
          featuredResultLabel = _this$props.featuredResultLabel,
          suppressContentType = _this$props.suppressContentType,
          suppressPublicationDate = _this$props.suppressPublicationDate;
      return /*#__PURE__*/_react.default.createElement("article", {
        className: "search-item",
        ref: function ref(el) {
          return _this2.itemWrapper = el;
        }
      }, featured && /*#__PURE__*/_react.default.createElement("span", {
        className: "search-item__featured"
      }, featuredResultLabel || "Featured"), /*#__PURE__*/_react.default.createElement("figure", null, imageSrc ? /*#__PURE__*/_react.default.createElement("a", {
        href: url
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: (0, _classnames.default)({
          "is-person": isPeople
        }),
        src: imageSrc
      })) : /*#__PURE__*/_react.default.createElement("span", {
        className: "search-item__image-shim"
      }, "\xA0"), /*#__PURE__*/_react.default.createElement("figcaption", null, /*#__PURE__*/_react.default.createElement("h3", {
        className: "search-item__title"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: url
      }, title)), /*#__PURE__*/_react.default.createElement("div", {
        className: "search-item__meta"
      }, contentType && displayMetadata && !suppressContentType ? /*#__PURE__*/_react.default.createElement("span", {
        className: "search-item__content-type"
      }, contentType) : null, date && !suppressPublicationDate && /*#__PURE__*/_react.default.createElement("span", {
        className: "search-item__date"
      }, date), projectTitle && projectLink ? /*#__PURE__*/_react.default.createElement("span", {
        className: "search-item__project"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: projectLink
      }, projectTitle)) : null, authors && authors.length > 0 ? /*#__PURE__*/_react.default.createElement("span", {
        className: "search-item__authors"
      }, " by ", /*#__PURE__*/_react.default.createElement("strong", null, authors.join(", "))) : null), /*#__PURE__*/_react.default.createElement("p", {
        className: "search-item__body",
        dangerouslySetInnerHTML: {
          __html: this.truncateSummary(summary)
        }
      }))));
    }
  }]);

  return ResultItem;
}(_react.default.Component);

exports.default = ResultItem;
var _React$PropTypes = _react.default.PropTypes,
    arrayOf = _React$PropTypes.arrayOf,
    string = _React$PropTypes.string,
    bool = _React$PropTypes.bool;
ResultItem.propTypes = {
  contentType: string,
  date: string,
  displayMetadata: bool,
  authors: arrayOf(string),
  title: string.isRequired,
  summary: string,
  url: string.isRequired,
  projectUrl: string,
  projectTitle: string,
  imageSrc: string,
  templateName: string,
  isPeople: bool,
  projectLink: string,
  featured: bool,
  featuredResultLabel: string,
  suppressContentType: bool,
  suppressPublicationDate: bool
};

},{"classnames":"classnames","moment":"moment","react":"react"}],89:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var _classnames = _interopRequireDefault(require("classnames"));

var _paging = require("../paging");

var _filterSlider = require("../filterSlider");

var _ResultItem = _interopRequireDefault(require("./ResultItem.jsx"));

var _LoadMore = _interopRequireDefault(require("./LoadMore.jsx"));

var _LoadingSpinner = _interopRequireDefault(require("./LoadingSpinner.jsx"));

var _SortBar = _interopRequireDefault(require("./SortBar.jsx"));

var _ContentFilterBar = _interopRequireDefault(require("./ContentFilterBar.jsx"));

var _SearchStatus = _interopRequireDefault(require("./SearchStatus.jsx"));

var _Pagination = _interopRequireDefault(require("./Pagination.jsx"));

var _resultsDisplay = require("../redux/resultsDisplay");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ResultList = function ResultList(_ref) {
  var results = _ref.results,
      resultsDisplayStrategy = _ref.resultsDisplayStrategy,
      selectedFacets = _ref.selectedFacets,
      totalResults = _ref.totalResults,
      loading = _ref.loading,
      isFirstLoad = _ref.isFirstLoad,
      sorters = _ref.sorters,
      nextPage = _ref.nextPage,
      gotoPage = _ref.gotoPage,
      dismissFacet = _ref.dismissFacet,
      contentFilterFacets = _ref.contentFilterFacets,
      changeSort = _ref.changeSort,
      query = _ref.query,
      pagination = _ref.pagination,
      dictionary = _ref.dictionary,
      showMobileFacets = _ref.showMobileFacets,
      changeContentFilter = _ref.changeContentFilter;
  var isLast = (0, _paging.isLastPage)(totalResults, query.perPage, query.page);
  var shouldShowNoResults = results.length === 0 && !isFirstLoad;
  var shouldShowPager = totalResults > query.perPage;

  function showFilters() {
    (0, _filterSlider.openFilters)(); // DOM ops

    showMobileFacets(); // action creator
  }

  function wrapperClass() {
    var isRefreshing = loading && resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_REFRESH;
    var isAppending = loading && resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND;
    return (0, _classnames.default)("search-results", {
      "is-refreshing": isRefreshing,
      "is-appending": isAppending
    });
  }

  function resultsRange() {
    // Upper bound of visible results
    var ceiling = query.page * query.perPage; // Lower bound of visible results

    var floor = ceiling - query.perPage + 1; // make sure the ceiling does not exceed total results

    if (ceiling > totalResults) {
      ceiling = totalResults;
    } // if results are only one page, eschew the range entirely


    if (totalResults <= query.perPage) {
      return "".concat(totalResults);
    } // if we're using load more, we want to show only
    // the ceiling of results displayed


    if (resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND) {
      return "".concat(ceiling);
    } // otherwise, return the full range


    return "".concat(floor, " - ").concat(ceiling);
  }

  function selectedContentFilter() {
    var selectedTypes = contentFilterFacets.values.filter(function (f) {
      return f.selected === true;
    });

    if (selectedTypes.length) {
      return selectedTypes[0].name;
    } else {
      return "all";
    }
  }

  function handleContentFilterSelection(selectedType) {
    changeContentFilter(selectedType, true);
  }

  function renderPagingControl() {
    if (pagination) {
      return /*#__PURE__*/_react.default.createElement(_Pagination.default, {
        totalResults: totalResults,
        resultsPerPage: query.perPage,
        currentPage: query.page,
        handlePageChange: gotoPage
      });
    }

    if (!pagination && !isLast) {
      return /*#__PURE__*/_react.default.createElement(_LoadMore.default, {
        handleClick: nextPage,
        dictionary: dictionary,
        loading: loading
      });
    }
  }

  function renderFilterToggle() {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "search-results__filter-open btn--primary",
      onClick: function onClick() {
        return showFilters();
      }
    }, "Filter Your Results", /*#__PURE__*/_react.default.createElement("svg", {
      className: "icon"
    }, /*#__PURE__*/_react.default.createElement("use", {
      xlinkHref: "/assets/pew/img/svg-sprite.svg#equalizer"
    })));
  } // Remove results will any duplicate ids


  var deDupedResults = _ramda.default.uniqWith(function (a, b) {
    return a.itemId === b.itemId;
  }, results);

  return /*#__PURE__*/_react.default.createElement("section", {
    className: wrapperClass()
  }, renderFilterToggle(), /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__bars"
  }, /*#__PURE__*/_react.default.createElement(_ContentFilterBar.default, {
    contentFilters: contentFilterFacets,
    selectedFilter: contentFilterFacets ? selectedContentFilter() : "all",
    onSelection: handleContentFilterSelection,
    dictionary: dictionary
  }), /*#__PURE__*/_react.default.createElement(_SortBar.default, {
    sorters: sorters,
    handleSortClick: changeSort
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__item-wrapper"
  }, loading && /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__loader"
  }, /*#__PURE__*/_react.default.createElement(_LoadingSpinner.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__items"
  }, shouldShowNoResults ? /*#__PURE__*/_react.default.createElement("p", null, "No results found to match your query.") : null, deDupedResults.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(_ResultItem.default, _extends({
      key: "".concat(item.itemId, "_").concat(i),
      featuredResultLabel: dictionary.featuredResultLabel
    }, item));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__bottom"
  }, /*#__PURE__*/_react.default.createElement(_SearchStatus.default, {
    resultsRange: resultsRange(),
    totalResults: totalResults,
    handleFacetDismiss: dismissFacet,
    dictionary: dictionary
  }), shouldShowPager ? renderPagingControl() : null));
};

var _React$PropTypes = _react.default.PropTypes,
    arrayOf = _React$PropTypes.arrayOf,
    string = _React$PropTypes.string,
    object = _React$PropTypes.object,
    func = _React$PropTypes.func,
    bool = _React$PropTypes.bool,
    number = _React$PropTypes.number,
    shape = _React$PropTypes.shape,
    oneOfType = _React$PropTypes.oneOfType;
ResultList.propTypes = {
  results: arrayOf(shape({
    id: oneOfType([number, string])
  })),
  resultsDisplayStrategy: number,
  selectedFacets: object.isRequired,
  totalResults: number.isRequired,
  sorters: arrayOf(shape({
    id: oneOfType([number, string]).isRequired,
    label: string.isRequired,
    value: string.isRequired,
    direction: oneOfType([bool, string]),
    isActive: bool.isRequired
  })),
  loading: bool,
  isFirstLoad: bool,
  nextPage: func,
  gotoPage: func,
  changeSort: func,
  showMobileFacets: func,
  contentFilterFacets: shape({
    id: oneOfType([number, string])
  }),
  changeContentFilter: func,
  dismissFacet: func,
  query: shape({
    q: string,
    sortBy: string,
    page: number,
    perPage: number,
    pageId: string
  }),
  pagination: bool,
  dictionary: object
};
ResultList.defaultProps = {
  selectedFacets: []
};
var _default = ResultList;
exports.default = _default;

},{"../filterSlider":101,"../paging":103,"../redux/resultsDisplay":108,"./ContentFilterBar.jsx":81,"./LoadMore.jsx":83,"./LoadingSpinner.jsx":84,"./Pagination.jsx":85,"./ResultItem.jsx":88,"./SearchStatus.jsx":91,"./SortBar.jsx":94,"classnames":"classnames","ramda":"ramda","react":"react"}],90:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _LoadingSpinner = _interopRequireDefault(require("./LoadingSpinner.jsx"));

var _SearchStatus = _interopRequireDefault(require("./SearchStatus.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SearchBox = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchBox, _React$Component);

  var _super = _createSuper(SearchBox);

  function SearchBox(props) {
    var _this;

    _classCallCheck(this, SearchBox);

    _this = _super.call(this, props);
    _this.state = {
      initiatedLoad: false
    };
    return _this;
  }

  _createClass(SearchBox, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.loading) {
        this.setState({
          initiatedLoad: false
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      event.preventDefault();
      this.props.handleEntry(this.keywordInput.value);
      this.setState({
        initiatedLoad: true
      });
    }
  }, {
    key: "handleSpellcheckResubmit",
    value: function handleSpellcheckResubmit(event) {
      event.preventDefault();
      this.keywordInput.value = this.props.spellcheckSuggestion;
      this.props.handleEntry(this.props.spellcheckSuggestion);
    }
  }, {
    key: "resultsRange",
    value: function resultsRange() {
      // Upper bound of visible results
      var _this$props = this.props,
          query = _this$props.query,
          totalResults = _this$props.totalResults;
      var ceiling = query.page * query.perPage; // Lower bound of visible results

      var floor = ceiling - query.perPage + 1; // make sure the ceiling does not exceed total results

      if (ceiling > totalResults) {
        ceiling = totalResults;
      } // if results are only one page, eschew the range entirely


      if (totalResults <= query.perPage) {
        return "".concat(totalResults);
      } //return the full range


      return "".concat(floor, " - ").concat(ceiling);
    }
  }, {
    key: "renderSearchStatus",
    value: function renderSearchStatus() {
      var _this$props2 = this.props,
          totalResults = _this$props2.totalResults,
          keywords = _this$props2.keywords,
          dictionary = _this$props2.dictionary;
      return /*#__PURE__*/_react.default.createElement(_SearchStatus.default, {
        resultsRange: this.resultsRange(),
        totalResults: totalResults,
        keywords: keywords,
        dictionary: dictionary
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          dictionary = _this$props3.dictionary,
          keywords = _this$props3.keywords,
          loading = _this$props3.loading;
      var shouldShowSpinner = this.state.initiatedLoad && loading;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "search-box-wrapper"
      }, /*#__PURE__*/_react.default.createElement("form", {
        className: "search-box search-page__search-box",
        onSubmit: function onSubmit(e) {
          return _this2.handleSubmit(e);
        },
        noValidate: true
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-box__input"
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "site-search",
        className: "u-visuallyhidden"
      }, dictionary.searchBoxLabel), /*#__PURE__*/_react.default.createElement("input", {
        id: "site-search",
        type: "text",
        autoComplete: "off",
        placeholder: dictionary.searchBoxPlaceholder,
        defaultValue: keywords || "",
        ref: function ref(input) {
          return _this2.keywordInput = input;
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "search-box__loader"
      }, shouldShowSpinner ? /*#__PURE__*/_react.default.createElement(_LoadingSpinner.default, null) : null), /*#__PURE__*/_react.default.createElement("button", {
        type: "submit",
        className: "search-box__button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "u-visuallyhidden"
      }, "Search"), /*#__PURE__*/_react.default.createElement("img", {
        src: "/assets/img/icon-search.png"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "search-box__spell-container"
      }, this.props.spellcheckSuggestion && /*#__PURE__*/_react.default.createElement("span", {
        className: "search-box__spell-suggest"
      }, "Did you mean", /*#__PURE__*/_react.default.createElement("button", {
        onClick: function onClick(e) {
          return _this2.handleSpellcheckResubmit(e);
        }
      }, this.props.spellcheckSuggestion), "?"))), this.renderSearchStatus());
    }
  }]);

  return SearchBox;
}(_react.default.Component);

exports.default = SearchBox;
var _React$PropTypes = _react.default.PropTypes,
    string = _React$PropTypes.string,
    func = _React$PropTypes.func,
    number = _React$PropTypes.number,
    object = _React$PropTypes.object,
    shape = _React$PropTypes.shape,
    bool = _React$PropTypes.bool;
SearchBox.propTypes = {
  keywords: string,
  totalResults: number,
  query: object,
  handleEntry: func.isRequired,
  loading: bool,
  dictionary: shape({
    searchBoxPlaceholder: string,
    searchBoxLabel: string,
    resultsForKeywordLabel: string,
    resultsLabel: string
  }).isRequired
};

},{"./LoadingSpinner.jsx":84,"./SearchStatus.jsx":91,"react":"react"}],91:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchStatus = function SearchStatus(_ref) {
  var resultsRange = _ref.resultsRange,
      totalResults = _ref.totalResults,
      keywords = _ref.keywords,
      selectedFacets = _ref.selectedFacets,
      handleFacetDismiss = _ref.handleFacetDismiss,
      dictionary = _ref.dictionary;
  var shouldRenderFacets = selectedFacets && selectedFacets.length > 0;
  var shouldRenderKeywords = !!keywords;

  var onFacetClick = function onFacetClick(groupId, value) {
    handleFacetDismiss(groupId, value.id);
  };

  var renderSelectedFacets = function renderSelectedFacets() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "search-results__active-facets"
    }, /*#__PURE__*/_react.default.createElement("span", null, "with filters"), /*#__PURE__*/_react.default.createElement("ul", null, selectedFacets.map(function (value) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: value.id
      }, /*#__PURE__*/_react.default.createElement("span", null, value.name), /*#__PURE__*/_react.default.createElement("button", {
        onClick: function onClick() {
          return onFacetClick(value);
        }
      }, /*#__PURE__*/_react.default.createElement("svg", {
        className: "icon"
      }, /*#__PURE__*/_react.default.createElement("use", {
        xlinkHref: "/assets/pew/img/svg-sprite.svg#close"
      }))));
    })));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__status"
  }, /*#__PURE__*/_react.default.createElement("span", null, resultsRange), "\xA0", /*#__PURE__*/_react.default.createElement("span", null, "of"), "\xA0", /*#__PURE__*/_react.default.createElement("span", null, totalResults), "\xA0", !shouldRenderKeywords && /*#__PURE__*/_react.default.createElement("span", null, dictionary.resultsLabel), shouldRenderKeywords && /*#__PURE__*/_react.default.createElement("span", null, dictionary.resultsForKeywordLabel, " \"", keywords, "\"\xA0"), shouldRenderFacets && renderSelectedFacets());
};

var _React$PropTypes = _react.default.PropTypes,
    string = _React$PropTypes.string,
    number = _React$PropTypes.number,
    object = _React$PropTypes.object,
    arrayOf = _React$PropTypes.arrayOf,
    func = _React$PropTypes.func;
SearchStatus.propTypes = {
  resultsRange: string.isRequired,
  totalResults: number.isRequired,
  keywords: string,
  selectedFacets: arrayOf(object),
  handleFacetDismiss: func.isRequired,
  dictionary: object
};
SearchStatus.defaultProps = {
  selectedFacets: []
};
var _default = SearchStatus;
exports.default = _default;

},{"react":"react"}],92:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var xIcon = function xIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.98 6.42L13.4 12 19 17.58l-1.4 1.4L12 13.4 6.42 19l-1.4-1.4L10.6 12 5 6.42l1.4-1.4L12 10.6 17.58 5z"
  }));
};

var SearchTokens = function SearchTokens(_ref) {
  var token = _ref.token,
      selectedFacets = _ref.selectedFacets,
      dictionary = _ref.dictionary,
      handleFacetChange = _ref.handleFacetChange,
      handleClearAll = _ref.handleClearAll,
      handleTokenChange = _ref.handleTokenChange;

  var addGroupId = _ramda.default.mapObjIndexed(function (v, k, o) {
    return _ramda.default.map(_ramda.default.assoc("groupId", k), v);
  });

  var facets = _ramda.default.pipe(addGroupId, _ramda.default.values, _ramda.default.flatten, _ramda.default.sortBy(_ramda.default.prop("name")))(selectedFacets);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "search-tokens"
  }, (facets.length > 0 || token) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "search-tokens__title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "search-tokens__title-text"
  }, dictionary.tokensTitle || "Filters", " ", "(".concat(facets.length, ")"))), /*#__PURE__*/_react.default.createElement("ul", {
    className: "search-tokens__list"
  }, token && /*#__PURE__*/_react.default.createElement("li", {
    className: "search-tokens__token"
  }, /*#__PURE__*/_react.default.createElement("span", null, token.title), /*#__PURE__*/_react.default.createElement("button", {
    className: "search-tokens__dismiss",
    type: "button",
    onClick: function onClick() {
      return handleTokenChange();
    }
  }, xIcon())), facets.map(function (f, i) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "search-tokens__token",
      key: i
    }, /*#__PURE__*/_react.default.createElement("span", null, f.name), /*#__PURE__*/_react.default.createElement("button", {
      className: "search-tokens__dismiss",
      type: "button",
      onClick: function onClick() {
        return handleFacetChange(f.groupId, f.id, false);
      }
    }, xIcon()));
  })), (facets.length > 0 || token) && /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return handleClearAll();
    },
    type: "button",
    className: "search-tokens__clear-all"
  }, dictionary.clearAllTokens || "Clear All Filters")));
};

var _React$PropTypes = _react.default.PropTypes,
    arrayOf = _React$PropTypes.arrayOf,
    shape = _React$PropTypes.shape,
    oneOfType = _React$PropTypes.oneOfType,
    number = _React$PropTypes.number,
    string = _React$PropTypes.string,
    object = _React$PropTypes.object;
SearchTokens.propTypes = {
  selectedFacets: object,
  dictionary: object,
  token: object
};
var _default = SearchTokens;
exports.default = _default;

},{"ramda":"ramda","react":"react"}],93:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

//import sampleData from "./sample.json";
var SearchWidget = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchWidget, _React$Component);

  var _super = _createSuper(SearchWidget);

  /*
  static propTypes = {
    perPageTaxonomy: arrayOf(shape({
      id: string.isRequired,
      values: arrayOf(shape({
        id: string,
        name: string,
        url: string,
        count: number
      }))
    }))
  }*/
  function SearchWidget(props) {
    _classCallCheck(this, SearchWidget);

    return _super.call(this, props);
  }

  _createClass(SearchWidget, [{
    key: "render",
    value: function render() {
      //when using test data:
      //const { perPageTaxonomy } = sampleData;
      //const { firstResultTaxonomy } = sampleData;
      var perPageTaxonomy = this.props.perPageTaxonomy;
      var firstResultTaxonomy = this.props.firstResultTaxonomy;

      var arrowIcon = function arrowIcon() {
        return /*#__PURE__*/_react.default.createElement("svg", {
          viewBox: "0 0 10 8",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react.default.createElement("g", {
          fill: "none",
          fillRule: "evenodd",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M.5 4h9"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M6.24.74L9.5 4"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M6.24 7.26L9.5 4"
        })));
      };

      var firstResultIds = [];
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "search-widget"
      }, (perPageTaxonomy != null || firstResultTaxonomy != null) && /*#__PURE__*/_react.default.createElement("div", {
        className: "search-widget__inner-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-widget__title"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "search-widget__title-text"
      }, config.dictionary.searchWidgetLabel)), /*#__PURE__*/_react.default.createElement("div", {
        className: "search-widget__top-hit"
      }, firstResultTaxonomy && firstResultTaxonomy.length > 0 && firstResultTaxonomy.map(function (itemsJ) {
        firstResultIds.push(itemsJ.id);

        if (itemsJ.taxonomy == "Expert") {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "search-widget__top-expert",
            key: itemsJ.id
          }, /*#__PURE__*/_react.default.createElement("a", {
            href: itemsJ.url
          }, /*#__PURE__*/_react.default.createElement("img", {
            className: "search-widget__expert-image",
            src: itemsJ.imgSrc
          })), /*#__PURE__*/_react.default.createElement("div", {
            className: "search-widget__expert-details"
          }, /*#__PURE__*/_react.default.createElement("a", {
            href: itemsJ.url,
            className: "search-widget__expert-name"
          }, itemsJ.name), /*#__PURE__*/_react.default.createElement("div", {
            className: "search-widget__expert-contact"
          }, /*#__PURE__*/_react.default.createElement("span", {
            className: "search-widget__expert-title"
          }, itemsJ.title)), /*#__PURE__*/_react.default.createElement("a", {
            href: itemsJ.url,
            className: "search-widget__expert-read-more"
          }, "Read More ", arrowIcon())));
        }

        return /*#__PURE__*/_react.default.createElement("div", {
          className: "search-widget__top-project-topic",
          key: itemsJ.id
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: itemsJ.url
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "search-widget__media-wrapper"
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: itemsJ.imgSrc
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "search-widget__top-hit-details"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "search-widget__top-hit-type"
        }, itemsJ.taxonomy), /*#__PURE__*/_react.default.createElement("div", {
          className: "search-widget__top-hit-title"
        }, itemsJ.name))));
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "search-widget__aggregate"
      }, perPageTaxonomy && perPageTaxonomy.length > 0 && perPageTaxonomy.map(function (taxonomy, i) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "search-widget__aggregate-section",
          key: i
        }, (taxonomy.values.length > 1 || taxonomy.values.length > 0 && firstResultIds.indexOf(taxonomy.values[0].id) < 0) && /*#__PURE__*/_react.default.createElement("h4", {
          className: "search-widget__aggregate-type"
        }, taxonomy.id), /*#__PURE__*/_react.default.createElement("div", {
          className: "search-widget__aggregate-links-wrapper"
        }, taxonomy.values.filter(function (t) {
          return firstResultIds.indexOf(t.id) < 0;
        }).slice(0, 3).map(function (link, index, arr) {
          return /*#__PURE__*/_react.default.createElement("a", {
            className: "search-widget__aggregate-link",
            href: link.url,
            key: link.id
          }, link.name, index < arr.length - 1 && ",");
        })));
      }))));
    }
  }]);

  return SearchWidget;
}(_react.default.Component);

exports.default = SearchWidget;

},{"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react"}],94:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = _interopRequireDefault(require("ramda"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeSortAscClass(sorter) {
  return (0, _classnames.default)({
    "is-selected": sorter.isActive && sorter.direction === "asc"
  });
}

function activeSortDescClass(sorter) {
  return (0, _classnames.default)({
    "is-selected": sorter.isActive && sorter.direction === "desc"
  });
}

function activateOrToggleSorter(sorterId, sorters, handleSortClick) {
  var toggleDir = function toggleDir(dir) {
    if (!dir) {
      return null;
    } else {
      return dir === "asc" ? "desc" : "asc";
    }
  }; // this is like a 'bookmark' to the direction property


  var dirLens = _ramda.default.lensProp("direction"); // each argument array supplies a condition predicate, and an action
  // 1) if clicked sorter and active, toggle the sort direction
  // 2) if clicked sorter and not active, make active
  // 3) if not clicked sorter, and active, make inactive
  // 4) all other cases, do nothing


  var adjustSorters = _ramda.default.cond([[_ramda.default.whereEq({
    id: sorterId,
    isActive: true
  }), _ramda.default.over(dirLens, toggleDir)], [_ramda.default.whereEq({
    id: sorterId,
    isActive: false
  }), _ramda.default.assoc("isActive", true)], [_ramda.default.whereEq({
    isActive: true
  }), _ramda.default.assoc("isActive", false)], [_ramda.default.T, _ramda.default.identity]]);

  var newSorters = _ramda.default.map(adjustSorters, sorters);

  handleSortClick(newSorters);
}

var SortBar = function SortBar(_ref) {
  var sorters = _ref.sorters,
      handleSortClick = _ref.handleSortClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "search-results__sort-bar"
  }, /*#__PURE__*/_react.default.createElement("ul", null, sorters.map(function (sorter) {
    var sorterClass = (0, _classnames.default)("search-results__sorter", {
      "is-active": sorter.isActive
    });
    return /*#__PURE__*/_react.default.createElement("li", {
      key: sorter.id,
      className: sorterClass,
      onClick: function onClick() {
        return activateOrToggleSorter(sorter.id, sorters, handleSortClick);
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "search-results__sort-label"
    }, sorter.label), sorter.direction && /*#__PURE__*/_react.default.createElement("span", {
      className: "search-results__sort-dir sort-dir-" + sorter.label
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: activeSortAscClass(sorter)
    }), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: activeSortDescClass(sorter)
    })));
  })));
};

var _React$PropTypes = _react.default.PropTypes,
    shape = _React$PropTypes.shape,
    func = _React$PropTypes.func,
    number = _React$PropTypes.number,
    string = _React$PropTypes.string,
    bool = _React$PropTypes.bool,
    oneOfType = _React$PropTypes.oneOfType,
    arrayOf = _React$PropTypes.arrayOf;
SortBar.propTypes = {
  sorters: arrayOf(shape({
    id: oneOfType([number, string]).isRequired,
    label: string.isRequired,
    value: string.isRequired,
    direction: oneOfType([bool, string]),
    isActive: bool.isRequired
  })).isRequired,
  handleSortClick: func.isRequired
};
var _default = SortBar;
exports.default = _default;

},{"classnames":"classnames","ramda":"ramda","react":"react"}],95:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _ramda = _interopRequireDefault(require("ramda"));

var _FacetBar = _interopRequireDefault(require("../components/FacetBar.jsx"));

var _search = require("../redux/search/search.actions");

var _facets = require("../redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ignoredFacetGroupIds = ["contentFilterType", "locationpaths"];

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    title: state.dictionary.tokensTitle,
    facets: _ramda.default.reject(function (g) {
      return _ramda.default.contains(_ramda.default.prop("id", g), ignoredFacetGroupIds);
    }, state.facets),
    numOpenGroups: state.numOpenGroups,
    mobileFacetsShown: state.mobileFacetsShown,
    dictionary: state.dictionary,
    facetDisplayOverride: state.facetDisplayOverride
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleFacetChange: function handleFacetChange(groupId, facetId, facetValue) {
      dispatch((0, _search.loadFacetChange)(groupId, facetId, facetValue));
    },
    handleTokenChange: function handleTokenChange() {
      dispatch(loadChangeToken());
    },
    handleFacetChangeSingular: function handleFacetChangeSingular(groupId, facetId, facetValue) {
      dispatch((0, _search.loadFacetChangeSingular)(groupId, facetId, facetValue));
    },
    handleSelectGroup: function handleSelectGroup(group) {
      dispatch((0, _search.loadSelectFacetGroup)(group));
    },
    handleClearGroup: function handleClearGroup(group) {
      dispatch((0, _search.loadClearFacetGroup)(group));
    },
    handleClearAll: function handleClearAll() {
      dispatch((0, _search.loadClearAllFacets)());
    },
    hideMobileFacets: function hideMobileFacets() {
      dispatch(_search.hideMobileFacets);
    },
    handleProjectStatusChange: function handleProjectStatusChange(groupId, facetId, facetValue) {
      dispatch((0, _search.loadProjectStatusChange)(groupId, facetId, facetValue));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FacetBar.default);

exports.default = _default;

},{"../components/FacetBar.jsx":82,"../redux/facets":106,"../redux/search/search.actions":111,"ramda":"ramda","react-redux":"react-redux"}],96:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _ProjectList = _interopRequireDefault(require("../components/ProjectList.jsx"));

var _facets = require("../redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    results: state.results,
    resultsDisplayStrategy: state.resultsDisplayStrategy,
    count: state.count
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(_ProjectList.default);

exports.default = _default;

},{"../components/ProjectList.jsx":86,"../redux/facets":106,"react-redux":"react-redux"}],97:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _SearchBox = _interopRequireDefault(require("../components/SearchBox.jsx"));

var _search = require("../redux/search/search.actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    keywords: state.query.q,
    dictionary: state.dictionary,
    loading: state.loading,
    spellcheckSuggestion: state.spellcheckSuggestion,
    totalResults: state.totalResults,
    query: state.query
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleEntry: function handleEntry(value) {
      dispatch((0, _search.loadNewKeywords)(value));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SearchBox.default);

exports.default = _default;

},{"../components/SearchBox.jsx":90,"../redux/search/search.actions":111,"react-redux":"react-redux"}],98:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _ResultList = _interopRequireDefault(require("../components/ResultList.jsx"));

var _search = require("../redux/search/search.actions");

var _facets = require("../redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    results: state.results,
    resultsDisplayStrategy: state.resultsDisplayStrategy,
    selectedFacets: (0, _facets.selectedFacetIdsByGroup)(state.facets),
    contentFilterFacets: (0, _facets.groupWithId)("contentFilterType", state.facets),
    totalResults: state.totalResults,
    loading: state.loading,
    isFirstLoad: state.isFirstLoad,
    sorters: state.sorters,
    query: state.query,
    pagination: state.pagination,
    dictionary: state.dictionary
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    nextPage: function nextPage() {
      dispatch((0, _search.loadNextPage)());
    },
    changeSort: function changeSort(sorters) {
      dispatch((0, _search.loadNewSort)(sorters));
    },
    gotoPage: function gotoPage(pageNum) {
      dispatch((0, _search.loadNewPage)(pageNum));
    },
    dismissFacet: function dismissFacet(groupId, facetId) {
      dispatch((0, _search.loadFacetChange)(groupId, facetId, false));
    },
    showMobileFacets: function showMobileFacets() {
      dispatch((0, _search.showMobileFacets)());
    },
    changeContentFilter: function changeContentFilter(contentFilterId, selectedValue) {
      dispatch((0, _search.loadFacetChangeSingular)("contentFilterType", contentFilterId, selectedValue));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ResultList.default);

exports.default = _default;

},{"../components/ResultList.jsx":89,"../redux/facets":106,"../redux/search/search.actions":111,"react-redux":"react-redux"}],99:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _ramda = _interopRequireDefault(require("ramda"));

var _SearchTokens = _interopRequireDefault(require("../components/SearchTokens.jsx"));

var _search = require("../redux/search/search.actions");

var _facets = require("../redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ignoredFacetGroupIds = ["contentFilterType", "locationpaths"];

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var relevantFacets = _ramda.default.reject(function (g) {
    return _ramda.default.contains(_ramda.default.prop("id", g), ignoredFacetGroupIds);
  }, state.facets);

  var selectedFacets = (0, _facets.selectedFacetsByGroup)(relevantFacets);
  var token = state.token;
  return {
    token: state.token,
    selectedFacets: selectedFacets,
    dictionary: state.dictionary
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleFacetChange: function handleFacetChange(groupId, facetId, facetValue) {
      dispatch((0, _search.loadFacetChange)(groupId, facetId, facetValue));
    },
    handleTokenChange: function handleTokenChange() {
      dispatch((0, _search.loadChangeToken)());
    },
    handleClearAll: function handleClearAll() {
      dispatch((0, _search.loadClearAllFacets)());
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SearchTokens.default);

exports.default = _default;

},{"../components/SearchTokens.jsx":92,"../redux/facets":106,"../redux/search/search.actions":111,"ramda":"ramda","react":"react","react-redux":"react-redux"}],100:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _SearchWidget = _interopRequireDefault(require("../components/SearchWidget.jsx"));

var _search = require("../redux/search/search.actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    firstResultTaxonomy: state.firstResultTaxonomy,
    perPageTaxonomy: state.perPageTaxonomy
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SearchWidget.default);

exports.default = _default;

},{"../components/SearchWidget.jsx":93,"../redux/search/search.actions":111,"react-redux":"react-redux"}],101:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openFilters = openFilters;
exports.closeFilters = closeFilters;
exports.setFiltersOpenDirection = setFiltersOpenDirection;
exports.manageContainerWhitespace = manageContainerWhitespace;

// Open/Close for mobile sliding of filter bar.
// Involves working with elements outside the
// scope of React components, so logic kept here.
function openFilters() {
  // Note - this depends on page state outside of the React app
  var filters = filtersWrapper();

  if (filters && !filtersAreOpen(filters)) {
    filters.classList.add("is-open");
  }
}

function closeFilters() {
  var filters = filtersWrapper();

  if (filters) {
    filters.classList.remove("is-open");
  }
}

function setFiltersOpenDirection() {
  var direction = "is-right";
  var filters = filtersWrapper();

  if (filters) {
    var sibling = filters.closest(".container__col").nextElementSibling;

    if (sibling && sibling.className.indexOf("container__col") >= 0) {
      direction = "is-left";
    }
  }

  filters.classList.add(direction);
} // when the facet column is 'lifted' absolutely from the container
// it leaves behind an empty stacked container with a bottom margin
// we want to remove that margin -- but only if facets are the
// only components in the column


function manageContainerWhitespace() {
  var parent = filtersWrapper().closest(".container__col");
  var col = parent;

  if (parent.children.item(0).classList.contains("container__inner")) {
    parent = parent.children.item(0);
  } // cast from HTMLCollection to Array


  var children = Array.from(parent.children);
  var childCount = children.reduce(function (count, child) {
    if (!child.classList.contains("search__facets-wrapper")) {
      count = count + 1;
    }

    return count;
  }, 0);

  if (childCount === 0) {
    // remove the margin on the parent column
    col.style.marginBottom = 0;
  }
}

function filtersWrapper() {
  return document.querySelector(".search__facets-wrapper");
}

function filtersAreOpen(filtersWrapper) {
  return filtersWrapper.classList.contains("is-open");
}

},{}],102:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSearchApp = initSearchApp;

var _jquery = _interopRequireDefault(require("jquery"));

var _ramda = _interopRequireDefault(require("ramda"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reactRedux = require("react-redux");

var _rootReducer = _interopRequireDefault(require("./redux/rootReducer"));

var _search = require("./redux/search/search.reducer");

var _search2 = require("./redux/search/search.actions");

var _configureStore = _interopRequireDefault(require("./redux/configureStore"));

var _createRoutingMiddleware = _interopRequireDefault(require("./redux/createRoutingMiddleware"));

var _service = require("./redux/service");

var _routing = require("./redux/routing");

var _resultsDisplay = require("./redux/resultsDisplay");

var _ResultsContainer = _interopRequireDefault(require("./containers/ResultsContainer.jsx"));

var _QueryContainer = _interopRequireDefault(require("./containers/QueryContainer.jsx"));

var _FacetsContainer = _interopRequireDefault(require("./containers/FacetsContainer.jsx"));

var _ProjectsContainer = _interopRequireDefault(require("./containers/ProjectsContainer.jsx"));

var _SearchTokensContainer = _interopRequireDefault(require("./containers/SearchTokensContainer.jsx"));

var _SearchWidgetContainer = _interopRequireDefault(require("./containers/SearchWidgetContainer.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the mount nodes are the elements we want to include
// as part of the search app
function initSearchApp(mountNodes) {
  if (!mountNodes.length) {
    return;
  } // extract the searchId from the mountNodes
  // while also checking mountNodes share same id


  var searchId = mountNodes.reduce(function (id, node) {
    var nodeId = (0, _jquery.default)(node).data("searchId"); // if id is null, we want to set it
    // with the first node's value

    if (id === null) {
      return nodeId;
    } // if node id does not equal current
    // id value, it's invalid and return undefined


    if (id !== nodeId) {
      return;
    }

    return id;
  }, null); // if we have an invalid or non-matching id, raise an error

  if (!searchId) {
    throw new Error("Could not initialize Pew search app. searchId was either not present, or provided mount nodes did not share the same searchId");
  } // define the canonical inital state of our redux store here
  // including some value taken from the data-attrs of the
  // mount node.


  var config = window.PewSearchConfigs.find(function (c) {
    return c.searchId === searchId;
  });

  if (!config) {
    throw new Error("Could not initialize Pew search app instance with id of \"".concat(searchId, "\". Configuration data not found."));
  } // create a starting state object,
  // which includes and intitial state
  // from individual reducers


  var initialState = _ramda.default.merge(_search.initialState, {
    url: config.url,
    pagination: config.pagination,
    resultsDisplayStrategy: config.pagination ? _resultsDisplay.RESULTS_DISPLAY_REFRESH : _resultsDisplay.RESULTS_DISPLAY_APPEND,
    sorters: config.sorters,
    dictionary: config.dictionary,
    numOpenGroups: config.numOpenGroups,
    initialResults: config.initialQueryResults || null,
    query: _ramda.default.merge(_search.initialState.query, {
      pageId: config.pageId,
      page: config.page
    })
  }); // determine if we want to load all page results in our cold load


  var doLoadAllPages = initialState.resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND && initialState.isFirstLoad;
  initialState = _ramda.default.merge(initialState, {
    query: _ramda.default.merge(initialState.query, {
      loadAllPages: doLoadAllPages
    })
  });

  var thunkMiddleware = _reduxThunk.default.withExtraArgument({
    mapResponseToState: _service.mapResponseToState,
    fetchSearchResults: _service.fetchSearchResults
  });

  var routingMiddleware = (0, _createRoutingMiddleware.default)(_routing.mapStateToUrl, _routing.handleUrlChange);
  var store = (0, _configureStore.default)(_rootReducer.default, initialState, [thunkMiddleware, routingMiddleware]);

  if (initialState.initialResults) {
    store.dispatch((0, _search2.loadSuccess)(initialState.initialResults, initialState.resultsDisplayStrategy, _service.mapResponseToState));
  } else {
    store.dispatch((0, _search2.loadResults)());
  }

  mountNodes.forEach(function (node) {
    if (node.className.indexOf("js-search-query") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_QueryContainer.default, null)), node);
    }

    if (node.className.indexOf("js-search-results") > -1 || node.className.indexOf("js-projects-container") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_ResultsContainer.default, null)), node);
    }

    if (node.className.indexOf("js-search-facets") > -1 || node.className.indexOf("js-projects-search-facets") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_FacetsContainer.default, null)), node);
    }

    if (node.className.indexOf("js-search-tokens") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_SearchTokensContainer.default, null)), node);
    }

    if (node.className.indexOf("js-projects-container") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_ProjectsContainer.default, null)), node);
    }

    if (node.className.indexOf("js-search-widget") > -1) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_SearchWidgetContainer.default, null)), node);
    }
  });
}

},{"./containers/FacetsContainer.jsx":95,"./containers/ProjectsContainer.jsx":96,"./containers/QueryContainer.jsx":97,"./containers/ResultsContainer.jsx":98,"./containers/SearchTokensContainer.jsx":99,"./containers/SearchWidgetContainer.jsx":100,"./redux/configureStore":104,"./redux/createRoutingMiddleware":105,"./redux/resultsDisplay":108,"./redux/rootReducer":109,"./redux/routing":110,"./redux/search/search.actions":111,"./redux/search/search.reducer":112,"./redux/service":113,"jquery":"jquery","ramda":"ramda","react":"react","react-dom":"react-dom","react-redux":"react-redux","redux-thunk":"redux-thunk"}],103:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.totalPages = totalPages;
exports.isLastPage = isLastPage;
exports.isFirstPage = isFirstPage;
exports.pageBlock = pageBlock;

var _ramda = _interopRequireDefault(require("ramda"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// number of page to show before and after current page
// if at first or last page, double the number will be shown
// either after or before
var PAGE_BLOCK_RANGE = 3;

function totalPages(totalResults, resultsPerPage) {
  return Math.ceil(totalResults / resultsPerPage);
}

function isLastPage(totalResults, resultsPerPage, currentPage) {
  var numPages = totalPages(totalResults, resultsPerPage);
  return currentPage >= numPages;
}

function isFirstPage(currentPage) {
  return currentPage === 1;
} // returns a block of page numbers appropriately
// adjacent to the currently selected page


function pageBlock(totalResults, resultsPerPage, currentPage) {
  var numPages = totalPages(totalResults, resultsPerPage);
  var numPagesVisible = Math.min(numPages, PAGE_BLOCK_RANGE * 2 + 1);
  var start = Math.max(1, currentPage - PAGE_BLOCK_RANGE);

  if (currentPage + PAGE_BLOCK_RANGE > numPages) {
    // (desired page range) - (Size of current page range)
    start -= numPagesVisible - (numPages - (start - 1));
  }

  var pages = _ramda.default.range(start, start + numPagesVisible);

  return _ramda.default.map(function (page) {
    return {
      num: page,
      label: page,
      current: page == currentPage
    };
  }, pages);
}

},{"ramda":"ramda"}],104:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = require("redux");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function configureStore(rootReducer) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var middlewares = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var middlewareEnhancer = _redux.applyMiddleware.apply(void 0, _toConsumableArray(middlewares)); // https://github.com/zalmoxisus/redux-devtools-extension#1-with-redux
  // Apply devToolsExtension if present on client, otherwise, just pass through an Identity function


  var devToolEnhancer = window.devToolsExtension ? window.devToolsExtension() : function (x) {
    return x;
  }; // build our store!

  return (0, _redux.createStore)(rootReducer, initialState, (0, _redux.compose)(middlewareEnhancer, devToolEnhancer));
}

},{"redux":"redux"}],105:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createRoutingMiddleware;

var _urijs = _interopRequireDefault(require("urijs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://redux.js.org/docs/advanced/Middleware.html
var URL_INIT = "ROUTING/URL_INIT";
/**
 * mapStateToUrl: User provided function to get the URL parameters out of the redux state.
 *                The middleware will use this to update the URL when the redux state changes.
 * @callback mapStateToUrl
 * @param  {Object} state: the current redux state
 * @return {Object} An object with key/value pairs of the parameters to go in the url.
 *                  This object will be passed to URI.search()
 *                  https://medialize.github.io/URI.js/docs.html#accessors-search
 *                  eg { location: state.location.slug } => my-url.com/?location=united-states
 */

/**
 * hangleUrlChange: User provided function to handle updating the state when the url changes
 * @callback hangleUrlChange
 * @param  {Object} urlParams: the current url params
 * @param  {Object} store    : the current redux store.  Use store.getState() and store.dispatch
 * @param  {Object} event    : the popstate event
 * @return {Promise|Any} Return a promise if something in handleUrlChange is disptached async.
 *                       Otherwise, it doesn't matter
 */

/**
 * createRoutingMiddleware: creates a middleware function to be passed to applyMiddleware
 *                          and attaches a window popstate listener
 * @param  {Function} mapStateToUrl   : callback function, see above
 * @param  {Function} handleUrlChange : callback function, see above
 * @param  {Boolean}  handleLoad      : if true, it will call handleUrlChange when the page loads
 * @return {Function} redux middleware
 */

function createRoutingMiddleware(mapStateToUrl, handleUrlChange) {
  var handleLoad = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // return the middlware
  // "next" is the next dispatch function
  return function (store) {
    return function (next) {
      // flags are a code smell, but maybe this is ok in the situation.
      // use replaceState instead of pushState if this dispatch came from the popstate
      var shouldReplace = false; // function to run the user-provided handleUrlChange

      var executeUrlChange = function executeUrlChange(event) {
        var urlParams = (0, _urijs.default)(window.location).search(true); // set the flag that lets the dispatch function know that it should use replaceState

        shouldReplace = true; // call user function to handle the url change.  This function will probably call store.dispatch

        var change = handleUrlChange(urlParams, store, event); // if handleUrlChange returns a promise, revert the flag only after it's done

        if (change && typeof change.then === "function") {
          change.then(function () {
            shouldReplace = false;
          });
        } // otherwise, revert it after handleUrlChange is done
        else {
          shouldReplace = false;
        }
      }; // execute handleUrlChange on load if specified


      if (handleLoad) {
        executeUrlChange();
      } // when the url changes...


      window.addEventListener("popstate", function (event) {
        event.preventDefault();
        executeUrlChange(event);
      }); // our augmented dispatch function

      var dispatch = function dispatch(action) {
        // result is the action itself, this will also update the state
        // http://redux.js.org/docs/api/Store.html#dispatch
        var result = next(action); // execute the user function to get the url params out of the newly updated redux state

        var params = mapStateToUrl(store.getState()); // .search uses a ? in the url

        var url = _urijs.default.decode((0, _urijs.default)(window.location.href).search(params).toString()); // if the url is different, pushState/replaceState the new url


        if (!(0, _urijs.default)(url).equals(window.location.href)) {
          // if we're initializing the url params, replace the url state instead of push
          // eg. /profile?loc=27 > /profile?loc=27&breakdown=...
          // when the browser navigates "back", we don't want to go back to just /profile?loc=27
          // we want all the breakdown=... stuff
          if (action.type === URL_INIT || shouldReplace === true) {
            history.replaceState(null, null, url);
          } else {
            history.pushState(null, null, url);
          }
        }

        return result;
      }; // dispatch immediately to populate the url params
      // (this only happens when createRoutingMiddleware is called)


      dispatch({
        type: URL_INIT
      }); // return the new dispatch function

      return dispatch;
    };
  };
}

},{"urijs":"urijs"}],106:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allFacetValuesFromGroup = allFacetValuesFromGroup;
exports.selectedFacetsByGroup = selectedFacetsByGroup;
exports.selectedFacetIdsByGroup = selectedFacetIdsByGroup;
exports.selectedFacetsFromValues = selectedFacetsFromValues;
exports.selectedFacetsFromGroup = selectedFacetsFromGroup;
exports.allSelectedFacets = allSelectedFacets;
exports.groupHasSelectedChildren = groupHasSelectedChildren;
exports.valueHasSelectedChildren = valueHasSelectedChildren;
exports.valuesWithSelectedChildren = valuesWithSelectedChildren;
exports.groupWithId = groupWithId;
exports.pathFromValueId = pathFromValueId;
exports.pathArrayFromFacetLookup = pathArrayFromFacetLookup;
exports.setSelectedFalseOnAllFacetValues = setSelectedFalseOnAllFacetValues;
exports.setGroupValues = setGroupValues;
exports.setSelectedOnFacetValues = setSelectedOnFacetValues;
exports.setSingularSelectedFacetValue = setSingularSelectedFacetValue;
exports.filterVisibleFacetsInGroup = filterVisibleFacetsInGroup;

var _ramda = _interopRequireDefault(require("ramda"));

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module search/facets **/

/**
 * @typedef {Object} FacetValueShape
 * @property {Array} childValues Array of {@link FacetValueShape}
 * @property {number} count Number of available records
 * @property {string} id Identifier
 * @property {string} name Display Name
 * @property {boolean} selected Selection state
 */

/**
 * @typedef {Object} FacetGroupShape
 * @property {Array} childGroups Array of {@link FacetGroupShape}
 * @property {string} id Identifier for group

 * @property {string} label Display name for group
 * @property {array} values Array of {@link FacetValueShape}
 */
function allFacetValuesFromGroup(group) {
  var allValues = [];

  var grabAllValues = function grabAllValues(value) {
    allValues.push(value);

    if (value.childValues.length > 0) {
      value.childValues.forEach(function (cv) {
        return grabAllValues(cv);
      });
    }
  };

  group.values.forEach(function (value) {
    return grabAllValues(value);
  });

  if (group.hasOwnProperty("childGroups")) {
    group.childGroups.forEach(function (childGroup) {
      childGroup.values.forEach(function (value) {
        return grabAllValues(value);
      });
    });
  }

  return allValues;
} // Returns an object with arrays of selected facet value objects, using
// their root group name as a key


function selectedFacetsByGroup(facets) {
  var facetsByGroup = {};
  facets.forEach(function (group) {
    var selectedFacets = selectedFacetsFromGroup(group);

    if (selectedFacets.length) {
      facetsByGroup[group.id] = selectedFacetsFromGroup(group);
    }
  });
  return facetsByGroup;
} // Returns an object with arrays of selected facet ids, using
// their root group name as a key


function selectedFacetIdsByGroup(facets) {
  var selectedFacets = selectedFacetsByGroup(facets);
  Object.keys(selectedFacets).forEach(function (k) {
    selectedFacets[k] = selectedFacets[k].map(function (f) {
      return f.id;
    });
  });
  return selectedFacets;
} // Given an array of facet value objects, return an
// a flat array of selected facet value object, including
// selected child values.


function selectedFacetsFromValues(values) {
  var selected = values.filter(function (v) {
    return v.selected === true;
  });
  values.forEach(function (value) {
    if (value.hasOwnProperty("childValues")) {
      selected = selected.concat(selectedFacetsFromValues(value.childValues));
    }
  });
  return selected;
} // Given a facet group, return a flat array of selected
// facets value object, including child groups and all child values.


function selectedFacetsFromGroup(group) {
  var selected = selectedFacetsFromValues(group.values);

  if (group.hasOwnProperty("childGroups")) {
    group.childGroups.forEach(function (childGroup) {
      selected = selected.concat(selectedFacetsFromGroup(childGroup));
    });
  }

  return selected;
}

function allSelectedFacets(facets) {
  return facets.reduce(function (all, group) {
    return all.concat(selectedFacetsFromGroup(group));
  }, []);
}

function groupHasSelectedChildren(group) {
  return selectedFacetsFromGroup(group).length > 0;
}

function valueHasSelectedChildren(value) {
  // does not include selection state of group itself
  var selectedChildren = [];

  if (value.hasOwnProperty("childValues")) {
    selectedChildren = selectedFacetsFromValues(value.childValues);
  }

  return selectedChildren.length > 0;
} // An array of values who have a child value
// selected. Does not require the value itself
// be selected.


function valuesWithSelectedChildren(group) {
  var all = allFacetValuesFromGroup(group);
  return all.reduce(function (hasSelected, value) {
    if (valueHasSelectedChildren(value)) {
      hasSelected.push(value);
    }

    return hasSelected;
  }, []);
} // Returns the top-level group with id


function groupWithId(id, facets) {
  var group = null;
  facets.forEach(function (g) {
    if (g.id === id) {
      group = g;
    }

    if (!group && g.hasOwnProperty("childGroups")) {
      group = groupWithId(id, g.childGroups);
    }
  });
  return group;
} // Returns an array of object path segments that
// resolves to the facet value object in the
// provided facets state object. This is useful
// when needing to make immutable changes using
// R.assocPath or R.lensPath
// TODO: This performs acceptably for now
// but is definitely not optimal for very large data sets.
// Should consider a different approach to setting deeply nested data.


function pathFromValueId(valueId, facets) {
  // First, flatten the facets object into k,v pairs of properties
  // and stringified "path" keys. Then use the paths to
  // lookup the facet value
  var facetLookup = _ramda.default.invertObj((0, _util.flattenObj)(facets));

  return pathArrayFromFacetLookup(valueId, facetLookup);
}

function pathArrayFromFacetLookup(valueId, facetLookup) {
  var delimitedPath = facetLookup[valueId]; // Our paths are in format "a.b.0.c', so convert into ["a", "b", 0, "c"].
  // Then pop off the last path segment so it points to the entire value
  // object, instead of just the id.

  var pathArr = delimitedPath.split(".");
  pathArr.pop(); // Finally, ensure numerical "keys" are properly cast to Numbers
  // or else Ramda will treat them as object keys and
  // convert arrays to objects when using assocPath or lens methods.

  pathArr = pathArr.map(function (segment) {
    var numberified = parseInt(segment, 10);
    return isNaN(numberified) ? segment : numberified;
  });
  return pathArr;
}

function setSelectedFalseOnAllFacetValues(facets) {
  var newFacets = _ramda.default.clone(facets);

  newFacets.forEach(function (group) {
    if (group.values) {
      group.values.forEach(function (value) {
        value.selected = false;

        if (value.childValues) {
          value.childValues.forEach(function (childValue) {
            childValue.selected = false;
          });
        }
      });
    }

    if (group.childGroups) {
      group.childGroups.forEach(function (childGroup) {
        childGroup.values.forEach(function (value) {
          value.selected = false;

          if (value.childValues) {
            value.childValues.forEach(function (childValue) {
              childValue.selected = false;
            });
          }
        });
      });
    }
  });
  return newFacets;
} //brute force the facets to the desired value (isSelected)


function setGroupValues(group, allFacets, isSelected) {
  var index = _ramda.default.findIndex(_ramda.default.propEq('id', group.id), allFacets);

  var parentIndex = -1;

  if (index == -1) {
    allFacets.forEach(function (facet) {
      if (facet.childGroups.length > 0) {
        index = _ramda.default.findIndex(_ramda.default.propEq('id', group.id), facet.childGroups);

        if (index > -1) {
          parentIndex = _ramda.default.findIndex(_ramda.default.propEq('id', facet.id), allFacets);
        }
      }
    });
  }

  var drillDown = function drillDown(value) {
    value.childValues.forEach(function (childValue) {
      childValue.selected = isSelected;

      if (childValue.childValues) {
        drillDown(childValue);
      }
    });
  };

  var newFacets = _ramda.default.clone(group);

  if (newFacets.values) {
    newFacets.values.forEach(function (value) {
      value.selected = isSelected;

      if (value.childValues) {
        drillDown(value);
      }
    });
  }

  if (newFacets.childGroups) {
    newFacets.childGroups.forEach(function (childGroup) {
      childGroup.values.forEach(function (value) {
        value.selected = isSelected;

        if (value.childValues) {
          drillDown(value);
        }
      });
    });
  }

  if (parentIndex > -1) {
    allFacets[parentIndex].childGroups[index] = newFacets;
  } else {
    allFacets[index] = newFacets;
  }

  return allFacets;
} // Return a new facets object with the give facet value selected


function setSelectedOnFacetValues(groupId, valueIds, selected, facets) {
  // Lookup the path for the given facetId
  // and change it using assocPath
  if (!valueIds.length) {
    return facets;
  }

  var paths = valueIds.map(function (valueId) {
    var group = groupWithId(groupId, facets);
    var pathArr = pathFromValueId(valueId, group);

    var index = _ramda.default.findIndex(_ramda.default.propEq("id", groupId), facets);

    pathArr = _ramda.default.prepend(index, pathArr); // add "selected" to the end of our path

    pathArr.push("selected");
    return pathArr;
  });
  return paths.reduce(function (newFacets, path) {
    // NOTE: Using numerical indexes in assocPath only work in
    // Ramda 0.23.0+
    return _ramda.default.assocPath(path, selected, newFacets);
  }, facets);
} // In a given group, toggle a single facet on/off and set all other
// to the opposite


function setSingularSelectedFacetValue(groupId, valueId, selected, facets) {
  var groupLens = _ramda.default.lensPath([_ramda.default.findIndex(_ramda.default.propEq("id", groupId), facets), "values"]);

  return _ramda.default.over(groupLens, _ramda.default.map(_ramda.default.ifElse(_ramda.default.propEq("id", valueId), _ramda.default.assoc("selected", selected), _ramda.default.assoc("selected", false))), facets);
} // based on a string search query,
// filter the facets


function filterVisibleFacetsInGroup(groupId, query, facets) {
  if (!query || query.trim() === "") {
    return facets;
  } // Flatten the facets object into k,v pairs of properties
  // and stringified "path" keys. Then use the paths to
  // lookup the facet value


  var facetLookup = _ramda.default.invertObj((0, _util.flattenObj)(facets));

  var group = groupWithId(groupId, facets);

  var matchName = function matchName(s) {
    return s.toLowerCase().match(new RegExp(query.toLowerCase(), "g"));
  }; // gather all facet values from group that don't match search query


  var unMatched = _ramda.default.reject(function (v) {
    return matchName(v.name);
  }, allFacetValuesFromGroup(group)); // get an array of object paths from non-matched values


  var unMatchedPaths = _ramda.default.map(function (f) {
    return pathArrayFromFacetLookup(_ramda.default.prop("id", f), facetLookup);
  }, unMatched); // flag the non-matched facet values as hidden


  return _ramda.default.reduce(function (newFacets, path) {
    return _ramda.default.assocPath(path.concat(["hide"]), true, newFacets);
  }, facets, unMatchedPaths);
}

},{"../util":114,"ramda":"ramda"}],107:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allFacetValuesFromGroup = allFacetValuesFromGroup;
exports.selectedFacetsByGroup = selectedFacetsByGroup;
exports.selectedFacetIdsByGroup = selectedFacetIdsByGroup;
exports.selectedFacetsFromValues = selectedFacetsFromValues;
exports.selectedFacetsFromGroup = selectedFacetsFromGroup;
exports.setSelectedFalseOnAllFacetValues = setSelectedFalseOnAllFacetValues;
exports.allSelectedFacets = allSelectedFacets;
exports.groupHasSelectedChildren = groupHasSelectedChildren;
exports.valueHasSelectedChildren = valueHasSelectedChildren;
exports.valuesWithSelectedChildren = valuesWithSelectedChildren;
exports.pathFromValueId = pathFromValueId;
exports.groupWithId = groupWithId;
exports.setSelectedOnFacetValues = setSelectedOnFacetValues;
exports.filterVisibleFacetsInGroup = filterVisibleFacetsInGroup;

var _ramda = _interopRequireDefault(require("ramda"));

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module search/facets **/

/**
 * @typedef {Object} FacetValueShape
 * @property {Array} childValues Array of {@link FacetValueShape}
 * @property {number} count Number of available records
 * @property {string} id Identifier
 * @property {string} name Display Name
 * @property {boolean} selected Selection state
 */

/**
 * @typedef {Object} FacetGroupShape
 * @property {Array} childGroups Array of {@link FacetGroupShape}
 * @property {string} id Identifier for group

 * @property {string} label Display name for group
 * @property {array} values Array of {@link FacetValueShape}
 */

/**
 * Extract all facet values from a facet group, including child groups and child values.
 * @param {FacetGroupShape} group The group to filter
 * @returns {Array<FacetValueShape>} List of extracted facet values
 */
function allFacetValuesFromGroup(group) {
  var allValues = [];

  var grabAllValues = function grabAllValues(value) {
    allValues.push(value);

    if (value.childValues && value.childValues.length > 0) {
      value.childValues.forEach(function (cv) {
        return grabAllValues(cv);
      });
    }
  };

  group.values.forEach(function (value) {
    return grabAllValues(value);
  });

  if (group.hasOwnProperty("childGroups")) {
    group.childGroups.forEach(function (childGroup) {
      childGroup.values.forEach(function (value) {
        return grabAllValues(value);
      });
    });
  }

  return allValues;
}
/**
 * Extract selected facet values, grouping by root facet group.
 * @param {Array<FacetGroupShape>} facets List of facet groups
 * @returns {Object<string, Array<FacetValueShape>>} Lists of selected facet values, keyed by root group id.
 */


function selectedFacetsByGroup(facets) {
  var facetsByGroup = {};
  facets.forEach(function (group) {
    var selectedFacets = selectedFacetsFromGroup(group);

    if (selectedFacets.length) {
      facetsByGroup[group.id] = selectedFacetsFromGroup(group);
    }
  });
  return facetsByGroup;
}
/**
 * Extract just the ids of select facet values from a facet group
 * @param {Array<FacetGroupShape>} facets List of facet groups
 * @returns {object<string, Array<string>>} Lists of selected ids, keyed by root group id.
 */


function selectedFacetIdsByGroup(facets) {
  var selectedFacets = selectedFacetsByGroup(facets);
  Object.keys(selectedFacets).forEach(function (k) {
    selectedFacets[k] = selectedFacets[k].map(function (f) {
      return f.id;
    });
  });
  return selectedFacets;
}
/**
 * Extract only selected facet values from a list of facet values. Inclusive of child facet values.
 * @param {Array<FacetValueShape>} values Facet value objects to filter
 * @returns {Array<FacetValueShape>} A flat list of selected facet values
 */


function selectedFacetsFromValues(values) {
  var selected = values.filter(function (v) {
    return v.selected === true;
  });
  values.forEach(function (value) {
    if (value.hasOwnProperty("childValues")) {
      selected = selected.concat(selectedFacetsFromValues(value.childValues));
    }
  });
  return selected;
}
/**
 * Extract only selected facet values from a facet group. Inclusive of child facet groups and child facet values.
 * @param {FacetGroupShape} values Facet group to filter
 * @returns {Array<FacetValueShape>} Only selected facet values
 */


function selectedFacetsFromGroup(group) {
  var selected = selectedFacetsFromValues(group.values);

  if (group.hasOwnProperty("childGroups")) {
    group.childGroups.forEach(function (childGroup) {
      selected = selected.concat(selectedFacetsFromGroup(childGroup));
    });
  }

  return selected;
}

function setSelectedFalseOnAllFacetValues(facets) {
  var newFacets = _ramda.default.clone(facets);

  newFacets.forEach(function (group) {
    if (group.values) {
      group.values.forEach(function (value) {
        value.selected = false;

        if (value.childValues) {
          value.childValues.forEach(function (childValue) {
            childValue.selected = false;
          });
        }
      });
    }

    if (group.childGroups) {
      group.childGroups.forEach(function (childGroup) {
        childGroup.values.forEach(function (value) {
          value.selected = false;

          if (value.childValues) {
            value.childValues.forEach(function (childValue) {
              childValue.selected = false;
            });
          }
        });
      });
    }
  });
  return newFacets;
}
/**
 * Extract all facet value objects that are selected. Inclusive of all groups, subgroups and child values.
 * @param {Array<FacetGroupShape>} facets List of facet groups to be filtered
 * @returns {Array<FacetValueShape>} Only selected facet values
 */


function allSelectedFacets(facets) {
  return facets.reduce(function (all, group) {
    return all.concat(selectedFacetsFromGroup(group));
  }, []);
}
/**
 * Does a group have a facet value object that is selected?
 * @param {FacetGroupShape} group Facet group to be filtered
 * @returns {boolean}
 */


function groupHasSelectedChildren(group) {
  return selectedFacetsFromGroup(group).length > 0;
}
/**
 * Does a facet value object have a child facet value that is selected?
 * @param {FacetGroupShape} group Facet group to check
 * @returns {boolean}
 */


function valueHasSelectedChildren(value) {
  // does not include selection state of group itself
  var selectedChildren = [];

  if (value.hasOwnProperty("childValues")) {
    selectedChildren = selectedFacetsFromValues(value.childValues);
  }

  return selectedChildren.length > 0;
}
/**
 * Extract facets value objects from a group which has a child value that is selected.
 * The parent facet value does not need to be selected in order to be chosen.
 * @param {FacetGroupShape}group Facet group to check
 * @returns {Array<FacetValueShape>}
 */


function valuesWithSelectedChildren(group) {
  var all = allFacetValuesFromGroup(group);
  return all.reduce(function (hasSelected, value) {
    if (valueHasSelectedChildren(value)) {
      hasSelected.push(value);
    }

    return hasSelected;
  }, []);
} // TODO: This performs acceptably for now
// but is definitely not optimal for very large data sets.
// Should consider a different approach to setting deeply nested data.

/**
 * Returns an array of object path segments that
 * resolves to the facet value object in the
 * provided facets state object. This is useful
 * when needing to make immutable changes using
 * R.assocPath or R.lensPath
 * @param {string} valueId
 * @param {Array<FacetGroupShape>} facets List of facet groups
 * @returns {Object<string, FacetValueShape>}
 */


function pathFromValueId(valueId, facets) {
  // First, flatten the facets object into k,v pairs of properties
  // and stringified "path" keys. Then use the paths to
  // lookup the facet value
  var facetLookup = _ramda.default.invertObj((0, _util.flattenObj)(facets));

  var delimitedPath = facetLookup[valueId]; // Our paths are in format "a.b.0.c', so convert into ["a", "b", 0, "c"].
  // Then pop off the last path segment so it points to the entire value
  // object, instead of just the id.

  var pathArr = delimitedPath.split(".");
  pathArr.pop(); // Finally, ensure numerical "keys" are properly cast to Numbers
  // or else Ramda will treat them as object keys and
  // convert arrays to objects when using assocPath or lens methods.

  pathArr = pathArr.map(function (segment) {
    var numberified = parseInt(segment, 10);
    return isNaN(numberified) ? segment : numberified;
  });
  return pathArr;
}

function groupWithId(id, facets) {
  var group = null;
  facets.forEach(function (g) {
    if (g.id === id) {
      group = g;
    }

    if (!group && g.hasOwnProperty("childGroups")) {
      group = groupWithId(id, g.childGroups);
    }
  });
  return group;
}

function setSelectedOnFacetValues(groupId, valueIds, selected, facets) {
  // Lookup the path for the given facetId
  // and change it using assocPath
  if (!valueIds.length) {
    return facets;
  }

  var paths = valueIds.map(function (valueId) {
    var group = groupWithId(groupId, facets);
    var pathArr = pathFromValueId(valueId, group);

    var index = _ramda.default.findIndex(_ramda.default.propEq('id', groupId), facets);

    pathArr = _ramda.default.prepend(index, pathArr); // add "selected" to the end of our path

    pathArr.push("selected");
    return pathArr;
  });
  return paths.reduce(function (newFacets, path) {
    // NOTE: Using numerical indexes in assocPath only work in
    // Ramda 0.23.0+
    return _ramda.default.assocPath(path, selected, newFacets);
  }, facets);
}
/**
 * Create a new facets array with the specified value objects set the desired selected state
 * @param {Array<string>} valueIds The ids of the value object we want to affect
 * @param {boolean} selected State of the selected property
 * @param {Array<FacetGroupShape>} facets List of facet groups
 * @returns {Array<FacetGroupShape>} The new facets array
 
export function setSelectedOnFacetValues(valueIds, selected, facets) {
  // Lookup the path for the given facetId
  // and change it using assocPath

  if (!valueIds.length) {
    return facets;
  }

  const paths = valueIds.map(valueId => {
    let pathArr = pathFromValueId(valueId, facets);
    // add "selected" to the end of our path
    pathArr.push("selected");

    return pathArr;
  });

  return paths.reduce((newFacets, path) => {
    // NOTE: Using numerical indexes in assocPath only work in
    // Ramda 0.23.0+
    return R.assocPath(path, selected, newFacets);
  }, facets);
}

*/
// based on a string search query,
// filter the facets


function filterVisibleFacetsInGroup(group, query) {
  if (!query || query.trim() === "") {
    return group;
  }

  var matchName = function matchName(s) {
    return s.toLowerCase().match(new RegExp(query.toLowerCase(), "g"));
  }; // gather all facet values from group that don't match search query


  var unMatched = _ramda.default.reject(function (v) {
    return matchName(v.name);
  }, allFacetValuesFromGroup(group)); // get an array of object paths from non-matched values
  //const unMatchedPaths = R.map((f) => pathFromValueId(R.prop("id", f), facets), unMatched);
  // flag the non-matched facet values as hidden


  return unMatched;
}

},{"../util":114,"ramda":"ramda"}],108:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESULTS_DISPLAY_APPEND = exports.RESULTS_DISPLAY_REFRESH = void 0;
// flags to determine how to handle
// showing a new result set
var RESULTS_DISPLAY_REFRESH = 0;
exports.RESULTS_DISPLAY_REFRESH = RESULTS_DISPLAY_REFRESH;
var RESULTS_DISPLAY_APPEND = 1;
exports.RESULTS_DISPLAY_APPEND = RESULTS_DISPLAY_APPEND;

},{}],109:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _search = _interopRequireDefault(require("./search/search.reducer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// For now, this application only has a single reducer
// Additional reducers can be added here by using
// combineReducers() from redux or rolling your
// own: http://redux.js.org/docs/recipes/reducers/BeyondCombineReducers.html
var _default = _search.default;
exports.default = _default;

},{"./search/search.reducer":112}],110:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToUrl = mapStateToUrl;
exports.handleUrlChange = handleUrlChange;

var _ramda = _interopRequireDefault(require("ramda"));

var _search = require("./search/search.actions");

var _facets = require("./facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToUrl(state) {
  // choose which parts of the query
  // state we want exposed in the
  // url query string
  var exposedParams = ["q", "sortBy", "sortOrder", "page", "componentGuid", "pageGuid"]; // if we're in pagination mode,
  // we also want to expose the page num

  if (state.pagination) {
    exposedParams.push("page");
  }

  var selectedFacets;

  if (state.facets.length > 0) {
    // get selected facets by group, url-encoding their ids
    selectedFacets = _ramda.default.map(function (g) {
      return _ramda.default.map(function (v) {
        return encodeURIComponent(v);
      }, g);
    }, (0, _facets.selectedFacetIdsByGroup)(state.facets)); // turn selected facets ids into comma delimited string

    Object.keys(selectedFacets).forEach(function (k) {
      selectedFacets[k] = selectedFacets[k].join(",");
    });
  } else {
    selectedFacets = state.preSelectedFacets;
  } // ecode the query keyword


  var encodeQuery = _ramda.default.ifElse(_ramda.default.prop("q"), _ramda.default.over(_ramda.default.lensProp("q"), _ramda.default.curry(encodeURIComponent)), _ramda.default.identity); // remove keys with empty values


  var compactQuery = _ramda.default.filter(_ramda.default.complement(_ramda.default.isNil));

  var whitelistParams = _ramda.default.pick(exposedParams);

  var processQuery = _ramda.default.compose(encodeQuery, whitelistParams, compactQuery);

  return _ramda.default.merge(selectedFacets, processQuery(state.query));
}

function handleUrlChange(urlParams, store) {
  // a list of parameters that we know aren't
  // bound to facet group names
  var nonFacetParams = ["q", "sortOrder", "sortBy", "page", "componentGuid", "pageGuid"];
  var facets = store.getState().facets; // separate out the param types

  var queryParams = _ramda.default.pick(nonFacetParams, urlParams);

  var facetParams = _ramda.default.omit(nonFacetParams, urlParams);

  var newFacets = [];
  var preSelectedFacets = {};

  if (facets.length > 0) {
    // get an array of valueIds from { group: valueId, valueId } format
    // and set them to selected. If
    _ramda.default.reduce(function (newFacets, key) {
      return (0, _facets.setSelectedOnFacetValues)(key, facetParams[key], true, facets);
    }, newFacets, _ramda.default.keys(facetParams));
  } else {
    // if facets is empty, it's because we haven't gotten
    // a response yet. So we'll also pass an object of
    // pre-selected facets we can pass to the query
    // Note: In some cases browsers will auto-parse comma delimited
    // query string to an array. If not the case, do it manually  
    var conformFacets = _ramda.default.ifElse(_ramda.default.is(Array), _ramda.default.identity, _ramda.default.split(","));

    preSelectedFacets = _ramda.default.map(conformFacets, facetParams);
  } // Anytime we expose a number value to the query
  // string it will be sent back to us as a string.
  // Make sure to cast it back to a number here.


  var castToInt = _ramda.default.curry(parseInt)(_ramda.default.__, 10);

  queryParams = _ramda.default.evolve({
    page: castToInt
  }, queryParams); // Provide a new facets object.
  // First, just grab all facets ids from
  // from the facetParams
  //pickIds = R.values();

  return store.dispatch((0, _search.mergeQueryParams)(queryParams, newFacets, preSelectedFacets));
}

},{"./facets":106,"./search/search.actions":111,"ramda":"ramda"}],111:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeQueryParams = mergeQueryParams;
exports.loadStart = loadStart;
exports.loadSuccess = loadSuccess;
exports.loadFail = loadFail;
exports.sortChanged = sortChanged;
exports.incrementPage = incrementPage;
exports.changePage = changePage;
exports.keywordsChanged = keywordsChanged;
exports.facetChanged = facetChanged;
exports.facetChangedSingular = facetChangedSingular;
exports.selectFacetGroup = selectFacetGroup;
exports.clearFacetGroup = clearFacetGroup;
exports.clearAllFacets = clearAllFacets;
exports.changeToken = changeToken;
exports.showMobileFacets = showMobileFacets;
exports.hideMobileFacets = hideMobileFacets;
exports.loadResults = loadResults;
exports.loadNextPage = loadNextPage;
exports.loadNewPage = loadNewPage;
exports.loadNewSort = loadNewSort;
exports.loadNewKeywords = loadNewKeywords;
exports.loadFacetChange = loadFacetChange;
exports.loadChangeToken = loadChangeToken;
exports.loadFacetChangeSingular = loadFacetChangeSingular;
exports.loadSelectFacetGroup = loadSelectFacetGroup;
exports.loadClearFacetGroup = loadClearFacetGroup;
exports.loadClearAllFacets = loadClearAllFacets;
exports.loadProjectStatusChange = loadProjectStatusChange;
exports.CHANGE_TOKEN = exports.TOGGLE_MOBILE_FACETS = exports.CLEAR_ALL_FACETS = exports.CLEAR_FACET_GROUP = exports.SELECT_FACET_GROUP = exports.FACET_CHANGED_SINGULAR = exports.FACET_CHANGED = exports.SORT_CHANGED = exports.CHANGE_PAGE = exports.INCREMENT_PAGE = exports.KEYWORDS_CHANGED = exports.MERGE_QUERY_PARAMS = exports.LOAD_RESULTS_SUCCESS = exports.LOAD_RESULTS_FAIL = exports.LOAD_RESULTS_START = void 0;

var _ramda = _interopRequireDefault(require("ramda"));

var _resultsDisplay = require("../resultsDisplay");

var _service = require("../service");

var _facets = require("../facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Action Names
var LOAD_RESULTS_START = "SEARCH/LOAD_RESULTS_START";
exports.LOAD_RESULTS_START = LOAD_RESULTS_START;
var LOAD_RESULTS_FAIL = "SEARCH/LOAD_RESULTS_FAIL";
exports.LOAD_RESULTS_FAIL = LOAD_RESULTS_FAIL;
var LOAD_RESULTS_SUCCESS = "SEARCH/LOAD_RESULTS_SUCCESS";
exports.LOAD_RESULTS_SUCCESS = LOAD_RESULTS_SUCCESS;
var MERGE_QUERY_PARAMS = "SEARCH/MERGE_QUERY_PARAMS";
exports.MERGE_QUERY_PARAMS = MERGE_QUERY_PARAMS;
var KEYWORDS_CHANGED = "SEARCH/KEYWORDS_CHANGED";
exports.KEYWORDS_CHANGED = KEYWORDS_CHANGED;
var INCREMENT_PAGE = "SEARCH/INCREMENT_PAGE";
exports.INCREMENT_PAGE = INCREMENT_PAGE;
var CHANGE_PAGE = "SEARCH/CHANGE_PAGE";
exports.CHANGE_PAGE = CHANGE_PAGE;
var SORT_CHANGED = "SEARCH/SORT_CHANGED";
exports.SORT_CHANGED = SORT_CHANGED;
var FACET_CHANGED = "SEARCH/FACET_CHANGED";
exports.FACET_CHANGED = FACET_CHANGED;
var FACET_CHANGED_SINGULAR = "SEARCH/FACET_CHANGED_SINGULAR";
exports.FACET_CHANGED_SINGULAR = FACET_CHANGED_SINGULAR;
var SELECT_FACET_GROUP = "SEARCH/SELECT_FACET_GROUP";
exports.SELECT_FACET_GROUP = SELECT_FACET_GROUP;
var CLEAR_FACET_GROUP = "SEARCH/CLEAR_FACET_GROUP";
exports.CLEAR_FACET_GROUP = CLEAR_FACET_GROUP;
var CLEAR_ALL_FACETS = "SEARCH/CLEAR_ALL_FACETS";
exports.CLEAR_ALL_FACETS = CLEAR_ALL_FACETS;
var TOGGLE_MOBILE_FACETS = "SEARCH/TOGGLE_MOBILE_FACETS";
exports.TOGGLE_MOBILE_FACETS = TOGGLE_MOBILE_FACETS;
var CHANGE_TOKEN = "SEARCH/CHANGE_TOKEN"; // Single-dispatch Action Creators

exports.CHANGE_TOKEN = CHANGE_TOKEN;

function mergeQueryParams(params, facets, preSelectedFacets) {
  return {
    type: MERGE_QUERY_PARAMS,
    payload: {
      params: params,
      facets: facets,
      preSelectedFacets: preSelectedFacets
    }
  };
}

function loadStart() {
  return {
    type: LOAD_RESULTS_START,
    payload: null
  };
}

function loadSuccess(response, resultsDisplay, mapResponseToState) {
  return {
    type: LOAD_RESULTS_SUCCESS,
    payload: {
      response: response,
      resultsDisplay: resultsDisplay,
      mapResponseToState: mapResponseToState
    }
  };
}

function loadFail(err) {
  return {
    type: LOAD_RESULTS_FAIL,
    payload: err
  };
}

function sortChanged(sorters) {
  return {
    type: SORT_CHANGED,
    payload: sorters
  };
}

function incrementPage() {
  return {
    type: INCREMENT_PAGE,
    payload: null
  };
}

function changePage(pageNum) {
  return {
    type: CHANGE_PAGE,
    payload: pageNum
  };
}

function keywordsChanged(keywords) {
  return {
    type: KEYWORDS_CHANGED,
    payload: keywords
  };
}

function facetChanged(groupId, facetId, facetValue) {
  return {
    type: FACET_CHANGED,
    payload: {
      groupId: groupId,
      facetId: facetId,
      facetValue: facetValue
    }
  };
}

function facetChangedSingular(groupId, valueId, selected) {
  return {
    type: FACET_CHANGED_SINGULAR,
    payload: {
      groupId: groupId,
      valueId: valueId,
      selected: selected
    }
  };
}

function selectFacetGroup(group) {
  return {
    type: SELECT_FACET_GROUP,
    payload: group
  };
}

function clearFacetGroup(group) {
  return {
    type: CLEAR_FACET_GROUP,
    payload: group
  };
}

function clearAllFacets() {
  return {
    type: CLEAR_ALL_FACETS,
    payload: null
  };
}

function changeToken() {
  return {
    type: CHANGE_TOKEN,
    payload: null
  };
}

function showMobileFacets() {
  return {
    type: TOGGLE_MOBILE_FACETS,
    payload: true
  };
}

function hideMobileFacets() {
  return {
    type: TOGGLE_MOBILE_FACETS,
    payload: false
  };
} // Multi-dispatch Action Creators
// Note that multiple dispatches inside an
// action creator only work when using the
// redux-thunk middleware. These action
// creators MUST return a function.
// https://github.com/gaearon/redux-thunk


function loadResults() {
  var resultsDisplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _resultsDisplay.RESULTS_DISPLAY_APPEND;
  return function (dispatch, getState, _ref) {
    var mapResponseToState = _ref.mapResponseToState,
        fetchSearchResults = _ref.fetchSearchResults;
    var state = getState();
    var url = state.url; // get our query params, and add any pre-selected facets we
    // might have. Also, encode our keyword query.

    var query = _ramda.default.merge(state.query, state.preSelectedFacets); // Get an object of selected facets by id, and URI encode their values


    var facets = (0, _facets.selectedFacetIdsByGroup)(getState().facets); // merge with pre-selected facets

    _ramda.default.merge(facets, state.preSelectedFacets);

    dispatch(loadStart());

    var _fetchSearchResults = fetchSearchResults(url, _ramda.default.merge(query, facets)),
        _fetchSearchResults2 = _slicedToArray(_fetchSearchResults, 2),
        searchPromise = _fetchSearchResults2[0],
        featuredPromise = _fetchSearchResults2[1];

    $.when(searchPromise, featuredPromise).then(function (searchResponse, featuredResponse) {
      var response = (0, _service.handleMultipleResponses)([searchResponse, featuredResponse]);
      dispatch(loadSuccess(response, resultsDisplay, mapResponseToState));
    }).fail(function (error) {
      dispatch(loadFail(error));
    });
  };
}

function loadNextPage() {
  return function (dispatch) {
    dispatch(incrementPage());
    dispatch(loadResults());
  };
}

function loadNewPage(pageNum) {
  return function (dispatch) {
    dispatch(changePage(pageNum));
    dispatch(loadResults());
  };
}

function loadNewSort(sorters) {
  return function (dispatch) {
    dispatch(sortChanged(sorters));
    dispatch(loadResults());
  };
}

function loadNewKeywords(keywords) {
  return function (dispatch) {
    dispatch(keywordsChanged(keywords));
    dispatch(loadResults());
  };
}

function loadFacetChange(groupId, facetId, facetValue) {
  return function (dispatch) {
    dispatch(facetChanged(groupId, facetId, facetValue));
    dispatch(loadResults());
  };
}

function loadChangeToken() {
  return function (dispatch) {
    dispatch(changeToken());
    dispatch(loadResults());
  };
}

function loadFacetChangeSingular(groupId, valueId, selected) {
  return function (dispatch) {
    dispatch(facetChangedSingular(groupId, valueId, selected));
    dispatch(loadResults());
  };
}

function loadSelectFacetGroup(group) {
  return function (dispatch) {
    dispatch(selectFacetGroup(group));
    dispatch(loadResults());
  };
}

function loadClearFacetGroup(group) {
  return function (dispatch) {
    dispatch(clearFacetGroup(group));
    dispatch(loadResults());
  };
}

function loadClearAllFacets() {
  return function (dispatch) {
    dispatch(clearAllFacets());
    dispatch(loadResults());
  };
}

function loadProjectStatusChange(groupId, valueId, selected) {
  return function (dispatch) {
    dispatch(clearAllFacets());
    dispatch(facetChangedSingular(groupId, valueId, selected));
    dispatch(loadResults());
  };
}

},{"../facets":106,"../resultsDisplay":108,"../service":113,"ramda":"ramda"}],112:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = searchReducer;
exports.initialState = void 0;

var _ramda = _interopRequireDefault(require("ramda"));

var _facets = require("../facets");

var _resultsDisplay = require("../resultsDisplay");

var _search = require("./search.actions");

var _initialState, _actionMap;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (_initialState = {
  query: {
    q: null,
    sortBy: "relevance",
    sortOrder: "asc",
    page: 1,
    perPage: 10,
    pageId: "00000000-0000-0000-0000-000000000000",
    loadAllPages: true
  },
  token: {},
  url: null,
  errorMsg: null,
  loading: true,
  pagination: false,
  totalResults: 0,
  results: [],
  resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_APPEND,
  sorters: [],
  dictionary: {},
  facets: []
}, _defineProperty(_initialState, "token", {}), _defineProperty(_initialState, "numOpenGroups", null), _defineProperty(_initialState, "preSelectedFacets", {}), _defineProperty(_initialState, "initialResults", null), _defineProperty(_initialState, "isFirstLoad", true), _defineProperty(_initialState, "mobileFacetsShown", false), _defineProperty(_initialState, "spellcheckSuggestion", null), _defineProperty(_initialState, "firstResultTaxonomy", []), _defineProperty(_initialState, "perPageTaxonomy", []), _initialState);
exports.initialState = initialState;
var actionMap = (_actionMap = {}, _defineProperty(_actionMap, _search.LOAD_RESULTS_START, loadStart), _defineProperty(_actionMap, _search.LOAD_RESULTS_SUCCESS, loadSuccess), _defineProperty(_actionMap, _search.LOAD_RESULTS_FAIL, loadError), _defineProperty(_actionMap, _search.SORT_CHANGED, updateSort), _defineProperty(_actionMap, _search.MERGE_QUERY_PARAMS, updateQueryParams), _defineProperty(_actionMap, _search.KEYWORDS_CHANGED, updateKeywords), _defineProperty(_actionMap, _search.INCREMENT_PAGE, incrementPage), _defineProperty(_actionMap, _search.CHANGE_PAGE, changePage), _defineProperty(_actionMap, _search.FACET_CHANGED, changeFacet), _defineProperty(_actionMap, _search.FACET_CHANGED_SINGULAR, changeFacetSingular), _defineProperty(_actionMap, _search.SELECT_FACET_GROUP, selectFacetGroup), _defineProperty(_actionMap, _search.CLEAR_FACET_GROUP, clearFacetGroup), _defineProperty(_actionMap, _search.CLEAR_ALL_FACETS, clearAllFacets), _defineProperty(_actionMap, _search.TOGGLE_MOBILE_FACETS, toggleMobileFacets), _defineProperty(_actionMap, _search.CHANGE_TOKEN, changeToken), _actionMap);

function searchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var actionType = actionMap[action.type];
  return actionType ? actionType(state, action) : state;
}

function loadStart(state, action) {
  return _ramda.default.merge(state, {
    loading: true
  });
}

function loadSuccess(state, action) {
  var _action$payload = action.payload,
      response = _action$payload.response,
      mapResponseToState = _action$payload.mapResponseToState;
  return _ramda.default.merge(mapResponseToState(response, state), {
    loading: false,
    isFirstLoad: false,
    preSelectedFacets: {}
  });
}

function loadError(state, action) {
  return _ramda.default.merge(state, {
    loading: false,
    errorMsg: action.payload
  });
}

function updateSort(state, action) {
  var activeSorter = _ramda.default.find(_ramda.default.propEq("isActive", true), action.payload);

  return _ramda.default.merge(state, {
    sorters: action.payload,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda.default.merge(state.query, {
      sortBy: activeSorter.value,
      sortOrder: activeSorter.direction,
      page: 1
    })
  });
}

function updateQueryParams(state, action) {
  return _ramda.default.merge(state, {
    query: _ramda.default.merge(state.query, action.payload.params),
    facets: action.payload.facets,
    preSelectedFacets: action.payload.preSelectedFacets
  });
}

function incrementPage(state, action) {
  var pageNum = parseInt(state.query.page, 10) + 1;
  return _ramda.default.merge(state, {
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_APPEND,
    query: _ramda.default.merge(state.query, {
      page: pageNum
    })
  });
}

function changePage(state, action) {
  return _ramda.default.merge(state, {
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda.default.merge(state.query, {
      page: action.payload
    })
  });
}

function updateKeywords(state, action) {
  return _ramda.default.merge(state, {
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda.default.merge(state.query, {
      q: action.payload,
      page: 1
    })
  });
}

function changeFacet(state, action) {
  // We want to provide a new facet object to our
  // state with a single facet changed.
  // Lookup the path for the given facetId
  // and change it using assocPath
  var groupId = action.payload.groupId;
  var facetId = action.payload.facetId;
  var facetValue = action.payload.facetValue;
  var newFacets = (0, _facets.setSelectedOnFacetValues)(groupId, [facetId], facetValue, state.facets);
  return _ramda.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda.default.merge(state.query, {
      page: 1
    })
  });
}

function changeToken(state, action) {
  /*
    return R.mergeDeepRight(state, {
        resultsDisplayStrategy: RESULTS_DISPLAY_REFRESH,
        query:  R.pipe(
        R.dissocPath(["query", "componentGuid"]),
        R.dissocPath(["query", "pageGuid"])
      )(state)
      });*/
  return _ramda.default.pipe(_ramda.default.dissocPath(["query", "componentGuid"]), _ramda.default.dissocPath(["query", "pageGuid"]))(state);
}

function changeFacetSingular(state, action) {
  // Rather than change a single facet, just replace
  // the entire facet group with the one passed in
  var _action$payload2 = action.payload,
      groupId = _action$payload2.groupId,
      valueId = _action$payload2.valueId,
      selected = _action$payload2.selected;
  var newFacets = (0, _facets.setSingularSelectedFacetValue)(groupId, valueId, selected, state.facets);
  return _ramda.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda.default.merge(state.query, {
      page: 1
    })
  });
}

function selectFacetGroup(state, action) {
  var group = action.payload; //const groupFacetIds = R.map(R.prop("id"), allFacetValuesFromGroup(group));

  var newFacets = (0, _facets.setGroupValues)(group, state.facets, true);
  return _ramda.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda.default.merge(state.query, {
      page: 1
    })
  });
}

function clearFacetGroup(state, action) {
  var group = action.payload; //const selectedFacetIds = selectedFacetsFromGroup(group).map(v => v.id);

  var newFacets = (0, _facets.setGroupValues)(group, state.facets, false);
  return _ramda.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda.default.merge(state.query, {
      page: 1
    })
  });
}

function clearAllFacets(state, action) {
  state = _ramda.default.pipe(_ramda.default.dissocPath(["query", "componentGuid"]), _ramda.default.dissocPath(["query", "pageGuid"]))(state);
  var facets = state.facets;
  var selectedFacetIds = facets.reduce(function (all, group) {
    return all.concat((0, _facets.selectedFacetsFromGroup)(group).map(function (v) {
      return v.id;
    }));
  }, []);
  var newFacets = (0, _facets.setSelectedFalseOnAllFacetValues)(facets);
  return _ramda.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda.default.merge(state.query, {
      page: 1
    })
  });
}

function toggleMobileFacets(state, action) {
  return _ramda.default.merge({
    mobileFacetsShown: action.payload
  }, state);
}

},{"../facets":106,"../resultsDisplay":108,"./search.actions":111,"ramda":"ramda"}],113:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSearchResults = fetchSearchResults;
exports.handleMultipleResponses = handleMultipleResponses;
exports.mapResponseToState = mapResponseToState;
exports.mapFiltersToFacets = mapFiltersToFacets;

var _jquery = _interopRequireDefault(require("jquery"));

var _ramda = _interopRequireDefault(require("ramda"));

var _util = require("../util");

var _resultsDisplay = require("./resultsDisplay");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newResults = _ramda.default.curry(function (newResults, oldResults, strategy) {
  return strategy === _resultsDisplay.RESULTS_DISPLAY_APPEND ? _ramda.default.concat(oldResults || [], newResults || []) : newResults || [];
});

function fetchSearchResults(url, query) {
  var nonFilters = ["pageId", "page", "pageGuid", "perPage", "q", "sortBy", "sortOrder", "loadAllPages", "numberOfItems", "startOffset", "componentGuid"];

  var stringifyArrayParams = _ramda.default.map(function (v) {
    return v instanceof Array ? v.join(";") : v;
  });

  var keyName = function keyName(key) {
    return _ramda.default.contains(key, nonFilters) ? key : "".concat(key);
  };

  var filterizeKeys = _ramda.default.partial(_util.renameKeysWith, [keyName]);

  var fixQuery = _ramda.default.pipe(stringifyArrayParams, filterizeKeys);

  var featuredResultsPromise = query.q !== null ? _jquery.default.ajax({
    url: "/api/FeaturedResultsApi/GetFeaturedItem",
    data: {
      keyword: query.q
    }
  }).catch(function () {
    return {};
  }) : {};

  var searchPromise = _jquery.default.ajax({
    url: url,
    data: _ramda.default.merge({
      pageId: query.pageId
    }, fixQuery(query))
  });

  return [searchPromise, featuredResultsPromise];
} // for handling queries that include a call to get Featured Items,
// which have result items that need to get merged into 
// the response


function handleMultipleResponses(responses) {
  return _ramda.default.reduce(function (obj, resp) {
    var data = resp[0];

    if (data) {
      // NOTE: this assumes that the response for Featured Items
      // occurs first in the array, respecting the order they
      // were passed into $.when()
      if (data.results) {
        return _ramda.default.merge(obj, data); // handle a normal search query case
      } else {
        // otherwise, seed the new results into the response,
        // update result totals and perPage count
        obj = _ramda.default.assoc("results", _ramda.default.insertAll(0, data, obj.results), obj);
        obj = _ramda.default.assoc("totalResults", obj.totalResults + data.length, obj);
        obj = _ramda.default.assocPath(["request", "perPage"], obj.request.perPage, obj);
        return obj;
      }
    } else {
      return obj; // pass through  if no response data found
    }
  }, {
    results: []
  }, responses);
}

function mapResponseToState(response, state) {
  var request = response.request;

  var castToInt = _ramda.default.curry(parseInt)(_ramda.default.__, 10);

  var mapFilters = _ramda.default.compose(_ramda.default.partial(mapFiltersToFacets, [response.filters]));

  return _ramda.default.evolve({
    totalResults: function totalResults() {
      return parseInt(response.totalResults, 10);
    },
    results: newResults(response.results, _ramda.default.__, state.resultsDisplayStrategy),
    facets: function facets() {
      return response.filters ? mapFilters(response.facets) : response.facets;
    },
    spellcheckSuggestion: function spellcheckSuggestion() {
      return response.spellcheckSuggestion;
    },
    token: function token() {
      return response.token;
    },
    firstResultTaxonomy: function firstResultTaxonomy() {
      return response.firstResultTaxonomy;
    },
    perPageTaxonomy: function perPageTaxonomy() {
      return response.perPageTaxonomy;
    },
    query: _ramda.default.merge(_ramda.default.__, {
      pageId: request.pageId,
      page: castToInt(request.page || 0),
      perPage: castToInt(request.perPage || 10),
      sortOrder: request.sortOrder,
      loadAllPages: false
    })
  }, state);
} // The search API returns some facet data outside of
// facets, and formatted in an incompatible manner. Clean it up here.


function mapFiltersToFacets(filters, facets) {
  var addNamesAsIds = _ramda.default.map(function (v) {
    return _ramda.default.evolve({
      id: function id() {
        return v.name;
      },
      childValues: addNamesAsIds
    }, v);
  });

  var rehabFilters = _ramda.default.pipe(_ramda.default.map(function (filter) {
    return _ramda.default.assoc("id", filter.name.toLowerCase(), filter);
  }), // subgroups do not come with ids, add one
  _ramda.default.map(function (filter) {
    return (0, _util.renameKeys)({
      locations: "values",
      name: "label"
    })(filter);
  }), // subgroup keys are not correct, rename them
  _ramda.default.map(function (filter) {
    return _ramda.default.over(_ramda.default.lensProp("values"), addNamesAsIds, filter);
  }) // the location ids we get from the backend aren't valid to use on the backend. Replace them with the display name
  );

  var locationIdx = _ramda.default.findIndex(_ramda.default.propEq("id", "places"))(facets);

  return locationIdx !== -1 ? _ramda.default.assocPath([locationIdx, "childGroups"], rehabFilters(filters), facets) : facets;
}

},{"../util":114,"./resultsDisplay":108,"jquery":"jquery","ramda":"ramda"}],114:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenObj = flattenObj;
exports.renameKeysWith = exports.renameKeys = void 0;

var _ramda = _interopRequireDefault(require("ramda"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Utility function to map object paths to values
// See: https://github.com/ramda/ramda/wiki/Cookbook#flatten-a-nested-object-into-dot-separated-key--value-pairs
function flattenObj(obj) {
  var go = function go(obj_) {
    return _ramda.default.chain(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];

      if (_typeof(v) == "object") {
        return _ramda.default.map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              k_ = _ref4[0],
              v_ = _ref4[1];

          return ["".concat(k, ".").concat(k_), v_];
        }, go(v));
      } else {
        return [[k, v]];
      }
    }, _ramda.default.toPairs(obj_));
  };

  return _ramda.default.fromPairs(go(obj));
}
/**
 * Creates a new object with the own properties of the provided object, but the
 * keys renamed according to the keysMap object as `{oldKey: newKey}`.
 * When some key is not found in the keysMap, then it's passed as-is.
 *
 * Keep in mind that in the case of keys conflict is behaviour undefined and
 * the result may vary between various JS engines!
 *
 * @sig {a: b} -> {a: *} -> {b: *}
 */


var renameKeys = _ramda.default.curry(function (keysMap, obj) {
  return _ramda.default.reduce(function (acc, key) {
    return _ramda.default.assoc(keysMap[key] || key, obj[key], acc);
  }, {}, _ramda.default.keys(obj));
}); // like renameKeys, but take a function instead of a map


exports.renameKeys = renameKeys;

var renameKeysWith = _ramda.default.curry(function (fn, obj) {
  return _ramda.default.pipe(_ramda.default.toPairs, _ramda.default.map(_ramda.default.adjust(0, fn)), _ramda.default.fromPairs)(obj);
});

exports.renameKeysWith = renameKeysWith;

},{"ramda":"ramda"}],115:[function(require,module,exports){
'use strict';
/*
 * 1. Check if the browser supports `position: sticky` natively or is too old to run the polyfill.
 *    If either of these is the case set `destroy` flag. It will be checked later to disable key features
 *    of the polyfill, but the API will remain functional to avoid breaking things.
 */

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var destroy = false;
var isWindowDefined = typeof window !== 'undefined'; // The polyfill can’t function properly without `window` or `window.getComputedStyle`.

if (!isWindowDefined || !window.getComputedStyle) destroy = true; // Dont’t get in a way if the browser supports `position: sticky` natively.
else {
  var testNode = document.createElement('div');
  if (['', '-webkit-', '-moz-', '-ms-'].some(function (prefix) {
    try {
      testNode.style.position = prefix + 'sticky';
    } catch (e) {}

    return testNode.style.position != '';
  })) destroy = true;
}
/*
 * 2. “Global” vars used across the polyfill
 */

var isInitialized = false; // Check if Shadow Root constructor exists to make further checks simpler

var shadowRootExists = typeof ShadowRoot !== 'undefined'; // Last saved scroll position

var scroll = {
  top: null,
  left: null
}; // Array of created Sticky instances

var stickies = [];
/*
 * 3. Utility functions
 */

function extend(targetObj, sourceObject) {
  for (var key in sourceObject) {
    if (sourceObject.hasOwnProperty(key)) {
      targetObj[key] = sourceObject[key];
    }
  }
}

function parseNumeric(val) {
  return parseFloat(val) || 0;
}

function getDocOffsetTop(node) {
  var docOffsetTop = 0;

  while (node) {
    docOffsetTop += node.offsetTop;
    node = node.offsetParent;
  }

  return docOffsetTop;
}
/*
 * 4. Sticky class
 */


var Sticky = /*#__PURE__*/function () {
  function Sticky(node) {
    _classCallCheck(this, Sticky);

    if (!(node instanceof HTMLElement)) throw new Error('First argument must be HTMLElement');
    if (stickies.some(function (sticky) {
      return sticky._node === node;
    })) throw new Error('Stickyfill is already applied to this node');
    this._node = node;
    this._stickyMode = null;
    this._active = false;
    stickies.push(this);
    this.refresh();
  }

  _createClass(Sticky, [{
    key: "refresh",
    value: function refresh() {
      if (destroy || this._removed) return;
      if (this._active) this._deactivate();
      var node = this._node;
      /*
       * 1. Save node computed props
       */

      var nodeComputedStyle = getComputedStyle(node);
      var nodeComputedProps = {
        position: nodeComputedStyle.position,
        top: nodeComputedStyle.top,
        display: nodeComputedStyle.display,
        marginTop: nodeComputedStyle.marginTop,
        marginBottom: nodeComputedStyle.marginBottom,
        marginLeft: nodeComputedStyle.marginLeft,
        marginRight: nodeComputedStyle.marginRight,
        cssFloat: nodeComputedStyle.cssFloat
      };
      /*
       * 2. Check if the node can be activated
       */

      if (isNaN(parseFloat(nodeComputedProps.top)) || nodeComputedProps.display == 'table-cell' || nodeComputedProps.display == 'none') return;
      this._active = true;
      /*
       * 3. Check if the current node position is `sticky`. If it is, it means that the browser supports sticky positioning,
       *    but the polyfill was force-enabled. We set the node’s position to `static` before continuing, so that the node
       *    is in it’s initial position when we gather its params.
       */

      var originalPosition = node.style.position;
      if (nodeComputedStyle.position == 'sticky' || nodeComputedStyle.position == '-webkit-sticky') node.style.position = 'static';
      /*
       * 4. Get necessary node parameters
       */

      var referenceNode = node.parentNode;
      var parentNode = shadowRootExists && referenceNode instanceof ShadowRoot ? referenceNode.host : referenceNode;
      var nodeWinOffset = node.getBoundingClientRect();
      var parentWinOffset = parentNode.getBoundingClientRect();
      var parentComputedStyle = getComputedStyle(parentNode);
      this._parent = {
        node: parentNode,
        styles: {
          position: parentNode.style.position
        },
        offsetHeight: parentNode.offsetHeight
      };
      this._offsetToWindow = {
        left: nodeWinOffset.left,
        right: document.documentElement.clientWidth - nodeWinOffset.right
      };
      this._offsetToParent = {
        top: nodeWinOffset.top - parentWinOffset.top - parseNumeric(parentComputedStyle.borderTopWidth),
        left: nodeWinOffset.left - parentWinOffset.left - parseNumeric(parentComputedStyle.borderLeftWidth),
        right: -nodeWinOffset.right + parentWinOffset.right - parseNumeric(parentComputedStyle.borderRightWidth)
      };
      this._styles = {
        position: originalPosition,
        top: node.style.top,
        bottom: node.style.bottom,
        left: node.style.left,
        right: node.style.right,
        width: node.style.width,
        marginTop: node.style.marginTop,
        marginLeft: node.style.marginLeft,
        marginRight: node.style.marginRight
      };
      var nodeTopValue = parseNumeric(nodeComputedProps.top);
      this._limits = {
        start: nodeWinOffset.top + window.pageYOffset - nodeTopValue,
        end: parentWinOffset.top + window.pageYOffset + parentNode.offsetHeight - parseNumeric(parentComputedStyle.borderBottomWidth) - node.offsetHeight - nodeTopValue - parseNumeric(nodeComputedProps.marginBottom)
      };
      /*
       * 5. Ensure that the node will be positioned relatively to the parent node
       */

      var parentPosition = parentComputedStyle.position;

      if (parentPosition != 'absolute' && parentPosition != 'relative') {
        parentNode.style.position = 'relative';
      }
      /*
       * 6. Recalc node position.
       *    It’s important to do this before clone injection to avoid scrolling bug in Chrome.
       */


      this._recalcPosition();
      /*
       * 7. Create a clone
       */


      var clone = this._clone = {};
      clone.node = document.createElement('div'); // Apply styles to the clone

      extend(clone.node.style, {
        width: nodeWinOffset.right - nodeWinOffset.left + 'px',
        height: nodeWinOffset.bottom - nodeWinOffset.top + 'px',
        marginTop: nodeComputedProps.marginTop,
        marginBottom: nodeComputedProps.marginBottom,
        marginLeft: nodeComputedProps.marginLeft,
        marginRight: nodeComputedProps.marginRight,
        cssFloat: nodeComputedProps.cssFloat,
        padding: 0,
        border: 0,
        borderSpacing: 0,
        fontSize: '1em',
        position: 'static'
      });
      referenceNode.insertBefore(clone.node, node);
      clone.docOffsetTop = getDocOffsetTop(clone.node);
    }
  }, {
    key: "_recalcPosition",
    value: function _recalcPosition() {
      if (!this._active || this._removed) return;
      var stickyMode = scroll.top <= this._limits.start ? 'start' : scroll.top >= this._limits.end ? 'end' : 'middle';
      if (this._stickyMode == stickyMode) return;

      switch (stickyMode) {
        case 'start':
          extend(this._node.style, {
            position: 'absolute',
            left: this._offsetToParent.left + 'px',
            right: this._offsetToParent.right + 'px',
            top: this._offsetToParent.top + 'px',
            bottom: 'auto',
            width: 'auto',
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0
          });
          break;

        case 'middle':
          extend(this._node.style, {
            position: 'fixed',
            left: this._offsetToWindow.left + 'px',
            right: this._offsetToWindow.right + 'px',
            top: this._styles.top,
            bottom: 'auto',
            width: 'auto',
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0
          });
          break;

        case 'end':
          extend(this._node.style, {
            position: 'absolute',
            left: this._offsetToParent.left + 'px',
            right: this._offsetToParent.right + 'px',
            top: 'auto',
            bottom: 0,
            width: 'auto',
            marginLeft: 0,
            marginRight: 0
          });
          break;
      }

      this._stickyMode = stickyMode;
    }
  }, {
    key: "_fastCheck",
    value: function _fastCheck() {
      if (!this._active || this._removed) return;
      if (Math.abs(getDocOffsetTop(this._clone.node) - this._clone.docOffsetTop) > 1 || Math.abs(this._parent.node.offsetHeight - this._parent.offsetHeight) > 1) this.refresh();
    }
  }, {
    key: "_deactivate",
    value: function _deactivate() {
      var _this = this;

      if (!this._active || this._removed) return;

      this._clone.node.parentNode.removeChild(this._clone.node);

      delete this._clone;
      extend(this._node.style, this._styles);
      delete this._styles; // Check whether element’s parent node is used by other stickies.
      // If not, restore parent node’s styles.

      if (!stickies.some(function (sticky) {
        return sticky !== _this && sticky._parent && sticky._parent.node === _this._parent.node;
      })) {
        extend(this._parent.node.style, this._parent.styles);
      }

      delete this._parent;
      this._stickyMode = null;
      this._active = false;
      delete this._offsetToWindow;
      delete this._offsetToParent;
      delete this._limits;
    }
  }, {
    key: "remove",
    value: function remove() {
      var _this2 = this;

      this._deactivate();

      stickies.some(function (sticky, index) {
        if (sticky._node === _this2._node) {
          stickies.splice(index, 1);
          return true;
        }
      });
      this._removed = true;
    }
  }]);

  return Sticky;
}();
/*
 * 5. Stickyfill API
 */


var Stickyfill = {
  stickies: stickies,
  Sticky: Sticky,
  forceSticky: function forceSticky() {
    destroy = false;
    init();
    this.refreshAll();
  },
  addOne: function addOne(node) {
    // Check whether it’s a node
    if (!(node instanceof HTMLElement)) {
      // Maybe it’s a node list of some sort?
      // Take first node from the list then
      if (node.length && node[0]) node = node[0];else return;
    } // Check if Stickyfill is already applied to the node
    // and return existing sticky


    for (var i = 0; i < stickies.length; i++) {
      if (stickies[i]._node === node) return stickies[i];
    } // Create and return new sticky


    return new Sticky(node);
  },
  add: function add(nodeList) {
    // If it’s a node make an array of one node
    if (nodeList instanceof HTMLElement) nodeList = [nodeList]; // Check if the argument is an iterable of some sort

    if (!nodeList.length) return; // Add every element as a sticky and return an array of created Sticky instances

    var addedStickies = [];

    var _loop = function _loop(i) {
      var node = nodeList[i]; // If it’s not an HTMLElement – create an empty element to preserve 1-to-1
      // correlation with input list

      if (!(node instanceof HTMLElement)) {
        addedStickies.push(void 0);
        return "continue";
      } // If Stickyfill is already applied to the node
      // add existing sticky


      if (stickies.some(function (sticky) {
        if (sticky._node === node) {
          addedStickies.push(sticky);
          return true;
        }
      })) return "continue"; // Create and add new sticky

      addedStickies.push(new Sticky(node));
    };

    for (var i = 0; i < nodeList.length; i++) {
      var _ret = _loop(i);

      if (_ret === "continue") continue;
    }

    return addedStickies;
  },
  refreshAll: function refreshAll() {
    stickies.forEach(function (sticky) {
      return sticky.refresh();
    });
  },
  removeOne: function removeOne(node) {
    // Check whether it’s a node
    if (!(node instanceof HTMLElement)) {
      // Maybe it’s a node list of some sort?
      // Take first node from the list then
      if (node.length && node[0]) node = node[0];else return;
    } // Remove the stickies bound to the nodes in the list


    stickies.some(function (sticky) {
      if (sticky._node === node) {
        sticky.remove();
        return true;
      }
    });
  },
  remove: function remove(nodeList) {
    // If it’s a node make an array of one node
    if (nodeList instanceof HTMLElement) nodeList = [nodeList]; // Check if the argument is an iterable of some sort

    if (!nodeList.length) return; // Remove the stickies bound to the nodes in the list

    var _loop2 = function _loop2(i) {
      var node = nodeList[i];
      stickies.some(function (sticky) {
        if (sticky._node === node) {
          sticky.remove();
          return true;
        }
      });
    };

    for (var i = 0; i < nodeList.length; i++) {
      _loop2(i);
    }
  },
  removeAll: function removeAll() {
    while (stickies.length) {
      stickies[0].remove();
    }
  }
};
/*
 * 6. Setup events (unless the polyfill was disabled)
 */

function init() {
  if (isInitialized) {
    return;
  }

  isInitialized = true; // Watch for scroll position changes and trigger recalc/refresh if needed

  function checkScroll() {
    if (window.pageXOffset != scroll.left) {
      scroll.top = window.pageYOffset;
      scroll.left = window.pageXOffset;
      Stickyfill.refreshAll();
    } else if (window.pageYOffset != scroll.top) {
      scroll.top = window.pageYOffset;
      scroll.left = window.pageXOffset; // recalc position for all stickies

      stickies.forEach(function (sticky) {
        return sticky._recalcPosition();
      });
    }
  }

  checkScroll();
  window.addEventListener('scroll', checkScroll); // Watch for window resizes and device orientation changes and trigger refresh

  window.addEventListener('resize', Stickyfill.refreshAll);
  window.addEventListener('orientationchange', Stickyfill.refreshAll); //Fast dirty check for layout changes every 500ms

  var fastCheckTimer;

  function startFastCheckTimer() {
    fastCheckTimer = setInterval(function () {
      stickies.forEach(function (sticky) {
        return sticky._fastCheck();
      });
    }, 500);
  }

  function stopFastCheckTimer() {
    clearInterval(fastCheckTimer);
  }

  var docHiddenKey;
  var visibilityChangeEventName;

  if ('hidden' in document) {
    docHiddenKey = 'hidden';
    visibilityChangeEventName = 'visibilitychange';
  } else if ('webkitHidden' in document) {
    docHiddenKey = 'webkitHidden';
    visibilityChangeEventName = 'webkitvisibilitychange';
  }

  if (visibilityChangeEventName) {
    if (!document[docHiddenKey]) startFastCheckTimer();
    document.addEventListener(visibilityChangeEventName, function () {
      if (document[docHiddenKey]) {
        stopFastCheckTimer();
      } else {
        startFastCheckTimer();
      }
    });
  } else startFastCheckTimer();
}

if (!destroy) init();
/*
 * 7. Expose Stickyfill
 */

if (typeof module != 'undefined' && module.exports) {
  module.exports = Stickyfill;
} else if (isWindowDefined) {
  window.Stickyfill = Stickyfill;
}

},{}],116:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerEvent = registerEvent;
exports.scrollPercent = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this is for the read goal
var scrollPercent; // support multiple players on the same page

exports.scrollPercent = scrollPercent;
var videoPlayers = []; // this is for the first visit goals

var firstVisitElement;
(0, _jquery.default)(document).ready(function () {
  (0, _jquery.default)('.xdbpe').click(function (event) {
    var eventId = (0, _jquery.default)(event.currentTarget).attr('data-xdbpe');
    var componentName = (0, _jquery.default)(event.currentTarget).parents().filter(function () {
      return (0, _jquery.default)(this).attr('data-component');
    }).eq(0).attr('data-component');
    registerEvent(eventId, componentName);
  });

  if ((0, _jquery.default)('.xdbpe-project').length || (0, _jquery.default)('.xdbpe-topic').length) {
    if ((0, _jquery.default)('.xdbpe-project').length) {
      firstVisitElement = (0, _jquery.default)('.xdbpe-project');
    } else {
      firstVisitElement = (0, _jquery.default)('.xdbpe-topic');
    }

    var firstVisitEventId = firstVisitElement.attr('data-xdbpe');
    registerEvent(firstVisitEventId);
  }

  (0, _jquery.default)(window).on('scroll', function () {
    if (scrollPercent == undefined || scrollPercent < 75) {
      var s = (0, _jquery.default)(window).scrollTop(),
          d = (0, _jquery.default)(document).height(),
          c = (0, _jquery.default)(window).height();
      exports.scrollPercent = scrollPercent = Math.round(s / (d - c) * 100);
    }
  });
});

function registerEvent(eventId, componentName, newsletterId) {
  _jquery.default.ajax({
    method: "POST",
    url: "/api/goals/registerevent",
    contentType: 'application/json; charset=utf-8',
    processData: false,
    dataType: 'json',
    data: JSON.stringify({
      id: eventId,
      componentName: componentName,
      newsletterId: newsletterId
    })
  });
} // this is for the video goal  
// using same script GTM uses


(0, _jquery.default)(document).ready(function () {
  if ((0, _jquery.default)(".xdbpe-video").length) {
    var onPlayerStateChange = function onPlayerStateChange(e) {
      e["data"] == YT.PlayerState.PLAYING && setTimeout(onPlayerPercent, 1000, e["target"]);
    };

    var onPlayerPercent = function onPlayerPercent(e) {
      if (e["getPlayerState"]() == YT.PlayerState.PLAYING) {
        var t = e["getDuration"]() - e["getCurrentTime"]() <= 1.5 ? 1 : (Math.floor(e["getCurrentTime"]() / e["getDuration"]() * 10) / 10).toFixed(2);

        if (parseFloat(t) < 0.25) {
          t = 0.00;
        } else if (parseFloat(t) < 0.5) {
          t = 0.25;
        } else if (parseFloat(t) < 0.75) {
          t = 0.50;
        } else if (parseFloat(t) < 0.9) {
          t = 0.75;
        } else if (parseFloat(t) < 1) {
          t = 0.90;
        }

        t = t.toFixed(2);

        if (!e["lastP"] || t > e["lastP"]) {
          e["lastP"] = t;

          if (parseFloat(t) === 0.75) {
            var videoParent = (0, _jquery.default)(e["getIframe"]()).parent();
            var eventId = videoParent.attr('data-xdbpe');
            var componentName = videoParent.attr('data-component');
            registerEvent(eventId, componentName);
          }
        }

        e["lastP"] != 1 && setTimeout(onPlayerPercent, 1000, e);
      }
    };

    if (typeof window.onYouTubeIframeAPIReady != "function") {
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var indexScript = document.querySelector("script[src=\"/assets/pew/js/index-generated.js\"");
      (0, _jquery.default)(tag).insertAfter(indexScript);
    }

    window.onYouTubeIframeAPIReady = function () {
      for (var e = document.getElementsByTagName("iframe"), x = e.length; x--;) {
        videoPlayers.push(new YT.Player(e[x], {
          events: {
            onStateChange: onPlayerStateChange
          }
        }));
      }
    };
  }
});

},{"jquery":"jquery"}],117:[function(require,module,exports){
"use strict";

require("./polyfill");

var _jquery = _interopRequireDefault(require("jquery"));

var _ramda = _interopRequireDefault(require("ramda"));

var _lodash = _interopRequireDefault(require("lodash"));

require("picturefill");

var _search = require("./Pew/search");

var _dynamicContent = require("./Pew/dynamic-content");

var _blogContent = require("./Pew/blog-content");

var _peopleListing = require("./Pew/people-listing");

var _projectListing = require("./Pew/project-listing");

var _blogSearch = require("./Pew/blog-search");

var _hiaMap = require("./Pew/hia-map");

var _PrimaryNav = require("./Pew/navigation/PrimaryNav");

var _initPrimaryNav = _interopRequireDefault(require("./Pew/navigation/initPrimaryNav.js"));

var _initMobileMenu = _interopRequireDefault(require("./Pew/navigation/initMobileMenu.js"));

var _initMobileSearchMenu = _interopRequireDefault(require("./Pew/navigation/initMobileSearchMenu.js"));

var _initMobileShare = _interopRequireDefault(require("./Pew/navigation/initMobileShare.js"));

var _ViewAllExpand = require("./Pew/ViewAllExpand");

var _ImageSlider = require("./Pew/ImageSlider");

var _GenericModal = require("./Pew/GenericModal");

var _SecondaryNav = require("./Pew/navigation/SecondaryNav");

var _DynamicBanner = require("./Pew/DynamicBanner");

var _LocalNav = _interopRequireDefault(require("./Pew/navigation/LocalNav"));

require("./Pew/MoreFromPewSlider");

require("./Pew/ImageGallery");

require("./Pew/DynamicContentListing");

require("./Pew/FlipTile");

require("./Pew/SelectionSharer");

require("./Pew/InnovationFundCheck");

require("./Pew/PageVarGTM.js");

var _ReadingTime = require("./Pew/ReadingTime");

var _ReadMode = require("./Pew/ReadMode");

var _breakpoint = require("./Pew/breakpoint");

var _Toolbar = require("./Pew/Toolbar");

var _LanguageSelector = require("./Pew/LanguageSelector");

var _VideoModal = require("./Pew/VideoModal");

var _LegacyVideoModal = require("./Pew/LegacyVideoModal");

var _ScholarGrid = require("./Pew/ScholarGrid");

var _WhatWeDo = require("./Pew/WhatWeDo");

var _HowWeWork = require("./Pew/HowWeWork");

var _FormDropdown = require("./Pew/FormDropdown");

var _ExploreModule = require("./Pew/ExploreModule");

var _InterstitialModal = require("./Pew/InterstitialModal");

var _EmbedToggle = require("./Pew/EmbedToggle");

var _RssListing = require("./Pew/RssListing");

var _ActionAlertShare = require("./Pew/ActionAlertShare");

var _xDB = require("./Pew/xDB");

var _HiaDownload = require("./Pew/HiaDownload");

var _Sticky = require("./Pew/Sticky30");

var _makeClickable = _interopRequireDefault(require("./Pew/makeClickable"));

var _ScrollAnimation = _interopRequireDefault(require("./Pew/ScrollAnimation"));

require("what-input");

var _FlipBanner = require("./Pew/FlipBanner");

var _ShareButton = require("./Pew/ShareButton");

var _Slider = require("./Pew/Slider");

var _ShareBar = require("./Pew/ShareBar");

var Stickyfill = _interopRequireWildcard(require("./Pew/stickyfill.js"));

var _InsertRelatedFactsArrows = _interopRequireDefault(require("./Pew/InsertRelatedFactsArrows"));

var _Typeahead = require("./Pew/Typeahead.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

document.addEventListener("DOMContentLoaded", function () {
  // .forEach() requires an array in IE11, but queryselectorAll returns a NodeList.
  var primaryNav = document.querySelectorAll(".js-primary-nav");
  var primaryNavArray = Array.from(primaryNav);
  primaryNavArray.forEach(function (el, i) {
    (0, _initPrimaryNav.default)(el, i);
  }); // .forEach() requires an array in IE11, but queryselectorAll returns a NodeList.

  var mobileMenu = document.querySelectorAll(".js-mobile-menu");
  var mobileMenuArray = Array.from(mobileMenu);
  mobileMenuArray.forEach(function (el, i) {
    (0, _initMobileMenu.default)(el, i);
  }); // .forEach() requires an array in IE11, but queryselectorAll returns a NodeList.

  var mobileSearchMenu = document.querySelectorAll(".js-mobile-search-menu");
  var mobileSearchMenuArray = Array.from(mobileSearchMenu);
  mobileSearchMenuArray.forEach(function (el, i) {
    (0, _initMobileSearchMenu.default)(el, i);
  }); // .forEach() requires an array in IE11, but queryselectorAll returns a NodeList.

  var mobileShares = document.querySelectorAll(".js-mobile-share");
  var mobileSharesArray = Array.from(mobileShares);
  mobileSharesArray.forEach(function (el, i) {
    (0, _initMobileShare.default)(el, i);
  });
  (0, _ScrollAnimation.default)();
  (0, _InsertRelatedFactsArrows.default)();
}); // exposes jQuery to browser console
// see: https://developers.google.com/web/tools/chrome-devtools/console/command-line-reference

window.$ = _jquery.default;

if ((0, _jquery.default)(".js-local-nav").length || (0, _jquery.default)(".js-section-nav").length || (0, _jquery.default)(".js-combined-nav").length) {
  _LocalNav.default.init();
} // PrimaryNav
// const $primaryNavEl = $(".js-primary-nav");
// if ($primaryNavEl.length) {
//   let primaryNav = new PrimaryNav($primaryNavEl);
// }
// Make Clickable
// .forEach() requires an array in IE11, but queryselectorAll returns a NodeList.


var clickables = document.querySelectorAll(".js-make-clickable");
var clickablesArray = Array.from(clickables);
clickablesArray.forEach(_makeClickable.default); // Expandable Listings

var viewAllables = _jquery.default.makeArray((0, _jquery.default)(".js-view-all-expand")).map(function (el) {
  return new _ViewAllExpand.ViewAllExpand((0, _jquery.default)(el));
}); // Slideshows
// do not intialize slideshows inside
// page editor


if (!(0, _jquery.default)("body").hasClass("is-page-editor")) {
  var slideshows = _jquery.default.makeArray((0, _jquery.default)(".slideshow .js-slider")).map(function (el) {
    return new _ImageSlider.ImageSlider((0, _jquery.default)(el), {});
  });
} // Flip Banner (from Living Facts)


if ((0, _jquery.default)(".js-flip").length && !(0, _jquery.default)("body").hasClass("is-page-editor")) {
  var flip = _jquery.default.makeArray((0, _jquery.default)(".js-flip")).map(function (el) {
    return new _FlipBanner.FlipBanner((0, _jquery.default)(el));
  });
} // Share Button (from Living Facts)


if ((0, _jquery.default)(".js-share").length) {
  (0, _jquery.default)(".js-share").each(function () {
    return new _ShareButton.ShareButton((0, _jquery.default)(this));
  });
} // Fact Slider (from Living Facts)


if (!(0, _jquery.default)("body").hasClass("is-page-editor")) {
  var conf = {
    slick: {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [{
        breakpoint: 470,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true
        }
      }, {
        breakpoint: 911,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: true
        }
      }]
    }
  };
  var confExactly3 = {
    slick: {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [{
        breakpoint: 470,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true
        }
      }, {
        breakpoint: 911,
        settings: "unslick"
      }]
    }
  };
  (0, _jquery.default)(".fact-slider.js-slider").each(function () {
    var facts = (0, _jquery.default)(this).children(".related-facts__fact");

    if (facts.length > 3) {
      return new _Slider.Slider((0, _jquery.default)(this), true, conf);
    } else {
      return new _Slider.Slider((0, _jquery.default)(this), true, confExactly3);
    }
  });
} // Image Modals
// do not intialize modals inside page editor


if (!(0, _jquery.default)("body").hasClass("is-page-editor")) {
  (0, _jquery.default)(".js-image-modal-source").each(function () {
    return new _GenericModal.GenericModal((0, _jquery.default)(this), false, function ($el) {
      return $el.width() < 649;
    });
  });
} // Flexible Promo Modals
// do not intialize modals inside page editor


if (!(0, _jquery.default)("body").hasClass("is-page-editor")) {
  (0, _jquery.default)(".js-flexible-promo-modal-source").each(function () {
    return new _GenericModal.GenericModal((0, _jquery.default)(this), (0, _jquery.default)(this).find(".js-modal-content"));
  });
}

if (!(0, _jquery.default)("body").hasClass("is-page-editor")) {
  (0, _jquery.default)(".js-video-modal-source").each(function () {
    return new _VideoModal.VideoModal((0, _jquery.default)(this));
  });
}

if (!(0, _jquery.default)("body").hasClass("is-page-editor")) {
  (0, _jquery.default)(".pct-modal").each(function () {
    return new _LegacyVideoModal.LegacyVideoModal((0, _jquery.default)(this));
  });
} // Interstitial Modal


var interstitialModals = _jquery.default.makeArray((0, _jquery.default)(".js-interstitial-popup")).map(function (el) {
  return new _InterstitialModal.InterstitialModal((0, _jquery.default)(el));
}); // Secondary Nav


if ((0, _jquery.default)(".js-secondary-nav").length) {
  var secondaryNav = new _SecondaryNav.SecondaryNav((0, _jquery.default)(".js-secondary-nav"));
}

if ((0, _jquery.default)(".page-toolbar__selector").length) {
  var toolbar = new _Toolbar.Toolbar((0, _jquery.default)(".page-toolbar__selector"));
}

if ((0, _jquery.default)(".language-callout__item").length) {
  var lang = new _LanguageSelector.LanguageSelector((0, _jquery.default)(".language-callout__item"));
}

if ((0, _jquery.default)("#content-toolbar--togglereadmode").length) {
  var readMode = new _ReadMode.ReadMode((0, _jquery.default)("#content-toolbar--togglereadmode"));
} //RSS Listing


if ((0, _jquery.default)(".js-rss-listing").length) {
  var rssListing = new _RssListing.RssListing((0, _jquery.default)(".js-rss-listing"));
} //What We DO


if ((0, _jquery.default)(".js-what-we-do").length) {
  var whatwedo = new _WhatWeDo.WhatWeDo((0, _jquery.default)(".js-what-we-do"));
}

if ((0, _jquery.default)(".js-how-we-work").length) {
  var howwework = new _HowWeWork.HowWeWork((0, _jquery.default)(".js-how-we-work"));
} // Dynamic Banners (Hero and Page Banner)


var $banners = (0, _jquery.default)(".js-dynamic-banner");

if ($banners.length) {
  var dynamicBanners = _jquery.default.makeArray($banners).map(function (el) {
    return new _DynamicBanner.DynamicBanner((0, _jquery.default)(el));
  });
}

if ((0, _jquery.default)("span.read-time").length) {
  var readingTime = new _ReadingTime.ReadingTime((0, _jquery.default)(".rich-text"));
  var readTimeText = (0, _jquery.default)("span.read-time").text();

  var _dataLayer = window.dataLayer || [];

  var readTimeIndex = _dataLayer ? _dataLayer.findIndex(function (obj) {
    return obj.suggest_read_time_msec === "";
  }) : null;

  if (readTimeText && readTimeText.match(/min/g).includes("min")) {
    var readTimeMs = readTimeText.replace(/\D/g, "") * 60000;
    readTimeIndex && (_dataLayer[readTimeIndex].suggest_read_time_msec = readTimeMs);
  } else {
    readTimeIndex && (_dataLayer[readTimeIndex].suggest_read_time_msec = 59000);
  }
}

if ((0, _jquery.default)(".js-read-time-gtm").length && dataLayer) {
  var readtime = (0, _jquery.default)(".js-read-time-gtm").text().replace(/\D/g, "") * 60000 * 0.75;

  if (readtime > 0 && (typeof dataLayer === "undefined" ? "undefined" : _typeof(dataLayer)) !== undefined) {
    setTimeout(function () {
      dataLayer.push({
        event: "pageRead"
      });
    }, readtime);
  }
} // Search Apps
// only init if results are included


if ((0, _jquery.default)(".js-search-results").length) {
  // in the case of multiples of same component, group nodes by search-id
  var groupedSearchNodes = _ramda.default.groupWith(function (a, b) {
    return a.getAttribute("data-search-id") === b.getAttribute("data-search-id");
  }, _jquery.default.makeArray((0, _jquery.default)(".js-search-query,.js-search-results,.js-search-facets,.js-search-tokens, .js-search-widget")));

  groupedSearchNodes.forEach(function (nodes) {
    return (0, _search.initSearchApp)(nodes);
  });
} //hia


if ((0, _jquery.default)(".js-hia-search-results").length) {
  (0, _hiaMap.initSearchApp)(_jquery.default.makeArray((0, _jquery.default)(".js-hia-search-results,.js-hia-search-facets, .js-search-query")));
}

if ((0, _jquery.default)(".js-hia-download-csv").length) {
  var download = new _HiaDownload.HiaDownload((0, _jquery.default)(".js-hia-download-csv"));
} // dynamic content


if ((0, _jquery.default)(".js-dynamic-items").length) {
  // in the case of multiples of same component, group nodes by search-id
  var groupedDynamicContentNodes = _ramda.default.groupWith(function (a, b) {
    return a.getAttribute("data-search-id") === b.getAttribute("data-search-id");
  }, _jquery.default.makeArray((0, _jquery.default)(".js-dynamic-items,.js-dynamic-items-search-facets")));

  groupedDynamicContentNodes.forEach(function (nodes) {
    return (0, _dynamicContent.initSearchApp)(nodes);
  });
} // people listing


if ((0, _jquery.default)(".js-people-items").length) {
  // in the case of multiples of same component, group nodes by search-id
  var groupedPeopleListingNodes = _ramda.default.groupWith(function (a, b) {
    return a.getAttribute("data-search-id") === b.getAttribute("data-search-id");
  }, _jquery.default.makeArray((0, _jquery.default)(".js-people-items,.js-people-items-search-facets")));

  groupedPeopleListingNodes.forEach(function (nodes) {
    return (0, _peopleListing.initSearchApp)(nodes);
  });
} // blog content


if ((0, _jquery.default)(".js-blog-content").length) {
  // in the case of multiples of same component, group nodes by search-id
  var groupedBlogContentNodes = _ramda.default.groupWith(function (a, b) {
    return a.getAttribute("data-search-id") === b.getAttribute("data-search-id");
  }, _jquery.default.makeArray((0, _jquery.default)(".js-blog-content,.js-blog-content-search-facets")));

  groupedBlogContentNodes.forEach(function (nodes) {
    return (0, _blogContent.initSearchApp)(nodes);
  });
} // blog search


if ((0, _jquery.default)(".js-blog-search").length) {
  // in the case of multiples of same component, group nodes by search-id
  var groupedBlogSearchNodes = _ramda.default.groupWith(function (a, b) {
    return a.getAttribute("data-search-id") === b.getAttribute("data-search-id");
  }, _jquery.default.makeArray((0, _jquery.default)(".js-blog-search")));

  groupedBlogSearchNodes.forEach(function (nodes) {
    return (0, _blogSearch.initSearchApp)(nodes);
  });
} // project listing


if ((0, _jquery.default)(".js-projects-container").length) {
  // in the case of multiples of same component, group nodes by search-id
  var groupedProjectListingNodes = _ramda.default.groupWith(function (a, b) {
    return a.getAttribute("data-search-id") === b.getAttribute("data-search-id");
  }, _jquery.default.makeArray((0, _jquery.default)(".js-projects-search-facets,.js-projects-container")));

  groupedProjectListingNodes.forEach(function (nodes) {
    return (0, _projectListing.initSearchApp)(nodes);
  });
} // Form dropdowns


var $dropdowns = (0, _jquery.default)(".js-form-dropdown");

if ($dropdowns.length) {
  var formDropdowns = _jquery.default.makeArray($dropdowns).map(function (el) {
    return new _FormDropdown.FormDropdown((0, _jquery.default)(el));
  });
} // 70-30 Sticky Sidebar
// create sticky 30 after page has been loaded


(0, _jquery.default)(document).ready(function () {
  var $sticky30 = (0, _jquery.default)(".container--70-30-sticky .container__col--30");

  if ($sticky30.length) {
    var sticky30s = _jquery.default.makeArray($sticky30).map(function (el) {
      return new _Sticky.Sticky30((0, _jquery.default)(el));
    });
  }
}); // Scholar Tile Grid

var $scholarGrids = (0, _jquery.default)(".js-scholar-grid");

if ($scholarGrids.length) {
  var scholarGrids = _jquery.default.makeArray($scholarGrids).map(function (el) {
    return new _ScholarGrid.ScholarGrid((0, _jquery.default)(el));
  });
} //Action Alert Share


if ((0, _jquery.default)(".js-action-alert-share").length) {
  var actionAlert = new _ActionAlertShare.ActionAlertShare((0, _jquery.default)(".js-action-alert-share"));
}

var $typeahead = (0, _jquery.default)(".js-quick-search-input");

if ($typeahead.length) {
  _jquery.default.makeArray($typeahead).forEach(function (el) {
    return (0, _Typeahead.initTypeahead)(el);
  });
}

var $mobileTypeahead = (0, _jquery.default)(".js-mobile-search-input");

if ($mobileTypeahead.length) {
  _jquery.default.makeArray($mobileTypeahead).forEach(function (el) {
    return (0, _Typeahead.initTypeahead)(el);
  });
}

var $searchTypeahead = (0, _jquery.default)(".js-search-query input");

if ($searchTypeahead.length) {
  _jquery.default.makeArray($searchTypeahead).forEach(function (el) {
    return (0, _Typeahead.initTypeahead)(el);
  });
} // Newsletter signup options


var getNewsletterOptions = function getNewsletterOptions(form) {
  var selectOptions = (0, _jquery.default)(form).find('.newsletter-signup__select-field input[type="checkbox"]:checked');
  var values = selectOptions.map(function () {
    return (0, _jquery.default)(this).val();
  }).get();
  var pipedOptions = values.join("|");
  return pipedOptions ? "&guid=".concat(pipedOptions) : "";
}; // Newsletter signup validation


var validateEmailAddress = function validateEmailAddress(form) {
  var newsletterOptions = getNewsletterOptions(form);
  var emailField = (0, _jquery.default)(form).find(".newsletter-signup__email-input");
  var elqErrorMessageField = (0, _jquery.default)(form).find(".newsletter-signup__validation-error");
  var email = emailField.val();

  if (email === emailField.attr("placeholder")) {
    email = "";
  }

  if (email === "") {
    elqErrorMessageField.show();
    emailField.focus();
    return false;
  }

  var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  if (!filter.test(email)) {
    elqErrorMessageField.show();
    emailField.focus();
    return false;
  } else {
    var eventId = (0, _jquery.default)(form).find(".xdbpe-newsletter").attr("data-xdbpe");
    var componentName = (0, _jquery.default)(form).attr("data-component");
    var newsletterId = (0, _jquery.default)(form).find(".js-newsletter-signup--landingguid").val();
    (0, _xDB.registerEvent)(eventId, componentName, newsletterId);
    var encodedEmail = window.btoa(email);

    var utmString = function utmString(utmType) {
      if (sessionStorage.getItem("utm_".concat(utmType)) !== null) {
        return "&utm_".concat(utmType, "=") + sessionStorage.getItem("utm_".concat(utmType));
      } else {
        return "";
      }
    };

    var baseURL = (0, _jquery.default)(form).find(".js-newsletter-signup--baseUrl").val();
    var landingGUID = (0, _jquery.default)(form).find(".js-newsletter-signup--landingguid").val();
    var emailAddressPrefix = landingGUID ? "&ea=" : "?ea=";
    var postURL = baseURL + landingGUID + emailAddressPrefix + encodedEmail + utmString("source") + utmString("medium") + utmString("campaign") + utmString("content") + utmString("term") + newsletterOptions;
    (0, _jquery.default)(form).attr("action", postURL);
    setTimeout(function () {
      (0, _jquery.default)(form)[0].reset();
      (0, _jquery.default)(form).attr("action", ""); //remove action after validation to prevent duplicate form submission

      elqErrorMessageField.hide();
    }, 0);
  }
};

(0, _jquery.default)(".js-footer-newsletter-signup").on("submit", function (e) {
  return validateEmailAddress(this);
});
(0, _jquery.default)(".js-newsletter-signup-with-images").on("submit", function (e) {
  var elqErrorMessageField = (0, _jquery.default)(this).find(".newsletter-signup__validation-error");
  var checkedNewsletters = getNewsletterOptions(this);

  if (checkedNewsletters.length == 0) {
    elqErrorMessageField.text("Please select a newsletter").show();
    return false;
  } else {
    elqErrorMessageField.text("Please provide a valid email address").hide();
    return validateEmailAddress(this);
  }
}); // The Downloads Callout component should only exist once per page at narrow (smartphone) widths

(0, _jquery.default)(".downloads-callout").each(function (index) {
  if (index > 0) {
    (0, _jquery.default)(this).addClass("downloads-callout--hide-narrow");
  }
});
var $embedToggleEls = (0, _jquery.default)(".js-embed-toggle");

if ($embedToggleEls.length) {
  var embedToggles = _jquery.default.makeArray($embedToggleEls).map(function (el) {
    return new _EmbedToggle.EmbedToggle((0, _jquery.default)(el));
  });
} //Magazine archive slider


if ((0, _jquery.default)(".js-magazine-archive-slider").length > 0) {
  (0, _jquery.default)(".js-magazine-archive-slider").each(function () {
    var _this = this;

    (0, _jquery.default)(this).slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      mobileFirst: true,
      arrows: false,
      dots: true,
      infinite: false,
      responsive: [{
        breakpoint: 910,
        settings: "unslick"
      }]
    });
    (0, _jquery.default)(window).on("resize", function (event) {
      (0, _jquery.default)(_this).slick("resize");
    });
  });
} //Products Navigation slider


if ((0, _jquery.default)(".js-product-navigation-slider").length > 0) {
  (0, _jquery.default)(".js-product-navigation-slider").each(function () {
    (0, _jquery.default)(this).slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: false,
      prevArrow: "\n        <button type=\"button\" class=\"slick-prev\" tabindex=\"0\">\n            Previous\n            <div class=\"icon\">\n              <svg role=\"img\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n              <path fill=\"#296EC3\" d=\"M15.422 16.078l-1.406 1.406-6-6 6-6 1.406 1.406-4.594 4.594z\">\n                <title>Previous</title>\n              </path>\n              </svg>\n            </div>\n        </button>",
      nextArrow: "\n        <button type=\"button\" class=\"slick-next\" tabindex=\"0\">\n            Next\n            <div class=\"icon\">\n              <svg role=\"img\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n              <path fill=\"#296EC3\" d=\"M8.578 16.359l4.594-4.594-4.594-4.594 1.406-1.406 6 6-6 6z\">\n              <title>Next</title>\n              </path>\n              </svg>\n            </div>\n         </button>",
      responsive: [{
        breakpoint: 911,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 679,
        settings: {
          arrows: false,
          slidesToShow: 1.3,
          centerMode: true
        }
      }]
    }); //Add aria-label to slick-track for accessibility

    (0, _jquery.default)(this).find(".slick-track").each(function (index) {
      (0, _jquery.default)(this).attr("aria-label", "product-navigation-slider" + index);
    }); //Add id to each slide for accessibility

    (0, _jquery.default)(this).find(".slick-slide").each(function () {
      var $slide = (0, _jquery.default)(this);

      if ($slide.attr("aria-describedby") != undefined) {
        // ignore extra/cloned slides        
        (0, _jquery.default)(this).attr("id", $slide.attr("aria-describedby"));
      }
    });
  });
}

(0, _jquery.default)(document).ready(function () {
  // DOM caching
  var pageToolbar = (0, _jquery.default)(".page-toolbar");
  var globalHeader = (0, _jquery.default)(".global-header");
  var pageToolbarShare = (0, _jquery.default)(".page-toolbar__share");
  var desktopShareBar = (0, _jquery.default)(".share-bar__sticky-wrapper");
  var mobileBreakpoint = 910;
  (0, _jquery.default)(window).on("resize", function () {
    var wi = (0, _jquery.default)(window).width(); // unhide toolbar share bar

    if (wi > mobileBreakpoint && wi < 1170 && desktopShareBar.length) {
      pageToolbarShare.css("display", "block");
    } else {
      pageToolbarShare.css("display", "");
    }
  }); // need to bake this, since the offset().top becomes 0 when toolbar goes fixed

  if (pageToolbar.length) {
    var toolbarOffset = pageToolbar.offset().top - globalHeader.outerHeight();
    desktopShareBar.css("top", "".concat(globalHeader.outerHeight() + pageToolbar.outerHeight(), "px"));
  }

  (0, _jquery.default)(window).on("scroll", function () {
    if ((0, _jquery.default)(this).scrollTop() > 0) {
      globalHeader.addClass("is-sticky");
    } else {
      globalHeader.removeClass("is-sticky");
    }

    if (pageToolbar.length && (0, _jquery.default)(this).scrollTop() >= toolbarOffset) {
      pageToolbar.addClass("page-toolbar--sticky").css("top", globalHeader.outerHeight() + "px");

      if ((0, _jquery.default)(".js-show-page-title-in-nav").length || (0, _jquery.default)(".page-toolbar__page-title--only-title").length) {
        (0, _jquery.default)(".page-toolbar__page-title").removeClass("u-hidden");
      }
    } else {
      pageToolbar.removeClass("page-toolbar--sticky");
      (0, _jquery.default)(".page-toolbar__page-title").addClass("u-hidden");
    }
  }); // read query string
  // example: http://dev93.pew.velir.com/en?utm_source=source_test&utm_medium=medium_test&utm_campaign=campaign_test&utm_content=content_test&utm_term=term_test

  var queryForm = function queryForm() {
    var url = window.location.toString();
    var queryString = url.split("?");

    if (queryString.length > 1) {
      var pairs = queryString[1].split("&");

      for (var i in pairs) {
        var keyVal = pairs[i].split("=");

        if (sessionStorage.getItem(keyVal[0]) === null) {
          sessionStorage.setItem(keyVal[0], decodeURIComponent(keyVal[1]));
        }
      }
    }
  };

  queryForm(); // Share Bar from Living Facts

  var $shareBar = (0, _jquery.default)(".js-plf-share-bar");

  function scrollHandler() {
    //check scroll position
    var viewPort = (0, _jquery.default)(window).scrollTop() + (0, _jquery.default)(window).height();

    if ($shareBar.length) {
      var topOfShareBar = $shareBar.offset().top;

      if (viewPort > topOfShareBar) {
        $shareBar.addClass("plf-share-bar--fixed");
      } else {
        $shareBar.removeClass("plf-share-bar--fixed");
      }
    }
  }

  (0, _jquery.default)(window).on("scroll", _lodash.default.throttle(scrollHandler, 200, {
    leading: true,
    trailing: true
  }));

  if ($shareBar.length) {
    var plfShareBar = new _ShareBar.ShareBar($shareBar);
    Stickyfill.add($shareBar);
  }
});
var SneakyEmail = {
  // Email addresses are obfuscated via ROT13 in C# in the templates
  // ROT13'ing again will deobfuscate and give us the real address
  ROT13: function ROT13(address) {
    return address.replace(/[a-zA-Z]/g, function (c) {
      return String.fromCharCode((c <= "Z" ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
    });
  },
  findEmailAddresses: function findEmailAddresses() {
    (0, _jquery.default)(".js-obfuscate-email").each(function () {
      var obfuscatedAddress = SneakyEmail.ROT13((0, _jquery.default)(this).attr("data-obfuscate-email"));
      (0, _jquery.default)(this).on("click", function () {
        window.location.href = "mailto:" + obfuscatedAddress;
      });
    });
  }
}; // jQuery method for shrinking/expanding text to fill its parent container

_jquery.default.fn.textfill = function (maxFontSize) {
  // maxFontSize = maxFontSize || 16;
  // maxFontSize = parseInt(maxFontSize, 10);
  return this.each(function () {
    var textHeight = (0, _jquery.default)(this).height(); // remove 100px from parent container height to account for padding/layout

    var containerHeight = (0, _jquery.default)(this).parent().height() - 100;
    var fontSize = parseInt((0, _jquery.default)(this).css("font-size"));

    if (textHeight > containerHeight) {
      while (textHeight > Math.max(0, containerHeight)) {
        --fontSize;
        (0, _jquery.default)(this).css("font-size", fontSize + "px");
        containerHeight = (0, _jquery.default)(this).parent().height() - 100;
        textHeight = (0, _jquery.default)(this).height();
      }
    } else {
      while (fontSize < 16 && textHeight <= Math.max(0, containerHeight)) {
        ++fontSize;
        (0, _jquery.default)(this).css("font-size", fontSize + "px");
        containerHeight = (0, _jquery.default)(this).parent().height() - 100;
        textHeight = (0, _jquery.default)(this).height();
      }
    }
  });
};

(0, _jquery.default)(document).ready(function () {
  // Obfuscate email addresses
  SneakyEmail.findEmailAddresses(); //checking for all possible combinations of external links since they all don't have the core class.

  if (!(0, _jquery.default)("body").hasClass("is-page-editor")) {
    (0, _jquery.default)(".link-item__external--blue, .link-item__external--white, .link-item__external").each(function () {
      (0, _jquery.default)(this).append("<svg class=\"icon icon--external-link\" viewBox=\"0 0 10 8\" xmlns=\"http://www.w3.org/2000/svg\">\n          <g fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke=\"currentColor\">\n          <path d=\"M.5 4h9\"></path>\n          <path d=\"M6.24.74L9.5 4\"></path>\n          <path d=\"M6.24 7.26L9.5 4\"></path>\n          </g>\n        </svg>");
    });
  }

  var videoCountPush = function videoCountPush() {
    var videoCount = (0, _jquery.default)(".video-block").length;

    if (videoCount > 0) {
      window.dataLayer.push({
        videoCount: videoCount
      });
    }
  };

  videoCountPush(); // Properly size page banner videos

  (0, _jquery.default)(".js-banner-video").each(function () {
    var videoHeight = (0, _jquery.default)(this)[0].videoHeight;
    var videoWidth = (0, _jquery.default)(this)[0].videoWidth;
    var videoAspectRatio = videoHeight / videoWidth;
    var videoParent = (0, _jquery.default)(this).closest(".page-banner");

    if (videoParent.width() < videoWidth) {
      (0, _jquery.default)(this).css({
        width: videoparent.width,
        height: videoparent.width * videoaspectratio
      });
      videoParent.css({
        width: videoparent.width,
        height: videoparent.width * videoaspectratio
      });
    } else {
      (0, _jquery.default)(this).css({
        width: videoparent.width * videoaspectratio + "px",
        height: videoparent.width
      });
      videoParent.css({
        width: videoparent.width * videoaspectratio + "px",
        height: videoparent.width
      });
    }
  });
  (0, _jquery.default)(".rte-expand-button").on("click", function () {
    (0, _jquery.default)(this).closest(".rich-text__expand-button").addClass("is-active").hide();
  });
  (0, _jquery.default)(".pct-expand-more").each(function (index, elm) {
    var newToggle = (0, _jquery.default)("<span>");
    var moreToggle = newToggle.clone().addClass("pct-expand-more__toggle pct-expand-more__toggle--more").text("More");
    var lessToggle = newToggle.clone().addClass("pct-expand-more__toggle pct-expand-more__toggle--less").text("Less");
    (0, _jquery.default)(elm).prev().append(moreToggle);
    (0, _jquery.default)(elm).find("p:last-child").append(lessToggle);
    moreToggle.on("click", function () {
      var contentBlock = (0, _jquery.default)(this).closest(".findings-content");
      contentBlock.find(".pct-expand-more").toggle();
      contentBlock.find(".pct-expand-more__toggle--more").hide();
    });
    lessToggle.on("click", function () {
      moreToggle.toggle();
      (0, _jquery.default)(this).closest(".pct-expand-more").toggle();
      (0, _jquery.default)(this).closest(".findings-content").find(".pct-expand-more__toggle--more").show();
    });
  }); // Some videos on the site (like legacy YouTube videos) need explicit sizing
  // target: the video itself
  // bounding: the selector to use for determining the video width
  //
  // TODO - Add params for custom aspect ratio besides 16:9?

  var resizeVideoContainer = function resizeVideoContainer(targets) {
    targets.forEach(function (val, ind, arr) {
      var $target = (0, _jquery.default)(val.target);
      $target.each(function (ind, elm) {
        var $parent = (0, _jquery.default)(elm).closest(val.bounding);
        (0, _jquery.default)(elm).css({
          width: $parent.width(),
          height: $parent.width() * (9 / 16)
        });
      });
    });
  };

  (0, _jquery.default)(window).on("resize", function () {
    (0, _jquery.default)(".flip-tile__center-body-copy").textfill();
    resizeVideoContainer([{
      target: ".fluid-width-video-wrapper iframe",
      bounding: ".fluid-width-video-wrapper"
    }, {
      target: '.rich-text iframe[src*="youtube"]',
      bounding: ".rich-text"
    }]);
  });
  (0, _jquery.default)(".flip-tile__center-body-copy").textfill();
  resizeVideoContainer([{
    target: ".fluid-width-video-wrapper iframe",
    bounding: ".fluid-width-video-wrapper"
  }, {
    target: '.rich-text iframe[src*="youtube"]',
    bounding: ".rich-text"
  }]);
  (0, _jquery.default)(".rich-text__accordion-toggle").on("click", function () {
    (0, _jquery.default)(this).closest(".rich-text__accordion").toggleClass("is-active");
  });
});
(0, _jquery.default)(window).on("load", function () {
  //map tool
  (0, _jquery.default)(".js-embed-toggle").off("click.embed-toggle").on("click.embed-toggle", function (e) {
    (0, _jquery.default)(this).next(".js-embed-code").slideToggle();
  });
  (0, _jquery.default)(".state").click(function (event) {
    if (event.target.nextSibling === null) dataLayerStatePush(event.target.innerHTML);else {
      dataLayerStatePush(event.target.nextSibling.innerHTML);
    }
  });
  (0, _jquery.default)(".state-boxes > g").click(function (event) {
    if (event.target.nextSibling === null) dataLayerStatePush(event.target.innerHTML);else {
      dataLayerStatePush(event.target.nextSibling.innerHTML);
    }
  });
  (0, _jquery.default)(".js-choropleth-mount .category-selector__item").click(function (event) {
    dataLayerYearPush(event.target.innerHTML);
  });

  var dataLayerStatePush = function dataLayerStatePush(eventValue) {
    window.dataLayer.push({
      event: "stateClick",
      stateName: eventValue
    });
  };

  var dataLayerYearPush = function dataLayerYearPush(eventValue) {
    window.dataLayer.push({
      event: "yearClick",
      yearName: eventValue
    });
  };
});

},{"./Pew/ActionAlertShare":1,"./Pew/DynamicBanner":2,"./Pew/DynamicContentListing":3,"./Pew/EmbedToggle":4,"./Pew/ExploreModule":6,"./Pew/FlipBanner":7,"./Pew/FlipTile":8,"./Pew/FormDropdown":9,"./Pew/GenericModal":10,"./Pew/HiaDownload":11,"./Pew/HowWeWork":12,"./Pew/ImageGallery":13,"./Pew/ImageSlider":14,"./Pew/InnovationFundCheck":15,"./Pew/InsertRelatedFactsArrows":16,"./Pew/InterstitialModal":17,"./Pew/LanguageSelector":18,"./Pew/LegacyVideoModal":19,"./Pew/MoreFromPewSlider":20,"./Pew/PageVarGTM.js":21,"./Pew/ReadMode":22,"./Pew/ReadingTime":23,"./Pew/RssListing":24,"./Pew/ScholarGrid":25,"./Pew/ScrollAnimation":26,"./Pew/SelectionSharer":27,"./Pew/ShareBar":28,"./Pew/ShareButton":29,"./Pew/Slider":30,"./Pew/Sticky30":31,"./Pew/Toolbar":32,"./Pew/Typeahead.js":33,"./Pew/VideoModal":34,"./Pew/ViewAllExpand":35,"./Pew/WhatWeDo":36,"./Pew/blog-content":44,"./Pew/blog-search":46,"./Pew/breakpoint":48,"./Pew/dynamic-content":55,"./Pew/hia-map":64,"./Pew/makeClickable":66,"./Pew/navigation/LocalNav":67,"./Pew/navigation/PrimaryNav":69,"./Pew/navigation/SecondaryNav":70,"./Pew/navigation/initMobileMenu.js":71,"./Pew/navigation/initMobileSearchMenu.js":72,"./Pew/navigation/initMobileShare.js":73,"./Pew/navigation/initPrimaryNav.js":74,"./Pew/people-listing":78,"./Pew/project-listing":80,"./Pew/search":102,"./Pew/stickyfill.js":115,"./Pew/xDB":116,"./polyfill":120,"jquery":"jquery","lodash":"lodash","picturefill":"picturefill","ramda":"ramda","what-input":"what-input"}],118:[function(require,module,exports){
"use strict";

(function (ElementProto) {
  if (typeof ElementProto.matches !== "function") {
    ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
      var element = this;
      var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
      var index = 0;

      while (elements[index] && elements[index] !== element) {
        ++index;
      }

      return Boolean(elements[index]);
    };
  }

  if (typeof ElementProto.closest !== "function") {
    ElementProto.closest = function closest(selector) {
      var element = this;

      while (element && element.nodeType === 1) {
        if (element.matches(selector)) {
          return element;
        }

        element = element.parentNode;
      }

      return null;
    };
  }
})(window.Element.prototype);

},{}],119:[function(require,module,exports){
"use strict";

require("core-js/fn/object/assign.js");

require("core-js/fn/array/find.js");

require("core-js/fn/array/find-index.js");

require("core-js/fn/array/fill.js");

require("core-js/fn/array/includes.js");

require("core-js/fn/array/from.js");

require("core-js/fn/symbol/index.js");

require("regenerator-runtime/runtime");

},{"core-js/fn/array/fill.js":"core-js/fn/array/fill.js","core-js/fn/array/find-index.js":"core-js/fn/array/find-index.js","core-js/fn/array/find.js":"core-js/fn/array/find.js","core-js/fn/array/from.js":"core-js/fn/array/from.js","core-js/fn/array/includes.js":"core-js/fn/array/includes.js","core-js/fn/object/assign.js":"core-js/fn/object/assign.js","core-js/fn/symbol/index.js":"core-js/fn/symbol/index.js","regenerator-runtime/runtime":"regenerator-runtime/runtime"}],120:[function(require,module,exports){
"use strict";

require("./es6-polyfill");

require("./closest");

var _svg4everybody = _interopRequireDefault(require("svg4everybody"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Note: object-fit has been refactored to be applied on-demand instead of automatically
// You may invoke it directly in your scripts
(0, _svg4everybody.default)();

},{"./closest":118,"./es6-polyfill":119,"svg4everybody":"svg4everybody"}],121:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objectFitPolyfill = exports.objectFit = exports.objectFitSupport = void 0;

/*----------------------------------------
 * objectFitPolyfill 2.0.3
 *
 * Made by Constance Chen
 * Released under the MIT license
 *
 * * https://github.com/constancecchen/object-fit-polyfill
 *
 * CUSTOMIZATIONS MADE BY VELIR. SEE LINES TAGGED 'VELIR'
 *  - Due to issues with object-fit and <video>, we always want
 *   to use this on video
 *
 *   - Do not auto-bind to browser events. Export several members
 *     to allow behaavior to be invoked on demand, or have events
 *     bound at a time of our choosing.
 *--------------------------------------*/

/* VELIR
 Object fit does not work property with <video> elements.
 If <video> elements present on page, run the polyfill
 regardless of style support.
 See: https://bugs.chromium.org/p/chromium/issues/detail?id=400829
 */
var objectFitSupport = function objectFitSupport() {
  return "objectFit" in document.documentElement.style;
};
/**
 * Check the container's parent element to make sure it will
 * correctly handle and clip absolutely positioned children
 *
 * @param {node} $container - parent element
 */


exports.objectFitSupport = objectFitSupport;

var checkParentContainer = function checkParentContainer($container) {
  var styles = window.getComputedStyle($container, null);
  var position = styles.getPropertyValue("position");
  var overflow = styles.getPropertyValue("overflow");
  var display = styles.getPropertyValue("display");

  if (!position || position === "static") {
    $container.style.position = "relative";
  }

  if (overflow !== "hidden") {
    $container.style.overflow = "hidden";
  } // Guesstimating that people want the parent to act like full width/height wrapper here.
  // Mostly attempts to target <picture> elements, which default to inline.


  if (!display || display === "inline") {
    $container.style.display = "block";
  }

  if ($container.clientHeight === 0 || $container.tagName === "PICTURE") {
    $container.style.height = "100%";
  }

  $container.classList.add("object-fit-polyfill");
};
/**
 * Check for pre-set max-width/height or min-width/height,
 * which can mess up image calculations
 *
 * @param {node} $media - img/video element
 */


var checkMediaConstraints = function checkMediaConstraints($media) {
  var styles = window.getComputedStyle($media, null);
  var constraints = {
    "max-width": "none",
    "max-height": "none",
    "min-width": "0px",
    "min-height": "0px"
  };

  for (var property in constraints) {
    var constraint = styles.getPropertyValue(property);

    if (constraint !== constraints[property]) {
      $media.style[property] = constraints[property];
    }
  }
};
/**
 * Calculate & set object-position
 *
 * @param {string} axis - either "x" or "y"
 * @param {node} $media - img or video element
 * @param {string} objectPosition - e.g. "50% 50%", "top bottom"
 */


var setPosition = function setPosition(axis, $media, objectPosition) {
  objectPosition = objectPosition.split(" ");
  var position, other, start, end, side;

  if (axis === "x") {
    position = objectPosition[0];
    other = objectPosition[1];
    start = "left";
    end = "right";
    side = $media.clientWidth;
  } else if (axis === "y") {
    position = objectPosition[1];
    other = objectPosition[0];
    start = "top";
    end = "bottom";
    side = $media.clientHeight;
  } else {
    return; // Neither x or y axis specified
  }

  if (position === start || other === start) {
    $media.style[start] = "0";
    return;
  }

  if (position === end || other === end) {
    $media.style[end] = "0";
    return;
  }

  if (position === "center" || position === "50%") {
    $media.style[start] = "50%";
    $media.style["margin-" + start] = side / -2 + "px";
    return;
  } // Percentage values (e.g., 30% 10%)


  if (position.indexOf("%") >= 0) {
    position = parseInt(position);

    if (position < 50) {
      $media.style[start] = position + "%";
      $media.style["margin-" + start] = side * (position / -100) + "px";
    } else {
      position = 100 - position;
      $media.style[end] = position + "%";
      $media.style["margin-" + end] = side * (position / -100) + "px";
    }

    return;
  } // Length-based values (e.g. 10px / 10em)
  else {
    $media.style[start] = position;
  }
};
/**
 * Calculate & set object-fit
 *
 * @param {node} $media - img/video/picture element
 */


var objectFit = function objectFit($media) {
  // Fallbacks, IE 10- data
  var fit = $media.dataset ? $media.dataset.objectFit : $media.getAttribute("data-object-fit");
  var position = $media.dataset ? $media.dataset.objectPosition : $media.getAttribute("data-object-position");
  fit = fit || "cover";
  position = position || "50% 50%"; // If necessary, make the parent container work with absolutely positioned elements

  var $container = $media.parentNode;
  checkParentContainer($container); // Check for max-width/height or min-width/height, which can mess up image calculations

  checkMediaConstraints($media); // Mathematically figure out which side needs covering, and add CSS positioning & centering

  $media.style.position = "absolute";
  $media.style.height = "100%";
  $media.style.width = "auto";

  if (fit === "scale-down") {
    $media.style.height = "auto";

    if ($media.clientWidth < $container.clientWidth && $media.clientHeight < $container.clientHeight) {
      setPosition("x", $media, position);
      setPosition("y", $media, position);
    } else {
      fit = "contain";
      $media.style.height = "100%";
    }
  }

  if (fit === "none") {
    $media.style.width = "auto";
    $media.style.height = "auto";
    setPosition("x", $media, position);
    setPosition("y", $media, position);
  } else if (fit === "cover" && $media.clientWidth > $container.clientWidth || fit === "contain" && $media.clientWidth < $container.clientWidth) {
    $media.style.top = "0";
    $media.style.marginTop = "0";
    setPosition("x", $media, position);
  } else if (fit !== "scale-down") {
    $media.style.width = "100%";
    $media.style.height = "auto";
    $media.style.left = "0";
    $media.style.marginLeft = "0";
    setPosition("y", $media, position);
  }
};
/**
 * Initialize plugin
 */


exports.objectFit = objectFit;

var objectFitPolyfill = function objectFitPolyfill() {
  var media = document.querySelectorAll("[data-object-fit]");

  for (var i = 0; i < media.length; i++) {
    var mediaType = media[i].nodeName.toLowerCase();

    if (mediaType === "img") {
      if (media[i].complete) {
        objectFit(media[i]);
      } else {
        media[i].addEventListener("load", function () {
          objectFit(this);
        });
      }
    } else if (mediaType === "video") {
      if (media[i].readyState > 0) {
        objectFit(media[i]);
      } else {
        media[i].addEventListener("loadedmetadata", function () {
          objectFit(this);
        });
      }
    }
  }

  return true;
};
/* VELIR: Do not autorun polyfill at page load */
//   document.addEventListener("DOMContentLoaded", function() {
//   objectFitPolyfill();
// });

/* VELIR: Do not autobind polyfill at page load */
// window.addEventListener("resize", function() {
//   objectFitPolyfill();
// VELIR: export polyfill methods
// window.objectFitPolyfill = objectFitPolyfill;


exports.objectFitPolyfill = objectFitPolyfill;

},{}]},{},[117]);
